/*** IMPORTS FROM imports-loader ***/
var Blockly = require("../shim/blocks_compressed_vertical-blockly_compressed_vertical-messages");
var goog = require("../shim/blockly_compressed_vertical.goog");

// This file was automatically generated.  Do not modify.

'use strict';

goog.provide('Blockly.ScratchMsgs.allLocales');

goog.require('Blockly.ScratchMsgs');


Blockly.ScratchMsgs.locales["ab"] =
{
    "CONTROL_FOREVER": "инагӡалатәуп",
    "CONTROL_REPEAT": "инагӡалатәуп %1 - нтә",
    "CONTROL_IF": "%1 акәзар",
    "CONTROL_ELSE": "акәымзар",
    "CONTROL_STOP": "иаанкылатәуп",
    "CONTROL_STOP_ALL": "зегьы",
    "CONTROL_STOP_THIS": "ари апрограмма",
    "CONTROL_STOP_OTHER": "анагӡаҩ егьырҭ ипрограммақәа",
    "CONTROL_WAIT": "иԥштәуп %1 секундк",
    "CONTROL_WAITUNTIL": "иԥштәуп %1 -нӡа",
    "CONTROL_REPEATUNTIL": "инагӡалатәуп %1 акәымзар",
    "CONTROL_WHILE": "%1 иашанаҵ",
    "CONTROL_FOREACH": "рыцԥхьаӡа %1 рзы %2 аҟны",
    "CONTROL_STARTASCLONE": "сара аклон еиԥш саналаго",
    "CONTROL_CREATECLONEOF": "иаԥҵатәуп аклон %1 аҟынтәи",
    "CONTROL_CREATECLONEOF_MYSELF": "сара схала",
    "CONTROL_DELETETHISCLONE": "ианыхтәуп ари аклон",
    "CONTROL_COUNTER": "аԥхьаӡага",
    "CONTROL_INCRCOUNTER": "аԥхьаӡага иазырҳатәуп",
    "CONTROL_CLEARCOUNTER": "ирыцқьатәуп аԥхьаӡага",
    "CONTROL_ALLATONCE": "зегьы иаразнак",
    "DATA_SETVARIABLETO": "%1 иаҭатәуп %2 ",
    "DATA_CHANGEVARIABLEBY": "иԥсахтәуп %1 %2 ала",
    "DATA_SHOWVARIABLE": "иаарԥштәуп аҽеиҭак %1",
    "DATA_HIDEVARIABLE": "иҵәахтәуп аҽеиҭак %1",
    "DATA_ADDTOLIST": "иацҵатәуп %1 %2 ахь  ",
    "DATA_DELETEOFLIST": "ианыхтәуп %1 %2 аҟынтәи ",
    "DATA_INSERTATLIST": "%3 аҟны ибжьаргылатәуп %1 %2 аҭыԥахь   ",
    "DATA_REPLACEITEMOFLIST": "%2 аҟны иԥсахтәуп аелемент %1 %3 ала  ",
    "DATA_ITEMOFLIST": "аелемент %1 %2 аҟынтәи  ",
    "DATA_LENGTHOFLIST": "%1 аура",
    "DATA_LISTCONTAINSITEM": "%1 иаҵанакуама %2?",
    "DATA_SHOWLIST": "иаарԥштәуп ахьӡынҵа %1",
    "DATA_HIDELIST": "иҵәахтәуп ахьӡынҵа %1",
    "DATA_INDEX_ALL": "зегьы",
    "DATA_INDEX_LAST": "аҵыхәтәантәи",
    "DATA_INDEX_RANDOM": "иарбанзаалакь",
    "EVENT_WHENFLAGCLICKED": "%1 ҳанақәыӷәӷәалакь",
    "EVENT_WHENTHISSPRITECLICKED": "анагӡаҩ ҳаниқәыӷәӷәалакь",
    "EVENT_WHENSTAGECLICKED": "асцена ҳанақәыӷәӷәалакь",
    "EVENT_WHENTOUCHINGOBJECT": "when this sprite touches %1",
    "EVENT_WHENBROADCASTRECEIVED": " %1 аус арура",
    "EVENT_WHENBACKDROPSWITCHESTO": "аҿаԥшыра %1 ала аҽанаԥсахуа ",
    "EVENT_WHENGREATERTHAN": "%1 > %2 акәзар",
    "EVENT_WHENGREATERTHAN_TIMER": "аамҭарбага",
    "EVENT_BROADCAST": "ишьҭтәуп %1  ",
    "EVENT_BROADCASTANDWAIT": "ишьҭтәуп %1 нас иԥштәуп",
    "EVENT_WHENKEYPRESSED": "аклавиша %1 ҳанақәыӷәӷәалакь",
    "EVENT_WHENKEYPRESSED_SPACE": "абжьажьга",
    "EVENT_WHENKEYPRESSED_LEFT": "ахыц арӷьарахь",
    "EVENT_WHENKEYPRESSED_RIGHT": "ахыц армарахь",
    "EVENT_WHENKEYPRESSED_DOWN": "ахыц алада",
    "EVENT_WHENKEYPRESSED_UP": "ахыц аҩада",
    "EVENT_WHENKEYPRESSED_ANY": "иарбанзаалакь",
    "LOOKS_SAYFORSECS": "иҳәалатәуп %1 %2 секундк  ",
    "LOOKS_SAY": "иҳәатәуп %1 ",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "ахәыцра %1 %2  секундк ",
    "LOOKS_THINK": "ахәыцра %1 ",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "ацәырҵра",
    "LOOKS_HIDE": "аҽыҵәахра",
    "LOOKS_HIDEALLSPRITES": "иҵәахтәуп анагӡаҩцәа зегьы",
    "LOOKS_EFFECT_COLOR": "аԥштәы",
    "LOOKS_EFFECT_FISHEYE": "аԥсыӡ аблақәа",
    "LOOKS_EFFECT_WHIRL": "акьаҳәхара",
    "LOOKS_EFFECT_PIXELATE": "апиксельқәа рырдура",
    "LOOKS_EFFECT_MOSAIC": "амозаика",
    "LOOKS_EFFECT_BRIGHTNESS": "ажжара",
    "LOOKS_EFFECT_GHOST": "алаԥшҵашәара",
    "LOOKS_CHANGEEFFECTBY": "иԥсахтәуп %1 аеффект %2 ала  ",
    "LOOKS_SETEFFECTTO": "иқәыргылатәуп аеффект %1 %2 аҟны  ",
    "LOOKS_CLEARGRAPHICEFFECTS": "иқәгатәуп аграфикатә еффектқәа",
    "LOOKS_CHANGESIZEBY": "иԥсахтәуп ашәагаа %1 ала",
    "LOOKS_SETSIZETO": "иқәыргылатәуп ашәагаа  %1 % ",
    "LOOKS_SIZE": "ашәагаа",
    "LOOKS_CHANGESTRETCHBY": "change stretch by %1",
    "LOOKS_SETSTRETCHTO": "set stretch to %1 %",
    "LOOKS_SWITCHCOSTUMETO": "иԥсахтәуп акостиум %1 ала",
    "LOOKS_NEXTCOSTUME": "анаҩстәи акостиум",
    "LOOKS_SWITCHBACKDROPTO": "иԥсахтәуп аҿаԥшыра %1 ала",
    "LOOKS_GOTOFRONTBACK": "ииастәуп %1 ҿыгҳарак ала ",
    "LOOKS_GOTOFRONTBACK_FRONT": "front",
    "LOOKS_GOTOFRONTBACK_BACK": "шьҭахьҟа",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "go %1 %2 layers",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ԥхьаҟа",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "шьҭахьҟа",
    "LOOKS_BACKDROPNUMBERNAME": "аҿаԥшыра %1 ",
    "LOOKS_COSTUMENUMBERNAME": "акостиум %1",
    "LOOKS_NUMBERNAME_NUMBER": "аномер",
    "LOOKS_NUMBERNAME_NAME": "ахьӡ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "иԥсахтәуп аҿаԥшыра %1 ала  нас иԥштәуп ",
    "LOOKS_NEXTBACKDROP": "анаҩстәи аҿаԥшыра",
    "LOOKS_PREVIOUSBACKDROP": "уаанӡатәи аҿаҧшыра",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "ицатәуп %1 шьаҿак",
    "MOTION_TURNLEFT": "иргьежьтәуп  %1 %2 градус рыла ",
    "MOTION_TURNRIGHT": "иргьежьтәуп %1 %2 градус рыла ",
    "MOTION_POINTINDIRECTION": "инарҳәтәуп %1 ",
    "MOTION_POINTTOWARDS": "%1 ахь инаҳәтәуп",
    "MOTION_POINTTOWARDS_POINTER": "аҳәынаԥ арбага",
    "MOTION_GOTO": "ииастәуп %1 ахь",
    "MOTION_GOTO_POINTER": "аҳәынаԥ арбага",
    "MOTION_GOTO_RANDOM": "иарбанзаалакь апозициа",
    "MOTION_GOTOXY": "ииастәуп x: %1 y: %2 ахь ",
    "MOTION_GLIDESECSTOXY": "иқәҵәраатәуп x: %2 y: %3 ахь %1 секундк ",
    "MOTION_GLIDETO": "иқәҵәраатәуп %2 ахь %1 секундк  ",
    "MOTION_GLIDETO_POINTER": "аҳәынаԥ арбага",
    "MOTION_GLIDETO_RANDOM": "иарбанзаалакь апозициа",
    "MOTION_CHANGEXBY": "иԥсахтәуп x %1 ала   ",
    "MOTION_SETX": "иқәыргылатәуп x %1 аҟны  ",
    "MOTION_CHANGEYBY": "иԥсахтәуп y %1 ала ",
    "MOTION_SETY": "иқәыргылатәуп y %1 аҟны ",
    "MOTION_IFONEDGEBOUNCE": "акьыԥшь акәзар, иадԥатәуп",
    "MOTION_SETROTATIONSTYLE": "аргьежьра астиль %1 ",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "армарахьтә-арӷьарахь",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "иргьежьтәӡам",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "акәша-мыкәша",
    "MOTION_XPOSITION": "x аҭыԥ",
    "MOTION_YPOSITION": "y аҭыԥ",
    "MOTION_DIRECTION": "ахырхарҭа",
    "MOTION_SCROLLRIGHT": "scroll right %1",
    "MOTION_SCROLLUP": "scroll up %1",
    "MOTION_ALIGNSCENE": "align scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bottom-left",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bottom-right",
    "MOTION_ALIGNSCENE_MIDDLE": "ибжьаратәу",
    "MOTION_ALIGNSCENE_TOPLEFT": "top-left",
    "MOTION_ALIGNSCENE_TOPRIGHT": "top-right",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "иарбанзаалакь %1 -и %2 -и рыбжьара  ",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 - еи  %2 - еи",
    "OPERATORS_OR": "%1 ма %2",
    "OPERATORS_NOT": "%1 акәӡам",
    "OPERATORS_JOIN": "еиԥшьтәуп %1 %2 ",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "асимвол %1 %2 аҟны",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "%1 аура",
    "OPERATORS_CONTAINS": "%1 иаҵанакуама %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "ихаргьежьтәуп %1 ",
    "OPERATORS_MATHOP": "%1 %2 аҟынтәи",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "еиҵоу еибгоу",
    "OPERATORS_MATHOP_CEILING": "еиҳау еибгоу",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "define %1",
    "SENSING_TOUCHINGOBJECT": "иадкьыслома %1?  ",
    "SENSING_TOUCHINGOBJECT_POINTER": "аҳәынаԥ арбага",
    "SENSING_TOUCHINGOBJECT_EDGE": "акьыԥшь",
    "SENSING_TOUCHINGCOLOR": "иадкьыслома аԥштәы %1? ",
    "SENSING_COLORISTOUCHINGCOLOR": "аԥштәы %1 иадкьыслома %2?  ",
    "SENSING_DISTANCETO": "%1 аҟынӡа ибжьоу",
    "SENSING_DISTANCETO_POINTER": "аҳәынаԥ арбага",
    "SENSING_ASKANDWAIT": "иазҵаатәуп %1 нас иԥштәуп ",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "аҭак",
    "SENSING_KEYPRESSED": "аклавиша %1  иақәыӷәӷәома? ",
    "SENSING_MOUSEDOWN": "аҳәынаԥ иақәыӷәӷәома?",
    "SENSING_MOUSEX": "аҳәынаԥ x ала",
    "SENSING_MOUSEY": "аҳәынаԥ y ала",
    "SENSING_SETDRAGMODE": "иқәыргылатәуп аиагара арежим %1 ",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ииаугар зуа",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "аиагара зымуа",
    "SENSING_LOUDNESS": "абжьы адура",
    "SENSING_LOUD": "loud?",
    "SENSING_TIMER": "аамҭарбага",
    "SENSING_RESETTIMER": "аамҭарбага ҿыц адәықәҵара",
    "SENSING_OF": "%1  %2",
    "SENSING_OF_XPOSITION": "x аҭыԥ",
    "SENSING_OF_YPOSITION": "y аҭыԥ",
    "SENSING_OF_DIRECTION": "ахырхарҭа",
    "SENSING_OF_COSTUMENUMBER": "акостиум №",
    "SENSING_OF_COSTUMENAME": "акостиум ахьӡ",
    "SENSING_OF_SIZE": "ашәагаа",
    "SENSING_OF_VOLUME": "абжьы адура",
    "SENSING_OF_BACKDROPNUMBER": "аҿаԥшыра №",
    "SENSING_OF_BACKDROPNAME": "аҿаԥшыра ахьӡ",
    "SENSING_OF_STAGE": "Асцена",
    "SENSING_CURRENT": "уажәтәи %1 ",
    "SENSING_CURRENT_YEAR": "ашықәс",
    "SENSING_CURRENT_MONTH": "амза",
    "SENSING_CURRENT_DATE": "арыцхә",
    "SENSING_CURRENT_DAYOFWEEK": "амчыбжь амш",
    "SENSING_CURRENT_HOUR": "асааҭ",
    "SENSING_CURRENT_MINUTE": "аминуҭ",
    "SENSING_CURRENT_SECOND": "асекунд",
    "SENSING_DAYSSINCE2000": "амшқәа 01.01.2000 инаркны ",
    "SENSING_USERNAME": "алахәылаҩ ихьӡ",
    "SENSING_USERID": "Ахархәаҩ ID",
    "SOUND_PLAY": "иргатәуп абжьы %1 ",
    "SOUND_PLAYUNTILDONE": "иргатәуп абжьы %1 инҵәаанӡа ",
    "SOUND_STOPALLSOUNDS": "иаанкылатәуп абжьқәа зегьы",
    "SOUND_SETEFFECTO": "иқәыргылатәуп %1 аеффект %2 аҟны  ",
    "SOUND_CHANGEEFFECTBY": "иԥсахтәуп  %1 аеффект %2 ала  ",
    "SOUND_CLEAREFFECTS": "иқәгатәуп абжьы аеффектқәа",
    "SOUND_EFFECTS_PITCH": "pitch",
    "SOUND_EFFECTS_PAN": "pan left/right",
    "SOUND_CHANGEVOLUMEBY": "иԥсахтәуп абжьы %1 ала ",
    "SOUND_SETVOLUMETO": "иқәыргылатәуп абжьы адура %1%",
    "SOUND_VOLUME": "абжьы адура",
    "CATEGORY_MOTION": "Аиҭаҵра",
    "CATEGORY_LOOKS": "Аԥшра-асахьа",
    "CATEGORY_SOUND": "Абжьы",
    "CATEGORY_EVENTS": "Ахҭысқәа",
    "CATEGORY_CONTROL": "Аконтроль",
    "CATEGORY_SENSING": "Асенсорқәа",
    "CATEGORY_OPERATORS": "Аоператорқәа",
    "CATEGORY_VARIABLES": "Аҽеиҭакқәа",
    "CATEGORY_MYBLOCKS": "Сара сблокқәа",
    "DUPLICATE": "Адубликат",
    "DELETE": "Ианыхтәуп",
    "ADD_COMMENT": "Иацҵатәуп акомментари",
    "REMOVE_COMMENT": "Ианыхтәуп акомментари",
    "DELETE_BLOCK": "Ианыхтәуп аблок",
    "DELETE_X_BLOCKS": "Ианыхтәуп %1 блокк ",
    "DELETE_ALL_BLOCKS": "Ианыхтәума аблокқәа %1 зегьы?",
    "CLEAN_UP": "Clean up Blocks",
    "HELP": "Ацхыраара",
    "UNDO": "Иаҟәыхтәуп",
    "REDO": "Ирхынҳәтәуп",
    "EDIT_PROCEDURE": "Ариашара",
    "SHOW_PROCEDURE_DEFINITION": "Go to definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Иҳәатәуп џьара акы...",
    "COLOUR_HUE_LABEL": "Аԥштәы",
    "COLOUR_SATURATION_LABEL": "Аԥштәылгазаара",
    "COLOUR_BRIGHTNESS_LABEL": "Ажжара",
    "CHANGE_VALUE_TITLE": "Change value:",
    "RENAME_VARIABLE": "Аҽеиҭак ахьӡ ԥсахтәуп",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Аҽеиҭак ахьӡ ԥсахтәуп",
    "NEW_VARIABLE": "Иаԥҵатәуп аҽеиҭак",
    "NEW_VARIABLE_TITLE": "Аҽеиҭак ахьӡ ҿыц:",
    "VARIABLE_MODAL_TITLE": "Аҽеиҭак ҿыц",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Иаԥҵатәуп аблок",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Ахьӡынҵа аԥҵара",
    "NEW_LIST_TITLE": "Ахьӡынҵа ахьӡ ҿыц:",
    "LIST_MODAL_TITLE": "Ахьӡынҵа ҿыц",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Ахьӡынҵа ахьӡ ԥсахтәуп",
    "NEW_BROADCAST_MESSAGE": "Ацҳамҭа ҿыц",
    "NEW_BROADCAST_MESSAGE_TITLE": "Ацҳамҭа ҿыц ахьӡ:",
    "BROADCAST_MODAL_TITLE": "Ацҳамҭа ҿыц",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "ацҳамҭа1"
};

Blockly.ScratchMsgs.locales["ca"] =
{
    "CONTROL_FOREVER": "per sempre",
    "CONTROL_REPEAT": "repeteix %1",
    "CONTROL_IF": "si %1 llavors",
    "CONTROL_ELSE": "si no",
    "CONTROL_STOP": "atura",
    "CONTROL_STOP_ALL": "tot",
    "CONTROL_STOP_THIS": "aquest programa",
    "CONTROL_STOP_OTHER": "altres programes del personatge",
    "CONTROL_WAIT": "espera %1 segons",
    "CONTROL_WAITUNTIL": "espera fins %1",
    "CONTROL_REPEATUNTIL": "repeteix fins %1",
    "CONTROL_WHILE": "mentre %1",
    "CONTROL_FOREACH": "per cada %1 a %2",
    "CONTROL_STARTASCLONE": "quan una còpia meva comenci",
    "CONTROL_CREATECLONEOF": "crea una còpia de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "jo mateix",
    "CONTROL_DELETETHISCLONE": "esborra aquesta còpia",
    "CONTROL_COUNTER": "comptador",
    "CONTROL_INCRCOUNTER": "augmenta comptador",
    "CONTROL_CLEARCOUNTER": "neteja comptador",
    "CONTROL_ALLATONCE": "tot d'una vegada",
    "DATA_SETVARIABLETO": "assigna a %1 el valor %2",
    "DATA_CHANGEVARIABLEBY": "augmenta %1 en %2",
    "DATA_SHOWVARIABLE": "mostra la variable %1",
    "DATA_HIDEVARIABLE": "amaga la variable %1",
    "DATA_ADDTOLIST": "afegeix %1 a %2",
    "DATA_DELETEOFLIST": "esborra l'element %1 de %2",
    "DATA_INSERTATLIST": "afegeix %1 a la posició %2 de %3",
    "DATA_REPLACEITEMOFLIST": "canvia l'element %1 de %2 per %3",
    "DATA_ITEMOFLIST": "element %1 de %2",
    "DATA_LENGTHOFLIST": "llargada de %1",
    "DATA_LISTCONTAINSITEM": "%1 conté %2?",
    "DATA_SHOWLIST": "mostra la llista %1",
    "DATA_HIDELIST": "amaga la llista %1",
    "DATA_INDEX_ALL": "tot",
    "DATA_INDEX_LAST": "darrer",
    "DATA_INDEX_RANDOM": "aleatori",
    "EVENT_WHENFLAGCLICKED": "quan %1 es premi",
    "EVENT_WHENTHISSPRITECLICKED": "quan es cliqui aquest personatge",
    "EVENT_WHENSTAGECLICKED": "quan es cliqui l'escenari",
    "EVENT_WHENTOUCHINGOBJECT": "quan aquest objecte toqui %1",
    "EVENT_WHENBROADCASTRECEIVED": "quan rebi %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "quan l'escenari canviï al fons %1",
    "EVENT_WHENGREATERTHAN": "quan %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronòmetre",
    "EVENT_BROADCAST": "envia a tots %1",
    "EVENT_BROADCASTANDWAIT": "envia a tots %1 i espera",
    "EVENT_WHENKEYPRESSED": "quan la tecla %1 es premi",
    "EVENT_WHENKEYPRESSED_SPACE": "espai",
    "EVENT_WHENKEYPRESSED_LEFT": "fletxa esquerra",
    "EVENT_WHENKEYPRESSED_RIGHT": "fletxa dreta",
    "EVENT_WHENKEYPRESSED_DOWN": "fletxa avall",
    "EVENT_WHENKEYPRESSED_UP": "fletxa amunt",
    "EVENT_WHENKEYPRESSED_ANY": "qualsevol",
    "LOOKS_SAYFORSECS": "digues %1 durant %2 segons",
    "LOOKS_SAY": "digues %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "pensa %1 durant %2 segons",
    "LOOKS_THINK": "pensa %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "mostra't",
    "LOOKS_HIDE": "amaga't",
    "LOOKS_HIDEALLSPRITES": "Amagar tots els personatges",
    "LOOKS_EFFECT_COLOR": "color",
    "LOOKS_EFFECT_FISHEYE": "ull de peix",
    "LOOKS_EFFECT_WHIRL": "girar",
    "LOOKS_EFFECT_PIXELATE": "pixelar",
    "LOOKS_EFFECT_MOSAIC": "mosaic",
    "LOOKS_EFFECT_BRIGHTNESS": "brillantor",
    "LOOKS_EFFECT_GHOST": "transparència",
    "LOOKS_CHANGEEFFECTBY": "augmenta l'efecte %1 en %2",
    "LOOKS_SETEFFECTTO": "fixa l'efecte %1 a %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "treu els efectes gràfics",
    "LOOKS_CHANGESIZEBY": "augmenta %1 la mida",
    "LOOKS_SETSIZETO": "fixa la mida a %1 %",
    "LOOKS_SIZE": "mida",
    "LOOKS_CHANGESTRETCHBY": "augmenta %1 l'estirament",
    "LOOKS_SETSTRETCHTO": "fixa l'estirament a %1 %",
    "LOOKS_SWITCHCOSTUMETO": "canvia el vestit a %1",
    "LOOKS_NEXTCOSTUME": "següent vestit",
    "LOOKS_SWITCHBACKDROPTO": "canvia el fons a %1",
    "LOOKS_GOTOFRONTBACK": "vés a la capa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "front",
    "LOOKS_GOTOFRONTBACK_BACK": "darrere",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "vés %1 %2 capes",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "endavant",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "enrere",
    "LOOKS_BACKDROPNUMBERNAME": "fons %1",
    "LOOKS_COSTUMENUMBERNAME": "vestit %1",
    "LOOKS_NUMBERNAME_NUMBER": "nombre",
    "LOOKS_NUMBERNAME_NAME": "nom",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "canvia el fons a %1 i espera",
    "LOOKS_NEXTBACKDROP": "següent fons de pantalla",
    "LOOKS_PREVIOUSBACKDROP": "fons anterior",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "mou-te %1 passos",
    "MOTION_TURNLEFT": "gira %1 %2 graus",
    "MOTION_TURNRIGHT": "gira %1 %2 graus",
    "MOTION_POINTINDIRECTION": "apunta en direcció %1",
    "MOTION_POINTTOWARDS": "apunta cap a %1",
    "MOTION_POINTTOWARDS_POINTER": "punter del ratolí",
    "MOTION_GOTO": "vés a %1",
    "MOTION_GOTO_POINTER": "punter del ratolí",
    "MOTION_GOTO_RANDOM": "posició aleatòria",
    "MOTION_GOTOXY": "vés a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "llisca en %1 segons fins a x: %2 y: %3",
    "MOTION_GLIDETO": "llisca en %1 segons fins a %2",
    "MOTION_GLIDETO_POINTER": "punter del ratolí",
    "MOTION_GLIDETO_RANDOM": "posició aleatòria",
    "MOTION_CHANGEXBY": "suma %1 a x",
    "MOTION_SETX": "assigna el valor %1 a x",
    "MOTION_CHANGEYBY": "suma %1 a y",
    "MOTION_SETY": "assigna el valor %1 a y",
    "MOTION_IFONEDGEBOUNCE": "rebota en tocar una vora",
    "MOTION_SETROTATIONSTYLE": "fixa el tipus de rotació %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "esquerra-dreta",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "no giris",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "al voltant",
    "MOTION_XPOSITION": "posició x",
    "MOTION_YPOSITION": "posició y",
    "MOTION_DIRECTION": "direcció",
    "MOTION_SCROLLRIGHT": "desplaça a la dreta %1",
    "MOTION_SCROLLUP": "desplaça amunt %1",
    "MOTION_ALIGNSCENE": "alinea centre %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "Inferior - Esquerre",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "Inferior - Dret",
    "MOTION_ALIGNSCENE_MIDDLE": "Centre",
    "MOTION_ALIGNSCENE_TOPLEFT": "Superior - Esquerre",
    "MOTION_ALIGNSCENE_TOPRIGHT": "Superior - Dret",
    "MOTION_XSCROLL": "Coordenada X",
    "MOTION_YSCROLL": "Coordenada Y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "nombre a l'atzar entre %1 i %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 i %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "no %1",
    "OPERATORS_JOIN": "uneix %1 i %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "lletra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "llargada de %1",
    "OPERATORS_CONTAINS": "%1 conté %2?",
    "OPERATORS_MOD": "residu de dividir %1 entre %2",
    "OPERATORS_ROUND": "arrodoneix %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "part sencera",
    "OPERATORS_MATHOP_CEILING": "sostre",
    "OPERATORS_MATHOP_SQRT": "arrel quadrada",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "defineix %1",
    "SENSING_TOUCHINGOBJECT": "tocant %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "punter del ratolí",
    "SENSING_TOUCHINGOBJECT_EDGE": "vora",
    "SENSING_TOUCHINGCOLOR": "tocant el color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "color %1 sobre %2?",
    "SENSING_DISTANCETO": "distància a %1",
    "SENSING_DISTANCETO_POINTER": "punter del ratolí",
    "SENSING_ASKANDWAIT": "pregunta %1 i espera",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "resposta",
    "SENSING_KEYPRESSED": "tecla %1 premuda?",
    "SENSING_MOUSEDOWN": "ratolí clicat?",
    "SENSING_MOUSEX": "ratolí x",
    "SENSING_MOUSEY": "ratolí y",
    "SENSING_SETDRAGMODE": "fixa el mode arrossega %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrossegadís",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "no arrossegadís",
    "SENSING_LOUDNESS": "volum del so",
    "SENSING_LOUD": "so fort?",
    "SENSING_TIMER": "cronòmetre",
    "SENSING_RESETTIMER": "reinicia el cronòmetre",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posició x",
    "SENSING_OF_YPOSITION": "posició y",
    "SENSING_OF_DIRECTION": "direcció",
    "SENSING_OF_COSTUMENUMBER": "vestit nr",
    "SENSING_OF_COSTUMENAME": "nom del vestit",
    "SENSING_OF_SIZE": "mida",
    "SENSING_OF_VOLUME": "volum",
    "SENSING_OF_BACKDROPNUMBER": "fons nr",
    "SENSING_OF_BACKDROPNAME": "nom del fons",
    "SENSING_OF_STAGE": "Escenari",
    "SENSING_CURRENT": "actual %1",
    "SENSING_CURRENT_YEAR": "any",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "dia de la setmana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minut",
    "SENSING_CURRENT_SECOND": "segon",
    "SENSING_DAYSSINCE2000": "dies des del 2000",
    "SENSING_USERNAME": "nom d'usuari",
    "SENSING_USERID": "Id. usuari",
    "SOUND_PLAY": "inicia el so %1",
    "SOUND_PLAYUNTILDONE": "toca el so %1 fins que acabi",
    "SOUND_STOPALLSOUNDS": "atura tots els sons",
    "SOUND_SETEFFECTO": "fixa l'efecte %1 a %2",
    "SOUND_CHANGEEFFECTBY": "augmenta l'efecte %1 en %2",
    "SOUND_CLEAREFFECTS": "treu els efectes sonors",
    "SOUND_EFFECTS_PITCH": "altura tonal",
    "SOUND_EFFECTS_PAN": "panoramització esquerra/dreta",
    "SOUND_CHANGEVOLUMEBY": "puja %1 el volum",
    "SOUND_SETVOLUMETO": "fixa el volum a %1%",
    "SOUND_VOLUME": "volum",
    "CATEGORY_MOTION": "Moviment",
    "CATEGORY_LOOKS": "Aspecte",
    "CATEGORY_SOUND": "So",
    "CATEGORY_EVENTS": "Esdeveniments",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensors",
    "CATEGORY_OPERATORS": "Operadors",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "Els meus blocs",
    "DUPLICATE": "Duplica",
    "DELETE": "Elimina",
    "ADD_COMMENT": "Afegir comentari",
    "REMOVE_COMMENT": "Eliminar comentari",
    "DELETE_BLOCK": "Eliminar bloc",
    "DELETE_X_BLOCKS": "Eliminar %1 blocs",
    "DELETE_ALL_BLOCKS": "Eliminar tots els blocs %1 ?",
    "CLEAN_UP": "Netejar blocs",
    "HELP": "Ajuda",
    "UNDO": "Desfer",
    "REDO": "Refer / Tornar a fer",
    "EDIT_PROCEDURE": "Edita",
    "SHOW_PROCEDURE_DEFINITION": "Anar a la definició",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Dir alguna cosa...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturació",
    "COLOUR_BRIGHTNESS_LABEL": "Lluminositat",
    "CHANGE_VALUE_TITLE": "Canviar el valor :",
    "RENAME_VARIABLE": "Canviar el nom de la variable",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Canviar el nom de la variable",
    "NEW_VARIABLE": "Crea una variable",
    "NEW_VARIABLE_TITLE": "Nou nom de variable :",
    "VARIABLE_MODAL_TITLE": "Nova Variable",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Crea un bloc",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Crea una llista",
    "NEW_LIST_TITLE": "Nou nom per la Llista :",
    "LIST_MODAL_TITLE": "Nova Llista",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Canviar el nom de la Llista",
    "NEW_BROADCAST_MESSAGE": "Nou missatge",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nou nom pel missatge :",
    "BROADCAST_MODAL_TITLE": "Missatge nou",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "missatge1"
};

Blockly.ScratchMsgs.locales["cs"] =
{
    "CONTROL_FOREVER": "opakuj stále",
    "CONTROL_REPEAT": "opakuj %1 krát",
    "CONTROL_IF": "když %1 tak",
    "CONTROL_ELSE": "jinak",
    "CONTROL_STOP": "zastav",
    "CONTROL_STOP_ALL": "všechno",
    "CONTROL_STOP_THIS": "tento scénář",
    "CONTROL_STOP_OTHER": "jiné scénáře postavy",
    "CONTROL_WAIT": "čekej %1 sekund",
    "CONTROL_WAITUNTIL": "čekej dokud nenastane %1",
    "CONTROL_REPEATUNTIL": "opakuj dokud nenastane %1",
    "CONTROL_WHILE": "opakuj dokud platí %1",
    "CONTROL_FOREACH": "pro každé %1 z %2",
    "CONTROL_STARTASCLONE": "když startuje můj klon",
    "CONTROL_CREATECLONEOF": "klonuj %1",
    "CONTROL_CREATECLONEOF_MYSELF": "sebe",
    "CONTROL_DELETETHISCLONE": "zruš tento klon",
    "CONTROL_COUNTER": "čítač",
    "CONTROL_INCRCOUNTER": "zvyš čítač",
    "CONTROL_CLEARCOUNTER": "vynuluj čítač",
    "CONTROL_ALLATONCE": "vše najednou",
    "DATA_SETVARIABLETO": "nastav %1 na %2",
    "DATA_CHANGEVARIABLEBY": "změň %1 o %2",
    "DATA_SHOWVARIABLE": "ukaž proměnnou %1",
    "DATA_HIDEVARIABLE": "skryj proměnnou %1",
    "DATA_ADDTOLIST": "přidej %1 k %2",
    "DATA_DELETEOFLIST": "smaž %1 z %2",
    "DATA_INSERTATLIST": "vlož %1 na %2 v %3",
    "DATA_REPLACEITEMOFLIST": "nahraď %1 v %2 hodnotou %3",
    "DATA_ITEMOFLIST": "prvek %1 z %2",
    "DATA_LENGTHOFLIST": "délka %1",
    "DATA_LISTCONTAINSITEM": "%1 obsahuje %2",
    "DATA_SHOWLIST": "ukaž seznam %1",
    "DATA_HIDELIST": "skryj seznam %1",
    "DATA_INDEX_ALL": "všechno",
    "DATA_INDEX_LAST": "poslední",
    "DATA_INDEX_RANDOM": "náhodně",
    "EVENT_WHENFLAGCLICKED": "po kliknutí na %1",
    "EVENT_WHENTHISSPRITECLICKED": "po kliknutí na mě",
    "EVENT_WHENSTAGECLICKED": "po kliknutí na scénu",
    "EVENT_WHENTOUCHINGOBJECT": "po doteku %1",
    "EVENT_WHENBROADCASTRECEIVED": "po obdržení zprávy %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "po změně pozadí na %1",
    "EVENT_WHENGREATERTHAN": "když %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "stopky",
    "EVENT_BROADCAST": "vyšli zprávu %1",
    "EVENT_BROADCASTANDWAIT": "vyšli zprávu %1 a čekej",
    "EVENT_WHENKEYPRESSED": "po stisku klávesy %1",
    "EVENT_WHENKEYPRESSED_SPACE": "mezerník",
    "EVENT_WHENKEYPRESSED_LEFT": "šipka vlevo",
    "EVENT_WHENKEYPRESSED_RIGHT": "šipka vpravo",
    "EVENT_WHENKEYPRESSED_DOWN": "šipka dolů",
    "EVENT_WHENKEYPRESSED_UP": "šipka nahoru",
    "EVENT_WHENKEYPRESSED_ANY": "libovolná",
    "LOOKS_SAYFORSECS": "bublina %1 %2 sekund",
    "LOOKS_SAY": "bublina %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "myšlenka %1 %2 sekund",
    "LOOKS_THINK": "myšlenka %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "ukaž se",
    "LOOKS_HIDE": "skryj se",
    "LOOKS_HIDEALLSPRITES": "skryj všechny postavy",
    "LOOKS_EFFECT_COLOR": "barva",
    "LOOKS_EFFECT_FISHEYE": "rybí oko",
    "LOOKS_EFFECT_WHIRL": "víření",
    "LOOKS_EFFECT_PIXELATE": "kostičkování",
    "LOOKS_EFFECT_MOSAIC": "mozaika",
    "LOOKS_EFFECT_BRIGHTNESS": "jas",
    "LOOKS_EFFECT_GHOST": "průhlednost",
    "LOOKS_CHANGEEFFECTBY": "změň efekt %1 o %2",
    "LOOKS_SETEFFECTTO": "nastav efekt %1 na %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "zruš grafické efekty",
    "LOOKS_CHANGESIZEBY": "změň velikost o %1",
    "LOOKS_SETSIZETO": "nastav velikost na %1 %",
    "LOOKS_SIZE": "velikost",
    "LOOKS_CHANGESTRETCHBY": "změň roztažení o %1",
    "LOOKS_SETSTRETCHTO": "nastav roztažení na %1 %",
    "LOOKS_SWITCHCOSTUMETO": "změň kostým na %1",
    "LOOKS_NEXTCOSTUME": "další kostým",
    "LOOKS_SWITCHBACKDROPTO": "přepni pozadí na %1",
    "LOOKS_GOTOFRONTBACK": "přejdi na vrstvu %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "popředí",
    "LOOKS_GOTOFRONTBACK_BACK": "pozadí",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "jdi %1 o %2",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "dopředu",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "dozadu",
    "LOOKS_BACKDROPNUMBERNAME": "pozadí %1",
    "LOOKS_COSTUMENUMBERNAME": "kostým %1",
    "LOOKS_NUMBERNAME_NUMBER": "číslo",
    "LOOKS_NUMBERNAME_NAME": "název",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "změň pozadí na %1",
    "LOOKS_NEXTBACKDROP": "další pozadí",
    "LOOKS_PREVIOUSBACKDROP": "předchozí pozadí",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "dopředu o %1 kroků",
    "MOTION_TURNLEFT": "otoč se %1 o %2 stupňů",
    "MOTION_TURNRIGHT": "otoč se %1 o %2 stupňů",
    "MOTION_POINTINDIRECTION": "nastav směr %1",
    "MOTION_POINTTOWARDS": "nastav směr k %1",
    "MOTION_POINTTOWARDS_POINTER": "ukazateli myši",
    "MOTION_GOTO": "skoč na %1",
    "MOTION_GOTO_POINTER": "ukazatel myši",
    "MOTION_GOTO_RANDOM": "náhodná pozice",
    "MOTION_GOTOXY": "skoč na x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "klouzej %1 sekund na x: %2 y: %3",
    "MOTION_GLIDETO": "klouzej %1 sekund na %2",
    "MOTION_GLIDETO_POINTER": "ukazatel myši",
    "MOTION_GLIDETO_RANDOM": "náhodná pozice",
    "MOTION_CHANGEXBY": "změň x o %1",
    "MOTION_SETX": "nastav x na %1",
    "MOTION_CHANGEYBY": "změň y o %1",
    "MOTION_SETY": "nastav y na %1",
    "MOTION_IFONEDGEBOUNCE": "když narazíš na okraj, odraž se",
    "MOTION_SETROTATIONSTYLE": "nastav otáčení %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vlevo-vpravo",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "neotáčet",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "dokola",
    "MOTION_XPOSITION": "x",
    "MOTION_YPOSITION": "y",
    "MOTION_DIRECTION": "směr",
    "MOTION_SCROLLRIGHT": "posuň se doprava %1",
    "MOTION_SCROLLUP": "posuň se nahoru %1",
    "MOTION_ALIGNSCENE": "zarovnej scénu %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "vlevo dole",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "vpravo dole",
    "MOTION_ALIGNSCENE_MIDDLE": "prostřední",
    "MOTION_ALIGNSCENE_TOPLEFT": "vlevo nahoře",
    "MOTION_ALIGNSCENE_TOPRIGHT": "vpravo nahoře",
    "MOTION_XSCROLL": "x přesouvání",
    "MOTION_YSCROLL": "y přesouvání",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "náhodné číslo od %1 do %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 a %2",
    "OPERATORS_OR": "%1 nebo %2",
    "OPERATORS_NOT": "ne %1",
    "OPERATORS_JOIN": "spoj %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "písmeno %1 z %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "délka %1",
    "OPERATORS_CONTAINS": "%1 obsahuje %2?",
    "OPERATORS_MOD": "zbytek %1 děleno %2",
    "OPERATORS_ROUND": "zaokrouhli %1",
    "OPERATORS_MATHOP": "%1 %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "zaokr. dolů",
    "OPERATORS_MATHOP_CEILING": "zaokr. nahoru",
    "OPERATORS_MATHOP_SQRT": "odmocnina",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctg",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "scénář pro %1",
    "SENSING_TOUCHINGOBJECT": "dotýkáš se %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "ukazatele myši",
    "SENSING_TOUCHINGOBJECT_EDGE": "okraje",
    "SENSING_TOUCHINGCOLOR": "dotýkáš se barvy %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "barvou %1 se dotýkáš %2?",
    "SENSING_DISTANCETO": "vzdálenost k %1",
    "SENSING_DISTANCETO_POINTER": "ukazateli myši",
    "SENSING_ASKANDWAIT": "otázka %1",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "odpověď",
    "SENSING_KEYPRESSED": "klávesa %1 stisknuta?",
    "SENSING_MOUSEDOWN": "myš stisknuta?",
    "SENSING_MOUSEX": "x myši",
    "SENSING_MOUSEY": "y myši",
    "SENSING_SETDRAGMODE": "povoleno přesouvat %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ano",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ne",
    "SENSING_LOUDNESS": "hlasitost",
    "SENSING_LOUD": "hlasité?",
    "SENSING_TIMER": "stopky",
    "SENSING_RESETTIMER": "vynuluj stopky",
    "SENSING_OF": "%1 z %2",
    "SENSING_OF_XPOSITION": "x",
    "SENSING_OF_YPOSITION": "y",
    "SENSING_OF_DIRECTION": "směr",
    "SENSING_OF_COSTUMENUMBER": "číslo kostýmu",
    "SENSING_OF_COSTUMENAME": "název kostýmu",
    "SENSING_OF_SIZE": "velikost",
    "SENSING_OF_VOLUME": "hlasitost",
    "SENSING_OF_BACKDROPNUMBER": "číslo pozadí",
    "SENSING_OF_BACKDROPNAME": "název pozadí",
    "SENSING_OF_STAGE": "Scéna",
    "SENSING_CURRENT": "aktuální %1",
    "SENSING_CURRENT_YEAR": "rok",
    "SENSING_CURRENT_MONTH": "měsíc",
    "SENSING_CURRENT_DATE": "den v měsíci",
    "SENSING_CURRENT_DAYOFWEEK": "den týdne",
    "SENSING_CURRENT_HOUR": "hodina",
    "SENSING_CURRENT_MINUTE": "minuta",
    "SENSING_CURRENT_SECOND": "sekunda",
    "SENSING_DAYSSINCE2000": "dnů od r. 2000",
    "SENSING_USERNAME": "jméno uživatele",
    "SENSING_USERID": "ID uživatele",
    "SOUND_PLAY": "začni hrát zvuk %1",
    "SOUND_PLAYUNTILDONE": "přehraj zvuk %1 až do konce",
    "SOUND_STOPALLSOUNDS": "zastav všechny zvuky",
    "SOUND_SETEFFECTO": "nastav efekt %1 na %2",
    "SOUND_CHANGEEFFECTBY": "změň efekt %1 o %2",
    "SOUND_CLEAREFFECTS": "zruš zvukové efekty",
    "SOUND_EFFECTS_PITCH": "poloha",
    "SOUND_EFFECTS_PAN": "stereo vlevo/vpravo",
    "SOUND_CHANGEVOLUMEBY": "změň hlasitost o %1",
    "SOUND_SETVOLUMETO": "nastav hlasitost na %1%",
    "SOUND_VOLUME": "hlasitost",
    "CATEGORY_MOTION": "Pohyb",
    "CATEGORY_LOOKS": "Vzhled",
    "CATEGORY_SOUND": "Zvuk",
    "CATEGORY_EVENTS": "Události",
    "CATEGORY_CONTROL": "Ovládání",
    "CATEGORY_SENSING": "Vnímání",
    "CATEGORY_OPERATORS": "Operátory",
    "CATEGORY_VARIABLES": "Proměnné",
    "CATEGORY_MYBLOCKS": "Moje bloky",
    "DUPLICATE": "Kopírovat",
    "DELETE": "Odstranit",
    "ADD_COMMENT": "Přidat poznámku",
    "REMOVE_COMMENT": "Odstranit poznámku",
    "DELETE_BLOCK": "Smaž blok",
    "DELETE_X_BLOCKS": "Smazat %1 bloků",
    "DELETE_ALL_BLOCKS": "Smazat všech %1 bloků?",
    "CLEAN_UP": "Ukliď bloky",
    "HELP": "Pomoc",
    "UNDO": "Vrátit",
    "REDO": "Znovu provést",
    "EDIT_PROCEDURE": "Upravit",
    "SHOW_PROCEDURE_DEFINITION": "Jdi ke scénáři",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Řekni něco ...",
    "COLOUR_HUE_LABEL": "Barva",
    "COLOUR_SATURATION_LABEL": "Sytost",
    "COLOUR_BRIGHTNESS_LABEL": "Jas",
    "CHANGE_VALUE_TITLE": "Změň hodnotu:",
    "RENAME_VARIABLE": "Přejmenovat proměnnou",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Přejmenovat proměnnou",
    "NEW_VARIABLE": "Vytvoř proměnnou",
    "NEW_VARIABLE_TITLE": "Nové jméno proměnné:",
    "VARIABLE_MODAL_TITLE": "Nová proměnná",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Vytvořit blok",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Vytvoř seznam",
    "NEW_LIST_TITLE": "Nový název seznamu:",
    "LIST_MODAL_TITLE": "Nový seznam",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Přejmenuj seznam",
    "NEW_BROADCAST_MESSAGE": "Nová zpráva",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nový název zprávy:",
    "BROADCAST_MODAL_TITLE": "Nová zpráva",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "zpráva1"
};

Blockly.ScratchMsgs.locales["cy"] =
{
    "CONTROL_FOREVER": "am byth",
    "CONTROL_REPEAT": "ailadrodd %1",
    "CONTROL_IF": "os %1 yna",
    "CONTROL_ELSE": "fel arall",
    "CONTROL_STOP": "aros",
    "CONTROL_STOP_ALL": "y cyfan",
    "CONTROL_STOP_THIS": "y sgript hon",
    "CONTROL_STOP_OTHER": "sgriptiau eraill yn y ciplun",
    "CONTROL_WAIT": "aros %1 eiliad",
    "CONTROL_WAITUNTIL": "aros hyd at %1",
    "CONTROL_REPEATUNTIL": "ailadrodd hyd at %1",
    "CONTROL_WHILE": "tra bo %1",
    "CONTROL_FOREACH": "am bob %1 yn %2",
    "CONTROL_STARTASCLONE": "pan rwyf yn dechrau fel clôn",
    "CONTROL_CREATECLONEOF": "creu clôn o %1",
    "CONTROL_CREATECLONEOF_MYSELF": "fi fy hun",
    "CONTROL_DELETETHISCLONE": "dileu y clôn hwn",
    "CONTROL_COUNTER": "rhifydd",
    "CONTROL_INCRCOUNTER": "rhifydd cynyddiad",
    "CONTROL_CLEARCOUNTER": "clirio'r rhifydd",
    "CONTROL_ALLATONCE": "pob un ar unwaith",
    "DATA_SETVARIABLETO": "gosod %1 i %2",
    "DATA_CHANGEVARIABLEBY": "newid %1 gan %2",
    "DATA_SHOWVARIABLE": "dangos newidyn %1",
    "DATA_HIDEVARIABLE": "cuddio newidyn %1",
    "DATA_ADDTOLIST": "ychwanegu %1 i %2",
    "DATA_DELETEOFLIST": "dileu %1 o %2",
    "DATA_INSERTATLIST": "mewnosod %1 yn %2 o %3",
    "DATA_REPLACEITEMOFLIST": "amnewid eitem %1 o %2 gyda %3",
    "DATA_ITEMOFLIST": "eitem %1 o %2",
    "DATA_LENGTHOFLIST": "hyd %1",
    "DATA_LISTCONTAINSITEM": "%1 yn cynnwys %2?",
    "DATA_SHOWLIST": "dangos rhestr %1",
    "DATA_HIDELIST": "cuddio rhestr %1",
    "DATA_INDEX_ALL": "y cyfan",
    "DATA_INDEX_LAST": "olaf",
    "DATA_INDEX_RANDOM": "ar hap",
    "EVENT_WHENFLAGCLICKED": "pan fydd %1 wedi ei glicio",
    "EVENT_WHENTHISSPRITECLICKED": "pan gaiff y ciplun yma ei glicio",
    "EVENT_WHENSTAGECLICKED": "pan fydd llwyfan wedi ei glicio",
    "EVENT_WHENTOUCHINGOBJECT": "when this sprite touches %1",
    "EVENT_WHENBROADCASTRECEIVED": "pan rwy'n derbyn %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "pan fydd cefndir yn newid i %1",
    "EVENT_WHENGREATERTHAN": "pan %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "amserydd",
    "EVENT_BROADCAST": "darlledu  %1",
    "EVENT_BROADCASTANDWAIT": "darlledu %1 ac aros",
    "EVENT_WHENKEYPRESSED": "pan fo bysell %1 wedi ei wasgu",
    "EVENT_WHENKEYPRESSED_SPACE": "bwlch",
    "EVENT_WHENKEYPRESSED_LEFT": "saeth chwith",
    "EVENT_WHENKEYPRESSED_RIGHT": "saeth de",
    "EVENT_WHENKEYPRESSED_DOWN": "saeth i lawr",
    "EVENT_WHENKEYPRESSED_UP": "saeth i fyny",
    "EVENT_WHENKEYPRESSED_ANY": "unrhyw",
    "LOOKS_SAYFORSECS": "dweud %1 am %2 eiliad",
    "LOOKS_SAY": "dweud %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "meddwl %1 am %2 eiliad",
    "LOOKS_THINK": "meddwl %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "dangos",
    "LOOKS_HIDE": "cuddio",
    "LOOKS_HIDEALLSPRITES": "cuddio pob ciplun",
    "LOOKS_EFFECT_COLOR": "lliw",
    "LOOKS_EFFECT_FISHEYE": "llygaid pysgodyn",
    "LOOKS_EFFECT_WHIRL": "chwyrliad",
    "LOOKS_EFFECT_PIXELATE": "picseleiddio",
    "LOOKS_EFFECT_MOSAIC": "mosaig",
    "LOOKS_EFFECT_BRIGHTNESS": "disgleirdeb",
    "LOOKS_EFFECT_GHOST": "ysbryd",
    "LOOKS_CHANGEEFFECTBY": "newid effaith %1 gan %2",
    "LOOKS_SETEFFECTTO": "gosod effaith %1 effaith i %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "clirio effeithiau graffeg",
    "LOOKS_CHANGESIZEBY": "newid maint gan %1",
    "LOOKS_SETSIZETO": "gosod maint i %1 %",
    "LOOKS_SIZE": "maint",
    "LOOKS_CHANGESTRETCHBY": "newid yr ymestyn gan %1",
    "LOOKS_SETSTRETCHTO": "gosod ymestyniad gan %1 %",
    "LOOKS_SWITCHCOSTUMETO": "newid gwisg i %1",
    "LOOKS_NEXTCOSTUME": "gwisg nesaf",
    "LOOKS_SWITCHBACKDROPTO": "newid cefndir i %1",
    "LOOKS_GOTOFRONTBACK": "mynd i haen %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "blaen",
    "LOOKS_GOTOFRONTBACK_BACK": "cefn",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "mynd i haenau %1 %2",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ymlaen",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "nôl",
    "LOOKS_BACKDROPNUMBERNAME": "cefnlen %1",
    "LOOKS_COSTUMENUMBERNAME": "gwisg %1",
    "LOOKS_NUMBERNAME_NUMBER": "rhif",
    "LOOKS_NUMBERNAME_NAME": "enw",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "newid cefnlen i %1 ac aros",
    "LOOKS_NEXTBACKDROP": "cefnlen nesaf",
    "LOOKS_PREVIOUSBACKDROP": "cefndir blaenorol",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "symud %1 cam",
    "MOTION_TURNLEFT": "troi %1 %2 gradd",
    "MOTION_TURNRIGHT": "troi %1 %2 gradd",
    "MOTION_POINTINDIRECTION": "pwyntio i gyfeiriad %1",
    "MOTION_POINTTOWARDS": "pwyntio tuag at %1",
    "MOTION_POINTTOWARDS_POINTER": "pwyntydd llygoden",
    "MOTION_GOTO": "mynd i %1",
    "MOTION_GOTO_POINTER": "pwyntydd llygoden",
    "MOTION_GOTO_RANDOM": "safle ar hap",
    "MOTION_GOTOXY": "mynd i x:%1 y: %2",
    "MOTION_GLIDESECSTOXY": "llithro %1 eiliad i x: %2 y: %3",
    "MOTION_GLIDETO": "llithro %1 eiliad i %2",
    "MOTION_GLIDETO_POINTER": "pwyntydd llygoden",
    "MOTION_GLIDETO_RANDOM": "safle ar hap",
    "MOTION_CHANGEXBY": "newid x gan %1",
    "MOTION_SETX": "gosod x i %1",
    "MOTION_CHANGEYBY": "newid y gan %1",
    "MOTION_SETY": "gosod y i %1",
    "MOTION_IFONEDGEBOUNCE": "os ar ymyl, bowndio",
    "MOTION_SETROTATIONSTYLE": "gosod steil cylchdroi %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "chwith-dde",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "peidio troi",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "o amgylch",
    "MOTION_XPOSITION": "safle x",
    "MOTION_YPOSITION": "safle y",
    "MOTION_DIRECTION": "cyfeiriad",
    "MOTION_SCROLLRIGHT": "sgrolio i'r dde %1",
    "MOTION_SCROLLUP": "sgrolio i fyny %1",
    "MOTION_ALIGNSCENE": "alinio golygfa %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "gwaelod chwith",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "gwaelod de",
    "MOTION_ALIGNSCENE_MIDDLE": "canol",
    "MOTION_ALIGNSCENE_TOPLEFT": "brig chwith",
    "MOTION_ALIGNSCENE_TOPRIGHT": "brig de",
    "MOTION_XSCROLL": "sgrolio x",
    "MOTION_YSCROLL": "sgrolio y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "dewis ar hap %1 i %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 a %2",
    "OPERATORS_OR": "%1 neu %2",
    "OPERATORS_NOT": "nid %1",
    "OPERATORS_JOIN": "uno %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "llythyren %1 o %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "hyd %1",
    "OPERATORS_CONTAINS": "%1 yn cynnwys %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "talgrynnu %1",
    "OPERATORS_MATHOP": "%1 o %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "llawr",
    "OPERATORS_MATHOP_CEILING": "nenfwd",
    "OPERATORS_MATHOP_SQRT": "ail isradd",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "Yn",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "diffinio %1",
    "SENSING_TOUCHINGOBJECT": "cyffwrdd %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "pwyntydd llygoden",
    "SENSING_TOUCHINGOBJECT_EDGE": "ymyl",
    "SENSING_TOUCHINGCOLOR": "cyffwrdd lliw %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "lliw %1 yn cyffwrdd %2?",
    "SENSING_DISTANCETO": "pellter i %1",
    "SENSING_DISTANCETO_POINTER": "pwyntydd llygoden",
    "SENSING_ASKANDWAIT": "gofyn %1 ac aros",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "ateb",
    "SENSING_KEYPRESSED": "bysell %1 wedi ei phwyso",
    "SENSING_MOUSEDOWN": "llygoden i lawr?",
    "SENSING_MOUSEX": "llygoden x",
    "SENSING_MOUSEY": "llygoden y",
    "SENSING_SETDRAGMODE": "gosod y modd llusgo %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "llusgadwy",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "anllusgadwy",
    "SENSING_LOUDNESS": "cryfder sain",
    "SENSING_LOUD": "sain gref?",
    "SENSING_TIMER": "amserydd",
    "SENSING_RESETTIMER": "ailosod amserydd",
    "SENSING_OF": "%1 o %2",
    "SENSING_OF_XPOSITION": "safle x",
    "SENSING_OF_YPOSITION": "safle y",
    "SENSING_OF_DIRECTION": "cyfeiriad",
    "SENSING_OF_COSTUMENUMBER": "gwisg #",
    "SENSING_OF_COSTUMENAME": "enw'r wisg",
    "SENSING_OF_SIZE": "maint",
    "SENSING_OF_VOLUME": "lefel sain",
    "SENSING_OF_BACKDROPNUMBER": "cefndir #",
    "SENSING_OF_BACKDROPNAME": "enw cefndir",
    "SENSING_OF_STAGE": "Llwyfan",
    "SENSING_CURRENT": "cyfredol %1",
    "SENSING_CURRENT_YEAR": "blwyddyn",
    "SENSING_CURRENT_MONTH": "mis",
    "SENSING_CURRENT_DATE": "dyddiad",
    "SENSING_CURRENT_DAYOFWEEK": "diwrnod o'r wythnos",
    "SENSING_CURRENT_HOUR": "awr",
    "SENSING_CURRENT_MINUTE": "munud",
    "SENSING_CURRENT_SECOND": "eiliad",
    "SENSING_DAYSSINCE2000": "dyddiau ers 2000",
    "SENSING_USERNAME": "enw defnyddiwr",
    "SENSING_USERID": "id defnyddiwr",
    "SOUND_PLAY": "cychwyn sain %1",
    "SOUND_PLAYUNTILDONE": "chwarae sain %1 tan y diwedd",
    "SOUND_STOPALLSOUNDS": "atal pob sain",
    "SOUND_SETEFFECTO": "gosod effaith %1 effaith i %2",
    "SOUND_CHANGEEFFECTBY": "newid effaith %1 gan %2",
    "SOUND_CLEAREFFECTS": "clirio effeithiau sain",
    "SOUND_EFFECTS_PITCH": "traw",
    "SOUND_EFFECTS_PAN": "troi chwith/de",
    "SOUND_CHANGEVOLUMEBY": "newid uchder sain gan %1",
    "SOUND_SETVOLUMETO": "gosod lefel sain i %1%",
    "SOUND_VOLUME": "lefel sain",
    "CATEGORY_MOTION": "Symudiad",
    "CATEGORY_LOOKS": "Edrychiad",
    "CATEGORY_SOUND": "Sain",
    "CATEGORY_EVENTS": "Digwyddiadau",
    "CATEGORY_CONTROL": "Rheoli",
    "CATEGORY_SENSING": "Synhwyro",
    "CATEGORY_OPERATORS": "Gweithredwyr",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "My Blocks",
    "DUPLICATE": "Dyblygu",
    "DELETE": "Dileu",
    "ADD_COMMENT": "Add Comment",
    "REMOVE_COMMENT": "Remove Comment",
    "DELETE_BLOCK": "Delete Block",
    "DELETE_X_BLOCKS": "Delete %1 Blocks",
    "DELETE_ALL_BLOCKS": "Delete all %1 blocks?",
    "CLEAN_UP": "Clean up Blocks",
    "HELP": "Cymorth",
    "UNDO": "Dadwneud",
    "REDO": "Ailwneud",
    "EDIT_PROCEDURE": "Golygu",
    "SHOW_PROCEDURE_DEFINITION": "Go to definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Say something...",
    "COLOUR_HUE_LABEL": "Lliw",
    "COLOUR_SATURATION_LABEL": "Dirlawnder",
    "COLOUR_BRIGHTNESS_LABEL": "Disgleirdeb",
    "CHANGE_VALUE_TITLE": "Change value:",
    "RENAME_VARIABLE": "Rename variable",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Rename Variable",
    "NEW_VARIABLE": "Creu Newidyn",
    "NEW_VARIABLE_TITLE": "New variable name:",
    "VARIABLE_MODAL_TITLE": "Newidyn Newydd",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Creu Bloc",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Gwneud Rhestr",
    "NEW_LIST_TITLE": "New list name:",
    "LIST_MODAL_TITLE": "Rhestr Newydd",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Rename List",
    "NEW_BROADCAST_MESSAGE": "New message",
    "NEW_BROADCAST_MESSAGE_TITLE": "New message name:",
    "BROADCAST_MODAL_TITLE": "Neges Newydd",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "neges1"
};

Blockly.ScratchMsgs.locales["da"] =
{
    "CONTROL_FOREVER": "for evigt",
    "CONTROL_REPEAT": "gentag %1",
    "CONTROL_IF": "hvis %1 så",
    "CONTROL_ELSE": "ellers",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "alle",
    "CONTROL_STOP_THIS": "dette script",
    "CONTROL_STOP_OTHER": "andre scripts i sprite",
    "CONTROL_WAIT": "vent %1 sekunder",
    "CONTROL_WAITUNTIL": "vent indtil %1",
    "CONTROL_REPEATUNTIL": "gentag indtil %1",
    "CONTROL_WHILE": "mens %1",
    "CONTROL_FOREACH": "for hver %1 i %2",
    "CONTROL_STARTASCLONE": "når jeg starter som klon",
    "CONTROL_CREATECLONEOF": "opret en klon af %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mig selv",
    "CONTROL_DELETETHISCLONE": "slet denne klon",
    "CONTROL_COUNTER": "tæller",
    "CONTROL_INCRCOUNTER": "tæl tæller op",
    "CONTROL_CLEARCOUNTER": "nulstil tæller",
    "CONTROL_ALLATONCE": "alle på en gang",
    "DATA_SETVARIABLETO": "sæt %1 til %2",
    "DATA_CHANGEVARIABLEBY": "ændre %1 med %2",
    "DATA_SHOWVARIABLE": "vis variabel %1",
    "DATA_HIDEVARIABLE": "skjul variabel %1",
    "DATA_ADDTOLIST": "tilføj %1 til %2",
    "DATA_DELETEOFLIST": "slet %1 af %2",
    "DATA_INSERTATLIST": "indsæt %1 ved %2 af %3",
    "DATA_REPLACEITEMOFLIST": "erstat objekt %1 af %2 med %3",
    "DATA_ITEMOFLIST": "objekt %1 af %2",
    "DATA_LENGTHOFLIST": "længden af %1",
    "DATA_LISTCONTAINSITEM": "%1 indeholder %2?",
    "DATA_SHOWLIST": "vis liste %1",
    "DATA_HIDELIST": "skjul liste %1",
    "DATA_INDEX_ALL": "alle",
    "DATA_INDEX_LAST": "sidste",
    "DATA_INDEX_RANDOM": "tilfældig",
    "EVENT_WHENFLAGCLICKED": "når der klikkes på %1 ",
    "EVENT_WHENTHISSPRITECLICKED": "når denne sprite klikkes",
    "EVENT_WHENSTAGECLICKED": "når scene er valgt",
    "EVENT_WHENTOUCHINGOBJECT": "når denne sprite berører %1",
    "EVENT_WHENBROADCASTRECEIVED": "når jeg modtager %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "når baggrund skifter til %1",
    "EVENT_WHENGREATERTHAN": "når %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "stopur",
    "EVENT_BROADCAST": "send %1",
    "EVENT_BROADCASTANDWAIT": "send %1 og vent",
    "EVENT_WHENKEYPRESSED": "når du trykker på %1",
    "EVENT_WHENKEYPRESSED_SPACE": "mellemrum",
    "EVENT_WHENKEYPRESSED_LEFT": "venstre pil",
    "EVENT_WHENKEYPRESSED_RIGHT": "højre pil",
    "EVENT_WHENKEYPRESSED_DOWN": "pil nedad",
    "EVENT_WHENKEYPRESSED_UP": "pil opad",
    "EVENT_WHENKEYPRESSED_ANY": "vilkårlig",
    "LOOKS_SAYFORSECS": "sig %1 i %2 sekunder",
    "LOOKS_SAY": "sig %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "tænke %1 i %2 sekunder",
    "LOOKS_THINK": "tænk %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "vis",
    "LOOKS_HIDE": "skjul",
    "LOOKS_HIDEALLSPRITES": "skjul alle sprites",
    "LOOKS_EFFECT_COLOR": "farve",
    "LOOKS_EFFECT_FISHEYE": "fiskeøje",
    "LOOKS_EFFECT_WHIRL": "vrid",
    "LOOKS_EFFECT_PIXELATE": "pixeler",
    "LOOKS_EFFECT_MOSAIC": "mosaik",
    "LOOKS_EFFECT_BRIGHTNESS": "lysstyrke",
    "LOOKS_EFFECT_GHOST": "spøgelse",
    "LOOKS_CHANGEEFFECTBY": "ændr effekt %1 med %2",
    "LOOKS_SETEFFECTTO": "sæt effekt %1 til %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "fjern grafiske effekter",
    "LOOKS_CHANGESIZEBY": "ændre størrelse med %1",
    "LOOKS_SETSIZETO": "sæt størrelse til %1 %",
    "LOOKS_SIZE": "størrelse",
    "LOOKS_CHANGESTRETCHBY": "ændre stræk med %1",
    "LOOKS_SETSTRETCHTO": "sæt stræk til %1 %",
    "LOOKS_SWITCHCOSTUMETO": "skift kostume til %1",
    "LOOKS_NEXTCOSTUME": "næste kostume",
    "LOOKS_SWITCHBACKDROPTO": "skift baggrund til %1",
    "LOOKS_GOTOFRONTBACK": "gå til %1 lag",
    "LOOKS_GOTOFRONTBACK_FRONT": "forreste",
    "LOOKS_GOTOFRONTBACK_BACK": "bagerste",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gå %2 lag %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "frem",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "tilbage",
    "LOOKS_BACKDROPNUMBERNAME": "baggrund %1",
    "LOOKS_COSTUMENUMBERNAME": "kostume %1",
    "LOOKS_NUMBERNAME_NUMBER": "nummer",
    "LOOKS_NUMBERNAME_NAME": "navn",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "skift baggrund til %1 og vent",
    "LOOKS_NEXTBACKDROP": "næste baggrund",
    "LOOKS_PREVIOUSBACKDROP": "forrige baggrund",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "gå %1 trin",
    "MOTION_TURNLEFT": "drej %1 %2 grader",
    "MOTION_TURNRIGHT": "drej %1 %2 grader",
    "MOTION_POINTINDIRECTION": "peg i retning %1",
    "MOTION_POINTTOWARDS": "peg mod %1",
    "MOTION_POINTTOWARDS_POINTER": "musepil",
    "MOTION_GOTO": "gå til %1",
    "MOTION_GOTO_POINTER": "musepil",
    "MOTION_GOTO_RANDOM": "tilfældig position",
    "MOTION_GOTOXY": "gå til x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glid %1 sekunder til x: %2 y: %3",
    "MOTION_GLIDETO": "glid %1 sekunder til %2",
    "MOTION_GLIDETO_POINTER": "musepil",
    "MOTION_GLIDETO_RANDOM": "tilfældig position",
    "MOTION_CHANGEXBY": "ændre x med %1",
    "MOTION_SETX": "sæt x til %1",
    "MOTION_CHANGEYBY": "ændre y med %1",
    "MOTION_SETY": "sæt y til %1",
    "MOTION_IFONEDGEBOUNCE": "hop tilbage ved kanten",
    "MOTION_SETROTATIONSTYLE": "sæt rotationsstil til %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "venstre-højre",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "drej ikke",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "alle retninger",
    "MOTION_XPOSITION": "x position",
    "MOTION_YPOSITION": "y position",
    "MOTION_DIRECTION": "retning",
    "MOTION_SCROLLRIGHT": "rul mod højre %1",
    "MOTION_SCROLLUP": "rul op %1",
    "MOTION_ALIGNSCENE": "tilpas scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "nederst-til-venstre",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "nederst-til-højre",
    "MOTION_ALIGNSCENE_MIDDLE": "midten",
    "MOTION_ALIGNSCENE_TOPLEFT": "øverst-til-venstre",
    "MOTION_ALIGNSCENE_TOPRIGHT": "øverst-til-højre",
    "MOTION_XSCROLL": "x rul",
    "MOTION_YSCROLL": "y rul",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "vælg tilfældigt mellem %1 og %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 og %2",
    "OPERATORS_OR": "%1 eller %2",
    "OPERATORS_NOT": "ikke %1",
    "OPERATORS_JOIN": "%1 tilkobles %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "bogstav %1 af %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "længden af %1",
    "OPERATORS_CONTAINS": "%1 indeholder %2?",
    "OPERATORS_MOD": "%1 modulus %2",
    "OPERATORS_ROUND": "afrund %1",
    "OPERATORS_MATHOP": "%1 af %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "gulv",
    "OPERATORS_MATHOP_CEILING": "loft",
    "OPERATORS_MATHOP_SQRT": "kvrod",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definer %1",
    "SENSING_TOUCHINGOBJECT": "berører %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "musepil",
    "SENSING_TOUCHINGOBJECT_EDGE": "kant",
    "SENSING_TOUCHINGCOLOR": "berører farven %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "berører %1 farven %2?",
    "SENSING_DISTANCETO": "afstand til %1",
    "SENSING_DISTANCETO_POINTER": "musepil",
    "SENSING_ASKANDWAIT": "bed om %1 og vent",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "svar",
    "SENSING_KEYPRESSED": "trykket på tasten %1?",
    "SENSING_MOUSEDOWN": "trykket på musen?",
    "SENSING_MOUSEX": "musens x-position",
    "SENSING_MOUSEY": "musens y-position",
    "SENSING_SETDRAGMODE": "sæt træk %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "kan trækkes",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "kan ikke trækkes",
    "SENSING_LOUDNESS": "lydstyrke",
    "SENSING_LOUD": "højt?",
    "SENSING_TIMER": "stopur",
    "SENSING_RESETTIMER": "nulstil stopur",
    "SENSING_OF": "%1 af %2",
    "SENSING_OF_XPOSITION": "x position",
    "SENSING_OF_YPOSITION": "y position",
    "SENSING_OF_DIRECTION": "retning",
    "SENSING_OF_COSTUMENUMBER": "kostume #",
    "SENSING_OF_COSTUMENAME": "navn på kostume",
    "SENSING_OF_SIZE": "størrelse",
    "SENSING_OF_VOLUME": "lydstyrke",
    "SENSING_OF_BACKDROPNUMBER": "baggrund #",
    "SENSING_OF_BACKDROPNAME": "navn på baggrund",
    "SENSING_OF_STAGE": "Scene",
    "SENSING_CURRENT": "nuværende %1",
    "SENSING_CURRENT_YEAR": "år",
    "SENSING_CURRENT_MONTH": "måned",
    "SENSING_CURRENT_DATE": "dato",
    "SENSING_CURRENT_DAYOFWEEK": "ugedag",
    "SENSING_CURRENT_HOUR": "time",
    "SENSING_CURRENT_MINUTE": "minut",
    "SENSING_CURRENT_SECOND": "sekund",
    "SENSING_DAYSSINCE2000": "dage siden 2000",
    "SENSING_USERNAME": "brugernavn",
    "SENSING_USERID": "bruger id",
    "SOUND_PLAY": "spil lyden %1",
    "SOUND_PLAYUNTILDONE": "spil lyden %1 indtil færdig",
    "SOUND_STOPALLSOUNDS": "stop al lyd",
    "SOUND_SETEFFECTO": "sæt effekt %1 til %2",
    "SOUND_CHANGEEFFECTBY": "ændr effekt %1 med %2",
    "SOUND_CLEAREFFECTS": "fjern lydeffekter",
    "SOUND_EFFECTS_PITCH": "tonehøjde",
    "SOUND_EFFECTS_PAN": "balance venstre/højre",
    "SOUND_CHANGEVOLUMEBY": "ændr lydstyrke med %1",
    "SOUND_SETVOLUMETO": "sæt lydstyrke til %1%",
    "SOUND_VOLUME": "lydstyrke",
    "CATEGORY_MOTION": "Bevægelse",
    "CATEGORY_LOOKS": "Udseende",
    "CATEGORY_SOUND": "Lyd",
    "CATEGORY_EVENTS": "Hændelser",
    "CATEGORY_CONTROL": "Kontrol",
    "CATEGORY_SENSING": "Registrering",
    "CATEGORY_OPERATORS": "Operatorer",
    "CATEGORY_VARIABLES": "Variabler",
    "CATEGORY_MYBLOCKS": "Mine brikker",
    "DUPLICATE": "Kopiér",
    "DELETE": "Slet",
    "ADD_COMMENT": "Tilføj kommentar",
    "REMOVE_COMMENT": "Slet kommentar",
    "DELETE_BLOCK": "Slet brik",
    "DELETE_X_BLOCKS": "Slet %1 brikker",
    "DELETE_ALL_BLOCKS": "Slet alle %1 brikker?",
    "CLEAN_UP": "Ryd brikkerne op",
    "HELP": "Hjælp",
    "UNDO": "Fortryd",
    "REDO": "Gør om",
    "EDIT_PROCEDURE": "Redigér",
    "SHOW_PROCEDURE_DEFINITION": "Gå til forklaring",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Sig noget...",
    "COLOUR_HUE_LABEL": "Farve",
    "COLOUR_SATURATION_LABEL": "Farvemætning",
    "COLOUR_BRIGHTNESS_LABEL": "Lysstyrke",
    "CHANGE_VALUE_TITLE": "Ændre værdien:",
    "RENAME_VARIABLE": "Omdøb variabel",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Omdøb variabel",
    "NEW_VARIABLE": "Lav en variabel",
    "NEW_VARIABLE_TITLE": "Navn på ny variabel:",
    "VARIABLE_MODAL_TITLE": "Ny variabel",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Lav en brik",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Lav en liste",
    "NEW_LIST_TITLE": "Navn på ny liste:",
    "LIST_MODAL_TITLE": "Ny liste",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Omdøb liste",
    "NEW_BROADCAST_MESSAGE": "Ny besked",
    "NEW_BROADCAST_MESSAGE_TITLE": "Navn på ny besked:",
    "BROADCAST_MODAL_TITLE": "Ny besked",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "besked1"
};

Blockly.ScratchMsgs.locales["de"] =
{
    "CONTROL_FOREVER": "wiederhole fortlaufend",
    "CONTROL_REPEAT": "wiederhole %1 mal",
    "CONTROL_IF": "falls %1, dann",
    "CONTROL_ELSE": "sonst",
    "CONTROL_STOP": "stoppe",
    "CONTROL_STOP_ALL": "alles",
    "CONTROL_STOP_THIS": "dieses Skript",
    "CONTROL_STOP_OTHER": "andere Skripte der Figur",
    "CONTROL_WAIT": "warte %1 Sekunden",
    "CONTROL_WAITUNTIL": "warte bis %1",
    "CONTROL_REPEATUNTIL": "wiederhole bis %1",
    "CONTROL_WHILE": "wiederhole solange %1",
    "CONTROL_FOREACH": "wiederhole für jedes %1 in %2",
    "CONTROL_STARTASCLONE": "Wenn ich als Klon entstehe",
    "CONTROL_CREATECLONEOF": "erzeuge Klon von %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mir selbst",
    "CONTROL_DELETETHISCLONE": "lösche diesen Klon",
    "CONTROL_COUNTER": "Zähler",
    "CONTROL_INCRCOUNTER": "erhöhe Zähler",
    "CONTROL_CLEARCOUNTER": "lösche Zähler",
    "CONTROL_ALLATONCE": "Alle gleichzeitig",
    "DATA_SETVARIABLETO": "setze %1 auf %2",
    "DATA_CHANGEVARIABLEBY": "ändere %1 um %2",
    "DATA_SHOWVARIABLE": "zeige Variable %1",
    "DATA_HIDEVARIABLE": "verstecke Variable %1",
    "DATA_ADDTOLIST": "füge %1 zu %2 hinzu",
    "DATA_DELETEOFLIST": "lösche %1 von %2",
    "DATA_INSERTATLIST": "füge %1 an %2 von %3 ein",
    "DATA_REPLACEITEMOFLIST": "ersetze Element %1 von %2 durch %3",
    "DATA_ITEMOFLIST": "Element %1 von %2",
    "DATA_LENGTHOFLIST": "Länge von %1",
    "DATA_LISTCONTAINSITEM": "%1 enthält %2?",
    "DATA_SHOWLIST": "zeige Liste %1",
    "DATA_HIDELIST": "verstecke Liste %1",
    "DATA_INDEX_ALL": "alles",
    "DATA_INDEX_LAST": "letztes",
    "DATA_INDEX_RANDOM": "zufälliges",
    "EVENT_WHENFLAGCLICKED": "Wenn %1 angeklickt",
    "EVENT_WHENTHISSPRITECLICKED": "Wenn diese Figur angeklickt",
    "EVENT_WHENSTAGECLICKED": "Wenn Bühne angeklickt",
    "EVENT_WHENTOUCHINGOBJECT": "Wenn diese Figur %1 berührt",
    "EVENT_WHENBROADCASTRECEIVED": "Wenn ich %1 empfange",
    "EVENT_WHENBACKDROPSWITCHESTO": "Wenn das Bühnenbild zu %1 wechselt",
    "EVENT_WHENGREATERTHAN": "Wenn %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "Stoppuhr",
    "EVENT_BROADCAST": "sende %1 an alle",
    "EVENT_BROADCASTANDWAIT": "sende %1 an alle und warte",
    "EVENT_WHENKEYPRESSED": "Wenn Taste %1 gedrückt",
    "EVENT_WHENKEYPRESSED_SPACE": "Leertaste",
    "EVENT_WHENKEYPRESSED_LEFT": "Pfeil nach links",
    "EVENT_WHENKEYPRESSED_RIGHT": "Pfeil nach rechts",
    "EVENT_WHENKEYPRESSED_DOWN": "Pfeil nach unten",
    "EVENT_WHENKEYPRESSED_UP": "Pfeil nach oben",
    "EVENT_WHENKEYPRESSED_ANY": "beliebiges",
    "LOOKS_SAYFORSECS": "sage %1 für %2 Sekunden",
    "LOOKS_SAY": "sage %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "denke %1 für %2 Sekunden",
    "LOOKS_THINK": "denke %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "zeige dich",
    "LOOKS_HIDE": "verstecke dich",
    "LOOKS_HIDEALLSPRITES": "Alle Figuren verbergen",
    "LOOKS_EFFECT_COLOR": "Farbe",
    "LOOKS_EFFECT_FISHEYE": "Fischauge",
    "LOOKS_EFFECT_WHIRL": "Wirbel",
    "LOOKS_EFFECT_PIXELATE": "Pixel",
    "LOOKS_EFFECT_MOSAIC": "Mosaik",
    "LOOKS_EFFECT_BRIGHTNESS": "Helligkeit",
    "LOOKS_EFFECT_GHOST": "Durchsichtigkeit",
    "LOOKS_CHANGEEFFECTBY": "ändere Effekt %1 um %2",
    "LOOKS_SETEFFECTTO": "setze Effekt %1 auf %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "schalte Grafikeffekte aus",
    "LOOKS_CHANGESIZEBY": "ändere Größe um %1",
    "LOOKS_SETSIZETO": "setze Größe auf %1",
    "LOOKS_SIZE": "Größe",
    "LOOKS_CHANGESTRETCHBY": "ändere Dehnung um %1",
    "LOOKS_SETSTRETCHTO": "setze Dehnung auf %1 %",
    "LOOKS_SWITCHCOSTUMETO": "wechsle zu Kostüm %1",
    "LOOKS_NEXTCOSTUME": "nächstes Kostüm",
    "LOOKS_SWITCHBACKDROPTO": "wechsle zu Bühnenbild %1",
    "LOOKS_GOTOFRONTBACK": "gehe zu %1 Ebene",
    "LOOKS_GOTOFRONTBACK_FRONT": "vorderster",
    "LOOKS_GOTOFRONTBACK_BACK": "hinterster",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gehe %2 Ebenen %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "nach vorne",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "nach hinten",
    "LOOKS_BACKDROPNUMBERNAME": "Bühnenbild %1",
    "LOOKS_COSTUMENUMBERNAME": "Kostüm %1",
    "LOOKS_NUMBERNAME_NUMBER": "Nummer",
    "LOOKS_NUMBERNAME_NAME": "Name",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "wechsle zu Bühnenbild %1 und warte",
    "LOOKS_NEXTBACKDROP": "nächstes Bühnenbild",
    "LOOKS_PREVIOUSBACKDROP": "vorheriges Bühnenbild",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "gehe %1 er Schritt",
    "MOTION_TURNLEFT": "drehe dich %1 um %2 Grad",
    "MOTION_TURNRIGHT": "drehe dich %1 um %2 Grad",
    "MOTION_POINTINDIRECTION": "setze Richtung auf %1 Grad",
    "MOTION_POINTTOWARDS": "drehe dich zu %1",
    "MOTION_POINTTOWARDS_POINTER": "Mauszeiger",
    "MOTION_GOTO": "gehe zu %1",
    "MOTION_GOTO_POINTER": "Mauszeiger",
    "MOTION_GOTO_RANDOM": "Zufallsposition",
    "MOTION_GOTOXY": "gehe zu x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "gleite %1 Sek. zu x: %2 y: %3",
    "MOTION_GLIDETO": "gleite %1 Sek. zu %2",
    "MOTION_GLIDETO_POINTER": "Mauszeiger",
    "MOTION_GLIDETO_RANDOM": "Zufallsposition",
    "MOTION_CHANGEXBY": "ändere x um %1",
    "MOTION_SETX": "setze x auf %1",
    "MOTION_CHANGEYBY": "ändere y um %1",
    "MOTION_SETY": "setze y auf %1",
    "MOTION_IFONEDGEBOUNCE": "pralle vom Rand ab",
    "MOTION_SETROTATIONSTYLE": "setze Drehtyp auf %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "links-rechts",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "nicht drehen",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "rundherum",
    "MOTION_XPOSITION": "x-Position",
    "MOTION_YPOSITION": "y-Position",
    "MOTION_DIRECTION": "Richtung",
    "MOTION_SCROLLRIGHT": "%1 nach rechts bewegen",
    "MOTION_SCROLLUP": "%1 nach oben bewegen",
    "MOTION_ALIGNSCENE": "Szene ausrichten %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "unten links",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "unten rechts",
    "MOTION_ALIGNSCENE_MIDDLE": "Mitte",
    "MOTION_ALIGNSCENE_TOPLEFT": "oben links",
    "MOTION_ALIGNSCENE_TOPRIGHT": "oben rechts",
    "MOTION_XSCROLL": "x-Bewegung",
    "MOTION_YSCROLL": "y-Bewegung",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "Zufallszahl von %1 bis %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 und %2",
    "OPERATORS_OR": "%1 oder %2",
    "OPERATORS_NOT": "nicht %1",
    "OPERATORS_JOIN": "verbinde %1 und %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "Zeichen %1 von %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "Länge von %1",
    "OPERATORS_CONTAINS": "%1 enthält %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "%1 gerundet",
    "OPERATORS_MATHOP": "%1 von %2",
    "OPERATORS_MATHOP_ABS": "Betrag",
    "OPERATORS_MATHOP_FLOOR": "abrunden",
    "OPERATORS_MATHOP_CEILING": "aufrunden",
    "OPERATORS_MATHOP_SQRT": "Wurzel",
    "OPERATORS_MATHOP_SIN": "Sinus",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e^",
    "OPERATORS_MATHOP_10EXP": "10^",
    "PROCEDURES_DEFINITION": "definiere %1",
    "SENSING_TOUCHINGOBJECT": "wird %1 berührt?",
    "SENSING_TOUCHINGOBJECT_POINTER": "Mauszeiger",
    "SENSING_TOUCHINGOBJECT_EDGE": "Rand",
    "SENSING_TOUCHINGCOLOR": "wird Farbe %1 berührt?",
    "SENSING_COLORISTOUCHINGCOLOR": "Farbe %1 berührt %2?",
    "SENSING_DISTANCETO": "Entfernung von %1",
    "SENSING_DISTANCETO_POINTER": "Mauszeiger",
    "SENSING_ASKANDWAIT": "frage %1 und warte",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "Antwort",
    "SENSING_KEYPRESSED": "Taste %1 gedrückt?",
    "SENSING_MOUSEDOWN": "Maustaste gedrückt?",
    "SENSING_MOUSEX": "Maus x-Position",
    "SENSING_MOUSEY": "Maus y-Position",
    "SENSING_SETDRAGMODE": "setze Ziehbarkeit auf %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ziehbar",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "nicht ziehbar",
    "SENSING_LOUDNESS": "Lautstärke",
    "SENSING_LOUD": "laut?",
    "SENSING_TIMER": "Stoppuhr",
    "SENSING_RESETTIMER": "setze Stoppuhr zurück",
    "SENSING_OF": "%1 von %2",
    "SENSING_OF_XPOSITION": "x-Position",
    "SENSING_OF_YPOSITION": "y-Position",
    "SENSING_OF_DIRECTION": "Richtung",
    "SENSING_OF_COSTUMENUMBER": "Kostümnummer",
    "SENSING_OF_COSTUMENAME": "Kostümname",
    "SENSING_OF_SIZE": "Größe",
    "SENSING_OF_VOLUME": "Lautstärke",
    "SENSING_OF_BACKDROPNUMBER": "Bühnenbildnummer",
    "SENSING_OF_BACKDROPNAME": "Bühnenbildname",
    "SENSING_OF_STAGE": "Bühne",
    "SENSING_CURRENT": "%1 im Moment",
    "SENSING_CURRENT_YEAR": "Jahr",
    "SENSING_CURRENT_MONTH": "Monat",
    "SENSING_CURRENT_DATE": "Datum",
    "SENSING_CURRENT_DAYOFWEEK": "Wochentag",
    "SENSING_CURRENT_HOUR": "Stunde",
    "SENSING_CURRENT_MINUTE": "Minute",
    "SENSING_CURRENT_SECOND": "Sekunde",
    "SENSING_DAYSSINCE2000": "Tage seit 2000",
    "SENSING_USERNAME": "Benutzername",
    "SENSING_USERID": "Benutzer-ID",
    "SOUND_PLAY": "spiele Klang %1",
    "SOUND_PLAYUNTILDONE": "spiele Klang %1 ganz",
    "SOUND_STOPALLSOUNDS": "stoppe alle Klänge",
    "SOUND_SETEFFECTO": "setze Effekt %1 auf %2",
    "SOUND_CHANGEEFFECTBY": "ändere Effekt %1 um %2",
    "SOUND_CLEAREFFECTS": "schalte Klangeffekte aus",
    "SOUND_EFFECTS_PITCH": "Höhe",
    "SOUND_EFFECTS_PAN": "aussteuern links/rechts",
    "SOUND_CHANGEVOLUMEBY": "ändere Lautstärke um %1",
    "SOUND_SETVOLUMETO": "setze Lautstärke auf %1%",
    "SOUND_VOLUME": "Lautstärke",
    "CATEGORY_MOTION": "Bewegung",
    "CATEGORY_LOOKS": "Aussehen",
    "CATEGORY_SOUND": "Klang",
    "CATEGORY_EVENTS": "Ereignisse",
    "CATEGORY_CONTROL": "Steuerung",
    "CATEGORY_SENSING": "Fühlen",
    "CATEGORY_OPERATORS": "Operatoren",
    "CATEGORY_VARIABLES": "Variablen",
    "CATEGORY_MYBLOCKS": "Meine Blöcke",
    "DUPLICATE": "Duplizieren",
    "DELETE": "Löschen",
    "ADD_COMMENT": "Kommentar hinzufügen",
    "REMOVE_COMMENT": "Kommentar entfernen",
    "DELETE_BLOCK": "Lösche Block",
    "DELETE_X_BLOCKS": "Lösche %1 Blöcke",
    "DELETE_ALL_BLOCKS": "Alle %1 Blöcke löschen?",
    "CLEAN_UP": "Blöcke aufräumen",
    "HELP": "Hilfe",
    "UNDO": "Rückgängig",
    "REDO": "Wiederherstellen",
    "EDIT_PROCEDURE": "Bearbeiten",
    "SHOW_PROCEDURE_DEFINITION": "Gehe zur Definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Sag etwas...",
    "COLOUR_HUE_LABEL": "Farbe",
    "COLOUR_SATURATION_LABEL": "Sättigung",
    "COLOUR_BRIGHTNESS_LABEL": "Helligkeit",
    "CHANGE_VALUE_TITLE": "Ändere Wert",
    "RENAME_VARIABLE": "Variable umbenennen",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Variable umbenennen",
    "NEW_VARIABLE": "Neue Variable",
    "NEW_VARIABLE_TITLE": "Neue Variable Name:",
    "VARIABLE_MODAL_TITLE": "Neue Variable",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Neuer Block",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Neue Liste",
    "NEW_LIST_TITLE": "Neuer Listen Name:",
    "LIST_MODAL_TITLE": "Neue Liste",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Liste umbenennen",
    "NEW_BROADCAST_MESSAGE": "Neue Nachricht",
    "NEW_BROADCAST_MESSAGE_TITLE": "Neue Nachricht name:",
    "BROADCAST_MODAL_TITLE": "Neue Nachricht",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "Nachricht1"
};

Blockly.ScratchMsgs.locales["el"] =
{
    "CONTROL_FOREVER": "για πάντα",
    "CONTROL_REPEAT": "επανάλαβε %1",
    "CONTROL_IF": "εάν %1 τότε",
    "CONTROL_ELSE": "αλλιώς",
    "CONTROL_STOP": "σταμάτησε",
    "CONTROL_STOP_ALL": "όλα",
    "CONTROL_STOP_THIS": "αυτό το σενάριο",
    "CONTROL_STOP_OTHER": "άλλα σενάρια σε αυτό το αντικείμενο",
    "CONTROL_WAIT": "περίμενε %1 δευτερόλεπτα",
    "CONTROL_WAITUNTIL": "περίμενε ώσπου %1",
    "CONTROL_REPEATUNTIL": "επανάλαβε ώσπου %1",
    "CONTROL_WHILE": "όσο %1",
    "CONTROL_FOREACH": "για κάθε %1 στο %2",
    "CONTROL_STARTASCLONE": "όταν ξεκινήσει ο κλώνος",
    "CONTROL_CREATECLONEOF": "δημιούργησε έναν κλώνο του %1",
    "CONTROL_CREATECLONEOF_MYSELF": "εαυτού μου",
    "CONTROL_DELETETHISCLONE": "διάγραψε αυτόν τον κλώνο",
    "CONTROL_COUNTER": "μετρητής",
    "CONTROL_INCRCOUNTER": "μετρητής αύξησης",
    "CONTROL_CLEARCOUNTER": "καθαρισμός μετρητή",
    "CONTROL_ALLATONCE": "all at once",
    "DATA_SETVARIABLETO": "όρισε το %1 σε %2",
    "DATA_CHANGEVARIABLEBY": "άλλαξε το %1 κατά %2",
    "DATA_SHOWVARIABLE": "εμφάνισε τη μεταβλητή %1",
    "DATA_HIDEVARIABLE": "απόκρυψε τη μεταβλητή %1",
    "DATA_ADDTOLIST": "πρόσθεσε το %1 στη λίστα %2",
    "DATA_DELETEOFLIST": "διάγραψε το %1 από τη λίστα %2",
    "DATA_INSERTATLIST": "βάλε το %1 στη θέση %2 της λίστας %3",
    "DATA_REPLACEITEMOFLIST": "αντικατάστησε το στοιχείο %1 της λίστας %2 με %3",
    "DATA_ITEMOFLIST": "το στοιχείο %1 της λίστας %2",
    "DATA_LENGTHOFLIST": "το μήκος της λίστας %1",
    "DATA_LISTCONTAINSITEM": "η λίστα %1 περιέχει %2",
    "DATA_SHOWLIST": "εμφάνισε την λίστα %1",
    "DATA_HIDELIST": "απόκρυψε τη λίστα %1",
    "DATA_INDEX_ALL": "όλα",
    "DATA_INDEX_LAST": "τελευταίο",
    "DATA_INDEX_RANDOM": "τυχαία επιλογή",
    "EVENT_WHENFLAGCLICKED": "όταν γίνει κλικ στο αντικείμενο %1",
    "EVENT_WHENTHISSPRITECLICKED": "όταν σε αυτό το αντικείμενο γίνει κλικ",
    "EVENT_WHENSTAGECLICKED": "όταν γίνει κλικ στο Σκηνικό",
    "EVENT_WHENTOUCHINGOBJECT": "when this sprite touches %1",
    "EVENT_WHENBROADCASTRECEIVED": "όταν λάβω %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "όταν το υπόβαθρο αλλάξει σε %1",
    "EVENT_WHENGREATERTHAN": "όταν %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "χρονομέτρηση",
    "EVENT_BROADCAST": "μετάδωσε %1",
    "EVENT_BROADCASTANDWAIT": "μετάδωσε %1 και περίμενε",
    "EVENT_WHENKEYPRESSED": "όταν το πλήκτρο %1 πατηθεί",
    "EVENT_WHENKEYPRESSED_SPACE": "διάστημα",
    "EVENT_WHENKEYPRESSED_LEFT": "αριστερό βέλος",
    "EVENT_WHENKEYPRESSED_RIGHT": "δεξί βέλος",
    "EVENT_WHENKEYPRESSED_DOWN": "κάτω βέλος",
    "EVENT_WHENKEYPRESSED_UP": "πάνω βέλος",
    "EVENT_WHENKEYPRESSED_ANY": "οποιοδήποτε",
    "LOOKS_SAYFORSECS": "πες %1 για %2 δευτερόλεπτα",
    "LOOKS_SAY": "πες %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "σκέψου %1 για %2 δευτερόλεπτα",
    "LOOKS_THINK": "σκέψου %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "εμφανίσου",
    "LOOKS_HIDE": "εξαφανίσου",
    "LOOKS_HIDEALLSPRITES": "hide all sprites",
    "LOOKS_EFFECT_COLOR": "χρώματος",
    "LOOKS_EFFECT_FISHEYE": "κυρτότητας",
    "LOOKS_EFFECT_WHIRL": "δίνης",
    "LOOKS_EFFECT_PIXELATE": "εικονοστοιχειοποίησης",
    "LOOKS_EFFECT_MOSAIC": "ψηφιδωτού",
    "LOOKS_EFFECT_BRIGHTNESS": "φωτεινότητας",
    "LOOKS_EFFECT_GHOST": "εξαφάνισης",
    "LOOKS_CHANGEEFFECTBY": "άλλαξε το εφέ %1 κατά %2",
    "LOOKS_SETEFFECTTO": "όρισε το εφέ %1 σε %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "επανάφερε τα γραφικά εφέ",
    "LOOKS_CHANGESIZEBY": "άλλαξε το μέγεθος του αντικειμένου κατά %1",
    "LOOKS_SETSIZETO": "όρισε το μέγεθος σε %1 %",
    "LOOKS_SIZE": "μέγεθος",
    "LOOKS_CHANGESTRETCHBY": "change stretch by %1",
    "LOOKS_SETSTRETCHTO": "set stretch to %1 %",
    "LOOKS_SWITCHCOSTUMETO": "άλλαξε την ενδυμασία σε %1",
    "LOOKS_NEXTCOSTUME": "άλλαξε στην επόμενη ενδυμασία",
    "LOOKS_SWITCHBACKDROPTO": "άλλαξε το υπόβαθρο σε %1",
    "LOOKS_GOTOFRONTBACK": "πήγαινε στην %1 στρώση",
    "LOOKS_GOTOFRONTBACK_FRONT": "μπροστινή",
    "LOOKS_GOTOFRONTBACK_BACK": "πισινή",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "πήγαινε %1 %2 στρώσεις",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "μπροστά",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "πίσω",
    "LOOKS_BACKDROPNUMBERNAME": "υπόβαθρο %1",
    "LOOKS_COSTUMENUMBERNAME": "ενδυμασία %1",
    "LOOKS_NUMBERNAME_NUMBER": "νούμερο",
    "LOOKS_NUMBERNAME_NAME": "όνομα",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "άλλαξε το υπόβαθρο σε %1 και περίμενε",
    "LOOKS_NEXTBACKDROP": "άλλαξε στο επόμενο υπόβαθρο",
    "LOOKS_PREVIOUSBACKDROP": "προηγούμενο υπόβαθρο",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "κινήσου %1 βήματα",
    "MOTION_TURNLEFT": "στρίψε %1 %2 μοίρες",
    "MOTION_TURNRIGHT": "στρίψε %1 %2 μοίρες",
    "MOTION_POINTINDIRECTION": "στρίψε προς την κατεύθυνση %1",
    "MOTION_POINTTOWARDS": "στρίψε προς το %1",
    "MOTION_POINTTOWARDS_POINTER": "δείκτη του ποντικιού",
    "MOTION_GOTO": "πήγαινε %1",
    "MOTION_GOTO_POINTER": "στο δείκτη του ποντικιού",
    "MOTION_GOTO_RANDOM": "σε μία τυχαία θέση",
    "MOTION_GOTOXY": "πήγαινε στη θέση x: %1 και y: %2",
    "MOTION_GLIDESECSTOXY": "ολίσθησε για %1 δευτερόλεπτα προς τη θέση x: %2 και y: %3",
    "MOTION_GLIDETO": "ολίσθησε για %1 δευτερόλεπτα προς %2",
    "MOTION_GLIDETO_POINTER": "το δείκτη του ποντικιού",
    "MOTION_GLIDETO_RANDOM": "μία τυχαία θέση",
    "MOTION_CHANGEXBY": "άλλαξε το x κατά %1",
    "MOTION_SETX": "όρισε το x ίσο με %1",
    "MOTION_CHANGEYBY": "άλλαξε το y κατά %1",
    "MOTION_SETY": "όρισε το y ίσο με %1",
    "MOTION_IFONEDGEBOUNCE": "εάν βρίσκεσαι στα όρια, αναπήδησε",
    "MOTION_SETROTATIONSTYLE": "όρισε τον τρόπο περιστροφής %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "οριζόντιο",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "να μην γίνεται περιστροφή",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "ελεύθερο",
    "MOTION_XPOSITION": "θέση x",
    "MOTION_YPOSITION": "θέση y",
    "MOTION_DIRECTION": "κατεύθυνση",
    "MOTION_SCROLLRIGHT": "κύλιση δεξιά %1",
    "MOTION_SCROLLUP": "κύλιση πάνω %1",
    "MOTION_ALIGNSCENE": "align scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "κάτω-αριστερά",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "κάτω-δεξιά",
    "MOTION_ALIGNSCENE_MIDDLE": "μέσο",
    "MOTION_ALIGNSCENE_TOPLEFT": "πάνω-αριστερά",
    "MOTION_ALIGNSCENE_TOPRIGHT": "πάνω-δεξιά",
    "MOTION_XSCROLL": "κύλιση χ",
    "MOTION_YSCROLL": "κύλιση ψ",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "επίλεξε έναν τυχαίο αριθμό από το %1 μέχρι το %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 και %2",
    "OPERATORS_OR": "%1 ή %2",
    "OPERATORS_NOT": "δεν ισχύει ότι %1",
    "OPERATORS_JOIN": "ένωσε το %1 και το %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "το %1 ° γράμμα του %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "το μήκος του %1",
    "OPERATORS_CONTAINS": "το %1 περιλαμβάνει το %2;",
    "OPERATORS_MOD": "υπόλοιπο ακέραιας διαίρεσης %1 δια %2",
    "OPERATORS_ROUND": "στρογγυλοποίησε το %1",
    "OPERATORS_MATHOP": "%1 από %2",
    "OPERATORS_MATHOP_ABS": "απόλυτη τιμή",
    "OPERATORS_MATHOP_FLOOR": "στρογγυλοποίηση προς τα κάτω",
    "OPERATORS_MATHOP_CEILING": "στρογγυλοποίηση προς τα πάνω",
    "OPERATORS_MATHOP_SQRT": "τετραγωνική ρίζα",
    "OPERATORS_MATHOP_SIN": "ημίτονο",
    "OPERATORS_MATHOP_COS": "συνημίτονο",
    "OPERATORS_MATHOP_TAN": "εφαπτομένη",
    "OPERATORS_MATHOP_ASIN": "αντίστροφο ημίτονο",
    "OPERATORS_MATHOP_ACOS": "αντίστροφο συνημίτονο",
    "OPERATORS_MATHOP_ATAN": "αντίστροφη εφαπτομένη",
    "OPERATORS_MATHOP_LN": "φυσικός λογάριθμος",
    "OPERATORS_MATHOP_LOG": "δεκαδικός λογάριθμος",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "ορισμός του %1",
    "SENSING_TOUCHINGOBJECT": "αγγίζει %1;",
    "SENSING_TOUCHINGOBJECT_POINTER": "το δείκτη του ποντικιού",
    "SENSING_TOUCHINGOBJECT_EDGE": "τα όρια",
    "SENSING_TOUCHINGCOLOR": "αγγίζει το χρώμα %1;",
    "SENSING_COLORISTOUCHINGCOLOR": "το χρώμα %1 αγγίζει το χρώμα %2;",
    "SENSING_DISTANCETO": "η απόσταση μέχρι το %1",
    "SENSING_DISTANCETO_POINTER": "δείκτη του ποντικιού",
    "SENSING_ASKANDWAIT": "ρώτησε %1 και περίμενε",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "απάντηση",
    "SENSING_KEYPRESSED": "πατήθηκε το πλήκτρο %1",
    "SENSING_MOUSEDOWN": "πατήθηκε το ποντίκι;",
    "SENSING_MOUSEX": "θέση x του ποντικιού",
    "SENSING_MOUSEY": "θέση y του ποντικιού",
    "SENSING_SETDRAGMODE": "όρισε τον τρόπο συρσίματος σε %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "συρόμενο",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "μη συρόμενο",
    "SENSING_LOUDNESS": "ένταση",
    "SENSING_LOUD": "loud?",
    "SENSING_TIMER": "χρονομέτρηση",
    "SENSING_RESETTIMER": "μηδένησε τη χρονομέτρηση",
    "SENSING_OF": "%1 από %2",
    "SENSING_OF_XPOSITION": "θέση x",
    "SENSING_OF_YPOSITION": "θέση y",
    "SENSING_OF_DIRECTION": "κατεύθυνση",
    "SENSING_OF_COSTUMENUMBER": "ενδυμασία #",
    "SENSING_OF_COSTUMENAME": "όνομα ενδυμασίας",
    "SENSING_OF_SIZE": "μέγεθος",
    "SENSING_OF_VOLUME": "ένταση",
    "SENSING_OF_BACKDROPNUMBER": "υπόβαθρο #",
    "SENSING_OF_BACKDROPNAME": "όνομα υποβάθρου",
    "SENSING_OF_STAGE": "Σκηνικό",
    "SENSING_CURRENT": "τρέχων %1",
    "SENSING_CURRENT_YEAR": "χρόνος",
    "SENSING_CURRENT_MONTH": "μήνας",
    "SENSING_CURRENT_DATE": "ημερομηνία",
    "SENSING_CURRENT_DAYOFWEEK": "μέρα της εβδομάδας",
    "SENSING_CURRENT_HOUR": "ώρα",
    "SENSING_CURRENT_MINUTE": "λεπτό",
    "SENSING_CURRENT_SECOND": "δευτερόλεπτο",
    "SENSING_DAYSSINCE2000": "ημέρες από το 2000",
    "SENSING_USERNAME": "όνομα χρήστη",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "παίξε τον ήχο %1",
    "SOUND_PLAYUNTILDONE": "παίξε τον ήχο %1 μέχρι το τέλος",
    "SOUND_STOPALLSOUNDS": "σταμάτησε όλους τους ήχους",
    "SOUND_SETEFFECTO": "όρισε το εφέ %1 σε %2",
    "SOUND_CHANGEEFFECTBY": "άλλαξε το εφέ %1 κατά %2",
    "SOUND_CLEAREFFECTS": "επανάφερε τα ηχητικά εφέ",
    "SOUND_EFFECTS_PITCH": "τόνος",
    "SOUND_EFFECTS_PAN": "μετατόπιση αριστερά/δεξιά",
    "SOUND_CHANGEVOLUMEBY": "άλλαξε την ένταση κατά %1",
    "SOUND_SETVOLUMETO": "όρισε την ένταση σε %1%",
    "SOUND_VOLUME": "ένταση",
    "CATEGORY_MOTION": "Κινήσεις",
    "CATEGORY_LOOKS": "Όψεις",
    "CATEGORY_SOUND": "Ήχος",
    "CATEGORY_EVENTS": "Συμβάντα",
    "CATEGORY_CONTROL": "Έλεγχος",
    "CATEGORY_SENSING": "Αισθητήρες",
    "CATEGORY_OPERATORS": "Τελεστές",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "My Blocks",
    "DUPLICATE": "Διπλασιασμός ",
    "DELETE": "Διαγραφή",
    "ADD_COMMENT": "Προσθήκη σχολίου",
    "REMOVE_COMMENT": "Αφαίρεση σχολίου",
    "DELETE_BLOCK": "Delete Block",
    "DELETE_X_BLOCKS": "Delete %1 Blocks",
    "DELETE_ALL_BLOCKS": "Delete all %1 blocks?",
    "CLEAN_UP": "Clean up Blocks",
    "HELP": "Βοήθεια",
    "UNDO": "Αναίρεση",
    "REDO": "Ακύρωση αναίρεσης",
    "EDIT_PROCEDURE": "Επεξεργασία",
    "SHOW_PROCEDURE_DEFINITION": "Μετάβαση σε όρισμό",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Πες κάτι...",
    "COLOUR_HUE_LABEL": "Χρώμα",
    "COLOUR_SATURATION_LABEL": "Κορεσμός",
    "COLOUR_BRIGHTNESS_LABEL": "Φωτεινότητα",
    "CHANGE_VALUE_TITLE": "Αλλαγή τιμής:",
    "RENAME_VARIABLE": "Μετονομασία μεταβλητής",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Μετονομασία μεταβλητής",
    "NEW_VARIABLE": "Δημιουργία Μεταβλητής",
    "NEW_VARIABLE_TITLE": "Νέο όνομα μεταβλητής:",
    "VARIABLE_MODAL_TITLE": "Νέα Μεταβλητή",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "δημιουργήστε ένα τετράγωνο εντολών",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Δημιουργία Λίστας",
    "NEW_LIST_TITLE": "Νέο όνομα λίστας:",
    "LIST_MODAL_TITLE": "Νέα Λίστα",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Μετονομασία λίστας",
    "NEW_BROADCAST_MESSAGE": "Νέο μήνυμα",
    "NEW_BROADCAST_MESSAGE_TITLE": "Νέο όνομα μηνύματος:",
    "BROADCAST_MODAL_TITLE": "Νέο μήνυμα",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "μήνυμα1"
};

Blockly.ScratchMsgs.locales["en"] =
{
    "CONTROL_FOREVER": "forever",
    "CONTROL_REPEAT": "repeat %1",
    "CONTROL_IF": "if %1 then",
    "CONTROL_ELSE": "else",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "all",
    "CONTROL_STOP_THIS": "this script",
    "CONTROL_STOP_OTHER": "other scripts in sprite",
    "CONTROL_WAIT": "wait %1 seconds",
    "CONTROL_WAITUNTIL": "wait until %1",
    "CONTROL_REPEATUNTIL": "repeat until %1",
    "CONTROL_WHILE": "while %1",
    "CONTROL_FOREACH": "for each %1 in %2",
    "CONTROL_STARTASCLONE": "when I start as a clone",
    "CONTROL_CREATECLONEOF": "create clone of %1",
    "CONTROL_CREATECLONEOF_MYSELF": "myself",
    "CONTROL_DELETETHISCLONE": "delete this clone",
    "CONTROL_COUNTER": "counter",
    "CONTROL_INCRCOUNTER": "increment counter",
    "CONTROL_CLEARCOUNTER": "clear counter",
    "CONTROL_ALLATONCE": "all at once",
    "DATA_SETVARIABLETO": "set %1 to %2",
    "DATA_CHANGEVARIABLEBY": "change %1 by %2",
    "DATA_SHOWVARIABLE": "show variable %1",
    "DATA_HIDEVARIABLE": "hide variable %1",
    "DATA_ADDTOLIST": "add %1 to %2",
    "DATA_DELETEOFLIST": "delete %1 of %2",
    "DATA_INSERTATLIST": "insert %1 at %2 of %3",
    "DATA_REPLACEITEMOFLIST": "replace item %1 of %2 with %3",
    "DATA_ITEMOFLIST": "item %1 of %2",
    "DATA_LENGTHOFLIST": "length of %1",
    "DATA_LISTCONTAINSITEM": "%1 contains %2?",
    "DATA_SHOWLIST": "show list %1",
    "DATA_HIDELIST": "hide list %1",
    "DATA_INDEX_ALL": "all",
    "DATA_INDEX_LAST": "last",
    "DATA_INDEX_RANDOM": "random",
    "EVENT_WHENFLAGCLICKED": "when %1 clicked",
    "EVENT_WHENTHISSPRITECLICKED": "when this sprite clicked",
    "EVENT_WHENSTAGECLICKED": "when stage clicked",
    "EVENT_WHENTOUCHINGOBJECT": "when this sprite touches %1",
    "EVENT_WHENBROADCASTRECEIVED": "when I receive %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "when backdrop switches to %1",
    "EVENT_WHENGREATERTHAN": "when %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "timer",
    "EVENT_BROADCAST": "broadcast %1",
    "EVENT_BROADCASTANDWAIT": "broadcast %1 and wait",
    "EVENT_WHENKEYPRESSED": "when %1 key pressed",
    "EVENT_WHENKEYPRESSED_SPACE": "space",
    "EVENT_WHENKEYPRESSED_LEFT": "left arrow",
    "EVENT_WHENKEYPRESSED_RIGHT": "right arrow",
    "EVENT_WHENKEYPRESSED_DOWN": "down arrow",
    "EVENT_WHENKEYPRESSED_UP": "up arrow",
    "EVENT_WHENKEYPRESSED_ANY": "any",
    "LOOKS_SAYFORSECS": "say %1 for %2 seconds",
    "LOOKS_SAY": "say %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "think %1 for %2 seconds",
    "LOOKS_THINK": "think %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "show",
    "LOOKS_HIDE": "hide",
    "LOOKS_HIDEALLSPRITES": "hide all sprites",
    "LOOKS_EFFECT_COLOR": "color",
    "LOOKS_EFFECT_FISHEYE": "fisheye",
    "LOOKS_EFFECT_WHIRL": "whirl",
    "LOOKS_EFFECT_PIXELATE": "pixelate",
    "LOOKS_EFFECT_MOSAIC": "mosaic",
    "LOOKS_EFFECT_BRIGHTNESS": "brightness",
    "LOOKS_EFFECT_GHOST": "ghost",
    "LOOKS_CHANGEEFFECTBY": "change %1 effect by %2",
    "LOOKS_SETEFFECTTO": "set %1 effect to %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "clear graphic effects",
    "LOOKS_CHANGESIZEBY": "change size by %1",
    "LOOKS_SETSIZETO": "set size to %1 %",
    "LOOKS_SIZE": "size",
    "LOOKS_CHANGESTRETCHBY": "change stretch by %1",
    "LOOKS_SETSTRETCHTO": "set stretch to %1 %",
    "LOOKS_SWITCHCOSTUMETO": "switch costume to %1",
    "LOOKS_NEXTCOSTUME": "next costume",
    "LOOKS_SWITCHBACKDROPTO": "switch backdrop to %1",
    "LOOKS_GOTOFRONTBACK": "go to %1 layer",
    "LOOKS_GOTOFRONTBACK_FRONT": "front",
    "LOOKS_GOTOFRONTBACK_BACK": "back",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "go %1 %2 layers",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "forward",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "backward",
    "LOOKS_BACKDROPNUMBERNAME": "backdrop %1",
    "LOOKS_COSTUMENUMBERNAME": "costume %1",
    "LOOKS_NUMBERNAME_NUMBER": "number",
    "LOOKS_NUMBERNAME_NAME": "name",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "switch backdrop to %1 and wait",
    "LOOKS_NEXTBACKDROP": "next backdrop",
    "LOOKS_PREVIOUSBACKDROP": "previous backdrop",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "move %1 steps",
    "MOTION_TURNLEFT": "turn %1 %2 degrees",
    "MOTION_TURNRIGHT": "turn %1 %2 degrees",
    "MOTION_POINTINDIRECTION": "point in direction %1",
    "MOTION_POINTTOWARDS": "point towards %1",
    "MOTION_POINTTOWARDS_POINTER": "mouse-pointer",
    "MOTION_GOTO": "go to %1",
    "MOTION_GOTO_POINTER": "mouse-pointer",
    "MOTION_GOTO_RANDOM": "random position",
    "MOTION_GOTOXY": "go to x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glide %1 secs to x: %2 y: %3",
    "MOTION_GLIDETO": "glide %1 secs to %2",
    "MOTION_GLIDETO_POINTER": "mouse-pointer",
    "MOTION_GLIDETO_RANDOM": "random position",
    "MOTION_CHANGEXBY": "change x by %1",
    "MOTION_SETX": "set x to %1",
    "MOTION_CHANGEYBY": "change y by %1",
    "MOTION_SETY": "set y to %1",
    "MOTION_IFONEDGEBOUNCE": "if on edge, bounce",
    "MOTION_SETROTATIONSTYLE": "set rotation style %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "left-right",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "don't rotate",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "all around",
    "MOTION_XPOSITION": "x position",
    "MOTION_YPOSITION": "y position",
    "MOTION_DIRECTION": "direction",
    "MOTION_SCROLLRIGHT": "scroll right %1",
    "MOTION_SCROLLUP": "scroll up %1",
    "MOTION_ALIGNSCENE": "align scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bottom-left",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bottom-right",
    "MOTION_ALIGNSCENE_MIDDLE": "middle",
    "MOTION_ALIGNSCENE_TOPLEFT": "top-left",
    "MOTION_ALIGNSCENE_TOPRIGHT": "top-right",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "pick random %1 to %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 and %2",
    "OPERATORS_OR": "%1 or %2",
    "OPERATORS_NOT": "not %1",
    "OPERATORS_JOIN": "join %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letter %1 of %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "length of %1",
    "OPERATORS_CONTAINS": "%1 contains %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "round %1",
    "OPERATORS_MATHOP": "%1 of %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "floor",
    "OPERATORS_MATHOP_CEILING": "ceiling",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "define %1",
    "SENSING_TOUCHINGOBJECT": "touching %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "mouse-pointer",
    "SENSING_TOUCHINGOBJECT_EDGE": "edge",
    "SENSING_TOUCHINGCOLOR": "touching color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "color %1 is touching %2?",
    "SENSING_DISTANCETO": "distance to %1",
    "SENSING_DISTANCETO_POINTER": "mouse-pointer",
    "SENSING_ASKANDWAIT": "ask %1 and wait",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "answer",
    "SENSING_KEYPRESSED": "key %1 pressed?",
    "SENSING_MOUSEDOWN": "mouse down?",
    "SENSING_MOUSEX": "mouse x",
    "SENSING_MOUSEY": "mouse y",
    "SENSING_SETDRAGMODE": "set drag mode %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "draggable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "not draggable",
    "SENSING_LOUDNESS": "loudness",
    "SENSING_LOUD": "loud?",
    "SENSING_TIMER": "timer",
    "SENSING_RESETTIMER": "reset timer",
    "SENSING_OF": "%1 of %2",
    "SENSING_OF_XPOSITION": "x position",
    "SENSING_OF_YPOSITION": "y position",
    "SENSING_OF_DIRECTION": "direction",
    "SENSING_OF_COSTUMENUMBER": "costume #",
    "SENSING_OF_COSTUMENAME": "costume name",
    "SENSING_OF_SIZE": "size",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "backdrop #",
    "SENSING_OF_BACKDROPNAME": "backdrop name",
    "SENSING_OF_STAGE": "Stage",
    "SENSING_CURRENT": "current %1",
    "SENSING_CURRENT_YEAR": "year",
    "SENSING_CURRENT_MONTH": "month",
    "SENSING_CURRENT_DATE": "date",
    "SENSING_CURRENT_DAYOFWEEK": "day of week",
    "SENSING_CURRENT_HOUR": "hour",
    "SENSING_CURRENT_MINUTE": "minute",
    "SENSING_CURRENT_SECOND": "second",
    "SENSING_DAYSSINCE2000": "days since 2000",
    "SENSING_USERNAME": "username",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "start sound %1",
    "SOUND_PLAYUNTILDONE": "play sound %1 until done",
    "SOUND_STOPALLSOUNDS": "stop all sounds",
    "SOUND_SETEFFECTO": "set %1 effect to %2",
    "SOUND_CHANGEEFFECTBY": "change %1 effect by %2",
    "SOUND_CLEAREFFECTS": "clear sound effects",
    "SOUND_EFFECTS_PITCH": "pitch",
    "SOUND_EFFECTS_PAN": "pan left/right",
    "SOUND_CHANGEVOLUMEBY": "change volume by %1",
    "SOUND_SETVOLUMETO": "set volume to %1%",
    "SOUND_VOLUME": "volume",
    "CATEGORY_MOTION": "Motion",
    "CATEGORY_LOOKS": "Looks",
    "CATEGORY_SOUND": "Sound",
    "CATEGORY_EVENTS": "Events",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensing",
    "CATEGORY_OPERATORS": "Operators",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "My Blocks",
    "DUPLICATE": "Duplicate",
    "DELETE": "Delete",
    "ADD_COMMENT": "Add Comment",
    "REMOVE_COMMENT": "Remove Comment",
    "DELETE_BLOCK": "Delete Block",
    "DELETE_X_BLOCKS": "Delete %1 Blocks",
    "DELETE_ALL_BLOCKS": "Delete all %1 blocks?",
    "CLEAN_UP": "Clean up Blocks",
    "HELP": "Help",
    "UNDO": "Undo",
    "REDO": "Redo",
    "EDIT_PROCEDURE": "Edit",
    "SHOW_PROCEDURE_DEFINITION": "Go to definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Say something...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturation",
    "COLOUR_BRIGHTNESS_LABEL": "Brightness",
    "CHANGE_VALUE_TITLE": "Change value:",
    "RENAME_VARIABLE": "Rename variable",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Rename Variable",
    "NEW_VARIABLE": "Make a Variable",
    "NEW_VARIABLE_TITLE": "New variable name:",
    "VARIABLE_MODAL_TITLE": "New Variable",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Make a Block",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Make a List",
    "NEW_LIST_TITLE": "New list name:",
    "LIST_MODAL_TITLE": "New List",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Rename List",
    "NEW_BROADCAST_MESSAGE": "New message",
    "NEW_BROADCAST_MESSAGE_TITLE": "New message name:",
    "BROADCAST_MODAL_TITLE": "New Message",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "message1"
};

Blockly.ScratchMsgs.locales["es-419"] =
{
    "CONTROL_FOREVER": "por siempre",
    "CONTROL_REPEAT": "repetir %1",
    "CONTROL_IF": "si %1 entonces",
    "CONTROL_ELSE": "si no",
    "CONTROL_STOP": "detener",
    "CONTROL_STOP_ALL": "todos",
    "CONTROL_STOP_THIS": "este programa",
    "CONTROL_STOP_OTHER": "otros programas en el objeto",
    "CONTROL_WAIT": "esperar %1 segundos",
    "CONTROL_WAITUNTIL": "esperar hasta que %1",
    "CONTROL_REPEATUNTIL": "repetir hasta que %1",
    "CONTROL_WHILE": "Mientras %1",
    "CONTROL_FOREACH": "para cada %1 en %2",
    "CONTROL_STARTASCLONE": "al comenzar como clon",
    "CONTROL_CREATECLONEOF": "crear clon de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mí mismo",
    "CONTROL_DELETETHISCLONE": "borrar este clon",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "incrementar contador",
    "CONTROL_CLEARCOUNTER": "borrar contador",
    "CONTROL_ALLATONCE": "todos a la vez",
    "DATA_SETVARIABLETO": "establecer %1 a %2",
    "DATA_CHANGEVARIABLEBY": "Cambiar %1 por %2",
    "DATA_SHOWVARIABLE": "mostrar variable %1",
    "DATA_HIDEVARIABLE": "esconder variable %1",
    "DATA_ADDTOLIST": "añadir %1 a %2",
    "DATA_DELETEOFLIST": "borrar %1 de %2",
    "DATA_INSERTATLIST": "insertar %1 en %2 de %3",
    "DATA_REPLACEITEMOFLIST": "reemplazar elemento %1 de %2 con %3",
    "DATA_ITEMOFLIST": "elemento %1 de %2",
    "DATA_LENGTHOFLIST": "longitud de %1",
    "DATA_LISTCONTAINSITEM": "¿%1 contiene %2?",
    "DATA_SHOWLIST": "mostrar lista %1",
    "DATA_HIDELIST": "esconder lista %1",
    "DATA_INDEX_ALL": "todos",
    "DATA_INDEX_LAST": "último",
    "DATA_INDEX_RANDOM": "al azar",
    "EVENT_WHENFLAGCLICKED": "al hacer clic en %1",
    "EVENT_WHENTHISSPRITECLICKED": "al hacer clic en este objeto",
    "EVENT_WHENSTAGECLICKED": "al hacer clic en el escenario",
    "EVENT_WHENTOUCHINGOBJECT": "cuando este objeto toca %1",
    "EVENT_WHENBROADCASTRECEIVED": "al recibir %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "cuando el fondo cambie a %1",
    "EVENT_WHENGREATERTHAN": "cuando %1 sea > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronómetro",
    "EVENT_BROADCAST": "enviar %1",
    "EVENT_BROADCASTANDWAIT": "enviar %1 y esperar",
    "EVENT_WHENKEYPRESSED": "al presionar tecla %1",
    "EVENT_WHENKEYPRESSED_SPACE": "Espacio",
    "EVENT_WHENKEYPRESSED_LEFT": "Flecha izquierda",
    "EVENT_WHENKEYPRESSED_RIGHT": "Flecha Derecha",
    "EVENT_WHENKEYPRESSED_DOWN": "Flecha abajo",
    "EVENT_WHENKEYPRESSED_UP": "Flecha arriba",
    "EVENT_WHENKEYPRESSED_ANY": "Cualquiera",
    "LOOKS_SAYFORSECS": "decir %1 por %2 segundos",
    "LOOKS_SAY": "decir %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "pensar %1 por %2 segundos",
    "LOOKS_THINK": "pensar %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "Mostrar",
    "LOOKS_HIDE": "Ocultar",
    "LOOKS_HIDEALLSPRITES": "esconder todos los disfraces",
    "LOOKS_EFFECT_COLOR": "Color",
    "LOOKS_EFFECT_FISHEYE": "ojo de pez",
    "LOOKS_EFFECT_WHIRL": "remolino",
    "LOOKS_EFFECT_PIXELATE": "pixelar",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "brillo",
    "LOOKS_EFFECT_GHOST": "desvanecer",
    "LOOKS_CHANGEEFFECTBY": "cambiar efecto %1 por %2",
    "LOOKS_SETEFFECTTO": "establecer efecto %1 a %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "quitar efectos gráficos",
    "LOOKS_CHANGESIZEBY": "cambiar tamaño en %1",
    "LOOKS_SETSIZETO": "fijar tamaño a %1 %",
    "LOOKS_SIZE": "tamaño",
    "LOOKS_CHANGESTRETCHBY": "cambiar estiramiento por %1",
    "LOOKS_SETSTRETCHTO": "fijar estiramiento a %1 %",
    "LOOKS_SWITCHCOSTUMETO": "cambiar disfraz a %1",
    "LOOKS_NEXTCOSTUME": "siguiente disfraz",
    "LOOKS_SWITCHBACKDROPTO": "cambiar fondo a %1",
    "LOOKS_GOTOFRONTBACK": "ir a la capa %1 ",
    "LOOKS_GOTOFRONTBACK_FRONT": "del frente",
    "LOOKS_GOTOFRONTBACK_BACK": "de atrás",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ir %1 %2 capas",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "adelante",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "atrás",
    "LOOKS_BACKDROPNUMBERNAME": "fondo %1",
    "LOOKS_COSTUMENUMBERNAME": "# de disfraz %1",
    "LOOKS_NUMBERNAME_NUMBER": "número",
    "LOOKS_NUMBERNAME_NAME": "nombre",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "cambiar fondo a %1 y esperar",
    "LOOKS_NEXTBACKDROP": "siguiente fondo",
    "LOOKS_PREVIOUSBACKDROP": "fondo anterior",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "mover %1 pasos",
    "MOTION_TURNLEFT": "girar %1 %2 grados",
    "MOTION_TURNRIGHT": "girar %1 %2 grados",
    "MOTION_POINTINDIRECTION": "apuntar en dirección %1",
    "MOTION_POINTTOWARDS": "apuntar hacia %1",
    "MOTION_POINTTOWARDS_POINTER": "puntero del ratón",
    "MOTION_GOTO": "ir a %1",
    "MOTION_GOTO_POINTER": "puntero del ratón",
    "MOTION_GOTO_RANDOM": "posición aleatoria",
    "MOTION_GOTOXY": "ir a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "deslizar en %1 segs a x: %2 y: %3",
    "MOTION_GLIDETO": "deslizar en %1 segs a x: %2",
    "MOTION_GLIDETO_POINTER": "puntero del ratón",
    "MOTION_GLIDETO_RANDOM": "posición aleatoria",
    "MOTION_CHANGEXBY": "cambiar x en %1",
    "MOTION_SETX": "fijar x a %1",
    "MOTION_CHANGEYBY": "cambiar y en %1",
    "MOTION_SETY": "fijar y a %1",
    "MOTION_IFONEDGEBOUNCE": "rebotar si toca un borde",
    "MOTION_SETROTATIONSTYLE": "fijar estilo de rotación %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "izquierda-derecha",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "no rotar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "en todas direcciones",
    "MOTION_XPOSITION": "posición en x",
    "MOTION_YPOSITION": "posición en y",
    "MOTION_DIRECTION": "dirección",
    "MOTION_SCROLLRIGHT": "desplazar a la derecha %1",
    "MOTION_SCROLLUP": "desplazar arriba %1",
    "MOTION_ALIGNSCENE": "alinear escena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "abajo-izquierda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "abajo-derecha",
    "MOTION_ALIGNSCENE_MIDDLE": "medio",
    "MOTION_ALIGNSCENE_TOPLEFT": "arriba-izquierda",
    "MOTION_ALIGNSCENE_TOPRIGHT": "arriba-derecha",
    "MOTION_XSCROLL": "desplazar x",
    "MOTION_YSCROLL": "desplazar y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "número al azar entre %1 y %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 y %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "no %1",
    "OPERATORS_JOIN": "unir %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "longitud de %1",
    "OPERATORS_CONTAINS": "%1 contiene %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "redondear %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "piso",
    "OPERATORS_MATHOP_CEILING": "techo",
    "OPERATORS_MATHOP_SQRT": "raíz cuadrada",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "En",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definir %1",
    "SENSING_TOUCHINGOBJECT": "tocando %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "puntero del ratón",
    "SENSING_TOUCHINGOBJECT_EDGE": "borde",
    "SENSING_TOUCHINGCOLOR": "¿tocando el color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "¿color %1 está tocando %2?",
    "SENSING_DISTANCETO": "distancia a %1",
    "SENSING_DISTANCETO_POINTER": "puntero del ratón",
    "SENSING_ASKANDWAIT": "preguntar %1 y esperar",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "respuesta",
    "SENSING_KEYPRESSED": "¿tecla %1 presionada?",
    "SENSING_MOUSEDOWN": "¿ratón presionado?",
    "SENSING_MOUSEX": "posición x del ratón",
    "SENSING_MOUSEY": "posición y del ratón",
    "SENSING_SETDRAGMODE": "fijar modo de arrastre a %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastrable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "no arrastrable",
    "SENSING_LOUDNESS": "intensidad del sonido",
    "SENSING_LOUD": "Muy fuerte?",
    "SENSING_TIMER": "cronómetro",
    "SENSING_RESETTIMER": "reiniciar cronómetro",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posición en x",
    "SENSING_OF_YPOSITION": "posición en y",
    "SENSING_OF_DIRECTION": "dirección",
    "SENSING_OF_COSTUMENUMBER": "# de disfraz",
    "SENSING_OF_COSTUMENAME": "nombre del disfraz",
    "SENSING_OF_SIZE": "tamaño",
    "SENSING_OF_VOLUME": "volumen",
    "SENSING_OF_BACKDROPNUMBER": "# de fondo",
    "SENSING_OF_BACKDROPNAME": "nombre de fondo",
    "SENSING_OF_STAGE": "Escenario",
    "SENSING_CURRENT": "%1 actual",
    "SENSING_CURRENT_YEAR": "año",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "fecha",
    "SENSING_CURRENT_DAYOFWEEK": "día de la semana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "días desde el 2000",
    "SENSING_USERNAME": "nombre de usuario",
    "SENSING_USERID": "Identificación de usuario",
    "SOUND_PLAY": "comenzar sonido %1",
    "SOUND_PLAYUNTILDONE": "tocar sonido %1 hasta terminar",
    "SOUND_STOPALLSOUNDS": "detener todos los sonidos",
    "SOUND_SETEFFECTO": "establecer efecto %1 a %2",
    "SOUND_CHANGEEFFECTBY": "cambiar efecto %1 por %2",
    "SOUND_CLEAREFFECTS": "borrar efectos de sonido",
    "SOUND_EFFECTS_PITCH": "altura",
    "SOUND_EFFECTS_PAN": "panel izquierda/derecha",
    "SOUND_CHANGEVOLUMEBY": "cambiar volumen por %1",
    "SOUND_SETVOLUMETO": "fijar volumen a %1%",
    "SOUND_VOLUME": "volumen",
    "CATEGORY_MOTION": "Movimiento",
    "CATEGORY_LOOKS": "Apariencia",
    "CATEGORY_SOUND": "Sonido",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "Mis Bloques",
    "DUPLICATE": "Duplicar",
    "DELETE": "Borrar",
    "ADD_COMMENT": "Agregar comentario",
    "REMOVE_COMMENT": "Eliminar comentario",
    "DELETE_BLOCK": "Eliminar bloque",
    "DELETE_X_BLOCKS": "Eliminar bloque %1",
    "DELETE_ALL_BLOCKS": "¿Eliminar todos los bloques %1?",
    "CLEAN_UP": "Limpiar bloques",
    "HELP": "Ayuda",
    "UNDO": "Deshacer",
    "REDO": "Rehacer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Ir a la definición",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Decir algo...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturación",
    "COLOUR_BRIGHTNESS_LABEL": "Brillo",
    "CHANGE_VALUE_TITLE": "Cambiar valor:",
    "RENAME_VARIABLE": "Renombrar variable",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renombrar variable",
    "NEW_VARIABLE": "Crear una variable",
    "NEW_VARIABLE_TITLE": "Nuevo nombre de variable:",
    "VARIABLE_MODAL_TITLE": "Variable nueva",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Crear un bloque",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Crear una lista",
    "NEW_LIST_TITLE": "Nombre para nueva lista:",
    "LIST_MODAL_TITLE": "Lista nueva",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Renombrar lista",
    "NEW_BROADCAST_MESSAGE": "Nuevo mensaje",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nombre para el nuevo mensaje:",
    "BROADCAST_MODAL_TITLE": "Nuevo Mensaje",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensaje1"
};

Blockly.ScratchMsgs.locales["es"] =
{
    "CONTROL_FOREVER": "por siempre",
    "CONTROL_REPEAT": "repetir %1",
    "CONTROL_IF": "si %1 entonces",
    "CONTROL_ELSE": "si no",
    "CONTROL_STOP": "detener",
    "CONTROL_STOP_ALL": "todos",
    "CONTROL_STOP_THIS": "este script",
    "CONTROL_STOP_OTHER": "otros scripts en el sprite",
    "CONTROL_WAIT": "esperar %1 segundos",
    "CONTROL_WAITUNTIL": "esperar hasta que %1",
    "CONTROL_REPEATUNTIL": "repetir hasta que %1",
    "CONTROL_WHILE": "mientras %1",
    "CONTROL_FOREACH": "para cada %1 de %2",
    "CONTROL_STARTASCLONE": "al comenzar como clon",
    "CONTROL_CREATECLONEOF": "crear clon de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mí mismo",
    "CONTROL_DELETETHISCLONE": "borrar este clon",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "incrementar contador",
    "CONTROL_CLEARCOUNTER": "borrar contador",
    "CONTROL_ALLATONCE": "todo de una vez",
    "DATA_SETVARIABLETO": "dar a %1 el valor %2",
    "DATA_CHANGEVARIABLEBY": "sumar a %1 %2",
    "DATA_SHOWVARIABLE": "mostrar variable %1",
    "DATA_HIDEVARIABLE": "ocultar variable %1",
    "DATA_ADDTOLIST": "añadir %1 a %2",
    "DATA_DELETEOFLIST": "eliminar %1 de %2",
    "DATA_INSERTATLIST": "insertar %1 en %2 de %3",
    "DATA_REPLACEITEMOFLIST": "reemplazar elemento %1 de %2 con %3",
    "DATA_ITEMOFLIST": "elemento %1 de %2",
    "DATA_LENGTHOFLIST": "longitud de %1",
    "DATA_LISTCONTAINSITEM": "¿%2 está en %1?",
    "DATA_SHOWLIST": "mostrar lista %1",
    "DATA_HIDELIST": "esconder lista %1",
    "DATA_INDEX_ALL": "todos",
    "DATA_INDEX_LAST": "último",
    "DATA_INDEX_RANDOM": "al azar",
    "EVENT_WHENFLAGCLICKED": "al hacer clic en %1",
    "EVENT_WHENTHISSPRITECLICKED": "al hacer clic en este objeto",
    "EVENT_WHENSTAGECLICKED": "al hacer clic en el escenario",
    "EVENT_WHENTOUCHINGOBJECT": "cuando el objeto toque %1",
    "EVENT_WHENBROADCASTRECEIVED": "al recibir %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "cuando el fondo cambie a %1",
    "EVENT_WHENGREATERTHAN": "cuando %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronómetro",
    "EVENT_BROADCAST": "enviar %1",
    "EVENT_BROADCASTANDWAIT": "enviar %1 y esperar",
    "EVENT_WHENKEYPRESSED": "al presionar tecla %1",
    "EVENT_WHENKEYPRESSED_SPACE": "espacio",
    "EVENT_WHENKEYPRESSED_LEFT": "flecha izquierda",
    "EVENT_WHENKEYPRESSED_RIGHT": "flecha derecha",
    "EVENT_WHENKEYPRESSED_DOWN": "flecha abajo",
    "EVENT_WHENKEYPRESSED_UP": "flecha arriba",
    "EVENT_WHENKEYPRESSED_ANY": "cualquiera",
    "LOOKS_SAYFORSECS": "decir %1 durante %2 segundos",
    "LOOKS_SAY": "decir %1",
    "LOOKS_HELLO": "¡Hola!",
    "LOOKS_THINKFORSECS": "pensar %1 durante %2 segundos",
    "LOOKS_THINK": "pensar %1",
    "LOOKS_HMM": "Umm...",
    "LOOKS_SHOW": "mostrar",
    "LOOKS_HIDE": "esconder",
    "LOOKS_HIDEALLSPRITES": "esconder todos los objetos",
    "LOOKS_EFFECT_COLOR": "color",
    "LOOKS_EFFECT_FISHEYE": "ojo de pez",
    "LOOKS_EFFECT_WHIRL": "remolino",
    "LOOKS_EFFECT_PIXELATE": "pixelizar",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "brillo",
    "LOOKS_EFFECT_GHOST": "desvanecer",
    "LOOKS_CHANGEEFFECTBY": "sumar al efecto %1 %2",
    "LOOKS_SETEFFECTTO": "dar al efecto %1 el valor %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "quitar efectos gráficos",
    "LOOKS_CHANGESIZEBY": "cambiar tamaño por %1",
    "LOOKS_SETSIZETO": "fijar tamaño al %1 %",
    "LOOKS_SIZE": "tamaño",
    "LOOKS_CHANGESTRETCHBY": "sumar al estiramiento %1",
    "LOOKS_SETSTRETCHTO": "fijar estiramiento al %1 %",
    "LOOKS_SWITCHCOSTUMETO": "cambiar disfraz a %1",
    "LOOKS_NEXTCOSTUME": "siguiente disfraz",
    "LOOKS_SWITCHBACKDROPTO": "cambiar fondo a %1",
    "LOOKS_GOTOFRONTBACK": "ir a capa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "delantera",
    "LOOKS_GOTOFRONTBACK_BACK": "trasera",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ir %2 capas hacia %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "delante",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "atrás",
    "LOOKS_BACKDROPNUMBERNAME": "%1 del fondo",
    "LOOKS_COSTUMENUMBERNAME": "%1 de disfraz",
    "LOOKS_NUMBERNAME_NUMBER": "número",
    "LOOKS_NUMBERNAME_NAME": "nombre",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "cambiar fondo a %1 y esperar",
    "LOOKS_NEXTBACKDROP": "siguiente fondo",
    "LOOKS_PREVIOUSBACKDROP": "fondo anterior",
    "LOOKS_RANDOMBACKDROP": "telón de fondo aleatorio",
    "MOTION_MOVESTEPS": "mover %1 pasos",
    "MOTION_TURNLEFT": "girar %1 %2 grados",
    "MOTION_TURNRIGHT": "girar %1 %2 grados",
    "MOTION_POINTINDIRECTION": "apuntar en dirección %1",
    "MOTION_POINTTOWARDS": "apuntar hacia %1",
    "MOTION_POINTTOWARDS_POINTER": "puntero del ratón",
    "MOTION_GOTO": "ir a %1",
    "MOTION_GOTO_POINTER": "puntero del ratón",
    "MOTION_GOTO_RANDOM": "posición aleatoria",
    "MOTION_GOTOXY": "ir a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "deslizar en %1 segs a x: %2 y: %3",
    "MOTION_GLIDETO": "deslizar en %1 segs a %2",
    "MOTION_GLIDETO_POINTER": "puntero del ratón",
    "MOTION_GLIDETO_RANDOM": "posición aleatoria",
    "MOTION_CHANGEXBY": "sumar a x %1",
    "MOTION_SETX": "dar a x el valor %1",
    "MOTION_CHANGEYBY": "sumar a y %1",
    "MOTION_SETY": "dar a y el valor %1",
    "MOTION_IFONEDGEBOUNCE": "si toca un borde, rebotar",
    "MOTION_SETROTATIONSTYLE": "fijar estilo de rotación a %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "izquierda-derecha",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "no rotar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "en todas direcciones",
    "MOTION_XPOSITION": "posición en x",
    "MOTION_YPOSITION": "posición en y",
    "MOTION_DIRECTION": "dirección",
    "MOTION_SCROLLRIGHT": "desplazar a la derecha %1",
    "MOTION_SCROLLUP": "desplazar arriba %1",
    "MOTION_ALIGNSCENE": "alinear escena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "abajo a la izquierda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "abajo a la derecha",
    "MOTION_ALIGNSCENE_MIDDLE": "al centro",
    "MOTION_ALIGNSCENE_TOPLEFT": "arriba a la izquierda",
    "MOTION_ALIGNSCENE_TOPRIGHT": "arriba a la derecha",
    "MOTION_XSCROLL": "desplazamiento en x",
    "MOTION_YSCROLL": "desplazamiento en y",
    "MOTION_STAGE_SELECTED": "Escenario seleccionado: sin bloques de movimiento",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "número aleatorio entre %1 y %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 y %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "no %1",
    "OPERATORS_JOIN": "unir %1 %2",
    "OPERATORS_JOIN_APPLE": "manzana",
    "OPERATORS_JOIN_BANANA": "plátano",
    "OPERATORS_LETTEROF": "letra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "un",
    "OPERATORS_LENGTH": "longitud de %1",
    "OPERATORS_CONTAINS": "¿%2 está en %1?",
    "OPERATORS_MOD": "%1 módulo %2",
    "OPERATORS_ROUND": "redondear %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "valor absoluto",
    "OPERATORS_MATHOP_FLOOR": "suelo",
    "OPERATORS_MATHOP_CEILING": "techo",
    "OPERATORS_MATHOP_SQRT": "raíz cuadrada",
    "OPERATORS_MATHOP_SIN": "sen",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsen",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definir %1",
    "SENSING_TOUCHINGOBJECT": "¿tocando %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "puntero del ratón",
    "SENSING_TOUCHINGOBJECT_EDGE": "borde",
    "SENSING_TOUCHINGCOLOR": "¿tocando el color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "¿color %1 tocando %2?",
    "SENSING_DISTANCETO": "distancia a %1",
    "SENSING_DISTANCETO_POINTER": "puntero del ratón",
    "SENSING_ASKANDWAIT": "preguntar %1 y esperar",
    "SENSING_ASK_TEXT": "¿Cuál es tu nombre?",
    "SENSING_ANSWER": "respuesta",
    "SENSING_KEYPRESSED": "¿tecla %1 presionada?",
    "SENSING_MOUSEDOWN": "¿ratón presionado?",
    "SENSING_MOUSEX": "posición x del ratón",
    "SENSING_MOUSEY": "posición y del ratón",
    "SENSING_SETDRAGMODE": "fijar modo de arrastre a %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastrable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "no arrastrable",
    "SENSING_LOUDNESS": "volumen del sonido",
    "SENSING_LOUD": "¿ruidoso?",
    "SENSING_TIMER": "cronómetro",
    "SENSING_RESETTIMER": "reiniciar cronómetro",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posición en x",
    "SENSING_OF_YPOSITION": "posición en y",
    "SENSING_OF_DIRECTION": "dirección",
    "SENSING_OF_COSTUMENUMBER": "disfraz #",
    "SENSING_OF_COSTUMENAME": "nombre del disfraz",
    "SENSING_OF_SIZE": "tamaño",
    "SENSING_OF_VOLUME": "volumen",
    "SENSING_OF_BACKDROPNUMBER": "# del fondo",
    "SENSING_OF_BACKDROPNAME": "nombre del fondo",
    "SENSING_OF_STAGE": "Escenario",
    "SENSING_CURRENT": "%1 actual",
    "SENSING_CURRENT_YEAR": "año",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "día",
    "SENSING_CURRENT_DAYOFWEEK": "día de la semana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "días desde el 2000",
    "SENSING_USERNAME": "nombre de usuario",
    "SENSING_USERID": "id de usuario",
    "SOUND_PLAY": "iniciar sonido %1",
    "SOUND_PLAYUNTILDONE": "tocar sonido %1 hasta que termine",
    "SOUND_STOPALLSOUNDS": "detener todos los sonidos",
    "SOUND_SETEFFECTO": "dar al efecto %1 el valor %2",
    "SOUND_CHANGEEFFECTBY": "sumar al efecto %1 %2",
    "SOUND_CLEAREFFECTS": "quitar efectos de sonido",
    "SOUND_EFFECTS_PITCH": "altura",
    "SOUND_EFFECTS_PAN": "balance izquierda/derecha",
    "SOUND_CHANGEVOLUMEBY": "cambiar volumen por %1",
    "SOUND_SETVOLUMETO": "fijar volumen a %1%",
    "SOUND_VOLUME": "volumen",
    "CATEGORY_MOTION": "Movimiento",
    "CATEGORY_LOOKS": "Apariencia",
    "CATEGORY_SOUND": "Sonido",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "Mis bloques",
    "DUPLICATE": "Duplicar",
    "DELETE": "Borrar",
    "ADD_COMMENT": "Añadir comentario",
    "REMOVE_COMMENT": "Eliminar comentario",
    "DELETE_BLOCK": "Borrar bloque",
    "DELETE_X_BLOCKS": "Borrar %1 bloques",
    "DELETE_ALL_BLOCKS": "¿Borrar los %1 bloques?",
    "CLEAN_UP": "Limpiar bloques",
    "HELP": "Ayuda",
    "UNDO": "Deshacer",
    "REDO": "Rehacer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Ir a definición",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Decir algo...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturación",
    "COLOUR_BRIGHTNESS_LABEL": "Brillo",
    "CHANGE_VALUE_TITLE": "Cambiar valor:",
    "RENAME_VARIABLE": "Renombrar variable",
    "RENAME_VARIABLE_TITLE": "Renombrar todas las variables '%1' por:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renombrar variable",
    "NEW_VARIABLE": "Crear una variable",
    "NEW_VARIABLE_TITLE": "Nuevo nombre de variable:",
    "VARIABLE_MODAL_TITLE": "Nueva variable",
    "VARIABLE_ALREADY_EXISTS": "Una variable llamada \"%1\" ya existe.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Una variable llamada \"%1\" ya existe para otra variable de tipo \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "¿Eliminar \"%1\" usos de la variable \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "No se puede borrar la variable \"%1\" porque es parte de la definición de la función \"%2\"",
    "DELETE_VARIABLE": "Borrar la variable \"%1\"",
    "NEW_PROCEDURE": "Crear un bloque",
    "PROCEDURE_ALREADY_EXISTS": "Un procedimiento llamado \"%1\" ya existe.",
    "NEW_LIST": "Crear una lista",
    "NEW_LIST_TITLE": "Nuevo nombre de lista:",
    "LIST_MODAL_TITLE": "Lista nueva",
    "LIST_ALREADY_EXISTS": "Una lista llamada \"%1\" ya existe.",
    "RENAME_LIST_TITLE": "Renombrar de todas las listas \"%1\" por:",
    "RENAME_LIST_MODAL_TITLE": "Renombrar lista",
    "NEW_BROADCAST_MESSAGE": "Nuevo mensaje",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nuevo nombre de mensaje:",
    "BROADCAST_MODAL_TITLE": "Nuevo Mensaje",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensaje1"
};

Blockly.ScratchMsgs.locales["fi"] =
{
    "CONTROL_FOREVER": "ikuisesti",
    "CONTROL_REPEAT": "toista %1 kertaa",
    "CONTROL_IF": "jos %1, niin",
    "CONTROL_ELSE": "tai muuten",
    "CONTROL_STOP": "pysäytä",
    "CONTROL_STOP_ALL": "kaikki",
    "CONTROL_STOP_THIS": "tämä skripti",
    "CONTROL_STOP_OTHER": "hahmon muut skriptit",
    "CONTROL_WAIT": "odota %1 sekuntia",
    "CONTROL_WAITUNTIL": "odota kunnes %1",
    "CONTROL_REPEATUNTIL": "toista kunnes %1",
    "CONTROL_WHILE": "kun %1",
    "CONTROL_FOREACH": "jokainen %1 joukossa %2",
    "CONTROL_STARTASCLONE": "kun aloitan kloonina",
    "CONTROL_CREATECLONEOF": "luo klooni hahmosta %1",
    "CONTROL_CREATECLONEOF_MYSELF": "minä itse",
    "CONTROL_DELETETHISCLONE": "poista tämä klooni",
    "CONTROL_COUNTER": "laskuri",
    "CONTROL_INCRCOUNTER": "lisäyslaskuri",
    "CONTROL_CLEARCOUNTER": "nollaa laskuri",
    "CONTROL_ALLATONCE": "kaikki kerralla",
    "DATA_SETVARIABLETO": "aseta %1 arvoon %2",
    "DATA_CHANGEVARIABLEBY": "lisää muuttujaan %1 arvo %2",
    "DATA_SHOWVARIABLE": "näytä muuttuja %1",
    "DATA_HIDEVARIABLE": "piilota muuttuja %1",
    "DATA_ADDTOLIST": "lisää %1 listaan %2",
    "DATA_DELETEOFLIST": "poista %1 listasta %2",
    "DATA_INSERTATLIST": "lisää %1 kohtaan %2 listassa %3",
    "DATA_REPLACEITEMOFLIST": "korvaa listan %2 kohdan %1 arvo arvolla %3",
    "DATA_ITEMOFLIST": "listan %2 alkio %1",
    "DATA_LENGTHOFLIST": "listan %1 pituus",
    "DATA_LISTCONTAINSITEM": "%1 sisältää %2?",
    "DATA_SHOWLIST": "näytä lista %1",
    "DATA_HIDELIST": "piilota lista %1",
    "DATA_INDEX_ALL": "kaikki",
    "DATA_INDEX_LAST": "viimeinen",
    "DATA_INDEX_RANDOM": "satunnainen",
    "EVENT_WHENFLAGCLICKED": "kun klikataan %1",
    "EVENT_WHENTHISSPRITECLICKED": "kun tätä hahmoa klikataan",
    "EVENT_WHENSTAGECLICKED": "kun esiintymislavaa klikataan",
    "EVENT_WHENTOUCHINGOBJECT": "kun tämä hahmo koskettaa %1",
    "EVENT_WHENBROADCASTRECEIVED": "kun vastaanotan %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "kun taustaksi vaihtuu %1",
    "EVENT_WHENGREATERTHAN": "kun %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "ajastin",
    "EVENT_BROADCAST": "lähetä %1",
    "EVENT_BROADCASTANDWAIT": "lähetä %1 ja odota",
    "EVENT_WHENKEYPRESSED": "kun painetaan %1",
    "EVENT_WHENKEYPRESSED_SPACE": "välilyönti",
    "EVENT_WHENKEYPRESSED_LEFT": "nuoli vasemmalle",
    "EVENT_WHENKEYPRESSED_RIGHT": "nuoli oikealle",
    "EVENT_WHENKEYPRESSED_DOWN": "nuoli alas",
    "EVENT_WHENKEYPRESSED_UP": "nuoli ylös",
    "EVENT_WHENKEYPRESSED_ANY": "mikä tahansa",
    "LOOKS_SAYFORSECS": "sano %1 %2 sekunnin ajan",
    "LOOKS_SAY": "sano %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "ajattele %1 %2 sekunnin ajan",
    "LOOKS_THINK": "ajattele %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "näytä",
    "LOOKS_HIDE": "piilota",
    "LOOKS_HIDEALLSPRITES": "piilota kaikki hahmot",
    "LOOKS_EFFECT_COLOR": "väri",
    "LOOKS_EFFECT_FISHEYE": "kalansilmä",
    "LOOKS_EFFECT_WHIRL": "pyörre",
    "LOOKS_EFFECT_PIXELATE": "pikselöi",
    "LOOKS_EFFECT_MOSAIC": "mosaiikki",
    "LOOKS_EFFECT_BRIGHTNESS": "kirkkaus",
    "LOOKS_EFFECT_GHOST": "haamu",
    "LOOKS_CHANGEEFFECTBY": " lisää tehosteeseen %1 arvo %2",
    "LOOKS_SETEFFECTTO": "aseta tehoste %1 arvoon %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "poista graafiset tehosteet",
    "LOOKS_CHANGESIZEBY": "kasvata kokoa arvolla %1",
    "LOOKS_SETSIZETO": "aseta koko arvoon %1",
    "LOOKS_SIZE": "koko",
    "LOOKS_CHANGESTRETCHBY": "lisää venytystä arvolla %1",
    "LOOKS_SETSTRETCHTO": "aseta venytys arvoon %1 %",
    "LOOKS_SWITCHCOSTUMETO": "vaihda asusteeksi %1",
    "LOOKS_NEXTCOSTUME": "seuraava asuste",
    "LOOKS_SWITCHBACKDROPTO": "vaihda taustaksi %1",
    "LOOKS_GOTOFRONTBACK": "mene %1 alalle",
    "LOOKS_GOTOFRONTBACK_FRONT": "etu",
    "LOOKS_GOTOFRONTBACK_BACK": "taka",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "mene %2 tasoa %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "eteenpäin",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "taaksepäin",
    "LOOKS_BACKDROPNUMBERNAME": "tausta %1",
    "LOOKS_COSTUMENUMBERNAME": "asuste %1",
    "LOOKS_NUMBERNAME_NUMBER": "luku",
    "LOOKS_NUMBERNAME_NAME": "nimi",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "vaihda taustaksi %1 ja odota",
    "LOOKS_NEXTBACKDROP": "seuraava tausta",
    "LOOKS_PREVIOUSBACKDROP": "edellinen tausta",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "liiku %1 askelta",
    "MOTION_TURNLEFT": "käänny %1 %2 astetta",
    "MOTION_TURNRIGHT": "käänny %1 %2 astetta",
    "MOTION_POINTINDIRECTION": "osoita suuntaan %1",
    "MOTION_POINTTOWARDS": "osoita kohti %1",
    "MOTION_POINTTOWARDS_POINTER": "hiiriosoitin",
    "MOTION_GOTO": "mene sijaintiin %1",
    "MOTION_GOTO_POINTER": "hiiriosoitin",
    "MOTION_GOTO_RANDOM": "satunnainen sijainti",
    "MOTION_GOTOXY": "mene sijaintiin x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "liu'u %1 sekuntia sijaintiin x: %2 y: %3",
    "MOTION_GLIDETO": "liu'u %1 sekuntia sijaintiin %2",
    "MOTION_GLIDETO_POINTER": "hiiriosoitin",
    "MOTION_GLIDETO_RANDOM": "satunnainen sijainti",
    "MOTION_CHANGEXBY": "lisää x:n arvoon arvo %1",
    "MOTION_SETX": "aseta x:n arvoksi %1",
    "MOTION_CHANGEYBY": "lisää y:n arvoon arvo %1",
    "MOTION_SETY": "aseta y:n arvoksi %1",
    "MOTION_IFONEDGEBOUNCE": "pomppaa reunasta",
    "MOTION_SETROTATIONSTYLE": "aseta kiertotyyliksi %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vasen-oikea",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "älä kierrä",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "joka suuntaan",
    "MOTION_XPOSITION": "x-sijainti",
    "MOTION_YPOSITION": "y-sijainti",
    "MOTION_DIRECTION": "suunta",
    "MOTION_SCROLLRIGHT": "kierrä oikealle %1",
    "MOTION_SCROLLUP": "kierrä ylös %1",
    "MOTION_ALIGNSCENE": "tasaa näkymä %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "alavasen",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "alaoikea",
    "MOTION_ALIGNSCENE_MIDDLE": "keskikohta",
    "MOTION_ALIGNSCENE_TOPLEFT": "ylävasen",
    "MOTION_ALIGNSCENE_TOPRIGHT": "yläoikea",
    "MOTION_XSCROLL": "x-kierto",
    "MOTION_YSCROLL": "y-kierto",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "valitse satunnaisluku väliltä %1 - %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 ja %2",
    "OPERATORS_OR": "%1 tai %2",
    "OPERATORS_NOT": "ei %1",
    "OPERATORS_JOIN": "yhdistä %1 ja %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "%1 kirjain sanasta %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "listan %1 pituus",
    "OPERATORS_CONTAINS": "%1 sisältää %2?",
    "OPERATORS_MOD": "lukujen %1 ja %2 jakojäännös",
    "OPERATORS_ROUND": "pyöristä %1",
    "OPERATORS_MATHOP": "%1 luvusta %2",
    "OPERATORS_MATHOP_ABS": "itseisarvo",
    "OPERATORS_MATHOP_FLOOR": "pyöristä alaspäin",
    "OPERATORS_MATHOP_CEILING": "pyöristä ylöspäin",
    "OPERATORS_MATHOP_SQRT": "neliöjuuri",
    "OPERATORS_MATHOP_SIN": "sini",
    "OPERATORS_MATHOP_COS": "kosini",
    "OPERATORS_MATHOP_TAN": "tangentti",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "luonnollinen logaritmi",
    "OPERATORS_MATHOP_LOG": "10-logaritmi",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "määrittele %1",
    "SENSING_TOUCHINGOBJECT": "koskettaako %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "hiiriosoitin",
    "SENSING_TOUCHINGOBJECT_EDGE": "reuna",
    "SENSING_TOUCHINGCOLOR": "koskettaako väriä %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "koskeeko väri %1 väriä %2?",
    "SENSING_DISTANCETO": "etäisyys kohteeseen %1",
    "SENSING_DISTANCETO_POINTER": "hiiriosoitin",
    "SENSING_ASKANDWAIT": "kysy %1 ja odota",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "vastaus",
    "SENSING_KEYPRESSED": "onko näppäin %1 painettu?",
    "SENSING_MOUSEDOWN": "onko hiiren nappi painettu?",
    "SENSING_MOUSEX": "hiiren x-sijainti",
    "SENSING_MOUSEY": "hiiren y-sijainti",
    "SENSING_SETDRAGMODE": "aseta raahaustilaksi %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "raahaus sallittu",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "raahaus ei sallittu",
    "SENSING_LOUDNESS": "äänentaso",
    "SENSING_LOUD": "kova äänentaso?",
    "SENSING_TIMER": "ajastin",
    "SENSING_RESETTIMER": "nollaa ajastin",
    "SENSING_OF": "kohteen %2 %1",
    "SENSING_OF_XPOSITION": "x-sijainti",
    "SENSING_OF_YPOSITION": "y-sijainti",
    "SENSING_OF_DIRECTION": "suunta",
    "SENSING_OF_COSTUMENUMBER": "asusteen nro.",
    "SENSING_OF_COSTUMENAME": "asusteen nimi",
    "SENSING_OF_SIZE": "koko",
    "SENSING_OF_VOLUME": "äänenvoimakkuus",
    "SENSING_OF_BACKDROPNUMBER": "taustan nro.",
    "SENSING_OF_BACKDROPNAME": "taustan nimi",
    "SENSING_OF_STAGE": "Esiintymislava",
    "SENSING_CURRENT": "nykyinen %1",
    "SENSING_CURRENT_YEAR": "vuosi",
    "SENSING_CURRENT_MONTH": "kuukausi",
    "SENSING_CURRENT_DATE": "päiväys",
    "SENSING_CURRENT_DAYOFWEEK": "viikonpäivä",
    "SENSING_CURRENT_HOUR": "tunti",
    "SENSING_CURRENT_MINUTE": "minuutti",
    "SENSING_CURRENT_SECOND": "sekunti",
    "SENSING_DAYSSINCE2000": "päiviä vuoden 2000 jälkeen",
    "SENSING_USERNAME": "käyttäjänimi",
    "SENSING_USERID": "käyttäjä-id",
    "SOUND_PLAY": "soita ääni %1",
    "SOUND_PLAYUNTILDONE": "soita ääni %1 loppuun",
    "SOUND_STOPALLSOUNDS": "pysäytä kaikki äänet",
    "SOUND_SETEFFECTO": "aseta tehoste %1 arvoon %2",
    "SOUND_CHANGEEFFECTBY": " lisää tehosteeseen %1 arvo %2",
    "SOUND_CLEAREFFECTS": "poista ääniefektit",
    "SOUND_EFFECTS_PITCH": "sävelkorkeus",
    "SOUND_EFFECTS_PAN": "panoroi vasen/oikea",
    "SOUND_CHANGEVOLUMEBY": "kasvata äänenvoimakkuutta arvolla %1",
    "SOUND_SETVOLUMETO": "aseta äänenvoimakkuudeksi %1%",
    "SOUND_VOLUME": "äänenvoimakkuus",
    "CATEGORY_MOTION": "Liike",
    "CATEGORY_LOOKS": "Ulkonäkö",
    "CATEGORY_SOUND": "Ääni",
    "CATEGORY_EVENTS": "Tapahtumat",
    "CATEGORY_CONTROL": "Ohjaus",
    "CATEGORY_SENSING": "Tuntoaisti",
    "CATEGORY_OPERATORS": "Toiminnot",
    "CATEGORY_VARIABLES": "Muuttujat",
    "CATEGORY_MYBLOCKS": "Lohkoni",
    "DUPLICATE": "Kopioi",
    "DELETE": "Poista",
    "ADD_COMMENT": "Lisää kommentti",
    "REMOVE_COMMENT": "Poista kommentti",
    "DELETE_BLOCK": "Poista lohko",
    "DELETE_X_BLOCKS": "Poista %1 lohkoa",
    "DELETE_ALL_BLOCKS": "Poistetaanko kaikki %1 lohkoa?",
    "CLEAN_UP": "Siivoa lohkot",
    "HELP": "Apua",
    "UNDO": "Kumoa",
    "REDO": "Tee uudelleen",
    "EDIT_PROCEDURE": "Muokkaa",
    "SHOW_PROCEDURE_DEFINITION": "Siirry määrittelyyn",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Sano jotakin...",
    "COLOUR_HUE_LABEL": "Väri",
    "COLOUR_SATURATION_LABEL": "Värikylläisyys",
    "COLOUR_BRIGHTNESS_LABEL": "Kirkkaus",
    "CHANGE_VALUE_TITLE": "Vaihda arvo:",
    "RENAME_VARIABLE": "Nimeä uudelleen muuttuja",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Nimeä uudelleen muuttuja",
    "NEW_VARIABLE": "Tee muuttuja",
    "NEW_VARIABLE_TITLE": "Uuden muuttujan nimi:",
    "VARIABLE_MODAL_TITLE": "Uusi muuttuja",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Tee lohko",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Tee lista",
    "NEW_LIST_TITLE": "Uuden listan nimi:",
    "LIST_MODAL_TITLE": "Uusi lista",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Nimeä uudelleen lista",
    "NEW_BROADCAST_MESSAGE": "Uusi viesti",
    "NEW_BROADCAST_MESSAGE_TITLE": "Uuden viestin nimi:",
    "BROADCAST_MODAL_TITLE": "Uusi viesti",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "viesti1"
};

Blockly.ScratchMsgs.locales["fr"] =
{
    "CONTROL_FOREVER": "répéter indéfiniment",
    "CONTROL_REPEAT": "répéter %1 fois",
    "CONTROL_IF": "si %1 alors",
    "CONTROL_ELSE": "sinon",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "tout",
    "CONTROL_STOP_THIS": "ce script",
    "CONTROL_STOP_OTHER": "autres scripts dans sprite",
    "CONTROL_WAIT": "attendre %1 secondes",
    "CONTROL_WAITUNTIL": "attendre jusqu'à %1",
    "CONTROL_REPEATUNTIL": "répéter jusqu'à %1",
    "CONTROL_WHILE": "tant que %1",
    "CONTROL_FOREACH": "pour chaque %1 dans %2",
    "CONTROL_STARTASCLONE": "quand je commence comme un clone",
    "CONTROL_CREATECLONEOF": "créer un clone de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "moi-même",
    "CONTROL_DELETETHISCLONE": "supprimer ce clone",
    "CONTROL_COUNTER": "compteur",
    "CONTROL_INCRCOUNTER": "incrémenter le compteur",
    "CONTROL_CLEARCOUNTER": "effacer le compteur",
    "CONTROL_ALLATONCE": "tous en même temps",
    "DATA_SETVARIABLETO": "mettre %1 à %2",
    "DATA_CHANGEVARIABLEBY": "changer %1 par %2",
    "DATA_SHOWVARIABLE": "montrer la variable %1",
    "DATA_HIDEVARIABLE": "cacher la variable %1",
    "DATA_ADDTOLIST": "ajouter %1 à %2",
    "DATA_DELETEOFLIST": "supprimer l'élément %1 de %2",
    "DATA_INSERTATLIST": "insérer %1 en position %2 de %3",
    "DATA_REPLACEITEMOFLIST": "remplacer l'élément %1 de la liste %2 par %3",
    "DATA_ITEMOFLIST": "élément %1 de %2",
    "DATA_LENGTHOFLIST": "longueur de %1",
    "DATA_LISTCONTAINSITEM": "%1 contient %2 ?",
    "DATA_SHOWLIST": "montrer la liste %1",
    "DATA_HIDELIST": "cacher la liste %1",
    "DATA_INDEX_ALL": "tout",
    "DATA_INDEX_LAST": "dernier",
    "DATA_INDEX_RANDOM": "au hasard",
    "EVENT_WHENFLAGCLICKED": "quand %1 est cliqué",
    "EVENT_WHENTHISSPRITECLICKED": "quand ce sprite est cliqué",
    "EVENT_WHENSTAGECLICKED": "quand la scène est cliquée",
    "EVENT_WHENTOUCHINGOBJECT": "quand ce lutin touche %1",
    "EVENT_WHENBROADCASTRECEIVED": "quand je reçois %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "quand l'arrière-plan bascule sur %1",
    "EVENT_WHENGREATERTHAN": "quand %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "chronomètre",
    "EVENT_BROADCAST": "envoyer à tous %1",
    "EVENT_BROADCASTANDWAIT": "envoyer à tous %1 et attendre",
    "EVENT_WHENKEYPRESSED": "quand la touche %1 est pressée",
    "EVENT_WHENKEYPRESSED_SPACE": "espace",
    "EVENT_WHENKEYPRESSED_LEFT": "flèche gauche",
    "EVENT_WHENKEYPRESSED_RIGHT": "flèche droite",
    "EVENT_WHENKEYPRESSED_DOWN": "flèche bas",
    "EVENT_WHENKEYPRESSED_UP": "flèche haut",
    "EVENT_WHENKEYPRESSED_ANY": "n'importe laquelle",
    "LOOKS_SAYFORSECS": "dire %1 pendant %2 secondes",
    "LOOKS_SAY": "dire %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "penser à %1 pendant %2 secondes",
    "LOOKS_THINK": "penser à %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "montrer",
    "LOOKS_HIDE": "cacher",
    "LOOKS_HIDEALLSPRITES": "cacher tous les sprites",
    "LOOKS_EFFECT_COLOR": "couleur",
    "LOOKS_EFFECT_FISHEYE": "œil de poisson",
    "LOOKS_EFFECT_WHIRL": "tournoyer",
    "LOOKS_EFFECT_PIXELATE": "pixeliser",
    "LOOKS_EFFECT_MOSAIC": "mosaïque",
    "LOOKS_EFFECT_BRIGHTNESS": "luminosité",
    "LOOKS_EFFECT_GHOST": "fantôme",
    "LOOKS_CHANGEEFFECTBY": "changer l'effet %1 par %2",
    "LOOKS_SETEFFECTTO": "mettre l'effet %1 sur %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "annuler les effets graphiques",
    "LOOKS_CHANGESIZEBY": "changer la taille par %1",
    "LOOKS_SETSIZETO": "mettre la taille sur %1 % de la taille initiale",
    "LOOKS_SIZE": "taille",
    "LOOKS_CHANGESTRETCHBY": "modifier l'étirement de %1",
    "LOOKS_SETSTRETCHTO": "mettre l'étirement sur %1 %",
    "LOOKS_SWITCHCOSTUMETO": "basculer le costume sur %1",
    "LOOKS_NEXTCOSTUME": "costume suivant",
    "LOOKS_SWITCHBACKDROPTO": "basculer l'arrière-plan sur %1",
    "LOOKS_GOTOFRONTBACK": "aller au %1 plan",
    "LOOKS_GOTOFRONTBACK_FRONT": "devant",
    "LOOKS_GOTOFRONTBACK_BACK": "derrière",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "déplacer de %2 plans %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "avant",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "arrière",
    "LOOKS_BACKDROPNUMBERNAME": "arrière-plan %1",
    "LOOKS_COSTUMENUMBERNAME": "costume %1",
    "LOOKS_NUMBERNAME_NUMBER": "nombre",
    "LOOKS_NUMBERNAME_NAME": "nom",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "basculer sur l'arrière-plan %1 et attendre",
    "LOOKS_NEXTBACKDROP": "arrière-plan suivant",
    "LOOKS_PREVIOUSBACKDROP": "arrière-plan précédent",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "avancer de %1 pas",
    "MOTION_TURNLEFT": "tourner %1 de %2 degrés",
    "MOTION_TURNRIGHT": "tourner %1 de %2 degrés",
    "MOTION_POINTINDIRECTION": "s'orienter en direction de %1",
    "MOTION_POINTTOWARDS": "s'orienter vers %1",
    "MOTION_POINTTOWARDS_POINTER": "pointeur de souris",
    "MOTION_GOTO": "aller à %1",
    "MOTION_GOTO_POINTER": "pointeur de souris",
    "MOTION_GOTO_RANDOM": "position aléatoire",
    "MOTION_GOTOXY": "aller à x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glisser en %1 secondes à x: %2 y: %3",
    "MOTION_GLIDETO": "glisser en %1 secondes à %2",
    "MOTION_GLIDETO_POINTER": "pointeur de souris",
    "MOTION_GLIDETO_RANDOM": "position aléatoire",
    "MOTION_CHANGEXBY": "changer x par %1",
    "MOTION_SETX": "mettre x sur %1",
    "MOTION_CHANGEYBY": "changer y par %1",
    "MOTION_SETY": "mettre y sur %1",
    "MOTION_IFONEDGEBOUNCE": "rebondir si le bord est atteint",
    "MOTION_SETROTATIONSTYLE": "fixer le sens de rotation %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "gauche-droite",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ne tourne pas",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "à 360°",
    "MOTION_XPOSITION": "abscisse x",
    "MOTION_YPOSITION": "ordonnée y",
    "MOTION_DIRECTION": "direction",
    "MOTION_SCROLLRIGHT": "défiler à droite de %1",
    "MOTION_SCROLLUP": "défiler en haut de %1",
    "MOTION_ALIGNSCENE": "aligner la scène %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bas-gauche",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bas-droite",
    "MOTION_ALIGNSCENE_MIDDLE": "milieu",
    "MOTION_ALIGNSCENE_TOPLEFT": "haut-gauche",
    "MOTION_ALIGNSCENE_TOPRIGHT": "haut-droite",
    "MOTION_XSCROLL": "défilement x",
    "MOTION_YSCROLL": "défilement y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "nombre aléatoire entre %1 et %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 et %2",
    "OPERATORS_OR": "%1 ou %2",
    "OPERATORS_NOT": "non %1",
    "OPERATORS_JOIN": "regroupe %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "lettre %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "longueur de %1",
    "OPERATORS_CONTAINS": "%1 contient %2 ?",
    "OPERATORS_MOD": "%1 modulo %2",
    "OPERATORS_ROUND": "arrondi de %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "plancher",
    "OPERATORS_MATHOP_CEILING": "plafond",
    "OPERATORS_MATHOP_SQRT": "racine",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e^",
    "OPERATORS_MATHOP_10EXP": "10^",
    "PROCEDURES_DEFINITION": "définir %1",
    "SENSING_TOUCHINGOBJECT": "touche %1 ?",
    "SENSING_TOUCHINGOBJECT_POINTER": "pointeur de souris",
    "SENSING_TOUCHINGOBJECT_EDGE": "bord",
    "SENSING_TOUCHINGCOLOR": "couleur %1 touchée ?",
    "SENSING_COLORISTOUCHINGCOLOR": "couleur %1 touche %2 ?",
    "SENSING_DISTANCETO": "distance de %1",
    "SENSING_DISTANCETO_POINTER": "pointeur de souris",
    "SENSING_ASKANDWAIT": "demander %1 et attendre",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "réponse",
    "SENSING_KEYPRESSED": "touche %1 pressée ?",
    "SENSING_MOUSEDOWN": "souris pressée ?",
    "SENSING_MOUSEX": "souris x",
    "SENSING_MOUSEY": "souris y",
    "SENSING_SETDRAGMODE": "mettre mode de glissement à %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "glissable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "non glissable",
    "SENSING_LOUDNESS": "intensité",
    "SENSING_LOUD": "fort ?",
    "SENSING_TIMER": "chronomètre",
    "SENSING_RESETTIMER": "réinitialiser le chronomètre",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "abscisse x",
    "SENSING_OF_YPOSITION": "ordonnée y",
    "SENSING_OF_DIRECTION": "direction",
    "SENSING_OF_COSTUMENUMBER": "costume #",
    "SENSING_OF_COSTUMENAME": "nom du costume",
    "SENSING_OF_SIZE": "taille",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "arrière-plan #",
    "SENSING_OF_BACKDROPNAME": "nom de l'arrière-plan",
    "SENSING_OF_STAGE": "La scène",
    "SENSING_CURRENT": "%1 actuel",
    "SENSING_CURRENT_YEAR": "année",
    "SENSING_CURRENT_MONTH": "mois",
    "SENSING_CURRENT_DATE": "date",
    "SENSING_CURRENT_DAYOFWEEK": "jour de la semaine",
    "SENSING_CURRENT_HOUR": "heure",
    "SENSING_CURRENT_MINUTE": "minute",
    "SENSING_CURRENT_SECOND": "seconde",
    "SENSING_DAYSSINCE2000": "jours depuis 2000",
    "SENSING_USERNAME": "nom d'utilisateur",
    "SENSING_USERID": "id de l'utilisateur",
    "SOUND_PLAY": "jouer le son %1",
    "SOUND_PLAYUNTILDONE": "jouer le son %1 jusqu'au bout",
    "SOUND_STOPALLSOUNDS": "arrêter tous les sons",
    "SOUND_SETEFFECTO": "mettre l'effet %1 sur %2",
    "SOUND_CHANGEEFFECTBY": "changer l'effet %1 par %2",
    "SOUND_CLEAREFFECTS": "annuler tous les effets sonores",
    "SOUND_EFFECTS_PITCH": "hauteur",
    "SOUND_EFFECTS_PAN": "stéréo gauche/droite",
    "SOUND_CHANGEVOLUMEBY": "ajouter %1 au volume",
    "SOUND_SETVOLUMETO": "mettre le volume au niveau %1%",
    "SOUND_VOLUME": "volume",
    "CATEGORY_MOTION": "Mouvement",
    "CATEGORY_LOOKS": "Apparence",
    "CATEGORY_SOUND": "Son",
    "CATEGORY_EVENTS": "Événements",
    "CATEGORY_CONTROL": "Contrôle",
    "CATEGORY_SENSING": "Capteurs",
    "CATEGORY_OPERATORS": "Opérateurs",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "Mes Blocs",
    "DUPLICATE": "Dupliquer",
    "DELETE": "Supprimer",
    "ADD_COMMENT": "Ajouter un commentaire",
    "REMOVE_COMMENT": "Retirer le commentaire",
    "DELETE_BLOCK": "Supprimer le bloc",
    "DELETE_X_BLOCKS": "Supprimer %1 blocs",
    "DELETE_ALL_BLOCKS": "Supprimer tous les %1 blocs ?",
    "CLEAN_UP": "Nettoyer les blocs",
    "HELP": "Aide",
    "UNDO": "Restaurer",
    "REDO": "Refaire",
    "EDIT_PROCEDURE": "Modifier",
    "SHOW_PROCEDURE_DEFINITION": "Aller à la définition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Dire quelque chose...",
    "COLOUR_HUE_LABEL": "Couleur",
    "COLOUR_SATURATION_LABEL": "Saturation",
    "COLOUR_BRIGHTNESS_LABEL": "Luminosité",
    "CHANGE_VALUE_TITLE": "Changer la valeur:",
    "RENAME_VARIABLE": "Renommer la variable",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renommer la variable",
    "NEW_VARIABLE": "Créer une variable",
    "NEW_VARIABLE_TITLE": "Nouveau nom de la variable",
    "VARIABLE_MODAL_TITLE": "Nouvelle variable",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Créer un bloc",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Créer une liste",
    "NEW_LIST_TITLE": "Nom de la nouvelle liste:",
    "LIST_MODAL_TITLE": "Nouvelle liste",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Renommer la liste",
    "NEW_BROADCAST_MESSAGE": "Nouveau message",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nom du nouveau message:",
    "BROADCAST_MODAL_TITLE": "Nouveau message",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "message1"
};

Blockly.ScratchMsgs.locales["ga"] =
{
    "CONTROL_FOREVER": "go deo",
    "CONTROL_REPEAT": "déan %1 uair",
    "CONTROL_IF": "más %1 ansin",
    "CONTROL_ELSE": "seachas sin",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "uile",
    "CONTROL_STOP_THIS": "an script seo",
    "CONTROL_STOP_OTHER": "scripteanna eile sa sprid",
    "CONTROL_WAIT": "fan %1 soicind",
    "CONTROL_WAITUNTIL": "fan go %1",
    "CONTROL_REPEATUNTIL": "athdhéan go %1",
    "CONTROL_WHILE": "chomh fada is %1",
    "CONTROL_FOREACH": "do gach %1 i %2",
    "CONTROL_STARTASCLONE": "nuair a thosaím mar chóip",
    "CONTROL_CREATECLONEOF": "cruthaigh cóip de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mise féin",
    "CONTROL_DELETETHISCLONE": "scrios an chóip seo",
    "CONTROL_COUNTER": "áiritheoir",
    "CONTROL_INCRCOUNTER": "incrimintigh an t-áiritheoir",
    "CONTROL_CLEARCOUNTER": "glan an t-áiritheoir",
    "CONTROL_ALLATONCE": "d'aon iarraidh",
    "DATA_SETVARIABLETO": "socraigh %1: %2",
    "DATA_CHANGEVARIABLEBY": "athraigh %1 de %2",
    "DATA_SHOWVARIABLE": "taispeáin athróg %1",
    "DATA_HIDEVARIABLE": "folaigh athróg %1",
    "DATA_ADDTOLIST": "cuir %1 le %2",
    "DATA_DELETEOFLIST": "scrios %1 as %2",
    "DATA_INSERTATLIST": "ionsáigh %1 ag %2 i %3",
    "DATA_REPLACEITEMOFLIST": "cuir %3 in áit mír %1 i %2",
    "DATA_ITEMOFLIST": "mír %1 as %2",
    "DATA_LENGTHOFLIST": "fad %1",
    "DATA_LISTCONTAINSITEM": "%1 agus %2 ann?",
    "DATA_SHOWLIST": "taispeáin liosta %1",
    "DATA_HIDELIST": "folaigh liosta %1",
    "DATA_INDEX_ALL": "uile",
    "DATA_INDEX_LAST": "deireanach",
    "DATA_INDEX_RANDOM": "randamach",
    "EVENT_WHENFLAGCLICKED": "nuair a chliceáiltear %1",
    "EVENT_WHENTHISSPRITECLICKED": "nuair a chliceáiltear an sprid seo",
    "EVENT_WHENSTAGECLICKED": "nuair a chliceáiltear an stáitse",
    "EVENT_WHENTOUCHINGOBJECT": "nuair a theagmhaíonn an sprid seo le %1",
    "EVENT_WHENBROADCASTRECEIVED": "nuair a fhaighim %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "nuair a chuirtear %1 suas",
    "EVENT_WHENGREATERTHAN": "nuair atá %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "amadóir",
    "EVENT_BROADCAST": "craol %1",
    "EVENT_BROADCASTANDWAIT": "craol %1 agus fan",
    "EVENT_WHENKEYPRESSED": "nuair a bhrúitear eochair %1",
    "EVENT_WHENKEYPRESSED_SPACE": "spás",
    "EVENT_WHENKEYPRESSED_LEFT": "saighead chlé",
    "EVENT_WHENKEYPRESSED_RIGHT": "saighead dheas",
    "EVENT_WHENKEYPRESSED_DOWN": "saighead síos",
    "EVENT_WHENKEYPRESSED_UP": "saighead suas",
    "EVENT_WHENKEYPRESSED_ANY": "ceann ar bith",
    "LOOKS_SAYFORSECS": "abair %1 ar feadh %2 soicind",
    "LOOKS_SAY": "abair %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "smaoinigh %1 ar feadh %2 soicind",
    "LOOKS_THINK": "smaoinigh %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "taispeáin",
    "LOOKS_HIDE": "folaigh",
    "LOOKS_HIDEALLSPRITES": "folaigh gach sprid",
    "LOOKS_EFFECT_COLOR": "dath",
    "LOOKS_EFFECT_FISHEYE": "súil an éisc",
    "LOOKS_EFFECT_WHIRL": "rothlú",
    "LOOKS_EFFECT_PIXELATE": "picteilíniú",
    "LOOKS_EFFECT_MOSAIC": "mósáic",
    "LOOKS_EFFECT_BRIGHTNESS": "gile",
    "LOOKS_EFFECT_GHOST": "taibhse",
    "LOOKS_CHANGEEFFECTBY": "athraigh maisíocht %1 de %2",
    "LOOKS_SETEFFECTTO": "socraigh maisíocht %1: %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "glan na maisíochtaí grafaice",
    "LOOKS_CHANGESIZEBY": "athraigh an méid de %1",
    "LOOKS_SETSIZETO": "socraigh an méid: %1 %",
    "LOOKS_SIZE": "méid",
    "LOOKS_CHANGESTRETCHBY": "athraigh an síneadh de %1",
    "LOOKS_SETSTRETCHTO": "socraigh an síneadh: %1 %",
    "LOOKS_SWITCHCOSTUMETO": "athraigh an chulaith go %1",
    "LOOKS_NEXTCOSTUME": "an chéad chulaith eile",
    "LOOKS_SWITCHBACKDROPTO": "athraigh an cúlra go %1",
    "LOOKS_GOTOFRONTBACK": "téigh go dtí an tsraith %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "thosaigh",
    "LOOKS_GOTOFRONTBACK_BACK": "dheiridh",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "téigh %1 %2 sraith",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ar aghaidh",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ar gcúl",
    "LOOKS_BACKDROPNUMBERNAME": "cúlra %1",
    "LOOKS_COSTUMENUMBERNAME": "culaith %1",
    "LOOKS_NUMBERNAME_NUMBER": "uimhir",
    "LOOKS_NUMBERNAME_NAME": "ainm",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "athraigh an cúlra go %1 agus fan",
    "LOOKS_NEXTBACKDROP": "an chéad chúlra eile",
    "LOOKS_PREVIOUSBACKDROP": "cúlra roimhe seo",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "bog %1 coiscéim",
    "MOTION_TURNLEFT": "rothlaigh %1 %2 céim",
    "MOTION_TURNRIGHT": "rothlaigh %1 %2 céim",
    "MOTION_POINTINDIRECTION": "tabhair aghaidh ar %1",
    "MOTION_POINTTOWARDS": "tabhair aghaidh i dtreo %1",
    "MOTION_POINTTOWARDS_POINTER": "pointeoir-luiche",
    "MOTION_GOTO": "téigh go %1",
    "MOTION_GOTO_POINTER": "pointeoir-luiche",
    "MOTION_GOTO_RANDOM": "ionad randamach",
    "MOTION_GOTOXY": "téigh go x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "sleamhnaigh %1 soicind go x: %2 y: %3",
    "MOTION_GLIDETO": "sleamhnaigh %1 soicind go %2",
    "MOTION_GLIDETO_POINTER": "pointeoir-luiche",
    "MOTION_GLIDETO_RANDOM": "ionad randamach",
    "MOTION_CHANGEXBY": "athraigh x de %1",
    "MOTION_SETX": "socraigh x: %1",
    "MOTION_CHANGEYBY": "athraigh y de %1",
    "MOTION_SETY": "socraigh y: %1",
    "MOTION_IFONEDGEBOUNCE": "más ar an imeall, preab",
    "MOTION_SETROTATIONSTYLE": "socraigh an stíl rothlaithe: %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "clé-deas",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ná rothlaigh",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "timpeall ar fad",
    "MOTION_XPOSITION": "ionad x",
    "MOTION_YPOSITION": "ionad y",
    "MOTION_DIRECTION": "treo",
    "MOTION_SCROLLRIGHT": "scrollaigh ar dheis %1",
    "MOTION_SCROLLUP": "scrollaigh suas %1",
    "MOTION_ALIGNSCENE": "ailínigh radharc %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bun ar chlé",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bun ar dheis",
    "MOTION_ALIGNSCENE_MIDDLE": "lár",
    "MOTION_ALIGNSCENE_TOPLEFT": "barr ar chlé",
    "MOTION_ALIGNSCENE_TOPRIGHT": "barr ar dheis",
    "MOTION_XSCROLL": "scrollaigh x",
    "MOTION_YSCROLL": "scrollaigh y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "uimhir randamach idir %1 agus %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 agus %2",
    "OPERATORS_OR": "%1 nó %2",
    "OPERATORS_NOT": "séanadh %1",
    "OPERATORS_JOIN": "ceangail %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "litir %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "fad %1",
    "OPERATORS_CONTAINS": "%1 agus %2 ann?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "slánaigh %1",
    "OPERATORS_MATHOP": "%1 as %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "urlár",
    "OPERATORS_MATHOP_CEILING": "síleáil",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "sainmhínigh %1",
    "SENSING_TOUCHINGOBJECT": "i dteagmháil le %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "pointeoir-luiche",
    "SENSING_TOUCHINGOBJECT_EDGE": "ciumhais",
    "SENSING_TOUCHINGCOLOR": "i dteagmháil le dath %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "dath %1 i dteagmháil le %2?",
    "SENSING_DISTANCETO": "fad go dtí %1",
    "SENSING_DISTANCETO_POINTER": "pointeoir-luiche",
    "SENSING_ASKANDWAIT": "fiafraigh %1 agus fan",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "freagra",
    "SENSING_KEYPRESSED": "eochair %1 brúite?",
    "SENSING_MOUSEDOWN": "luchóg síos?",
    "SENSING_MOUSEX": "luchóg x",
    "SENSING_MOUSEY": "luchóg y",
    "SENSING_SETDRAGMODE": "socraigh mód tarraingthe: %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "intarraingthe",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "dotharraingthe",
    "SENSING_LOUDNESS": "treise",
    "SENSING_LOUD": "os ard?",
    "SENSING_TIMER": "amadóir",
    "SENSING_RESETTIMER": "athshocraigh an t-amadóir",
    "SENSING_OF": "%1 as %2",
    "SENSING_OF_XPOSITION": "ionad x",
    "SENSING_OF_YPOSITION": "ionad y",
    "SENSING_OF_DIRECTION": "treo",
    "SENSING_OF_COSTUMENUMBER": "culaith #",
    "SENSING_OF_COSTUMENAME": "ainm na culaithe",
    "SENSING_OF_SIZE": "méid",
    "SENSING_OF_VOLUME": "airde",
    "SENSING_OF_BACKDROPNUMBER": "cúlra #",
    "SENSING_OF_BACKDROPNAME": "ainm an chúlra",
    "SENSING_OF_STAGE": "Stáitse",
    "SENSING_CURRENT": "%1 reatha",
    "SENSING_CURRENT_YEAR": "bliain",
    "SENSING_CURRENT_MONTH": "mí",
    "SENSING_CURRENT_DATE": "dáta",
    "SENSING_CURRENT_DAYOFWEEK": "lá den tseachtain",
    "SENSING_CURRENT_HOUR": "uair",
    "SENSING_CURRENT_MINUTE": "nóiméad",
    "SENSING_CURRENT_SECOND": "soicind",
    "SENSING_DAYSSINCE2000": "laethanta ó 2000",
    "SENSING_USERNAME": "ainm úsáideora",
    "SENSING_USERID": "aitheantas úsáideora",
    "SOUND_PLAY": "cas fuaim %1",
    "SOUND_PLAYUNTILDONE": "seinn fuaim %1 go dtí a deireadh",
    "SOUND_STOPALLSOUNDS": "stop gach fuaim",
    "SOUND_SETEFFECTO": "socraigh maisíocht %1: %2",
    "SOUND_CHANGEEFFECTBY": "athraigh maisíocht %1 de %2",
    "SOUND_CLEAREFFECTS": "glan na maisíochtaí fuaime",
    "SOUND_EFFECTS_PITCH": "tuinairde",
    "SOUND_EFFECTS_PAN": "peanáil ar chlé/ar dheis",
    "SOUND_CHANGEVOLUMEBY": "athraigh airde na fuaime de %1",
    "SOUND_SETVOLUMETO": "socraigh airde na fuaime: %1%",
    "SOUND_VOLUME": "airde",
    "CATEGORY_MOTION": "Gluaiseacht",
    "CATEGORY_LOOKS": "Cuma",
    "CATEGORY_SOUND": "Fuaim",
    "CATEGORY_EVENTS": "Teagmhais",
    "CATEGORY_CONTROL": "Rialú",
    "CATEGORY_SENSING": "Brath",
    "CATEGORY_OPERATORS": "Oibreoirí",
    "CATEGORY_VARIABLES": "Athróga",
    "CATEGORY_MYBLOCKS": "Mo Chuid Blocanna",
    "DUPLICATE": "Cóipeáil",
    "DELETE": "Scrios",
    "ADD_COMMENT": "Cuir Nóta Tráchta Leis",
    "REMOVE_COMMENT": "Bain an Nóta Tráchta",
    "DELETE_BLOCK": "Scrios an Bloc",
    "DELETE_X_BLOCKS": "Scrios %1 Bloc",
    "DELETE_ALL_BLOCKS": "Scrios na %1 bloc go léir?",
    "CLEAN_UP": "Glan na Blocanna",
    "HELP": "Cabhair",
    "UNDO": "Cealaigh",
    "REDO": "Athdhéan",
    "EDIT_PROCEDURE": "Eagar",
    "SHOW_PROCEDURE_DEFINITION": "Taispeáin an sainmhíniú",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Abair rud éigin...",
    "COLOUR_HUE_LABEL": "Dath",
    "COLOUR_SATURATION_LABEL": "Sáithiú",
    "COLOUR_BRIGHTNESS_LABEL": "Gile",
    "CHANGE_VALUE_TITLE": "Athraigh an luach:",
    "RENAME_VARIABLE": "Cuir ainm nua ar an athróg",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Cuir Ainm Nua ar an Athróg",
    "NEW_VARIABLE": "Cruthaigh Athróg",
    "NEW_VARIABLE_TITLE": "Ainm na hathróige nua:",
    "VARIABLE_MODAL_TITLE": "Athróg Nua",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Cruthaigh Bloc",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Cruthaigh Liosta",
    "NEW_LIST_TITLE": "Ainm an liosta nua:",
    "LIST_MODAL_TITLE": "Liosta Nua",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Cuir ainm nua ar an liosta",
    "NEW_BROADCAST_MESSAGE": "Teachtaireacht nua",
    "NEW_BROADCAST_MESSAGE_TITLE": "Ainm na teachtaireachta nua:",
    "BROADCAST_MODAL_TITLE": "Teachtaireacht Nua",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "teachtaireacht1"
};

Blockly.ScratchMsgs.locales["gd"] =
{
    "CONTROL_FOREVER": "gu buan",
    "CONTROL_REPEAT": "dèan seo %1 tursan",
    "CONTROL_IF": "ma tha %1 a-rèiste",
    "CONTROL_ELSE": "air neo",
    "CONTROL_STOP": "cuir stad air",
    "CONTROL_STOP_ALL": "na h-uile",
    "CONTROL_STOP_THIS": "an sgriobt seo",
    "CONTROL_STOP_OTHER": "sgriobtaichean eile na sprìd",
    "CONTROL_WAIT": "fan fad %1 diog",
    "CONTROL_WAITUNTIL": "fan gus am bi %1",
    "CONTROL_REPEATUNTIL": "dèan a-rithist e gus am bi %1",
    "CONTROL_WHILE": "fhad ’s a tha %1",
    "CONTROL_FOREACH": "airson gach %1 air %2",
    "CONTROL_STARTASCLONE": "nuair a thèid thu nad chlòn",
    "CONTROL_CREATECLONEOF": "cruthaich clòn %1",
    "CONTROL_CREATECLONEOF_MYSELF": "dhut fhèin",
    "CONTROL_DELETETHISCLONE": "sguab às an clòn seo",
    "CONTROL_COUNTER": "cunntair",
    "CONTROL_INCRCOUNTER": "cunntair ioncramaide",
    "CONTROL_CLEARCOUNTER": "falamhaich an cunntair",
    "CONTROL_ALLATONCE": "a h-uile gin aig an aon àm",
    "DATA_SETVARIABLETO": "suidhich %1 air %2",
    "DATA_CHANGEVARIABLEBY": "atharraich %1 le %2",
    "DATA_SHOWVARIABLE": "seall an caochladair %1",
    "DATA_HIDEVARIABLE": "falaich an caochladair %1",
    "DATA_ADDTOLIST": "cuir %1 ri %2",
    "DATA_DELETEOFLIST": "sguab às %1 de %2",
    "DATA_INSERTATLIST": "cuir %1 ris aig %2 de %3",
    "DATA_REPLACEITEMOFLIST": "cuir an àite %1 de %2 le %3",
    "DATA_ITEMOFLIST": "nì %1 de %2",
    "DATA_LENGTHOFLIST": "an fhaide aig %1",
    "DATA_LISTCONTAINSITEM": "%2 air %1",
    "DATA_SHOWLIST": "seall an liosta %1",
    "DATA_HIDELIST": "falaich an liosta %1",
    "DATA_INDEX_ALL": "na h-uile",
    "DATA_INDEX_LAST": "am fear mu dheireadh",
    "DATA_INDEX_RANDOM": "tuaireamach",
    "EVENT_WHENFLAGCLICKED": "le briogadh air %1",
    "EVENT_WHENTHISSPRITECLICKED": "le briogadh air an sprìd seo",
    "EVENT_WHENSTAGECLICKED": "le briogadh air an àrd-ùrlar",
    "EVENT_WHENTOUCHINGOBJECT": "nuair a bhios an sprìd a’ beantainn ri %1",
    "EVENT_WHENBROADCASTRECEIVED": "nuair a gheibh thu %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "nuair a thèid an cùlaibh na %1",
    "EVENT_WHENGREATERTHAN": "nuair a thèid %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "tìmear",
    "EVENT_BROADCAST": "craol %1",
    "EVENT_BROADCASTANDWAIT": "craol %1 is fan",
    "EVENT_WHENKEYPRESSED": "le brùthadh na h-iuchrach %1",
    "EVENT_WHENKEYPRESSED_SPACE": "spàs",
    "EVENT_WHENKEYPRESSED_LEFT": "saighead gu clì",
    "EVENT_WHENKEYPRESSED_RIGHT": "saighead gu deas",
    "EVENT_WHENKEYPRESSED_DOWN": "saighead sìos",
    "EVENT_WHENKEYPRESSED_UP": "saighead suas",
    "EVENT_WHENKEYPRESSED_ANY": "sam bith",
    "LOOKS_SAYFORSECS": "can %1 fad %2 diog",
    "LOOKS_SAY": "can %1",
    "LOOKS_HELLO": "Shin thu!",
    "LOOKS_THINKFORSECS": "smaoinich %1 fad %2 diog",
    "LOOKS_THINK": "smaoinich %1",
    "LOOKS_HMM": "An-dà…",
    "LOOKS_SHOW": "seall",
    "LOOKS_HIDE": "falaich",
    "LOOKS_HIDEALLSPRITES": "cuir gach sprìd am falach",
    "LOOKS_EFFECT_COLOR": "datha",
    "LOOKS_EFFECT_FISHEYE": "sùil èisg",
    "LOOKS_EFFECT_WHIRL": "cuairteige",
    "LOOKS_EFFECT_PIXELATE": "phiogsailean",
    "LOOKS_EFFECT_MOSAIC": "mosàig",
    "LOOKS_EFFECT_BRIGHTNESS": "soilleireachd",
    "LOOKS_EFFECT_GHOST": "taibhse",
    "LOOKS_CHANGEEFFECTBY": "atharraich èifeachd %1 le %2",
    "LOOKS_SETEFFECTTO": "suidhich èifeachd %1 de %2 ort",
    "LOOKS_CLEARGRAPHICEFFECTS": "falamhaich na h-èifeachdan",
    "LOOKS_CHANGESIZEBY": "atharraich do mheud le %1",
    "LOOKS_SETSIZETO": "suidhich do mheud air %1 %",
    "LOOKS_SIZE": "meud",
    "LOOKS_CHANGESTRETCHBY": "atharraich an sìneadh le %1",
    "LOOKS_SETSTRETCHTO": "suidhich an sìneadh air %1 %",
    "LOOKS_SWITCHCOSTUMETO": "cuir an t-aodach %1 ort",
    "LOOKS_NEXTCOSTUME": "an t-ath-aodach",
    "LOOKS_SWITCHBACKDROPTO": "atharraich an cùlaibh gu %1",
    "LOOKS_GOTOFRONTBACK": "rach gu breath %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "an fhìor-bheulaibh",
    "LOOKS_GOTOFRONTBACK_BACK": "an fhìor-chùlaibh",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "rach %2 breath %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "an comhair a’ bheòil",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "an comhair a’ chùil",
    "LOOKS_BACKDROPNUMBERNAME": "cùlaibh %1",
    "LOOKS_COSTUMENUMBERNAME": "aodach %1",
    "LOOKS_NUMBERNAME_NUMBER": "àireamh",
    "LOOKS_NUMBERNAME_NAME": "ainm",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "atharraich an cùlaibh gun %1 is fan",
    "LOOKS_NEXTBACKDROP": "an t-ath-chùlaibh",
    "LOOKS_PREVIOUSBACKDROP": "chùlaibh roimhe",
    "LOOKS_RANDOMBACKDROP": "cùlaibh air thuaiream",
    "MOTION_MOVESTEPS": "gluais %1 ceum",
    "MOTION_TURNLEFT": "cuairtich %1 le %2 ceum",
    "MOTION_TURNRIGHT": "cuairtich %1 le %2 ceum",
    "MOTION_POINTINDIRECTION": "cuir d’ aghaidh ri %1",
    "MOTION_POINTTOWARDS": "cuir d’ aghaidh an comhair %1",
    "MOTION_POINTTOWARDS_POINTER": "tomhaire na luchaige",
    "MOTION_GOTO": "rach gu %1",
    "MOTION_GOTO_POINTER": "tomhaire na luchaige",
    "MOTION_GOTO_RANDOM": "ionad air thuaiream",
    "MOTION_GOTOXY": "rach gu x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "gluais fad %1 diog gu x: %2 y: %3",
    "MOTION_GLIDETO": "gluais fad %1 diog gu %2",
    "MOTION_GLIDETO_POINTER": "tomhaire na luchaige",
    "MOTION_GLIDETO_RANDOM": "ionad air thuaiream",
    "MOTION_CHANGEXBY": "atharraich x le %1",
    "MOTION_SETX": "suidhich x air %1",
    "MOTION_CHANGEYBY": "atharraich y le %1",
    "MOTION_SETY": "suidhich y air %1",
    "MOTION_IFONEDGEBOUNCE": "ma tha thu ris an oir, boc",
    "MOTION_SETROTATIONSTYLE": "suidhich stoidhle na cuairte air %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "clì is deas",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "gun chuairteachadh",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "cuairt shlàn",
    "MOTION_XPOSITION": "ionad x",
    "MOTION_YPOSITION": "ionad y",
    "MOTION_DIRECTION": "comhair",
    "MOTION_SCROLLRIGHT": "sgrolaich gu deas le %1",
    "MOTION_SCROLLUP": "sgrolaich suas le %1",
    "MOTION_ALIGNSCENE": "co-thaobhaich an sealladh dhan %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "taobh clì aig a’ bhonn",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "taobh deas aig a’ bhonn",
    "MOTION_ALIGNSCENE_MIDDLE": "mheadhan",
    "MOTION_ALIGNSCENE_TOPLEFT": "taobh clì aig a’ bharr",
    "MOTION_ALIGNSCENE_TOPRIGHT": "taobh deas aig a’ bharr",
    "MOTION_XSCROLL": "sgroladh x",
    "MOTION_YSCROLL": "sgroladh y",
    "MOTION_STAGE_SELECTED": "Chaidh an t-àrd-ùrlar a thaghadh: chan eil bloca gluasaid ann",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 × %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "luach tuaireamach eadar %1 is %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 agus %2",
    "OPERATORS_OR": "%1 no %2",
    "OPERATORS_NOT": "e fallsa gu bheil %1",
    "OPERATORS_JOIN": "ceangail %1 ri %2",
    "OPERATORS_JOIN_APPLE": "ubhal",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "litir %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "an fhaide aig %1",
    "OPERATORS_CONTAINS": "%2 air %1",
    "OPERATORS_MOD": "%1 mòidealas %2",
    "OPERATORS_ROUND": "cuairtich %1",
    "OPERATORS_MATHOP": "%1 aig %2",
    "OPERATORS_MATHOP_ABS": "an luach absaloideach",
    "OPERATORS_MATHOP_FLOOR": "an cuairteachadh sìos",
    "OPERATORS_MATHOP_CEILING": "an cuairteachadh suas",
    "OPERATORS_MATHOP_SQRT": "am freumh ceàrnagach",
    "OPERATORS_MATHOP_SIN": "an sìneas",
    "OPERATORS_MATHOP_COS": "an co-shìneas",
    "OPERATORS_MATHOP_TAN": "am beantan",
    "OPERATORS_MATHOP_ASIN": "an t-àrc-shìneas",
    "OPERATORS_MATHOP_ACOS": "an t-àrc-cho-shìneas",
    "OPERATORS_MATHOP_ATAN": "an t-àrc-bheantan",
    "OPERATORS_MATHOP_LN": "an log-àireamh nàdarra",
    "OPERATORS_MATHOP_LOG": "an log-àireamh",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "mìnich %1",
    "SENSING_TOUCHINGOBJECT": "%1 a’ beantainn riut",
    "SENSING_TOUCHINGOBJECT_POINTER": "tomhaire na luchaige",
    "SENSING_TOUCHINGOBJECT_EDGE": "an oir",
    "SENSING_TOUCHINGCOLOR": "an dath %1 a’ beantainn riut",
    "SENSING_COLORISTOUCHINGCOLOR": "an dath %1 a’ beantainn ri %2",
    "SENSING_DISTANCETO": "an t-astar gu %1",
    "SENSING_DISTANCETO_POINTER": "tomhaire na luchaige",
    "SENSING_ASKANDWAIT": "faighnich %1 is fan",
    "SENSING_ASK_TEXT": "Dè an t-ainm a th’ort?",
    "SENSING_ANSWER": "freagairt",
    "SENSING_KEYPRESSED": "an iuchair %1 ga brùthadh",
    "SENSING_MOUSEDOWN": "an luchag ga briogadh",
    "SENSING_MOUSEX": "x na luchaige",
    "SENSING_MOUSEY": "y na luchaige",
    "SENSING_SETDRAGMODE": "suidhich %1 a shlaodadh leis an luchag",
    "SENSING_SETDRAGMODE_DRAGGABLE": "gun tèid",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "nach tèid",
    "SENSING_LOUDNESS": "àirde na fuaime",
    "SENSING_LOUD": "an fhuaim air",
    "SENSING_TIMER": "tìmear",
    "SENSING_RESETTIMER": "ath-shuidhich an tìmear",
    "SENSING_OF": "%1 aig %2",
    "SENSING_OF_XPOSITION": "ionad x",
    "SENSING_OF_YPOSITION": "ionad y",
    "SENSING_OF_DIRECTION": "comhair",
    "SENSING_OF_COSTUMENUMBER": "àireamh an aodaich",
    "SENSING_OF_COSTUMENAME": "ainm an aodaich",
    "SENSING_OF_SIZE": "meud",
    "SENSING_OF_VOLUME": "àirde na fuaime",
    "SENSING_OF_BACKDROPNUMBER": "àireamh a’ chùlaibh",
    "SENSING_OF_BACKDROPNAME": "ainm a’ chùlaibh",
    "SENSING_OF_STAGE": "Àrd-ùrlar",
    "SENSING_CURRENT": "%1 làithreach",
    "SENSING_CURRENT_YEAR": "bliadhna",
    "SENSING_CURRENT_MONTH": "mìos",
    "SENSING_CURRENT_DATE": "ceann-là",
    "SENSING_CURRENT_DAYOFWEEK": "latha na seachdaine",
    "SENSING_CURRENT_HOUR": "uair",
    "SENSING_CURRENT_MINUTE": "mionaid",
    "SENSING_CURRENT_SECOND": "diog",
    "SENSING_DAYSSINCE2000": "làithean o 2000 a-mach",
    "SENSING_USERNAME": "ainm-cleachdaiche",
    "SENSING_USERID": "ID a’ chleachdaiche",
    "SOUND_PLAY": "tòisich air fuaim %1 a chluich",
    "SOUND_PLAYUNTILDONE": "cluich fuaim %1 gu lèir",
    "SOUND_STOPALLSOUNDS": "cuir stad air a h-uile fuaim",
    "SOUND_SETEFFECTO": "suidhich èifeachd %1 de %2 ort",
    "SOUND_CHANGEEFFECTBY": "atharraich èifeachd %1 le %2",
    "SOUND_CLEAREFFECTS": "falamhaich èifeachdan na fuaime",
    "SOUND_EFFECTS_PITCH": "gleus",
    "SOUND_EFFECTS_PAN": "panachadh gu clì/deas",
    "SOUND_CHANGEVOLUMEBY": "atharraich àirde na fuaime le %1",
    "SOUND_SETVOLUMETO": "suidhich àirde na fuaime air %1%",
    "SOUND_VOLUME": "àirde na fuaime",
    "CATEGORY_MOTION": "Gluasad",
    "CATEGORY_LOOKS": "Coltas",
    "CATEGORY_SOUND": "Fuaim",
    "CATEGORY_EVENTS": "Tachartas",
    "CATEGORY_CONTROL": "Smachd",
    "CATEGORY_SENSING": "Mothachadh",
    "CATEGORY_OPERATORS": "Gnìomharaiche",
    "CATEGORY_VARIABLES": "Caochladairean",
    "CATEGORY_MYBLOCKS": "Am bloca agam",
    "DUPLICATE": "Dùblaich",
    "DELETE": "Sguab às",
    "ADD_COMMENT": "Cuir beachd ris",
    "REMOVE_COMMENT": "Thoir am beachd air falbh",
    "DELETE_BLOCK": "Sguab às am bloca",
    "DELETE_X_BLOCKS": "Sguab às %1 bloca(ichean)",
    "DELETE_ALL_BLOCKS": "A bheil thu airson na %1 bloca(ichean) uile a sguabadh às?",
    "CLEAN_UP": "Sgioblaich na blocaichean",
    "HELP": "Cobhair",
    "UNDO": "Neo-dhèan",
    "REDO": "Ath-dhèan",
    "EDIT_PROCEDURE": "Deasaich",
    "SHOW_PROCEDURE_DEFINITION": "Rach dhan mhìneachadh",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Can rudeigin…",
    "COLOUR_HUE_LABEL": "Dath",
    "COLOUR_SATURATION_LABEL": "Sàthachd",
    "COLOUR_BRIGHTNESS_LABEL": "Soilleireachd",
    "CHANGE_VALUE_TITLE": "Atharraich an luach:",
    "RENAME_VARIABLE": "Thoir ainm ùr air a’ chaochladair",
    "RENAME_VARIABLE_TITLE": "Thoir ainm ùr air gach caochladair “%1”:",
    "RENAME_VARIABLE_MODAL_TITLE": "Thoir ainm ùr air a’ chaochladair",
    "NEW_VARIABLE": "Cruthaich caochladair",
    "NEW_VARIABLE_TITLE": "Ainm ùr a’ chaochladair:",
    "VARIABLE_MODAL_TITLE": "Caochladair ùr",
    "VARIABLE_ALREADY_EXISTS": "Tha caochladair air a bheil “%1” ann mu thràth.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "Tha caochladair air a bheil “%1” ann mu thràth airson caochladair eile dhen t-seòrsa “%2”.",
    "DELETE_VARIABLE_CONFIRMATION": "A bheil thu airson a sguabadh às dha %1 chleachdadh/cleachdaidhean dhen chaochladair “%2”?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Chan urrainn dhuinn an caochladair “%1” a sguabadh às on a e am broinn mìneachadh an fhoincsein “%2”",
    "DELETE_VARIABLE": "Sguab às dhan chaochladair “%1”",
    "NEW_PROCEDURE": "Cruthaich bloca",
    "PROCEDURE_ALREADY_EXISTS": "Tha modh air a bheil “%1” ann mu thràth.",
    "NEW_LIST": "Cruthaich liosta",
    "NEW_LIST_TITLE": "Ainm na liosta ùire:",
    "LIST_MODAL_TITLE": "Liosta ùr",
    "LIST_ALREADY_EXISTS": "Tha liosta air a bheil “%1” ann mu thràth.",
    "RENAME_LIST_TITLE": "Thoir ainm ùr air gach liosta “%1”:",
    "RENAME_LIST_MODAL_TITLE": "Thoir ainm ùr air an liosta",
    "NEW_BROADCAST_MESSAGE": "Teachdaireachd ùr",
    "NEW_BROADCAST_MESSAGE_TITLE": "Ainm na teachdaireachd ùire:",
    "BROADCAST_MODAL_TITLE": "Teachdaireachd ùr",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "teachdaireachd1"
};

Blockly.ScratchMsgs.locales["gl"] =
{
    "CONTROL_FOREVER": "para sempre",
    "CONTROL_REPEAT": "repetir %1",
    "CONTROL_IF": "se %1 entón",
    "CONTROL_ELSE": "se non",
    "CONTROL_STOP": "parar",
    "CONTROL_STOP_ALL": "todos",
    "CONTROL_STOP_THIS": "este programa",
    "CONTROL_STOP_OTHER": "outros programas na figura",
    "CONTROL_WAIT": "agardar %1 segundos",
    "CONTROL_WAITUNTIL": "agardar ata %1",
    "CONTROL_REPEATUNTIL": "repetir ata %1",
    "CONTROL_WHILE": "mentres %1",
    "CONTROL_FOREACH": "para cada %1 en %2",
    "CONTROL_STARTASCLONE": "cando comece como clon",
    "CONTROL_CREATECLONEOF": "crear clon de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "a min mesmo",
    "CONTROL_DELETETHISCLONE": "borrar este clon",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "contador de incremento",
    "CONTROL_CLEARCOUNTER": "limpar contador",
    "CONTROL_ALLATONCE": "todo de vez",
    "DATA_SETVARIABLETO": "fixar %1 a %2",
    "DATA_CHANGEVARIABLEBY": "trocar %1 por %2",
    "DATA_SHOWVARIABLE": "amosar variable %1",
    "DATA_HIDEVARIABLE": "ocultar variable %1",
    "DATA_ADDTOLIST": "engadir %1 a %2",
    "DATA_DELETEOFLIST": "borrar %1 de %2",
    "DATA_INSERTATLIST": "inserir %1 en %2 de %3",
    "DATA_REPLACEITEMOFLIST": "reemplazar elemento %1 de %2 con %3",
    "DATA_ITEMOFLIST": "elemento %1 de %2",
    "DATA_LENGTHOFLIST": "lonxitude de %1",
    "DATA_LISTCONTAINSITEM": "%1 contén %2?",
    "DATA_SHOWLIST": "amosar lista %1",
    "DATA_HIDELIST": "ocultar lista %1",
    "DATA_INDEX_ALL": "todos",
    "DATA_INDEX_LAST": "último",
    "DATA_INDEX_RANDOM": "ao chou",
    "EVENT_WHENFLAGCLICKED": "cando se prema %1",
    "EVENT_WHENTHISSPRITECLICKED": "cando se prema esta figura",
    "EVENT_WHENSTAGECLICKED": "cando se prema no escenario",
    "EVENT_WHENTOUCHINGOBJECT": "cando esta figura toca %1",
    "EVENT_WHENBROADCASTRECEIVED": "cando reciba %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "cando o fondo cambie a %1",
    "EVENT_WHENGREATERTHAN": "cando %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronómetro",
    "EVENT_BROADCAST": "emitir %1",
    "EVENT_BROADCASTANDWAIT": "emitir %1 e agardar",
    "EVENT_WHENKEYPRESSED": "cando se prema a tecla %1",
    "EVENT_WHENKEYPRESSED_SPACE": "espazo",
    "EVENT_WHENKEYPRESSED_LEFT": "frecha esquerda",
    "EVENT_WHENKEYPRESSED_RIGHT": "frecha dereita",
    "EVENT_WHENKEYPRESSED_DOWN": "frecha abaixo",
    "EVENT_WHENKEYPRESSED_UP": "frecha arriba",
    "EVENT_WHENKEYPRESSED_ANY": "calquera",
    "LOOKS_SAYFORSECS": "dicir %1 durante %2 segundos",
    "LOOKS_SAY": "dicir %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "pensar %1 durante %2 segundos",
    "LOOKS_THINK": "pensar %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "amosar",
    "LOOKS_HIDE": "ocultar",
    "LOOKS_HIDEALLSPRITES": "agochar todas as figuras",
    "LOOKS_EFFECT_COLOR": "cor",
    "LOOKS_EFFECT_FISHEYE": "ollo de peixe",
    "LOOKS_EFFECT_WHIRL": "remuiño",
    "LOOKS_EFFECT_PIXELATE": "pixelar",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "luminosidade",
    "LOOKS_EFFECT_GHOST": "desaparecer",
    "LOOKS_CHANGEEFFECTBY": "trocar o efecto %1 por %2",
    "LOOKS_SETEFFECTTO": "fixar efecto %1 a %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "quitar efectos gráficos",
    "LOOKS_CHANGESIZEBY": "cambiar tamaño por %1",
    "LOOKS_SETSIZETO": "fixar tamaño a %1 %",
    "LOOKS_SIZE": "tamaño",
    "LOOKS_CHANGESTRETCHBY": "cambiar estiramento por %1",
    "LOOKS_SETSTRETCHTO": "fixar estiramento en %1 %",
    "LOOKS_SWITCHCOSTUMETO": "mudar vestimenta a %1",
    "LOOKS_NEXTCOSTUME": "seguinte vestimenta",
    "LOOKS_SWITCHBACKDROPTO": "cambiar fondo a %1",
    "LOOKS_GOTOFRONTBACK": "ir a capa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "fronte",
    "LOOKS_GOTOFRONTBACK_BACK": "atrás",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ir %1 %2 capas",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "adiante",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "atrás",
    "LOOKS_BACKDROPNUMBERNAME": "fondo %1",
    "LOOKS_COSTUMENUMBERNAME": "vestimenta %1",
    "LOOKS_NUMBERNAME_NUMBER": "número",
    "LOOKS_NUMBERNAME_NAME": "nome",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "cambiar fondo a %1 e agardar",
    "LOOKS_NEXTBACKDROP": "seguinte fondo",
    "LOOKS_PREVIOUSBACKDROP": "fondo anterior",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "mover %1 paso",
    "MOTION_TURNLEFT": "xirar %1 %2 grados",
    "MOTION_TURNRIGHT": "xirar %1 %2 grados",
    "MOTION_POINTINDIRECTION": "apuntar en dirección %1",
    "MOTION_POINTTOWARDS": "apuntar cara a %1",
    "MOTION_POINTTOWARDS_POINTER": "punteiro do rato",
    "MOTION_GOTO": "ir a %1",
    "MOTION_GOTO_POINTER": "punteiro do rato",
    "MOTION_GOTO_RANDOM": "posición aleatoria",
    "MOTION_GOTOXY": "ir a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "esbarar %1 seg a x: %2 y: %3",
    "MOTION_GLIDETO": "esbarar %1 seg a %2",
    "MOTION_GLIDETO_POINTER": "punteiro do rato",
    "MOTION_GLIDETO_RANDOM": "posición aleatoria",
    "MOTION_CHANGEXBY": "cambiar x por %1",
    "MOTION_SETX": "fixar x a %1",
    "MOTION_CHANGEYBY": "cambiar y por %1",
    "MOTION_SETY": "fixar y a %1",
    "MOTION_IFONEDGEBOUNCE": "se toca un bordo, rebotar",
    "MOTION_SETROTATIONSTYLE": "fixar estilo de rotación %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "esquerda-dereita",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "non rotar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "en todas as direccións",
    "MOTION_XPOSITION": "posición x",
    "MOTION_YPOSITION": "posición y",
    "MOTION_DIRECTION": "dirección",
    "MOTION_SCROLLRIGHT": "desprazamento dereita %1",
    "MOTION_SCROLLUP": "desprazamento arriba %1",
    "MOTION_ALIGNSCENE": "aliñar escena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "abaixo esquerda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "abaixo dereita",
    "MOTION_ALIGNSCENE_MIDDLE": "medio",
    "MOTION_ALIGNSCENE_TOPLEFT": "arriba esquerda",
    "MOTION_ALIGNSCENE_TOPRIGHT": "arriba dereita",
    "MOTION_XSCROLL": "desprazamento x",
    "MOTION_YSCROLL": "desprazamento y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "número ao choun entre %1 e %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 e %2",
    "OPERATORS_OR": "%1 ou %2",
    "OPERATORS_NOT": "non %1",
    "OPERATORS_JOIN": "unir %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "lonxitude de %1",
    "OPERATORS_CONTAINS": "%1 contén %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "redondear %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "valor absoluto",
    "OPERATORS_MATHOP_FLOOR": "chan",
    "OPERATORS_MATHOP_CEILING": "teito",
    "OPERATORS_MATHOP_SQRT": "raíz cadrada",
    "OPERATORS_MATHOP_SIN": "seno",
    "OPERATORS_MATHOP_COS": "coseno",
    "OPERATORS_MATHOP_TAN": "tanxente",
    "OPERATORS_MATHOP_ASIN": "arco seno",
    "OPERATORS_MATHOP_ACOS": "arco coseno",
    "OPERATORS_MATHOP_ATAN": "arco tanxente",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definir %1",
    "SENSING_TOUCHINGOBJECT": "tocando %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "punteiro do rato",
    "SENSING_TOUCHINGOBJECT_EDGE": "bordo",
    "SENSING_TOUCHINGCOLOR": "tocando cor %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "cor %1 está tocando %2?",
    "SENSING_DISTANCETO": "distancia a %1",
    "SENSING_DISTANCETO_POINTER": "punteiro do rato",
    "SENSING_ASKANDWAIT": "preguntar %1 e agardar",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "resposta",
    "SENSING_KEYPRESSED": "tecla %1 premida?",
    "SENSING_MOUSEDOWN": "rato premido?",
    "SENSING_MOUSEX": "posición x do rato",
    "SENSING_MOUSEY": "posición y do rato",
    "SENSING_SETDRAGMODE": "fixar modo de arrastre %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastrábel",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "non arrastrábel",
    "SENSING_LOUDNESS": "intensidade do son",
    "SENSING_LOUD": "alto?",
    "SENSING_TIMER": "cronómetro",
    "SENSING_RESETTIMER": "reiniciar o cronómetro",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posición x",
    "SENSING_OF_YPOSITION": "posición y",
    "SENSING_OF_DIRECTION": "dirección",
    "SENSING_OF_COSTUMENUMBER": "vestimenta #",
    "SENSING_OF_COSTUMENAME": "nome da vestimenta",
    "SENSING_OF_SIZE": "tamaño",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "fondo #",
    "SENSING_OF_BACKDROPNAME": "nome do fondo",
    "SENSING_OF_STAGE": "Escenario",
    "SENSING_CURRENT": "actual %1",
    "SENSING_CURRENT_YEAR": "ano",
    "SENSING_CURRENT_MONTH": "mes",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "día da semana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "días desde o 2000",
    "SENSING_USERNAME": "nome de usuario",
    "SENSING_USERID": "identificador de usuario",
    "SOUND_PLAY": "iniciar son %1",
    "SOUND_PLAYUNTILDONE": "reproducir %1 até rematar",
    "SOUND_STOPALLSOUNDS": "deter todos os sons",
    "SOUND_SETEFFECTO": "fixar efecto %1 a %2",
    "SOUND_CHANGEEFFECTBY": "trocar o efecto %1 por %2",
    "SOUND_CLEAREFFECTS": "limpar efectos de son",
    "SOUND_EFFECTS_PITCH": "ton",
    "SOUND_EFFECTS_PAN": "desprazar esquerda/dereita",
    "SOUND_CHANGEVOLUMEBY": "cambiar volume en %1",
    "SOUND_SETVOLUMETO": "fixar volume en %1%",
    "SOUND_VOLUME": "volume",
    "CATEGORY_MOTION": "Movemento",
    "CATEGORY_LOOKS": "Aparencia",
    "CATEGORY_SOUND": "Son",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variábeis",
    "CATEGORY_MYBLOCKS": "Os meus bloques",
    "DUPLICATE": "Duplicar",
    "DELETE": "Borrar",
    "ADD_COMMENT": "Engadir comentario",
    "REMOVE_COMMENT": "Retirar comentario",
    "DELETE_BLOCK": "Eliminar bloque",
    "DELETE_X_BLOCKS": "Eliminar %1 bloques",
    "DELETE_ALL_BLOCKS": "Eliminar os %1 bloques?",
    "CLEAN_UP": "Limpar bloques",
    "HELP": "Axuda",
    "UNDO": "Desfacer",
    "REDO": "Refacer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Ir a definición",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Dicir algo...",
    "COLOUR_HUE_LABEL": "Cor",
    "COLOUR_SATURATION_LABEL": "Saturación",
    "COLOUR_BRIGHTNESS_LABEL": "Luminosidade",
    "CHANGE_VALUE_TITLE": "Cambiar valor:",
    "RENAME_VARIABLE": "Renomear variábel",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renomear variábel",
    "NEW_VARIABLE": "Crear unha variábel",
    "NEW_VARIABLE_TITLE": "Novo nome da variábel:",
    "VARIABLE_MODAL_TITLE": "Nova Variable",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Crear un bloque",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Crear unha lista",
    "NEW_LIST_TITLE": "Novo nome da lista:",
    "LIST_MODAL_TITLE": "Nova lista",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Renomear lista",
    "NEW_BROADCAST_MESSAGE": "Nova mensaxe",
    "NEW_BROADCAST_MESSAGE_TITLE": "Novo nome da mensaxe:",
    "BROADCAST_MODAL_TITLE": "Mensaxe nova",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensaxe1"
};

Blockly.ScratchMsgs.locales["he"] =
{
    "CONTROL_FOREVER": "לעולמים",
    "CONTROL_REPEAT": "חזור  %1 פעמים",
    "CONTROL_IF": "אם %1 אז",
    "CONTROL_ELSE": "אחרת",
    "CONTROL_STOP": "עצור",
    "CONTROL_STOP_ALL": "הכל",
    "CONTROL_STOP_THIS": "תסריט זה",
    "CONTROL_STOP_OTHER": "תסריטים אחרים בדמות",
    "CONTROL_WAIT": "חכה %1 שניות",
    "CONTROL_WAITUNTIL": "חכה עד ש %1",
    "CONTROL_REPEATUNTIL": "חזור עד ש %1",
    "CONTROL_WHILE": "כל עוד %1",
    "CONTROL_FOREACH": "עבור כל %1 ב %2",
    "CONTROL_STARTASCLONE": "כאשר מופעל ככפיל",
    "CONTROL_CREATECLONEOF": "צור כפיל של %1",
    "CONTROL_CREATECLONEOF_MYSELF": "עצמי",
    "CONTROL_DELETETHISCLONE": "מחק כפיל זה",
    "CONTROL_COUNTER": "מונה",
    "CONTROL_INCRCOUNTER": "הגדל מונה",
    "CONTROL_CLEARCOUNTER": "אפס מונה",
    "CONTROL_ALLATONCE": "הכל בבת אחת",
    "DATA_SETVARIABLETO": "קבע %1 ל %2",
    "DATA_CHANGEVARIABLEBY": "שנה ערך %1 ב %2",
    "DATA_SHOWVARIABLE": "הצג משתנה %1",
    "DATA_HIDEVARIABLE": "הסתר משתנה %1",
    "DATA_ADDTOLIST": "הוסף %1 ל %2",
    "DATA_DELETEOFLIST": "מחק פריט %1 מתוך %2",
    "DATA_INSERTATLIST": "הכנס %1 במקום %2 של %3",
    "DATA_REPLACEITEMOFLIST": "קבע פריט %1 של %2 ל %3",
    "DATA_ITEMOFLIST": "פריט %1 של %2",
    "DATA_LENGTHOFLIST": "אורך של %1",
    "DATA_LISTCONTAINSITEM": "%1 מכיל %2 ?",
    "DATA_SHOWLIST": "הצג רשימה %1",
    "DATA_HIDELIST": "הסתר רשימה %1",
    "DATA_INDEX_ALL": "הכל",
    "DATA_INDEX_LAST": "אחרון",
    "DATA_INDEX_RANDOM": "אקראי",
    "EVENT_WHENFLAGCLICKED": "כאשר לוחצים על %1",
    "EVENT_WHENTHISSPRITECLICKED": "כאשר לוחצים על דמות זו",
    "EVENT_WHENSTAGECLICKED": "כאשר לוחצים על הבמה",
    "EVENT_WHENTOUCHINGOBJECT": "כאשר דמות זו נוגעת ב %1",
    "EVENT_WHENBROADCASTRECEIVED": "כאשר מתקבל מסר %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "כאשר הרקע משתנה ל %1",
    "EVENT_WHENGREATERTHAN": "כאשר %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "שעון עצר",
    "EVENT_BROADCAST": "שדר מסר %1",
    "EVENT_BROADCASTANDWAIT": "שדר מסר %1 וחכה",
    "EVENT_WHENKEYPRESSED": "כאשר נלחץ מקש %1",
    "EVENT_WHENKEYPRESSED_SPACE": "רווח",
    "EVENT_WHENKEYPRESSED_LEFT": "חץ שמאלי",
    "EVENT_WHENKEYPRESSED_RIGHT": "חץ ימני",
    "EVENT_WHENKEYPRESSED_DOWN": "חץ מטה",
    "EVENT_WHENKEYPRESSED_UP": "חץ מעלה",
    "EVENT_WHENKEYPRESSED_ANY": "כל",
    "LOOKS_SAYFORSECS": "אמור %1 למשך %2 שניות",
    "LOOKS_SAY": "אמור %1",
    "LOOKS_HELLO": "שלום!",
    "LOOKS_THINKFORSECS": "חשוב %1 למשך %2 שניות",
    "LOOKS_THINK": "חשוב %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "הצג",
    "LOOKS_HIDE": "הסתר",
    "LOOKS_HIDEALLSPRITES": "הסתר את כל הדמויות",
    "LOOKS_EFFECT_COLOR": "צבע",
    "LOOKS_EFFECT_FISHEYE": "עין דג",
    "LOOKS_EFFECT_WHIRL": "סחרור",
    "LOOKS_EFFECT_PIXELATE": "פיקסלים",
    "LOOKS_EFFECT_MOSAIC": "פסיפס",
    "LOOKS_EFFECT_BRIGHTNESS": "בהירות",
    "LOOKS_EFFECT_GHOST": "רוח",
    "LOOKS_CHANGEEFFECTBY": "שנה אפקט %1 ב %2",
    "LOOKS_SETEFFECTTO": "קבע אפקט %1 ל %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "נקה אפקטים",
    "LOOKS_CHANGESIZEBY": "שנה גודל ב %1",
    "LOOKS_SETSIZETO": "קבע גודל ל %1 %",
    "LOOKS_SIZE": "גודל",
    "LOOKS_CHANGESTRETCHBY": "שנה מתיחה ב %1",
    "LOOKS_SETSTRETCHTO": "קבע מתיחה ל %1",
    "LOOKS_SWITCHCOSTUMETO": "קבע תלבושת ל %1",
    "LOOKS_NEXTCOSTUME": "התלבושת הבאה",
    "LOOKS_SWITCHBACKDROPTO": "קבע רקע ל %1",
    "LOOKS_GOTOFRONTBACK": "העבר לשכבה ה %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "קדמית",
    "LOOKS_GOTOFRONTBACK_BACK": "אחורית",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "העבר %2 שכבות %1",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "קדימה",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "אחורה",
    "LOOKS_BACKDROPNUMBERNAME": "רקע %1",
    "LOOKS_COSTUMENUMBERNAME": "תלבושת %1",
    "LOOKS_NUMBERNAME_NUMBER": "מספר",
    "LOOKS_NUMBERNAME_NAME": "שם",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "החלף רקע ל %1 וחכה",
    "LOOKS_NEXTBACKDROP": "הרקע הבא",
    "LOOKS_PREVIOUSBACKDROP": "הרקע הקודם",
    "LOOKS_RANDOMBACKDROP": "רקע אקראי",
    "MOTION_MOVESTEPS": "זוז %1 צעדים",
    "MOTION_TURNLEFT": "הסתובב %1 %2 מעלות",
    "MOTION_TURNRIGHT": "הסתובב %1 %2 מעלות",
    "MOTION_POINTINDIRECTION": "פנה לכיוון %1",
    "MOTION_POINTTOWARDS": "פנה לכיוון של %1",
    "MOTION_POINTTOWARDS_POINTER": "מצביע העכבר",
    "MOTION_GOTO": "קפוץ אל %1",
    "MOTION_GOTO_POINTER": "מצביע העכבר",
    "MOTION_GOTO_RANDOM": "מיקום אקראי",
    "MOTION_GOTOXY": "קפוץ אל x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "גלוש %1 שניות ל x: %2 y: %3",
    "MOTION_GLIDETO": "גלוש %1 שניות ל %2",
    "MOTION_GLIDETO_POINTER": "סמן העכבר",
    "MOTION_GLIDETO_RANDOM": "מיקום אקראי",
    "MOTION_CHANGEXBY": "שנה את ערך x ב %1",
    "MOTION_SETX": "קבע את x ל %1",
    "MOTION_CHANGEYBY": "שנה את ערך y ב %1",
    "MOTION_SETY": "קבע את ערך y ל %1",
    "MOTION_IFONEDGEBOUNCE": "בנגיעה במסגרת שנה כיוון",
    "MOTION_SETROTATIONSTYLE": "קבע אופן סיבוב %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "שמאל-ימין",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "בטל סיבוב",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "מסביב",
    "MOTION_XPOSITION": "מיקום על ציר x",
    "MOTION_YPOSITION": "מיקום על ציר Y",
    "MOTION_DIRECTION": "כיוון",
    "MOTION_SCROLLRIGHT": "גלול ימינה %1",
    "MOTION_SCROLLUP": "גלול למעלה %1",
    "MOTION_ALIGNSCENE": "ישר סצנה %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "למטה־משמאל",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "למטה־מימין",
    "MOTION_ALIGNSCENE_MIDDLE": "אמצעי",
    "MOTION_ALIGNSCENE_TOPLEFT": "למעלה־משמאל",
    "MOTION_ALIGNSCENE_TOPRIGHT": "למעלה־מימין",
    "MOTION_XSCROLL": "גלילה בציר x",
    "MOTION_YSCROLL": "גלילה בציר y",
    "MOTION_STAGE_SELECTED": "נבחרה במה: אין לבנים לתנועה",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "בחר מספר אקראי בין %1 ל %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 וגם %2",
    "OPERATORS_OR": "%1 או %2",
    "OPERATORS_NOT": "לא %1",
    "OPERATORS_JOIN": "חבר %1 %2",
    "OPERATORS_JOIN_APPLE": "תפוח",
    "OPERATORS_JOIN_BANANA": "בננה",
    "OPERATORS_LETTEROF": "אות %1 של %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "האורך של %1",
    "OPERATORS_CONTAINS": "%1 מכיל %2 ?",
    "OPERATORS_MOD": "%1 מודולו %2",
    "OPERATORS_ROUND": "עגל %1",
    "OPERATORS_MATHOP": "%1 של %2",
    "OPERATORS_MATHOP_ABS": "ערך מוחלט",
    "OPERATORS_MATHOP_FLOOR": "עיגול למטה",
    "OPERATORS_MATHOP_CEILING": "עיגול למעלה",
    "OPERATORS_MATHOP_SQRT": "שורש ריבועי",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": " ^e",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "הגדר %1",
    "SENSING_TOUCHINGOBJECT": "נוגע ב %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "סמן העכבר",
    "SENSING_TOUCHINGOBJECT_EDGE": "קצה",
    "SENSING_TOUCHINGCOLOR": "נוגע בצבע  %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "צבע %1 נוגע בצבע %2?",
    "SENSING_DISTANCETO": "מרחק אל %1",
    "SENSING_DISTANCETO_POINTER": "סמן העכבר",
    "SENSING_ASKANDWAIT": "שאל %1 והמתן",
    "SENSING_ASK_TEXT": "מה השם שלך?",
    "SENSING_ANSWER": "תשובה",
    "SENSING_KEYPRESSED": "מקש %1 נלחץ?",
    "SENSING_MOUSEDOWN": "עכבר נלחץ?",
    "SENSING_MOUSEX": "מיקום עכבר בציר x",
    "SENSING_MOUSEY": "מיקום עכבר בציר y",
    "SENSING_SETDRAGMODE": "קבע מצב גרירה ל %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ניתן לגרירה",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "לא ניתן לגרירה",
    "SENSING_LOUDNESS": "עוצמת קול",
    "SENSING_LOUD": "עוצמת קול?",
    "SENSING_TIMER": "שעון עצר",
    "SENSING_RESETTIMER": "אפס מונה",
    "SENSING_OF": "%1 של %2",
    "SENSING_OF_XPOSITION": "מיקום על ציר x",
    "SENSING_OF_YPOSITION": "מיקום על ציר y",
    "SENSING_OF_DIRECTION": "כיוון",
    "SENSING_OF_COSTUMENUMBER": "תלבושת #",
    "SENSING_OF_COSTUMENAME": "שם תלבושת",
    "SENSING_OF_SIZE": "גודל",
    "SENSING_OF_VOLUME": "עוצמת קול",
    "SENSING_OF_BACKDROPNUMBER": "רקע #",
    "SENSING_OF_BACKDROPNAME": "שם רקע",
    "SENSING_OF_STAGE": "במה",
    "SENSING_CURRENT": "%1 נוכחית",
    "SENSING_CURRENT_YEAR": "שנה",
    "SENSING_CURRENT_MONTH": "חודש",
    "SENSING_CURRENT_DATE": "תאריך",
    "SENSING_CURRENT_DAYOFWEEK": "יום בשבוע",
    "SENSING_CURRENT_HOUR": "שעה",
    "SENSING_CURRENT_MINUTE": "דקה",
    "SENSING_CURRENT_SECOND": "שניה",
    "SENSING_DAYSSINCE2000": "ימים מאז 2000",
    "SENSING_USERNAME": "שם משתמש",
    "SENSING_USERID": "זהות המשתמש",
    "SOUND_PLAY": "נגן צליל %1",
    "SOUND_PLAYUNTILDONE": "נגן צליל %1 עד לסיום",
    "SOUND_STOPALLSOUNDS": "הפסק את כל הצלילים",
    "SOUND_SETEFFECTO": "קבע אפקט %1 ל %2",
    "SOUND_CHANGEEFFECTBY": "שנה אפקט %1 ב %2",
    "SOUND_CLEAREFFECTS": "נקה אפקטים קוליים",
    "SOUND_EFFECTS_PITCH": "גובה צליל",
    "SOUND_EFFECTS_PAN": "ערוץ שמע שמאלי/ימני",
    "SOUND_CHANGEVOLUMEBY": "שנה עוצמת קול ב %1",
    "SOUND_SETVOLUMETO": "קבע עוצמת קול ל %1%",
    "SOUND_VOLUME": "עוצמת קול",
    "CATEGORY_MOTION": "תנועה",
    "CATEGORY_LOOKS": "מראה",
    "CATEGORY_SOUND": "צלילים",
    "CATEGORY_EVENTS": "אירועים",
    "CATEGORY_CONTROL": "בקרה",
    "CATEGORY_SENSING": "חיישנים",
    "CATEGORY_OPERATORS": "מפעילים",
    "CATEGORY_VARIABLES": "משתנים",
    "CATEGORY_MYBLOCKS": "הלבנים שלי",
    "DUPLICATE": "שכפל",
    "DELETE": "מחק",
    "ADD_COMMENT": "הוסף תגובה",
    "REMOVE_COMMENT": "מחק תגובה",
    "DELETE_BLOCK": "מחק לבנה",
    "DELETE_X_BLOCKS": "מחק %1 לבנים ",
    "DELETE_ALL_BLOCKS": "למחוק את כל הלבנים של %1?",
    "CLEAN_UP": "נקה לבנים",
    "HELP": "עזרה",
    "UNDO": "בטל",
    "REDO": "בצע שוב",
    "EDIT_PROCEDURE": "ערוך",
    "SHOW_PROCEDURE_DEFINITION": "עבור להגדרה",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "אמור משהו...",
    "COLOUR_HUE_LABEL": "צבע",
    "COLOUR_SATURATION_LABEL": "רווי צבע",
    "COLOUR_BRIGHTNESS_LABEL": "בהירות",
    "CHANGE_VALUE_TITLE": "שנה ערך:",
    "RENAME_VARIABLE": "שנה שם משתנה",
    "RENAME_VARIABLE_TITLE": "שנה שמם של המשתנים \"%1\" ל:",
    "RENAME_VARIABLE_MODAL_TITLE": "שנה שם משתנה",
    "NEW_VARIABLE": "צור משתנה",
    "NEW_VARIABLE_TITLE": "שם המשתנה",
    "VARIABLE_MODAL_TITLE": "משתנה חדשה",
    "VARIABLE_ALREADY_EXISTS": "משתנה בשם \"%1\" כבר קיים",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "משתנה בשם  \"%1\" כבר קיים למשתנה  מסוג \"%2\"",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "צור לבנה",
    "PROCEDURE_ALREADY_EXISTS": "פרוצדורה בשם  \"%1\" כבר קיימת",
    "NEW_LIST": "צור רשימה",
    "NEW_LIST_TITLE": "שם הרשימה",
    "LIST_MODAL_TITLE": "רשימה חדשה",
    "LIST_ALREADY_EXISTS": "רשימה בשם \"%1\" כבר קיימת",
    "RENAME_LIST_TITLE": "שנה כל \"%1\" הרשימות ל:",
    "RENAME_LIST_MODAL_TITLE": "שנה שם רשימה",
    "NEW_BROADCAST_MESSAGE": "מסר חדש",
    "NEW_BROADCAST_MESSAGE_TITLE": "צור מסר חדש",
    "BROADCAST_MODAL_TITLE": "מסר חדש",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "מסר 1"
};

Blockly.ScratchMsgs.locales["hu"] =
{
    "CONTROL_FOREVER": "örökké",
    "CONTROL_REPEAT": "repeat %1",
    "CONTROL_IF": "if %1 then",
    "CONTROL_ELSE": "különben",
    "CONTROL_STOP": "állj",
    "CONTROL_STOP_ALL": "mind",
    "CONTROL_STOP_THIS": "ez a feladat",
    "CONTROL_STOP_OTHER": "szereplő többi feladata",
    "CONTROL_WAIT": "wait %1 seconds",
    "CONTROL_WAITUNTIL": "wait until %1",
    "CONTROL_REPEATUNTIL": "repeat until %1",
    "CONTROL_WHILE": "while %1",
    "CONTROL_FOREACH": "for each %1 in %2",
    "CONTROL_STARTASCLONE": "mikor indul, mint egy klón",
    "CONTROL_CREATECLONEOF": "create clone of %1",
    "CONTROL_CREATECLONEOF_MYSELF": "magadról",
    "CONTROL_DELETETHISCLONE": "klón törlése",
    "CONTROL_COUNTER": "számláló",
    "CONTROL_INCRCOUNTER": "increment counter",
    "CONTROL_CLEARCOUNTER": "clear counter",
    "CONTROL_ALLATONCE": "all at once",
    "DATA_SETVARIABLETO": "set %1 to %2",
    "DATA_CHANGEVARIABLEBY": "change %1 by %2",
    "DATA_SHOWVARIABLE": "show variable %1",
    "DATA_HIDEVARIABLE": "hide variable %1",
    "DATA_ADDTOLIST": "add %1 to %2",
    "DATA_DELETEOFLIST": "delete %1 of %2",
    "DATA_INSERTATLIST": "insert %1 at %2 of %3",
    "DATA_REPLACEITEMOFLIST": "replace item %1 of %2 with %3",
    "DATA_ITEMOFLIST": "item %1 of %2",
    "DATA_LENGTHOFLIST": "length of %1",
    "DATA_LISTCONTAINSITEM": "%1 contains %2?",
    "DATA_SHOWLIST": "show list %1",
    "DATA_HIDELIST": "hide list %1",
    "DATA_INDEX_ALL": "mind",
    "DATA_INDEX_LAST": "utolsó",
    "DATA_INDEX_RANDOM": "véletlen",
    "EVENT_WHENFLAGCLICKED": "when %1 clicked",
    "EVENT_WHENTHISSPRITECLICKED": "ha erre a szereplőre a kattint",
    "EVENT_WHENSTAGECLICKED": "when stage clicked",
    "EVENT_WHENTOUCHINGOBJECT": "when this sprite touches %1",
    "EVENT_WHENBROADCASTRECEIVED": "when I receive %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "when backdrop switches to %1",
    "EVENT_WHENGREATERTHAN": "when %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "időzítő",
    "EVENT_BROADCAST": "broadcast %1",
    "EVENT_BROADCASTANDWAIT": "broadcast %1 and wait",
    "EVENT_WHENKEYPRESSED": "when %1 key pressed",
    "EVENT_WHENKEYPRESSED_SPACE": "szóköz",
    "EVENT_WHENKEYPRESSED_LEFT": "balra nyíl",
    "EVENT_WHENKEYPRESSED_RIGHT": "jobbra nyíl",
    "EVENT_WHENKEYPRESSED_DOWN": "lefele nyíl",
    "EVENT_WHENKEYPRESSED_UP": "felfele nyíl",
    "EVENT_WHENKEYPRESSED_ANY": "egyik",
    "LOOKS_SAYFORSECS": "say %1 for %2 seconds",
    "LOOKS_SAY": "say %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "think %1 for %2 seconds",
    "LOOKS_THINK": "think %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "mutat",
    "LOOKS_HIDE": "elrejt",
    "LOOKS_HIDEALLSPRITES": "hide all sprites",
    "LOOKS_EFFECT_COLOR": "szín",
    "LOOKS_EFFECT_FISHEYE": "halszem",
    "LOOKS_EFFECT_WHIRL": "örvény",
    "LOOKS_EFFECT_PIXELATE": "képpont",
    "LOOKS_EFFECT_MOSAIC": "mozaik",
    "LOOKS_EFFECT_BRIGHTNESS": "fényerő",
    "LOOKS_EFFECT_GHOST": "szellem",
    "LOOKS_CHANGEEFFECTBY": "change %1 effect by %2",
    "LOOKS_SETEFFECTTO": "set %1 effect to %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "töröld a grafikus hatásokat",
    "LOOKS_CHANGESIZEBY": "change size by %1",
    "LOOKS_SETSIZETO": "set size to %1 %",
    "LOOKS_SIZE": "méret",
    "LOOKS_CHANGESTRETCHBY": "change stretch by %1",
    "LOOKS_SETSTRETCHTO": "set stretch to %1 %",
    "LOOKS_SWITCHCOSTUMETO": "switch costume to %1",
    "LOOKS_NEXTCOSTUME": "következő jelmez",
    "LOOKS_SWITCHBACKDROPTO": "switch backdrop to %1",
    "LOOKS_GOTOFRONTBACK": "go to %1 layer",
    "LOOKS_GOTOFRONTBACK_FRONT": "előtérbe",
    "LOOKS_GOTOFRONTBACK_BACK": "háttérbe",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "go %1 %2 layers",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "előre",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "hátra",
    "LOOKS_BACKDROPNUMBERNAME": "backdrop %1",
    "LOOKS_COSTUMENUMBERNAME": "costume %1",
    "LOOKS_NUMBERNAME_NUMBER": "szám",
    "LOOKS_NUMBERNAME_NAME": "név",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "switch backdrop to %1 and wait",
    "LOOKS_NEXTBACKDROP": "következő háttér",
    "LOOKS_PREVIOUSBACKDROP": "előző háttér",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "move %1 steps",
    "MOTION_TURNLEFT": "fordulj %1 %2 fokot",
    "MOTION_TURNRIGHT": "fordulj %1 %2 fokot",
    "MOTION_POINTINDIRECTION": "point in direction %1",
    "MOTION_POINTTOWARDS": "point towards %1",
    "MOTION_POINTTOWARDS_POINTER": "egérmutató",
    "MOTION_GOTO": "ugorj %1",
    "MOTION_GOTO_POINTER": "egérmutató",
    "MOTION_GOTO_RANDOM": "véletlen pozíció",
    "MOTION_GOTOXY": "go to x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glide %1 secs to x: %2 y: %3",
    "MOTION_GLIDETO": "glide %1 secs to %2",
    "MOTION_GLIDETO_POINTER": "egérmutató",
    "MOTION_GLIDETO_RANDOM": "véletlen pozíció",
    "MOTION_CHANGEXBY": "change x by %1",
    "MOTION_SETX": "set x to %1",
    "MOTION_CHANGEYBY": "change y by %1",
    "MOTION_SETY": "set y to %1",
    "MOTION_IFONEDGEBOUNCE": "ha a szélén, ugrál",
    "MOTION_SETROTATIONSTYLE": "set rotation style %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "balra-jobbra",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "nem foroghat",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "foroghat",
    "MOTION_XPOSITION": "x pozíció",
    "MOTION_YPOSITION": "y pozíció",
    "MOTION_DIRECTION": "irány",
    "MOTION_SCROLLRIGHT": "scroll right %1",
    "MOTION_SCROLLUP": "scroll up %1",
    "MOTION_ALIGNSCENE": "align scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bottom-left",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bottom-right",
    "MOTION_ALIGNSCENE_MIDDLE": "middle",
    "MOTION_ALIGNSCENE_TOPLEFT": "top-left",
    "MOTION_ALIGNSCENE_TOPRIGHT": "top-right",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "pick random %1 to %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 és %2",
    "OPERATORS_OR": "%1 vagy %2",
    "OPERATORS_NOT": "not %1",
    "OPERATORS_JOIN": "join %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letter %1 of %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "length of %1",
    "OPERATORS_CONTAINS": "%1 contains %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "round %1",
    "OPERATORS_MATHOP": "%1 of %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "lefelé kerekítve",
    "OPERATORS_MATHOP_CEILING": "felfelé kerekítve",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "define %1",
    "SENSING_TOUCHINGOBJECT": "touching %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "egérmutató",
    "SENSING_TOUCHINGOBJECT_EDGE": "játéktér széle",
    "SENSING_TOUCHINGCOLOR": "touching color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "color %1 is touching %2?",
    "SENSING_DISTANCETO": "distance to %1",
    "SENSING_DISTANCETO_POINTER": "egérmutató",
    "SENSING_ASKANDWAIT": "ask %1 and wait",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "válasz",
    "SENSING_KEYPRESSED": "key %1 pressed?",
    "SENSING_MOUSEDOWN": "egér lenyomva?",
    "SENSING_MOUSEX": "egér x",
    "SENSING_MOUSEY": "egér y",
    "SENSING_SETDRAGMODE": "set drag mode %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "draggable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "not draggable",
    "SENSING_LOUDNESS": "hangerő",
    "SENSING_LOUD": "loud?",
    "SENSING_TIMER": "időzítő",
    "SENSING_RESETTIMER": "időzítő visszaállítása",
    "SENSING_OF": "%1 of %2",
    "SENSING_OF_XPOSITION": "x pozíció",
    "SENSING_OF_YPOSITION": "y pozíció",
    "SENSING_OF_DIRECTION": "irány",
    "SENSING_OF_COSTUMENUMBER": "lemez #",
    "SENSING_OF_COSTUMENAME": "jelmez név",
    "SENSING_OF_SIZE": "méret",
    "SENSING_OF_VOLUME": "hangerő",
    "SENSING_OF_BACKDROPNUMBER": "háttér sorszáma",
    "SENSING_OF_BACKDROPNAME": "háttér neve",
    "SENSING_OF_STAGE": "Játéktér",
    "SENSING_CURRENT": "current %1",
    "SENSING_CURRENT_YEAR": "év",
    "SENSING_CURRENT_MONTH": "hónap",
    "SENSING_CURRENT_DATE": "nap",
    "SENSING_CURRENT_DAYOFWEEK": "hét napja",
    "SENSING_CURRENT_HOUR": "óra",
    "SENSING_CURRENT_MINUTE": "perc",
    "SENSING_CURRENT_SECOND": "másodperc",
    "SENSING_DAYSSINCE2000": "napok 2000 óta",
    "SENSING_USERNAME": "felhasználónév",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "start sound %1",
    "SOUND_PLAYUNTILDONE": "play sound %1 until done",
    "SOUND_STOPALLSOUNDS": "minden hang álljon le",
    "SOUND_SETEFFECTO": "set %1 effect to %2",
    "SOUND_CHANGEEFFECTBY": "change %1 effect by %2",
    "SOUND_CLEAREFFECTS": "clear sound effects",
    "SOUND_EFFECTS_PITCH": "pitch",
    "SOUND_EFFECTS_PAN": "pan left/right",
    "SOUND_CHANGEVOLUMEBY": "change volume by %1",
    "SOUND_SETVOLUMETO": "set volume to %1%",
    "SOUND_VOLUME": "hangerő",
    "CATEGORY_MOTION": "Mozgás",
    "CATEGORY_LOOKS": "Kinézet",
    "CATEGORY_SOUND": "Hang",
    "CATEGORY_EVENTS": "Események",
    "CATEGORY_CONTROL": "Vezérlőelem",
    "CATEGORY_SENSING": "Érzékelés",
    "CATEGORY_OPERATORS": "Operátorok",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "My Blocks",
    "DUPLICATE": "Duplikálás",
    "DELETE": "Törlés",
    "ADD_COMMENT": "Add Comment",
    "REMOVE_COMMENT": "Remove Comment",
    "DELETE_BLOCK": "Delete Block",
    "DELETE_X_BLOCKS": "Delete %1 Blocks",
    "DELETE_ALL_BLOCKS": "Delete all %1 blocks?",
    "CLEAN_UP": "Clean up Blocks",
    "HELP": "Súgó",
    "UNDO": "Visszavonás",
    "REDO": "Mégis",
    "EDIT_PROCEDURE": "Szerkesztés",
    "SHOW_PROCEDURE_DEFINITION": "Go to definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Say something...",
    "COLOUR_HUE_LABEL": "Szín",
    "COLOUR_SATURATION_LABEL": "Színtelítettség",
    "COLOUR_BRIGHTNESS_LABEL": "Fényerő",
    "CHANGE_VALUE_TITLE": "Change value:",
    "RENAME_VARIABLE": "Rename variable",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Rename Variable",
    "NEW_VARIABLE": "Készíts egy változót",
    "NEW_VARIABLE_TITLE": "New variable name:",
    "VARIABLE_MODAL_TITLE": "Új változó",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Készíts blokkot",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Készíts egy listát",
    "NEW_LIST_TITLE": "New list name:",
    "LIST_MODAL_TITLE": "Új lista",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Rename List",
    "NEW_BROADCAST_MESSAGE": "New message",
    "NEW_BROADCAST_MESSAGE_TITLE": "New message name:",
    "BROADCAST_MODAL_TITLE": "Új üzenet",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "üzenet1"
};

Blockly.ScratchMsgs.locales["id"] =
{
    "CONTROL_FOREVER": "selamanya",
    "CONTROL_REPEAT": "ulangi %1 kali",
    "CONTROL_IF": "jika %1 maka",
    "CONTROL_ELSE": "jika tidak",
    "CONTROL_STOP": "berhenti",
    "CONTROL_STOP_ALL": "semua",
    "CONTROL_STOP_THIS": "skrip ini",
    "CONTROL_STOP_OTHER": "skrip lain di sprite ini",
    "CONTROL_WAIT": "tunggu %1 detik",
    "CONTROL_WAITUNTIL": "tunggu sampai %1",
    "CONTROL_REPEATUNTIL": "ulangi sampai %1",
    "CONTROL_WHILE": "selama %1",
    "CONTROL_FOREACH": "untuk setiap %1 dalam %2",
    "CONTROL_STARTASCLONE": "ketika aku mulai sebagai clone",
    "CONTROL_CREATECLONEOF": "buat clone dari %1",
    "CONTROL_CREATECLONEOF_MYSELF": "diriku",
    "CONTROL_DELETETHISCLONE": "hapus clone ini",
    "CONTROL_COUNTER": "hitungan",
    "CONTROL_INCRCOUNTER": "tingkatkan hitungan",
    "CONTROL_CLEARCOUNTER": "bersihkan hitungan",
    "CONTROL_ALLATONCE": "semuanya sekaligus",
    "DATA_SETVARIABLETO": "atur %1 ke %2",
    "DATA_CHANGEVARIABLEBY": "ubah %1 sebesar %2",
    "DATA_SHOWVARIABLE": "tampilkan variabel %1",
    "DATA_HIDEVARIABLE": "sembunyikan variabel %1",
    "DATA_ADDTOLIST": "tambahkan %1 ke %2",
    "DATA_DELETEOFLIST": "hapus %1 dari %2",
    "DATA_INSERTATLIST": "sisipkan %1 pada %2 dari %3",
    "DATA_REPLACEITEMOFLIST": "ganti benda %1 dari %2 dengan %3",
    "DATA_ITEMOFLIST": "benda %1 dari %2",
    "DATA_LENGTHOFLIST": "panjang dari %1",
    "DATA_LISTCONTAINSITEM": "%1 berisi %2?",
    "DATA_SHOWLIST": "tampilkan daftar %1",
    "DATA_HIDELIST": "sembunyikan daftar %1",
    "DATA_INDEX_ALL": "semua",
    "DATA_INDEX_LAST": "terakhir",
    "DATA_INDEX_RANDOM": "random",
    "EVENT_WHENFLAGCLICKED": "ketika %1 diklik",
    "EVENT_WHENTHISSPRITECLICKED": "ketika sprite ini diklik",
    "EVENT_WHENSTAGECLICKED": "ketika panggung diklik",
    "EVENT_WHENTOUCHINGOBJECT": "ketika sprite ini menyentuk %1",
    "EVENT_WHENBROADCASTRECEIVED": "ketika aku menerima %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "ketika latar menjadi %1",
    "EVENT_WHENGREATERTHAN": "ketika %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "pengatur waktu",
    "EVENT_BROADCAST": "siarkan %1",
    "EVENT_BROADCASTANDWAIT": "siarkan %1 dan tunggu",
    "EVENT_WHENKEYPRESSED": "ketika tombol %1 ditekan",
    "EVENT_WHENKEYPRESSED_SPACE": "spasi",
    "EVENT_WHENKEYPRESSED_LEFT": "panah kiri",
    "EVENT_WHENKEYPRESSED_RIGHT": "panah kanan",
    "EVENT_WHENKEYPRESSED_DOWN": "panah bawah",
    "EVENT_WHENKEYPRESSED_UP": "panah atas",
    "EVENT_WHENKEYPRESSED_ANY": "manapun",
    "LOOKS_SAYFORSECS": "katakan %1 selama %2 detik",
    "LOOKS_SAY": "katakan %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "pikirkan %1 selama %2 detik",
    "LOOKS_THINK": "pikirkan %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "tampilkan",
    "LOOKS_HIDE": "sembunyikan",
    "LOOKS_HIDEALLSPRITES": "sembunyikan semua sprite",
    "LOOKS_EFFECT_COLOR": "warna",
    "LOOKS_EFFECT_FISHEYE": "mata ikan",
    "LOOKS_EFFECT_WHIRL": "pusaran",
    "LOOKS_EFFECT_PIXELATE": "pixelasi",
    "LOOKS_EFFECT_MOSAIC": "mosaik",
    "LOOKS_EFFECT_BRIGHTNESS": "kecerahan",
    "LOOKS_EFFECT_GHOST": "bayangan",
    "LOOKS_CHANGEEFFECTBY": "ubah efek %1 sebesar %2",
    "LOOKS_SETEFFECTTO": "atur efek %1 ke %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "hapus semua efek grafis",
    "LOOKS_CHANGESIZEBY": "ubah ukuran sebesar %1",
    "LOOKS_SETSIZETO": "atur ukuran ke %1 %",
    "LOOKS_SIZE": "ukuran",
    "LOOKS_CHANGESTRETCHBY": "ubah rentangan sebesar %1",
    "LOOKS_SETSTRETCHTO": "atur rentangan ke %1 %",
    "LOOKS_SWITCHCOSTUMETO": "ganti kostum ke %1",
    "LOOKS_NEXTCOSTUME": "kostum berikutnya",
    "LOOKS_SWITCHBACKDROPTO": "ganti latar ke %1",
    "LOOKS_GOTOFRONTBACK": "pergi ke lapisan %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "depan",
    "LOOKS_GOTOFRONTBACK_BACK": "belakang",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "pergi %1 %2 lapisan",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "maju",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "mundur",
    "LOOKS_BACKDROPNUMBERNAME": "latar %1",
    "LOOKS_COSTUMENUMBERNAME": "kostum %1",
    "LOOKS_NUMBERNAME_NUMBER": "angka",
    "LOOKS_NUMBERNAME_NAME": "nama",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "ganti latar ke %1 dan tunggu",
    "LOOKS_NEXTBACKDROP": "latar berikutnya",
    "LOOKS_PREVIOUSBACKDROP": "Latar sebelumnya",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "gerak %1 langkah",
    "MOTION_TURNLEFT": "putar %1 %2 derajat",
    "MOTION_TURNRIGHT": "putar %1 %2 derajat",
    "MOTION_POINTINDIRECTION": "mengarah ke arah %1",
    "MOTION_POINTTOWARDS": "mengarah ke %1",
    "MOTION_POINTTOWARDS_POINTER": "penunjuk tetikus",
    "MOTION_GOTO": "pergi ke %1",
    "MOTION_GOTO_POINTER": "penunjuk tetikus",
    "MOTION_GOTO_RANDOM": "posisi sembarang",
    "MOTION_GOTOXY": "pergi ke x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "meluncur %1 detik ke x: %2 y: %3",
    "MOTION_GLIDETO": "meluncur %1 detik ke %2",
    "MOTION_GLIDETO_POINTER": "penunjuk tetikus",
    "MOTION_GLIDETO_RANDOM": "posisi sembarang",
    "MOTION_CHANGEXBY": "ubah x sebesar %1",
    "MOTION_SETX": "atur x ke %1",
    "MOTION_CHANGEYBY": "ubah y sebesar %1",
    "MOTION_SETY": "atur y ke %1",
    "MOTION_IFONEDGEBOUNCE": "jika di pinggir, pantulkan",
    "MOTION_SETROTATIONSTYLE": "atur gaya rotasi %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "kiri-kanan",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "jangan berputar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "seluruh",
    "MOTION_XPOSITION": "posisi x",
    "MOTION_YPOSITION": "posisi y",
    "MOTION_DIRECTION": "arah",
    "MOTION_SCROLLRIGHT": "gulir ke kanan %1",
    "MOTION_SCROLLUP": "gulir ke atas %1",
    "MOTION_ALIGNSCENE": "luruskan pemandangan %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "kiri-bawah",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "kanan-bawah",
    "MOTION_ALIGNSCENE_MIDDLE": "tengah",
    "MOTION_ALIGNSCENE_TOPLEFT": "kiri-atas",
    "MOTION_ALIGNSCENE_TOPRIGHT": "kanan-atas",
    "MOTION_XSCROLL": "guliran x",
    "MOTION_YSCROLL": "guliran y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "pilih acak dari %1 hingga %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 dan %2",
    "OPERATORS_OR": "%1 atau %2",
    "OPERATORS_NOT": "tidak %1",
    "OPERATORS_JOIN": "gabungkan %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "huruf %1 dari %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "panjang dari %1",
    "OPERATORS_CONTAINS": "%1 berisi %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "bulatkan %1",
    "OPERATORS_MATHOP": "%1 dari %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "floor",
    "OPERATORS_MATHOP_CEILING": "ceil",
    "OPERATORS_MATHOP_SQRT": "akar kuadrat",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "artikan %1",
    "SENSING_TOUCHINGOBJECT": "menyentuh %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "penunjuk tetikus",
    "SENSING_TOUCHINGOBJECT_EDGE": "pinggir",
    "SENSING_TOUCHINGCOLOR": "menyentuh warna %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "warna %1 menyentuh %2?",
    "SENSING_DISTANCETO": "jarak dari %1",
    "SENSING_DISTANCETO_POINTER": "penunujuk tetikus",
    "SENSING_ASKANDWAIT": "tanya %1 dan tunggu",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "jawaban",
    "SENSING_KEYPRESSED": "tombol %1 ditekan?",
    "SENSING_MOUSEDOWN": "tetikus ditekan?",
    "SENSING_MOUSEX": "x tetikus",
    "SENSING_MOUSEY": "y tetikus",
    "SENSING_SETDRAGMODE": "atur mode seret %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "dapat diseret",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "tidak dapat diseret",
    "SENSING_LOUDNESS": "kenyaringan",
    "SENSING_LOUD": "nyaring?",
    "SENSING_TIMER": "pengatur waktu",
    "SENSING_RESETTIMER": "atur ulang pengatur waktu",
    "SENSING_OF": "%1 dari %2",
    "SENSING_OF_XPOSITION": "posisi x",
    "SENSING_OF_YPOSITION": "posisi y",
    "SENSING_OF_DIRECTION": "arah",
    "SENSING_OF_COSTUMENUMBER": "kostum #",
    "SENSING_OF_COSTUMENAME": "nama kostum",
    "SENSING_OF_SIZE": "ukuran",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "latar #",
    "SENSING_OF_BACKDROPNAME": "nama latar",
    "SENSING_OF_STAGE": "Stage",
    "SENSING_CURRENT": "%1 saat ini",
    "SENSING_CURRENT_YEAR": "tahun",
    "SENSING_CURRENT_MONTH": "bulan",
    "SENSING_CURRENT_DATE": "tanggal",
    "SENSING_CURRENT_DAYOFWEEK": "nama hari",
    "SENSING_CURRENT_HOUR": "jam",
    "SENSING_CURRENT_MINUTE": "menit",
    "SENSING_CURRENT_SECOND": "detik",
    "SENSING_DAYSSINCE2000": "hari-hari sejak 2000",
    "SENSING_USERNAME": "nama pengguna",
    "SENSING_USERID": "id pengguna",
    "SOUND_PLAY": "mulai suara %1",
    "SOUND_PLAYUNTILDONE": "mainkan suara %1 sampai selesai",
    "SOUND_STOPALLSOUNDS": "hentikan semua suara",
    "SOUND_SETEFFECTO": "atur efek %1 ke %2",
    "SOUND_CHANGEEFFECTBY": "ubah efek %1 sebesar %2",
    "SOUND_CLEAREFFECTS": "hapus semua efek suara",
    "SOUND_EFFECTS_PITCH": "nada",
    "SOUND_EFFECTS_PAN": "pan kiri/kanan",
    "SOUND_CHANGEVOLUMEBY": "ubah volume sebesar %1",
    "SOUND_SETVOLUMETO": "atur volume ke %1%",
    "SOUND_VOLUME": "volume",
    "CATEGORY_MOTION": "Gerakan",
    "CATEGORY_LOOKS": "Tampilan",
    "CATEGORY_SOUND": "Suara",
    "CATEGORY_EVENTS": "Kejadian",
    "CATEGORY_CONTROL": "Kontrol",
    "CATEGORY_SENSING": "Sensor",
    "CATEGORY_OPERATORS": "Operator",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "My Blocks",
    "DUPLICATE": "Gandakan",
    "DELETE": "Hapus",
    "ADD_COMMENT": "Tambahkan Komentar",
    "REMOVE_COMMENT": "Hapus Komentar",
    "DELETE_BLOCK": "Hapus Balok",
    "DELETE_X_BLOCKS": "Hapus %1 Balok-Balok",
    "DELETE_ALL_BLOCKS": "Hapus semua %1 balok?",
    "CLEAN_UP": "Bersihkan Balok-Balok",
    "HELP": "Bantuan",
    "UNDO": "Undo",
    "REDO": "Ulangi",
    "EDIT_PROCEDURE": "Edit",
    "SHOW_PROCEDURE_DEFINITION": "Pergi ke pengartian",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Katakan sesuatu...",
    "COLOUR_HUE_LABEL": "Warna",
    "COLOUR_SATURATION_LABEL": "Saturasi",
    "COLOUR_BRIGHTNESS_LABEL": "Keterangan",
    "CHANGE_VALUE_TITLE": "Ubah nilai:",
    "RENAME_VARIABLE": "Namakan ulang variabel",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Namakan Ulang Variabel",
    "NEW_VARIABLE": "Buat sebuah Variabel",
    "NEW_VARIABLE_TITLE": "Nama variabel baru:",
    "VARIABLE_MODAL_TITLE": "Variabel Baru",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Buat sebuah Balok",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Buat sebuah Daftar",
    "NEW_LIST_TITLE": "Nama daftar baru:",
    "LIST_MODAL_TITLE": "List Baru",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Namakan Ulang Daftar:",
    "NEW_BROADCAST_MESSAGE": "Pesan baru",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nama pesan baru:",
    "BROADCAST_MODAL_TITLE": "Pesan Baru",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "pesan1"
};

Blockly.ScratchMsgs.locales["it"] =
{
    "CONTROL_FOREVER": "per sempre",
    "CONTROL_REPEAT": "ripeti %1  volte",
    "CONTROL_IF": "se %1 allora",
    "CONTROL_ELSE": "altrimenti",
    "CONTROL_STOP": "ferma",
    "CONTROL_STOP_ALL": "tutto",
    "CONTROL_STOP_THIS": "questo script",
    "CONTROL_STOP_OTHER": "tutti gli altri script dello sprite",
    "CONTROL_WAIT": "attendi %1 secondi",
    "CONTROL_WAITUNTIL": "attendi fino a quando %1",
    "CONTROL_REPEATUNTIL": "ripeti fino a quando %1",
    "CONTROL_WHILE": "mentre %1",
    "CONTROL_FOREACH": "per ogni %1 in %2",
    "CONTROL_STARTASCLONE": "quando vengo clonato",
    "CONTROL_CREATECLONEOF": "crea clone di %1",
    "CONTROL_CREATECLONEOF_MYSELF": "me stesso",
    "CONTROL_DELETETHISCLONE": "elimina questo clone",
    "CONTROL_COUNTER": "contatore",
    "CONTROL_INCRCOUNTER": "incrementa contatore",
    "CONTROL_CLEARCOUNTER": "azzera contatore",
    "CONTROL_ALLATONCE": "esegui tutto insieme",
    "DATA_SETVARIABLETO": "porta %1 a %2",
    "DATA_CHANGEVARIABLEBY": "cambia %1 di %2",
    "DATA_SHOWVARIABLE": "mostra la variabile %1",
    "DATA_HIDEVARIABLE": "nascondi la variabile %1",
    "DATA_ADDTOLIST": "aggiungi %1 a %2",
    "DATA_DELETEOFLIST": "cancella %1 da %2",
    "DATA_INSERTATLIST": "inserisci %1 alla posizione %2 di %3",
    "DATA_REPLACEITEMOFLIST": "sostituisci elemento %1 di %2 con %3",
    "DATA_ITEMOFLIST": "elemento %1 di %2",
    "DATA_LENGTHOFLIST": "lunghezza di %1",
    "DATA_LISTCONTAINSITEM": "%1 contiene %2?",
    "DATA_SHOWLIST": "mostra la lista %1",
    "DATA_HIDELIST": "nascondi la lista %1",
    "DATA_INDEX_ALL": "tutto",
    "DATA_INDEX_LAST": "ultimo",
    "DATA_INDEX_RANDOM": "a caso",
    "EVENT_WHENFLAGCLICKED": "quando si clicca sullo sprite %1",
    "EVENT_WHENTHISSPRITECLICKED": "quando si clicca questo sprite",
    "EVENT_WHENSTAGECLICKED": "quando si clicca sullo Stage",
    "EVENT_WHENTOUCHINGOBJECT": "quando questo sprite tocca %1",
    "EVENT_WHENBROADCASTRECEIVED": "quando ricevo %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "quando lo sfondo passa a %1",
    "EVENT_WHENGREATERTHAN": "porta %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronometro",
    "EVENT_BROADCAST": "invia a tutti %1",
    "EVENT_BROADCASTANDWAIT": "invia a tutti %1 e attendi",
    "EVENT_WHENKEYPRESSED": "quando si preme il tasto %1",
    "EVENT_WHENKEYPRESSED_SPACE": "spazio",
    "EVENT_WHENKEYPRESSED_LEFT": "freccia sinistra",
    "EVENT_WHENKEYPRESSED_RIGHT": "freccia destra",
    "EVENT_WHENKEYPRESSED_DOWN": "freccia giù",
    "EVENT_WHENKEYPRESSED_UP": "freccia su",
    "EVENT_WHENKEYPRESSED_ANY": "qualunque",
    "LOOKS_SAYFORSECS": "dire %1 per %2 secondi",
    "LOOKS_SAY": "dire %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "pensa %1 per %2 secondi",
    "LOOKS_THINK": "pensa %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "mostra",
    "LOOKS_HIDE": "nascondi",
    "LOOKS_HIDEALLSPRITES": "nascondi tutti gli sprite",
    "LOOKS_EFFECT_COLOR": "colore",
    "LOOKS_EFFECT_FISHEYE": "fish-eye",
    "LOOKS_EFFECT_WHIRL": "mulinello",
    "LOOKS_EFFECT_PIXELATE": "effetto pixel",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "luminosità",
    "LOOKS_EFFECT_GHOST": "fantasma",
    "LOOKS_CHANGEEFFECTBY": "cambia effetto %1 di %2",
    "LOOKS_SETEFFECTTO": "porta effetto %1 a %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "rimuovi effetti grafici",
    "LOOKS_CHANGESIZEBY": "cambia dimensione di %1",
    "LOOKS_SETSIZETO": "porta dimensione a %1 %",
    "LOOKS_SIZE": "dimensione",
    "LOOKS_CHANGESTRETCHBY": "cambia allungamento di %1",
    "LOOKS_SETSTRETCHTO": "porta allungamento a %1 %",
    "LOOKS_SWITCHCOSTUMETO": "passa al costume %1",
    "LOOKS_NEXTCOSTUME": "costume seguente",
    "LOOKS_SWITCHBACKDROPTO": "passa allo sfondo %1",
    "LOOKS_GOTOFRONTBACK": "vai al %1 livello",
    "LOOKS_GOTOFRONTBACK_FRONT": "Primo piano",
    "LOOKS_GOTOFRONTBACK_BACK": "Secondo piano",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "vai %1 %2 livelli",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "avanti",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "indietro",
    "LOOKS_BACKDROPNUMBERNAME": "sfondo %1",
    "LOOKS_COSTUMENUMBERNAME": "costume %1",
    "LOOKS_NUMBERNAME_NUMBER": "numero",
    "LOOKS_NUMBERNAME_NAME": "nome",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "passa allo sfondo %1 e attendi",
    "LOOKS_NEXTBACKDROP": "passa allo sfondo seguente",
    "LOOKS_PREVIOUSBACKDROP": "sfondo precedente",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "fai %1 passi",
    "MOTION_TURNLEFT": "ruota %1 di %2 gradi",
    "MOTION_TURNRIGHT": "ruota %1 di %2 gradi",
    "MOTION_POINTINDIRECTION": "punta in direzione %1",
    "MOTION_POINTTOWARDS": "punta verso %1",
    "MOTION_POINTTOWARDS_POINTER": "puntatore del mouse",
    "MOTION_GOTO": "vai a %1",
    "MOTION_GOTO_POINTER": "puntatore del mouse",
    "MOTION_GOTO_RANDOM": "posizione a caso",
    "MOTION_GOTOXY": "vai a x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "scivola in %1 secondi a x: %2 y: %3",
    "MOTION_GLIDETO": "scivola in %1 secondi a %2",
    "MOTION_GLIDETO_POINTER": "puntatore del mouse",
    "MOTION_GLIDETO_RANDOM": "posizione a caso",
    "MOTION_CHANGEXBY": "cambia x di %1",
    "MOTION_SETX": "vai dove y è %1",
    "MOTION_CHANGEYBY": "cambia y di %1",
    "MOTION_SETY": "vai dove y è %1",
    "MOTION_IFONEDGEBOUNCE": "rimbalza quando tocchi il bordo",
    "MOTION_SETROTATIONSTYLE": "porta stile rotazione a %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "sinistra-destra",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "non ruotare",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "può ruotare",
    "MOTION_XPOSITION": "posizione x",
    "MOTION_YPOSITION": "posizione y",
    "MOTION_DIRECTION": "direzione",
    "MOTION_SCROLLRIGHT": "scrolla a destra di %1",
    "MOTION_SCROLLUP": "scrolla in alto di %1",
    "MOTION_ALIGNSCENE": "allinea la scena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "in basso a sinistra",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "in basso a destra",
    "MOTION_ALIGNSCENE_MIDDLE": "in mezzo",
    "MOTION_ALIGNSCENE_TOPLEFT": "in alto a sinistra",
    "MOTION_ALIGNSCENE_TOPRIGHT": "in alto a destra",
    "MOTION_XSCROLL": "posizione x dello scroll",
    "MOTION_YSCROLL": "posizione y dello scroll",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "numero a caso tra %1 e %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 e %2",
    "OPERATORS_OR": "%1 o %2",
    "OPERATORS_NOT": "non %1",
    "OPERATORS_JOIN": "unione di %1 e %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "lettera %1 di %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "lunghezza di %1",
    "OPERATORS_CONTAINS": "%1 contiene %2?",
    "OPERATORS_MOD": "resto della divisione di %1 diviso %2",
    "OPERATORS_ROUND": "arrotonda %1",
    "OPERATORS_MATHOP": "%1 di %2",
    "OPERATORS_MATHOP_ABS": "valore assoluto",
    "OPERATORS_MATHOP_FLOOR": "intero inferiore",
    "OPERATORS_MATHOP_CEILING": "intero superiore",
    "OPERATORS_MATHOP_SQRT": "radice quadrata",
    "OPERATORS_MATHOP_SIN": "sen",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsen",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definisci %1",
    "SENSING_TOUCHINGOBJECT": "sta toccando %1",
    "SENSING_TOUCHINGOBJECT_POINTER": "puntatore del mouse",
    "SENSING_TOUCHINGOBJECT_EDGE": "bordo",
    "SENSING_TOUCHINGCOLOR": "sta toccando il colore %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "il colore %1 sta toccando il colore %2?",
    "SENSING_DISTANCETO": "distanza da %1",
    "SENSING_DISTANCETO_POINTER": "puntatore del mouse",
    "SENSING_ASKANDWAIT": "chiedi %1 e attendi",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "risposta",
    "SENSING_KEYPRESSED": "tasto %1 premuto?",
    "SENSING_MOUSEDOWN": "pulsante del mouse premuto?",
    "SENSING_MOUSEX": "x del mouse",
    "SENSING_MOUSEY": "y del mouse",
    "SENSING_SETDRAGMODE": "rendi lo sprite %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "trascinabile",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "non trascinabile",
    "SENSING_LOUDNESS": "volume microfono",
    "SENSING_LOUD": "volume alto?",
    "SENSING_TIMER": "cronometro",
    "SENSING_RESETTIMER": "azzera cronometro",
    "SENSING_OF": "%1 di %2",
    "SENSING_OF_XPOSITION": "posizione x",
    "SENSING_OF_YPOSITION": "posizione y",
    "SENSING_OF_DIRECTION": "direzione",
    "SENSING_OF_COSTUMENUMBER": "numero del costume",
    "SENSING_OF_COSTUMENAME": "nome del costume",
    "SENSING_OF_SIZE": "dimensione",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "numero dello sfondo",
    "SENSING_OF_BACKDROPNAME": "nome dello sfondo",
    "SENSING_OF_STAGE": "Palco",
    "SENSING_CURRENT": "%1 attuale",
    "SENSING_CURRENT_YEAR": "anno",
    "SENSING_CURRENT_MONTH": "mese",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "giorno della settimana",
    "SENSING_CURRENT_HOUR": "ora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "secondo",
    "SENSING_DAYSSINCE2000": "giorni trascorsi dal 2000",
    "SENSING_USERNAME": "username",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "avvia suono %1",
    "SOUND_PLAYUNTILDONE": "riproduci suono %1 e attendi la fine",
    "SOUND_STOPALLSOUNDS": "ferma tutti i suoni",
    "SOUND_SETEFFECTO": "porta effetto %1 a %2",
    "SOUND_CHANGEEFFECTBY": "cambia effetto %1 di %2",
    "SOUND_CLEAREFFECTS": "rimuovi effetti audio",
    "SOUND_EFFECTS_PITCH": "frequenza",
    "SOUND_EFFECTS_PAN": "panning sinistra/destra",
    "SOUND_CHANGEVOLUMEBY": "cambia volume di %1",
    "SOUND_SETVOLUMETO": "porta volume a %1%",
    "SOUND_VOLUME": "volume",
    "CATEGORY_MOTION": "Movimento",
    "CATEGORY_LOOKS": "Aspetto",
    "CATEGORY_SOUND": "Suono",
    "CATEGORY_EVENTS": "Situazioni",
    "CATEGORY_CONTROL": "Controllo",
    "CATEGORY_SENSING": "Sensori",
    "CATEGORY_OPERATORS": "Operatori",
    "CATEGORY_VARIABLES": "Variabili",
    "CATEGORY_MYBLOCKS": "I Miei Blocchi",
    "DUPLICATE": "Duplica",
    "DELETE": "Cancella",
    "ADD_COMMENT": "Aggiungi commento",
    "REMOVE_COMMENT": "Rimuovi commento",
    "DELETE_BLOCK": "Cancella questo Blocco",
    "DELETE_X_BLOCKS": "Cancella %1 Blocchi",
    "DELETE_ALL_BLOCKS": "Cancellare i %1 blocchi?",
    "CLEAN_UP": "Riordina i Blocchi",
    "HELP": "Aiuto",
    "UNDO": "Annulla",
    "REDO": "Ripristina",
    "EDIT_PROCEDURE": "Modifica",
    "SHOW_PROCEDURE_DEFINITION": "Vai alla definizione",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Dì qualcosa...",
    "COLOUR_HUE_LABEL": "Colore",
    "COLOUR_SATURATION_LABEL": "Saturazione",
    "COLOUR_BRIGHTNESS_LABEL": "Luminosità",
    "CHANGE_VALUE_TITLE": "Cambia il valore:",
    "RENAME_VARIABLE": "Rinomina la variabile",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Rinomina la Variabile",
    "NEW_VARIABLE": "Crea una Variabile",
    "NEW_VARIABLE_TITLE": "Nome della nuova variabile:",
    "VARIABLE_MODAL_TITLE": "Nuova Variabile",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Crea un Blocco",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Crea una Lista",
    "NEW_LIST_TITLE": "Nome della nuova lista:",
    "LIST_MODAL_TITLE": "Nuova Lista",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Rinomina la Lista",
    "NEW_BROADCAST_MESSAGE": "Nuovo messaggio",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nome del nuovo messaggio:",
    "BROADCAST_MODAL_TITLE": "Nuovo Messaggio",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "messaggio1"
};

Blockly.ScratchMsgs.locales["ja-Hira"] =
{
    "CONTROL_FOREVER": "ずっと",
    "CONTROL_REPEAT": "%1 かいくりかえす",
    "CONTROL_IF": "もし %1 なら",
    "CONTROL_ELSE": "でなければ",
    "CONTROL_STOP": "とめる",
    "CONTROL_STOP_ALL": "すべて",
    "CONTROL_STOP_THIS": "このスクリプト",
    "CONTROL_STOP_OTHER": "スプライトのほかのスクリプト",
    "CONTROL_WAIT": "%1 びょうまつ",
    "CONTROL_WAITUNTIL": "%1 までまつ",
    "CONTROL_REPEATUNTIL": "%1 までくりかえす",
    "CONTROL_WHILE": "%1 のあいだくりかえす",
    "CONTROL_FOREACH": "%2 のようそを %1 にいれてくりかえす",
    "CONTROL_STARTASCLONE": "クローンされたとき",
    "CONTROL_CREATECLONEOF": "%1 のクローンをつくる",
    "CONTROL_CREATECLONEOF_MYSELF": "じぶんじしん",
    "CONTROL_DELETETHISCLONE": "このクローンをさくじょする",
    "CONTROL_COUNTER": "カウンター",
    "CONTROL_INCRCOUNTER": "カウンターにたす",
    "CONTROL_CLEARCOUNTER": "カウンターをクリアする",
    "CONTROL_ALLATONCE": "all at once",
    "DATA_SETVARIABLETO": "%1 を %2 にする",
    "DATA_CHANGEVARIABLEBY": "%1 を %2 ずつかえる",
    "DATA_SHOWVARIABLE": "へんすう %1 をひょうじする",
    "DATA_HIDEVARIABLE": "へんすう %1 をかくす",
    "DATA_ADDTOLIST": "%1 を %2 についかする",
    "DATA_DELETEOFLIST": "%2 の %1 ばんめをさくじょする",
    "DATA_INSERTATLIST": "%3 の %2 ばんめに %1 をそうにゅうする",
    "DATA_REPLACEITEMOFLIST": "%2 の %1 を %3 でおきかえる",
    "DATA_ITEMOFLIST": "%2 の %1 ばんめ",
    "DATA_LENGTHOFLIST": "%1 のながさ",
    "DATA_LISTCONTAINSITEM": "%1 に %2 がふくまれる",
    "DATA_SHOWLIST": "リスト %1 をひょうじする",
    "DATA_HIDELIST": "リスト %1 をかくす",
    "DATA_INDEX_ALL": "すべて",
    "DATA_INDEX_LAST": "さいご",
    "DATA_INDEX_RANDOM": "らんすう",
    "EVENT_WHENFLAGCLICKED": "%1 がクリックされたとき",
    "EVENT_WHENTHISSPRITECLICKED": "このスプライトがクリックされたとき",
    "EVENT_WHENSTAGECLICKED": "ステージがクリックされたとき",
    "EVENT_WHENTOUCHINGOBJECT": "when this sprite touches %1",
    "EVENT_WHENBROADCASTRECEIVED": "%1 をうけとったとき",
    "EVENT_WHENBACKDROPSWITCHESTO": "はいけいが %1 になったとき",
    "EVENT_WHENGREATERTHAN": "%1 &gt; %2 のとき",
    "EVENT_WHENGREATERTHAN_TIMER": "タイマー",
    "EVENT_BROADCAST": "%1 をおくる",
    "EVENT_BROADCASTANDWAIT": "%1 をおくってまつ",
    "EVENT_WHENKEYPRESSED": "%1 キーがおされたとき",
    "EVENT_WHENKEYPRESSED_SPACE": "スペース",
    "EVENT_WHENKEYPRESSED_LEFT": "ひだりむきやじるし",
    "EVENT_WHENKEYPRESSED_RIGHT": "みぎむきやじるし",
    "EVENT_WHENKEYPRESSED_DOWN": "したむきやじるし",
    "EVENT_WHENKEYPRESSED_UP": "うわむきやじるし",
    "EVENT_WHENKEYPRESSED_ANY": "どれかの",
    "LOOKS_SAYFORSECS": "%1 と %2 びょういう",
    "LOOKS_SAY": "%1 という",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "%1 と %2 びょうかんがえる",
    "LOOKS_THINK": "%1 とかんがえる",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "ひょうじする",
    "LOOKS_HIDE": "かくす",
    "LOOKS_HIDEALLSPRITES": "hide all sprites",
    "LOOKS_EFFECT_COLOR": "いろ",
    "LOOKS_EFFECT_FISHEYE": "ぎょがんレンズ",
    "LOOKS_EFFECT_WHIRL": "うずまき",
    "LOOKS_EFFECT_PIXELATE": "ピクセルか",
    "LOOKS_EFFECT_MOSAIC": "モザイク",
    "LOOKS_EFFECT_BRIGHTNESS": "あかるさ",
    "LOOKS_EFFECT_GHOST": "ゆうれい",
    "LOOKS_CHANGEEFFECTBY": "%1 のこうかを %2 ずつかえる",
    "LOOKS_SETEFFECTTO": "%1 のこうかを %2 にする",
    "LOOKS_CLEARGRAPHICEFFECTS": "がぞうこうかをなくす",
    "LOOKS_CHANGESIZEBY": "おおきさを %1 ずつかえる",
    "LOOKS_SETSIZETO": "おおきさを %1 %にする",
    "LOOKS_SIZE": "おおきさ",
    "LOOKS_CHANGESTRETCHBY": "change stretch by %1",
    "LOOKS_SETSTRETCHTO": "set stretch to %1 %",
    "LOOKS_SWITCHCOSTUMETO": "コスチュームを %1 にする",
    "LOOKS_NEXTCOSTUME": "つぎのコスチュームにする",
    "LOOKS_SWITCHBACKDROPTO": "はいけいを %1 にする",
    "LOOKS_GOTOFRONTBACK": "%1 へいどうする ",
    "LOOKS_GOTOFRONTBACK_FRONT": "さいぜんめん",
    "LOOKS_GOTOFRONTBACK_BACK": "さいはいめん",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%2 そう %1 ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "てまえにだす ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "おくにさげる ",
    "LOOKS_BACKDROPNUMBERNAME": "はいけいの %1 ",
    "LOOKS_COSTUMENUMBERNAME": "コスチュームの %1 ",
    "LOOKS_NUMBERNAME_NUMBER": "ばんごう ",
    "LOOKS_NUMBERNAME_NAME": "なまえ ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "はいけいを %1 にしてまつ",
    "LOOKS_NEXTBACKDROP": "つぎのはいけい ",
    "LOOKS_PREVIOUSBACKDROP": "まえのはいけい",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "%1 ほうごかす",
    "MOTION_TURNLEFT": "%1 %2 たびまわす",
    "MOTION_TURNRIGHT": "%1 %2 たびまわす",
    "MOTION_POINTINDIRECTION": "%1 たびにむける",
    "MOTION_POINTTOWARDS": "%1 へむける",
    "MOTION_POINTTOWARDS_POINTER": "マウスのポインター",
    "MOTION_GOTO": "%1 へいく",
    "MOTION_GOTO_POINTER": "マウスのポインター",
    "MOTION_GOTO_RANDOM": "ランダムなばしょ",
    "MOTION_GOTOXY": "xざひょうを %1 、yざひょうを %2 にする",
    "MOTION_GLIDESECSTOXY": "%1 びょうでxざひょうを %2 に、yざひょうを %3 にかえる",
    "MOTION_GLIDETO": "%1 びょうで %2 へいく ",
    "MOTION_GLIDETO_POINTER": "マウスのポインター",
    "MOTION_GLIDETO_RANDOM": "どこかのばしょ",
    "MOTION_CHANGEXBY": "xざひょうを %1 ずつかえる",
    "MOTION_SETX": "xざひょうを %1 にする",
    "MOTION_CHANGEYBY": "yざひょうを %1 ずつかえる",
    "MOTION_SETY": "yざひょうを %1 にする",
    "MOTION_IFONEDGEBOUNCE": "もしはしについたら、はねかえる",
    "MOTION_SETROTATIONSTYLE": "かいてんほうほうを %1 にする",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "さゆうのみ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "かいてんしない",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "じゆうにかいてん",
    "MOTION_XPOSITION": "xざひょう",
    "MOTION_YPOSITION": "yざひょう",
    "MOTION_DIRECTION": "むき",
    "MOTION_SCROLLRIGHT": "scroll right %1",
    "MOTION_SCROLLUP": "scroll up %1",
    "MOTION_ALIGNSCENE": "align scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bottom-left",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bottom-right",
    "MOTION_ALIGNSCENE_MIDDLE": "middle",
    "MOTION_ALIGNSCENE_TOPLEFT": "top-left",
    "MOTION_ALIGNSCENE_TOPRIGHT": "top-right",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 から %2 までのらんすう",
    "OPERATORS_GT": "%1 &gt; %2",
    "OPERATORS_LT": "%1 &lt; %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 かつ %2",
    "OPERATORS_OR": "%1 または %2",
    "OPERATORS_NOT": "%1 ではない",
    "OPERATORS_JOIN": "%1 と %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "%2 の %1 ばんめのもじ ",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "%1 のながさ",
    "OPERATORS_CONTAINS": "%1 に %2 がふくまれる",
    "OPERATORS_MOD": "%1 を %2 でわったあまり",
    "OPERATORS_ROUND": "%1 をししゃごにゅう",
    "OPERATORS_MATHOP": "%2 の %1 ",
    "OPERATORS_MATHOP_ABS": "ぜったいち",
    "OPERATORS_MATHOP_FLOOR": "きりすて",
    "OPERATORS_MATHOP_CEILING": "きりあげ",
    "OPERATORS_MATHOP_SQRT": "へいほうこん",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "ていぎ %1",
    "SENSING_TOUCHINGOBJECT": "%1 にふれた",
    "SENSING_TOUCHINGOBJECT_POINTER": "マウスのポインター",
    "SENSING_TOUCHINGOBJECT_EDGE": "はし",
    "SENSING_TOUCHINGCOLOR": "%1 いろにふれた",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 いろが %2 いろにふれた",
    "SENSING_DISTANCETO": "%1 までのきょり",
    "SENSING_DISTANCETO_POINTER": "マウスのポインター",
    "SENSING_ASKANDWAIT": "%1 ときいてまつ",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "こたえ",
    "SENSING_KEYPRESSED": "%1 キーがおされた",
    "SENSING_MOUSEDOWN": "マウスがおされた",
    "SENSING_MOUSEX": "マウスのxざひょう",
    "SENSING_MOUSEY": "マウスのyざひょう",
    "SENSING_SETDRAGMODE": "ドラッグ %1 ようにする ",
    "SENSING_SETDRAGMODE_DRAGGABLE": "できる",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "できない",
    "SENSING_LOUDNESS": "おんりょう",
    "SENSING_LOUD": "loud?",
    "SENSING_TIMER": "タイマー",
    "SENSING_RESETTIMER": "タイマーをリセット",
    "SENSING_OF": "%2 の %1 ",
    "SENSING_OF_XPOSITION": "xざひょう",
    "SENSING_OF_YPOSITION": "yざひょう",
    "SENSING_OF_DIRECTION": "むき",
    "SENSING_OF_COSTUMENUMBER": "コスチューム #",
    "SENSING_OF_COSTUMENAME": "コスチュームめい",
    "SENSING_OF_SIZE": "おおきさ",
    "SENSING_OF_VOLUME": "おんりょう",
    "SENSING_OF_BACKDROPNUMBER": "はいけい #",
    "SENSING_OF_BACKDROPNAME": "はいけいのなまえ",
    "SENSING_OF_STAGE": "ステージ",
    "SENSING_CURRENT": "げんざいの %1",
    "SENSING_CURRENT_YEAR": "とし",
    "SENSING_CURRENT_MONTH": "つき",
    "SENSING_CURRENT_DATE": "ひ",
    "SENSING_CURRENT_DAYOFWEEK": "ようび",
    "SENSING_CURRENT_HOUR": "とき",
    "SENSING_CURRENT_MINUTE": "ぶん",
    "SENSING_CURRENT_SECOND": "びょう",
    "SENSING_DAYSSINCE2000": "2000ねんからのにっすう",
    "SENSING_USERNAME": "ユーザーめい",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "%1 のおとをならす",
    "SOUND_PLAYUNTILDONE": "おわるまで %1 のおとをならす",
    "SOUND_STOPALLSOUNDS": "すべてのおとをとめる",
    "SOUND_SETEFFECTO": "%1 のこうかを %2 にする ",
    "SOUND_CHANGEEFFECTBY": "%1 のこうかを %2 ずつかえる",
    "SOUND_CLEAREFFECTS": "おとのこうかをなくす",
    "SOUND_EFFECTS_PITCH": "ピッチ ",
    "SOUND_EFFECTS_PAN": "さゆうのパン ",
    "SOUND_CHANGEVOLUMEBY": "おんりょうを %1 ずつかえる",
    "SOUND_SETVOLUMETO": "おんりょうを %1 %にする",
    "SOUND_VOLUME": "おんりょう",
    "CATEGORY_MOTION": "うごき",
    "CATEGORY_LOOKS": "みため",
    "CATEGORY_SOUND": "おと",
    "CATEGORY_EVENTS": "イベント",
    "CATEGORY_CONTROL": "せいぎょ",
    "CATEGORY_SENSING": "しらべる",
    "CATEGORY_OPERATORS": "えんざん",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "My Blocks",
    "DUPLICATE": "ふくせい",
    "DELETE": "さくじょ",
    "ADD_COMMENT": "Add Comment",
    "REMOVE_COMMENT": "Remove Comment",
    "DELETE_BLOCK": "Delete Block",
    "DELETE_X_BLOCKS": "Delete %1 Blocks",
    "DELETE_ALL_BLOCKS": "Delete all %1 blocks?",
    "CLEAN_UP": "Clean up Blocks",
    "HELP": "ヘルプ",
    "UNDO": "とりけし",
    "REDO": "やりなおし",
    "EDIT_PROCEDURE": "へんしゅう",
    "SHOW_PROCEDURE_DEFINITION": "Go to definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Say something...",
    "COLOUR_HUE_LABEL": "いろ",
    "COLOUR_SATURATION_LABEL": "あざやかさ",
    "COLOUR_BRIGHTNESS_LABEL": "あかるさ",
    "CHANGE_VALUE_TITLE": "Change value:",
    "RENAME_VARIABLE": "Rename variable",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Rename Variable",
    "NEW_VARIABLE": "へんすうをつくる",
    "NEW_VARIABLE_TITLE": "New variable name:",
    "VARIABLE_MODAL_TITLE": "あたらしいへんすう",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "ブロックをつくる",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "リストをつくる",
    "NEW_LIST_TITLE": "New list name:",
    "LIST_MODAL_TITLE": "あたらしいリスト",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Rename List",
    "NEW_BROADCAST_MESSAGE": "New message",
    "NEW_BROADCAST_MESSAGE_TITLE": "New message name:",
    "BROADCAST_MODAL_TITLE": "あたらしいメッセージ",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "メッセージ1"
};

Blockly.ScratchMsgs.locales["ja"] =
{
    "CONTROL_FOREVER": "ずっと",
    "CONTROL_REPEAT": "%1 回繰り返す",
    "CONTROL_IF": "もし %1 なら",
    "CONTROL_ELSE": "でなければ",
    "CONTROL_STOP": "止める",
    "CONTROL_STOP_ALL": "すべて",
    "CONTROL_STOP_THIS": "このスクリプト",
    "CONTROL_STOP_OTHER": "スプライトの他のスクリプト",
    "CONTROL_WAIT": "%1 秒待つ",
    "CONTROL_WAITUNTIL": "%1 まで待つ",
    "CONTROL_REPEATUNTIL": "%1 まで繰り返す",
    "CONTROL_WHILE": "%1 の間繰り返す",
    "CONTROL_FOREACH": "%2 の要素を %1 に入れて繰り返す",
    "CONTROL_STARTASCLONE": "クローンされたとき",
    "CONTROL_CREATECLONEOF": "%1 のクローンを作る",
    "CONTROL_CREATECLONEOF_MYSELF": "自分自身",
    "CONTROL_DELETETHISCLONE": "このクローンを削除する",
    "CONTROL_COUNTER": "カウンター",
    "CONTROL_INCRCOUNTER": "カウンターに足す",
    "CONTROL_CLEARCOUNTER": "カウンターをクリアする",
    "CONTROL_ALLATONCE": "一斉に",
    "DATA_SETVARIABLETO": "%1 を %2 にする",
    "DATA_CHANGEVARIABLEBY": "%1 を %2 ずつ変える",
    "DATA_SHOWVARIABLE": "変数 %1 を表示する",
    "DATA_HIDEVARIABLE": "変数 %1 を隠す",
    "DATA_ADDTOLIST": "%1 を %2 に追加する",
    "DATA_DELETEOFLIST": "%2 の %1 番目を削除する",
    "DATA_INSERTATLIST": "%3 の %2 番目に %1 を挿入する",
    "DATA_REPLACEITEMOFLIST": "%2 の %1 を %3 で置き換える",
    "DATA_ITEMOFLIST": "%2 の %1 番目",
    "DATA_LENGTHOFLIST": "%1 の長さ",
    "DATA_LISTCONTAINSITEM": "%1 に %2 が含まれる",
    "DATA_SHOWLIST": "リスト %1 を表示する",
    "DATA_HIDELIST": "リスト %1 を隠す",
    "DATA_INDEX_ALL": "すべて",
    "DATA_INDEX_LAST": "最後",
    "DATA_INDEX_RANDOM": "乱数",
    "EVENT_WHENFLAGCLICKED": "%1 がクリックされたとき",
    "EVENT_WHENTHISSPRITECLICKED": "このスプライトがクリックされたとき",
    "EVENT_WHENSTAGECLICKED": "ステージがクリックされたとき",
    "EVENT_WHENTOUCHINGOBJECT": "このスプライトが %1 に触れたとき",
    "EVENT_WHENBROADCASTRECEIVED": "%1 を受け取ったとき",
    "EVENT_WHENBACKDROPSWITCHESTO": "背景が %1 になったとき",
    "EVENT_WHENGREATERTHAN": "%1 > %2 のとき",
    "EVENT_WHENGREATERTHAN_TIMER": "タイマー",
    "EVENT_BROADCAST": "%1 を送る",
    "EVENT_BROADCASTANDWAIT": "%1 を送って待つ",
    "EVENT_WHENKEYPRESSED": "%1 キーが押されたとき",
    "EVENT_WHENKEYPRESSED_SPACE": "スペース",
    "EVENT_WHENKEYPRESSED_LEFT": "左向き矢印",
    "EVENT_WHENKEYPRESSED_RIGHT": "右向き矢印",
    "EVENT_WHENKEYPRESSED_DOWN": "下向き矢印",
    "EVENT_WHENKEYPRESSED_UP": "上向き矢印",
    "EVENT_WHENKEYPRESSED_ANY": "どれかの",
    "LOOKS_SAYFORSECS": "%1 と %2 秒言う",
    "LOOKS_SAY": "%1 と言う",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "%1 と %2 秒考える",
    "LOOKS_THINK": "%1 と考える",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "表示する",
    "LOOKS_HIDE": "隠す",
    "LOOKS_HIDEALLSPRITES": "すべてのスプライトを隠す",
    "LOOKS_EFFECT_COLOR": "色",
    "LOOKS_EFFECT_FISHEYE": "魚眼レンズ",
    "LOOKS_EFFECT_WHIRL": "渦巻き",
    "LOOKS_EFFECT_PIXELATE": "ピクセル化",
    "LOOKS_EFFECT_MOSAIC": "モザイク",
    "LOOKS_EFFECT_BRIGHTNESS": "明るさ",
    "LOOKS_EFFECT_GHOST": "幽霊",
    "LOOKS_CHANGEEFFECTBY": "%1 の効果を %2 ずつ変える",
    "LOOKS_SETEFFECTTO": "%1 の効果を %2 にする",
    "LOOKS_CLEARGRAPHICEFFECTS": "画像効果をなくす",
    "LOOKS_CHANGESIZEBY": "大きさを %1 ずつ変える",
    "LOOKS_SETSIZETO": "大きさを %1 %にする",
    "LOOKS_SIZE": "大きさ",
    "LOOKS_CHANGESTRETCHBY": "伸びを %1 ずつ変える",
    "LOOKS_SETSTRETCHTO": "伸びを %1 %にする",
    "LOOKS_SWITCHCOSTUMETO": "コスチュームを %1 にする",
    "LOOKS_NEXTCOSTUME": "次のコスチュームにする",
    "LOOKS_SWITCHBACKDROPTO": "背景を %1 にする",
    "LOOKS_GOTOFRONTBACK": "%1 へ移動する ",
    "LOOKS_GOTOFRONTBACK_FRONT": "最前面",
    "LOOKS_GOTOFRONTBACK_BACK": "最背面",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%2 層 %1 ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "手前に出す ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "奥に下げる ",
    "LOOKS_BACKDROPNUMBERNAME": "背景の %1 ",
    "LOOKS_COSTUMENUMBERNAME": "コスチュームの %1 ",
    "LOOKS_NUMBERNAME_NUMBER": "番号 ",
    "LOOKS_NUMBERNAME_NAME": "名前 ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "背景を %1 にして待つ",
    "LOOKS_NEXTBACKDROP": "次の背景 ",
    "LOOKS_PREVIOUSBACKDROP": "前の背景",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "%1 歩動かす",
    "MOTION_TURNLEFT": "%1 %2 度回す",
    "MOTION_TURNRIGHT": "%1 %2 度回す",
    "MOTION_POINTINDIRECTION": "%1 度に向ける",
    "MOTION_POINTTOWARDS": "%1 へ向ける",
    "MOTION_POINTTOWARDS_POINTER": "マウスのポインター",
    "MOTION_GOTO": "%1 へ行く",
    "MOTION_GOTO_POINTER": "マウスのポインター",
    "MOTION_GOTO_RANDOM": "ランダムな場所",
    "MOTION_GOTOXY": "x座標を %1 、y座標を %2 にする",
    "MOTION_GLIDESECSTOXY": "%1 秒でx座標を %2 に、y座標を %3 に変える",
    "MOTION_GLIDETO": "%1 秒で %2 へ行く ",
    "MOTION_GLIDETO_POINTER": "マウスのポインター",
    "MOTION_GLIDETO_RANDOM": "どこかの場所",
    "MOTION_CHANGEXBY": "x座標を %1 ずつ変える",
    "MOTION_SETX": "x座標を %1 にする",
    "MOTION_CHANGEYBY": "y座標を %1 ずつ変える",
    "MOTION_SETY": "y座標を %1 にする",
    "MOTION_IFONEDGEBOUNCE": "もし端に着いたら、跳ね返る",
    "MOTION_SETROTATIONSTYLE": "回転方法を %1 にする",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "左右のみ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "回転しない",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "自由に回転",
    "MOTION_XPOSITION": "x座標",
    "MOTION_YPOSITION": "y座標",
    "MOTION_DIRECTION": "向き",
    "MOTION_SCROLLRIGHT": "右に %1 スクロールする",
    "MOTION_SCROLLUP": "上に %1 スクロールする",
    "MOTION_ALIGNSCENE": "スクロール位置を %1 にする",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "左下",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "右下",
    "MOTION_ALIGNSCENE_MIDDLE": "中央",
    "MOTION_ALIGNSCENE_TOPLEFT": "左上",
    "MOTION_ALIGNSCENE_TOPRIGHT": "右上",
    "MOTION_XSCROLL": "x方向のスクロール量",
    "MOTION_YSCROLL": "y方向のスクロール方向",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 から %2 までの乱数",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 かつ %2",
    "OPERATORS_OR": "%1 または %2",
    "OPERATORS_NOT": "%1 ではない",
    "OPERATORS_JOIN": "%1 と %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "%2 の %1 番目の文字 ",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "%1 の長さ",
    "OPERATORS_CONTAINS": "%1 に %2 が含まれる",
    "OPERATORS_MOD": "%1 を %2 で割った余り",
    "OPERATORS_ROUND": "%1 を四捨五入",
    "OPERATORS_MATHOP": "%2 の %1 ",
    "OPERATORS_MATHOP_ABS": "絶対値",
    "OPERATORS_MATHOP_FLOOR": "切り下げ",
    "OPERATORS_MATHOP_CEILING": "切り上げ",
    "OPERATORS_MATHOP_SQRT": "平方根",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "定義 %1",
    "SENSING_TOUCHINGOBJECT": "%1 に触れた",
    "SENSING_TOUCHINGOBJECT_POINTER": "マウスのポインター",
    "SENSING_TOUCHINGOBJECT_EDGE": "端",
    "SENSING_TOUCHINGCOLOR": "%1 色に触れた",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 色が %2 色に触れた",
    "SENSING_DISTANCETO": "%1 までの距離",
    "SENSING_DISTANCETO_POINTER": "マウスのポインター",
    "SENSING_ASKANDWAIT": "%1 と聞いて待つ",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "答え",
    "SENSING_KEYPRESSED": "%1 キーが押された",
    "SENSING_MOUSEDOWN": "マウスが押された",
    "SENSING_MOUSEX": "マウスのx座標",
    "SENSING_MOUSEY": "マウスのy座標",
    "SENSING_SETDRAGMODE": "ドラッグ %1 ようにする ",
    "SENSING_SETDRAGMODE_DRAGGABLE": "できる",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "できない",
    "SENSING_LOUDNESS": "音量",
    "SENSING_LOUD": "うるさい",
    "SENSING_TIMER": "タイマー",
    "SENSING_RESETTIMER": "タイマーをリセット",
    "SENSING_OF": "%2 の %1 ",
    "SENSING_OF_XPOSITION": "x座標",
    "SENSING_OF_YPOSITION": "y座標",
    "SENSING_OF_DIRECTION": "向き",
    "SENSING_OF_COSTUMENUMBER": "コスチューム #",
    "SENSING_OF_COSTUMENAME": "コスチューム名",
    "SENSING_OF_SIZE": "大きさ",
    "SENSING_OF_VOLUME": "音量",
    "SENSING_OF_BACKDROPNUMBER": "背景 #",
    "SENSING_OF_BACKDROPNAME": "背景の名前",
    "SENSING_OF_STAGE": "ステージ",
    "SENSING_CURRENT": "現在の %1",
    "SENSING_CURRENT_YEAR": "年",
    "SENSING_CURRENT_MONTH": "月",
    "SENSING_CURRENT_DATE": "日",
    "SENSING_CURRENT_DAYOFWEEK": "曜日",
    "SENSING_CURRENT_HOUR": "時",
    "SENSING_CURRENT_MINUTE": "分",
    "SENSING_CURRENT_SECOND": "秒",
    "SENSING_DAYSSINCE2000": "2000年からの日数",
    "SENSING_USERNAME": "ユーザー名",
    "SENSING_USERID": "ユーザーID",
    "SOUND_PLAY": "%1 の音を鳴らす",
    "SOUND_PLAYUNTILDONE": "終わるまで %1 の音を鳴らす",
    "SOUND_STOPALLSOUNDS": "すべての音を止める",
    "SOUND_SETEFFECTO": "%1 の効果を %2 にする ",
    "SOUND_CHANGEEFFECTBY": "%1 の効果を %2 ずつ変える",
    "SOUND_CLEAREFFECTS": "音の効果をなくす",
    "SOUND_EFFECTS_PITCH": "ピッチ ",
    "SOUND_EFFECTS_PAN": "左右のパン ",
    "SOUND_CHANGEVOLUMEBY": "音量を %1 ずつ変える",
    "SOUND_SETVOLUMETO": "音量を %1 %にする",
    "SOUND_VOLUME": "音量",
    "CATEGORY_MOTION": "動き",
    "CATEGORY_LOOKS": "見た目",
    "CATEGORY_SOUND": "音",
    "CATEGORY_EVENTS": "イベント",
    "CATEGORY_CONTROL": "制御",
    "CATEGORY_SENSING": "調べる",
    "CATEGORY_OPERATORS": "演算",
    "CATEGORY_VARIABLES": "変数",
    "CATEGORY_MYBLOCKS": "自分のブロック",
    "DUPLICATE": "複製",
    "DELETE": "削除",
    "ADD_COMMENT": "コメントを追加",
    "REMOVE_COMMENT": "コメントを削除",
    "DELETE_BLOCK": "ブロックを削除",
    "DELETE_X_BLOCKS": "%1 ブロックを削除",
    "DELETE_ALL_BLOCKS": "%1 個のブロックをすべて削除しますか?",
    "CLEAN_UP": "きれいにする",
    "HELP": "ヘルプ",
    "UNDO": "取り消し",
    "REDO": "やり直し",
    "EDIT_PROCEDURE": "編集",
    "SHOW_PROCEDURE_DEFINITION": "定義へ行く",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "何かを言う...",
    "COLOUR_HUE_LABEL": "色",
    "COLOUR_SATURATION_LABEL": "鮮やかさ",
    "COLOUR_BRIGHTNESS_LABEL": "明るさ",
    "CHANGE_VALUE_TITLE": "値を変える:",
    "RENAME_VARIABLE": "変数の名前を変更",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "変数の名前を変更",
    "NEW_VARIABLE": "変数を作る",
    "NEW_VARIABLE_TITLE": "新しい変数の名前:",
    "VARIABLE_MODAL_TITLE": "新しい変数",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "ブロックを作る",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "リストを作る",
    "NEW_LIST_TITLE": "新しいリスト名:",
    "LIST_MODAL_TITLE": "新しいリスト",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "リストの名前を変更",
    "NEW_BROADCAST_MESSAGE": "新しいメッセージ",
    "NEW_BROADCAST_MESSAGE_TITLE": "新しいメッセージ名:",
    "BROADCAST_MODAL_TITLE": "新しいメッセージ",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "メッセージ1"
};

Blockly.ScratchMsgs.locales["ko"] =
{
    "CONTROL_FOREVER": "무한 반복하기",
    "CONTROL_REPEAT": "%1 번 반복하기",
    "CONTROL_IF": "만약 %1 (이)라면",
    "CONTROL_ELSE": "아니면",
    "CONTROL_STOP": "멈추기",
    "CONTROL_STOP_ALL": "모두",
    "CONTROL_STOP_THIS": "이 스크립트",
    "CONTROL_STOP_OTHER": "이 스프라이트에 있는 다른 스크립트",
    "CONTROL_WAIT": "%1 초 기다리기",
    "CONTROL_WAITUNTIL": "%1 까지 기다리기",
    "CONTROL_REPEATUNTIL": "%1 까지 반복하기",
    "CONTROL_WHILE": "%1 동안 반복하기",
    "CONTROL_FOREACH": "%1 변수로 %2 번 반복하기",
    "CONTROL_STARTASCLONE": "복제되었을 때",
    "CONTROL_CREATECLONEOF": "%1 복제하기",
    "CONTROL_CREATECLONEOF_MYSELF": "나 자신",
    "CONTROL_DELETETHISCLONE": "이 복제본 삭제하기",
    "CONTROL_COUNTER": "카운터",
    "CONTROL_INCRCOUNTER": "카운터 증가하기",
    "CONTROL_CLEARCOUNTER": "카운터 초기화",
    "CONTROL_ALLATONCE": "한 번에 실행하기",
    "DATA_SETVARIABLETO": "%1 을(를) %2 로 정하기",
    "DATA_CHANGEVARIABLEBY": "%1 을(를) %2 만큼 바꾸기",
    "DATA_SHOWVARIABLE": "%1 변수 보이기",
    "DATA_HIDEVARIABLE": "%1 변수 숨기기",
    "DATA_ADDTOLIST": "%1 을(를) %2 에 추가하기",
    "DATA_DELETEOFLIST": "%1 번째 항목을 %2 에서 삭제하기",
    "DATA_INSERTATLIST": "%1 을(를) %3 리스트의 %2 번째에 넣기",
    "DATA_REPLACEITEMOFLIST": "%2 리스트의 %1 번째 항목을 %3 으로 바꾸기",
    "DATA_ITEMOFLIST": "%2 리스트의 %1 번째 항목",
    "DATA_LENGTHOFLIST": "%1 의 길이",
    "DATA_LISTCONTAINSITEM": "%1 이(가) %2 을(를) 포함하는가?",
    "DATA_SHOWLIST": "%1 리스트 보이기",
    "DATA_HIDELIST": "%1 리스트 숨기기",
    "DATA_INDEX_ALL": "모두",
    "DATA_INDEX_LAST": "마지막",
    "DATA_INDEX_RANDOM": "랜덤",
    "EVENT_WHENFLAGCLICKED": "%1 을(를) 클릭했을 때",
    "EVENT_WHENTHISSPRITECLICKED": "이 스프라이트를 클릭했을 때",
    "EVENT_WHENSTAGECLICKED": "무대를 클릭했을 때",
    "EVENT_WHENTOUCHINGOBJECT": "이 스프라이트가 %1 에 닿을 때",
    "EVENT_WHENBROADCASTRECEIVED": "%1 받았을 때",
    "EVENT_WHENBACKDROPSWITCHESTO": "배경이 %1 (으)로 바뀌었을 때",
    "EVENT_WHENGREATERTHAN": "%1 > %2 일 때",
    "EVENT_WHENGREATERTHAN_TIMER": "타이머",
    "EVENT_BROADCAST": "%1 방송하기",
    "EVENT_BROADCASTANDWAIT": "%1 방송하고 기다리기",
    "EVENT_WHENKEYPRESSED": "%1 키를 눌렀을 때",
    "EVENT_WHENKEYPRESSED_SPACE": "스페이스",
    "EVENT_WHENKEYPRESSED_LEFT": "왼쪽 화살표",
    "EVENT_WHENKEYPRESSED_RIGHT": "오른쪽 화살표",
    "EVENT_WHENKEYPRESSED_DOWN": "아래쪽 화살표",
    "EVENT_WHENKEYPRESSED_UP": "위쪽 화살표",
    "EVENT_WHENKEYPRESSED_ANY": "아무",
    "LOOKS_SAYFORSECS": "%1 을(를) %2 초 동안 말하기",
    "LOOKS_SAY": "%1 말하기",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "%1 을(를) %2 초 동안 생각하기",
    "LOOKS_THINK": "%1 생각하기",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "보이기",
    "LOOKS_HIDE": "숨기기",
    "LOOKS_HIDEALLSPRITES": "모든 스프라이트 숨기기",
    "LOOKS_EFFECT_COLOR": "색깔",
    "LOOKS_EFFECT_FISHEYE": "어안 렌즈",
    "LOOKS_EFFECT_WHIRL": "소용돌이",
    "LOOKS_EFFECT_PIXELATE": "픽셀화",
    "LOOKS_EFFECT_MOSAIC": "모자이크",
    "LOOKS_EFFECT_BRIGHTNESS": "밝기",
    "LOOKS_EFFECT_GHOST": "투명도",
    "LOOKS_CHANGEEFFECTBY": "%1 효과를 %2 만큼 바꾸기",
    "LOOKS_SETEFFECTTO": "%1 효과를 %2 (으)로 정하기",
    "LOOKS_CLEARGRAPHICEFFECTS": "그래픽 효과 지우기",
    "LOOKS_CHANGESIZEBY": "크기를 %1 만큼 바꾸기",
    "LOOKS_SETSIZETO": "크기를 %1 %로 정하기",
    "LOOKS_SIZE": "크기",
    "LOOKS_CHANGESTRETCHBY": "너비를 %1 만큼 바꾸기",
    "LOOKS_SETSTRETCHTO": "너비를 %1 %로 정하기",
    "LOOKS_SWITCHCOSTUMETO": "모양을 %1 (으)로 바꾸기",
    "LOOKS_NEXTCOSTUME": "다음 모양으로 바꾸기",
    "LOOKS_SWITCHBACKDROPTO": "배경을 %1 (으)로 바꾸기",
    "LOOKS_GOTOFRONTBACK": "%1 으로 순서 바꾸기",
    "LOOKS_GOTOFRONTBACK_FRONT": "맨 앞쪽",
    "LOOKS_GOTOFRONTBACK_BACK": "맨 뒤쪽",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 단계 보내기",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "앞으로",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "뒤로",
    "LOOKS_BACKDROPNUMBERNAME": "배경 %1",
    "LOOKS_COSTUMENUMBERNAME": "모양 %1",
    "LOOKS_NUMBERNAME_NUMBER": "번호",
    "LOOKS_NUMBERNAME_NAME": "이름",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "배경을 %1 (으)로 바꾸고 기다리기",
    "LOOKS_NEXTBACKDROP": "다음 배경으로 바꾸기",
    "LOOKS_PREVIOUSBACKDROP": "이전 배경으로 바꾸기",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "%1 만큼 움직이기",
    "MOTION_TURNLEFT": "%1 방향으로 %2 도 돌기",
    "MOTION_TURNRIGHT": "%1 방향으로 %2 도 돌기",
    "MOTION_POINTINDIRECTION": "%1 도 방향 보기",
    "MOTION_POINTTOWARDS": "%1 쪽 보기",
    "MOTION_POINTTOWARDS_POINTER": "마우스 포인터",
    "MOTION_GOTO": "%1 (으)로 이동하기",
    "MOTION_GOTO_POINTER": "마우스 포인터",
    "MOTION_GOTO_RANDOM": "랜덤 위치",
    "MOTION_GOTOXY": "x: %1 y: %2 (으)로 이동하기",
    "MOTION_GLIDESECSTOXY": "%1 초 동안 x: %2 y: %3 (으)로 이동하기",
    "MOTION_GLIDETO": "%1 초 동안 %2 (으)로 이동하기",
    "MOTION_GLIDETO_POINTER": "마우스 포인터",
    "MOTION_GLIDETO_RANDOM": "랜덤 위치",
    "MOTION_CHANGEXBY": "x 좌표를 %1 만큼 바꾸기",
    "MOTION_SETX": "x 좌표를 %1 (으)로 정하기",
    "MOTION_CHANGEYBY": "y 좌표를 %1 만큼 바꾸기",
    "MOTION_SETY": "y 좌표를 %1 (으)로 정하기",
    "MOTION_IFONEDGEBOUNCE": "벽에 닿으면 튕기기",
    "MOTION_SETROTATIONSTYLE": "회전 방식을 %1 (으)로 정하기",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "왼쪽-오른쪽",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "회전하지 않기",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "회전하기",
    "MOTION_XPOSITION": "x좌표",
    "MOTION_YPOSITION": "y좌표",
    "MOTION_DIRECTION": "방향",
    "MOTION_SCROLLRIGHT": "오른쪽으로 %1 만큼 스크롤하기",
    "MOTION_SCROLLUP": "위쪽으로 %1 만큼 스크롤하기",
    "MOTION_ALIGNSCENE": "화면을 %1 로 정렬하기",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "왼쪽 아래",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "오른쪽 아래",
    "MOTION_ALIGNSCENE_MIDDLE": "가운데",
    "MOTION_ALIGNSCENE_TOPLEFT": "왼쪽 위",
    "MOTION_ALIGNSCENE_TOPRIGHT": "오른쪽 위",
    "MOTION_XSCROLL": "x 스크롤",
    "MOTION_YSCROLL": "y 스크롤",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 × %2",
    "OPERATORS_DIVIDE": "%1 ÷ %2",
    "OPERATORS_RANDOM": "%1 부터 %2 사이의 난수",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 그리고 %2",
    "OPERATORS_OR": "%1 또는 %2",
    "OPERATORS_NOT": "%1 이(가) 아니다",
    "OPERATORS_JOIN": "%1 와(과) %2 결합하기",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "%2 의 %1 번째 글자",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "%1 의 길이",
    "OPERATORS_CONTAINS": "%1 이(가) %2 을(를) 포함하는가?",
    "OPERATORS_MOD": "%1 나누기 %2 의 나머지",
    "OPERATORS_ROUND": "%1 의 반올림",
    "OPERATORS_MATHOP": "%1 ( %2 )",
    "OPERATORS_MATHOP_ABS": "절댓값",
    "OPERATORS_MATHOP_FLOOR": "버림",
    "OPERATORS_MATHOP_CEILING": "올림",
    "OPERATORS_MATHOP_SQRT": "제곱근",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "%1 정의하기",
    "SENSING_TOUCHINGOBJECT": "%1 에 닿았는가?",
    "SENSING_TOUCHINGOBJECT_POINTER": "마우스 포인터",
    "SENSING_TOUCHINGOBJECT_EDGE": "벽",
    "SENSING_TOUCHINGCOLOR": "%1 색에 닿았는가?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 색이 %2 색에 닿았는가?",
    "SENSING_DISTANCETO": "%1 까지의 거리",
    "SENSING_DISTANCETO_POINTER": "마우스 포인터",
    "SENSING_ASKANDWAIT": "%1 라고 묻고 기다리기",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "대답",
    "SENSING_KEYPRESSED": "%1 키를 눌렸는가?",
    "SENSING_MOUSEDOWN": "마우스를 클릭했는가?",
    "SENSING_MOUSEX": "마우스의 x좌표",
    "SENSING_MOUSEY": "마우스의 y좌표",
    "SENSING_SETDRAGMODE": "드래그 모드를 %1 상태로 정하기",
    "SENSING_SETDRAGMODE_DRAGGABLE": "드래그 할 수 있는",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "드래그 할 수 없는",
    "SENSING_LOUDNESS": "음량",
    "SENSING_LOUD": "소리가 큰가?",
    "SENSING_TIMER": "타이머",
    "SENSING_RESETTIMER": "타이머 초기화",
    "SENSING_OF": "%2 의 %1",
    "SENSING_OF_XPOSITION": "x좌표",
    "SENSING_OF_YPOSITION": "y좌표",
    "SENSING_OF_DIRECTION": "방향",
    "SENSING_OF_COSTUMENUMBER": "모양 번호",
    "SENSING_OF_COSTUMENAME": "모양 이름",
    "SENSING_OF_SIZE": "크기",
    "SENSING_OF_VOLUME": "음량",
    "SENSING_OF_BACKDROPNUMBER": "배경 번호",
    "SENSING_OF_BACKDROPNAME": "배경 이름",
    "SENSING_OF_STAGE": "무대",
    "SENSING_CURRENT": "현재 %1",
    "SENSING_CURRENT_YEAR": "년",
    "SENSING_CURRENT_MONTH": "월",
    "SENSING_CURRENT_DATE": "일",
    "SENSING_CURRENT_DAYOFWEEK": "요일",
    "SENSING_CURRENT_HOUR": "시",
    "SENSING_CURRENT_MINUTE": "분",
    "SENSING_CURRENT_SECOND": "초",
    "SENSING_DAYSSINCE2000": "2000년 이후 현재까지 날짜 수",
    "SENSING_USERNAME": "사용자 이름",
    "SENSING_USERID": "사용자 번호",
    "SOUND_PLAY": "%1 재생하기",
    "SOUND_PLAYUNTILDONE": "%1 끝까지 재생하기",
    "SOUND_STOPALLSOUNDS": "모든 소리 끄기",
    "SOUND_SETEFFECTO": "%1 효과를 %2 로 정하기",
    "SOUND_CHANGEEFFECTBY": "%1 효과를 %2 만큼 바꾸기",
    "SOUND_CLEAREFFECTS": "소리 효과 지우기",
    "SOUND_EFFECTS_PITCH": "음 높이",
    "SOUND_EFFECTS_PAN": "음향 위치 왼쪽/오른쪽",
    "SOUND_CHANGEVOLUMEBY": "음량을 %1 만큼 바꾸기",
    "SOUND_SETVOLUMETO": "음량을 %1% 로 정하기",
    "SOUND_VOLUME": "음량",
    "CATEGORY_MOTION": "동작",
    "CATEGORY_LOOKS": "형태",
    "CATEGORY_SOUND": "소리",
    "CATEGORY_EVENTS": "이벤트",
    "CATEGORY_CONTROL": "제어",
    "CATEGORY_SENSING": "감지",
    "CATEGORY_OPERATORS": "연산",
    "CATEGORY_VARIABLES": "변수",
    "CATEGORY_MYBLOCKS": "나만의 블록",
    "DUPLICATE": "복사하기",
    "DELETE": "삭제하기",
    "ADD_COMMENT": "주석 넣기",
    "REMOVE_COMMENT": "주석 지우기",
    "DELETE_BLOCK": "블록 삭제하기",
    "DELETE_X_BLOCKS": "블록 %1개 삭제하기",
    "DELETE_ALL_BLOCKS": " %1개의 블록을 모두 삭제할까요?",
    "CLEAN_UP": "블록 정리하기",
    "HELP": "도움말",
    "UNDO": "되돌리기",
    "REDO": "재시도",
    "EDIT_PROCEDURE": "편집",
    "SHOW_PROCEDURE_DEFINITION": "정의로 이동하기",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Say something...",
    "COLOUR_HUE_LABEL": "색상",
    "COLOUR_SATURATION_LABEL": "채도",
    "COLOUR_BRIGHTNESS_LABEL": "명도",
    "CHANGE_VALUE_TITLE": "값 바꾸기:",
    "RENAME_VARIABLE": "변수 이름 수정하기",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "변수 이름 수정하기",
    "NEW_VARIABLE": "변수 만들기",
    "NEW_VARIABLE_TITLE": "새로운 변수 이름:",
    "VARIABLE_MODAL_TITLE": "새로운 변수",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "블록 만들기",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "리스트 만들기",
    "NEW_LIST_TITLE": "새로운 리스트 이름:",
    "LIST_MODAL_TITLE": "새로운 리스트",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "리스트 이름 수정하기",
    "NEW_BROADCAST_MESSAGE": "새로운 메시지",
    "NEW_BROADCAST_MESSAGE_TITLE": "새로운 메시지 이름:",
    "BROADCAST_MODAL_TITLE": "새로운 메시지",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "메시지1"
};

Blockly.ScratchMsgs.locales["mi"] =
{
    "CONTROL_FOREVER": "mō ake, ake mahia",
    "CONTROL_REPEAT": "tōaitia %1",
    "CONTROL_IF": "mēnā %1 mahia",
    "CONTROL_ELSE": "kē atu",
    "CONTROL_STOP": "katia",
    "CONTROL_STOP_ALL": "katoa",
    "CONTROL_STOP_THIS": "tēnei hōtuhi",
    "CONTROL_STOP_OTHER": "hōtuhi kē i roto i te parehe",
    "CONTROL_WAIT": "tatari kia %1 hēkona",
    "CONTROL_WAITUNTIL": "tatari kia %1",
    "CONTROL_REPEATUNTIL": "tōaitia tonutia kia %1",
    "CONTROL_WHILE": "tōaitia tonutia mēnā %1",
    "CONTROL_FOREACH": "mō ia %1 o roto i te %2",
    "CONTROL_STARTASCLONE": "ina ka tīmata mai ahau hei tārua",
    "CONTROL_CREATECLONEOF": "whakapūruatia %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ahau anō",
    "CONTROL_DELETETHISCLONE": "mukua tēnei tāruarua",
    "CONTROL_COUNTER": "pūtatau",
    "CONTROL_INCRCOUNTER": "tāpiri tahi ki te pūtatau",
    "CONTROL_CLEARCOUNTER": "ūkui pūtatau",
    "CONTROL_ALLATONCE": "te katoa i te wā kotahi",
    "DATA_SETVARIABLETO": "tautuhia %1 ki te %2",
    "DATA_CHANGEVARIABLEBY": "panonitia %1 mā te %2",
    "DATA_SHOWVARIABLE": "whakaaturia te taurangi %1",
    "DATA_HIDEVARIABLE": "hunaia te taurangi %1",
    "DATA_ADDTOLIST": "tāpiritia te %1 ki te %2",
    "DATA_DELETEOFLIST": "mukua %1 i a %2",
    "DATA_INSERTATLIST": "whakaurua te %1 hei %2 o %3",
    "DATA_REPLACEITEMOFLIST": "whakakapia te tūemi %1 o %2, ki %3",
    "DATA_ITEMOFLIST": "te tūemi %1 o %2",
    "DATA_LENGTHOFLIST": "te roanga o te %1",
    "DATA_LISTCONTAINSITEM": "kei roto i %1 te %2?",
    "DATA_SHOWLIST": "whakaaturia te rārangi %1",
    "DATA_HIDELIST": "hunāia te rārangi %1",
    "DATA_INDEX_ALL": "katoa",
    "DATA_INDEX_LAST": "whakamutunga",
    "DATA_INDEX_RANDOM": "matapōkere",
    "EVENT_WHENFLAGCLICKED": "ina pāwhiria te %1",
    "EVENT_WHENTHISSPRITECLICKED": "ina pāwhiria tēnei parehe",
    "EVENT_WHENSTAGECLICKED": "ina pāwhiria te Atamira",
    "EVENT_WHENTOUCHINGOBJECT": "ka pā tēnei parehe i te %1",
    "EVENT_WHENBROADCASTRECEIVED": "ina ka riro mai te %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "ina hurihia te ārai tuarongo kia %1",
    "EVENT_WHENGREATERTHAN": "mēnā %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "taima",
    "EVENT_BROADCAST": "whakapaoho %1",
    "EVENT_BROADCASTANDWAIT": "whakapaoho %1, kātahi tatari",
    "EVENT_WHENKEYPRESSED": "ina pēhia te pātuhi %1",
    "EVENT_WHENKEYPRESSED_SPACE": "mokowā",
    "EVENT_WHENKEYPRESSED_LEFT": "pere mauī",
    "EVENT_WHENKEYPRESSED_RIGHT": "pere katau",
    "EVENT_WHENKEYPRESSED_DOWN": "pere whakararo",
    "EVENT_WHENKEYPRESSED_UP": "pere whakarunga",
    "EVENT_WHENKEYPRESSED_ANY": "noa",
    "LOOKS_SAYFORSECS": "kīia %1 mō ngā hēkona %2",
    "LOOKS_SAY": "kīia %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "whakaarohia te %1 mō ngā hēkona %2",
    "LOOKS_THINK": "whakaarohia te %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "whakaatu",
    "LOOKS_HIDE": "huna",
    "LOOKS_HIDEALLSPRITES": "hunaia ngā parehe katoa",
    "LOOKS_EFFECT_COLOR": "tae",
    "LOOKS_EFFECT_FISHEYE": "karu ika",
    "LOOKS_EFFECT_WHIRL": "kōriporipo",
    "LOOKS_EFFECT_PIXELATE": "whakatongitongi",
    "LOOKS_EFFECT_MOSAIC": "toi rōpinepine",
    "LOOKS_EFFECT_BRIGHTNESS": "pīataata",
    "LOOKS_EFFECT_GHOST": "kēhua",
    "LOOKS_CHANGEEFFECTBY": "panonitia te rākeitanga %1 mā te %2",
    "LOOKS_SETEFFECTTO": "panonitia te rākeitanga %1 ki te %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "ūkui rākeitanga whakairoiro",
    "LOOKS_CHANGESIZEBY": "panonitia te nui mā te %1",
    "LOOKS_SETSIZETO": "tautuhia te rahi kia %1 %",
    "LOOKS_SIZE": "rahi",
    "LOOKS_CHANGESTRETCHBY": "panonitia te toronga mā te %1",
    "LOOKS_SETSTRETCHTO": "tautuhia te toronga kia %1 %",
    "LOOKS_SWITCHCOSTUMETO": "panonitia te kākahu kia %1",
    "LOOKS_NEXTCOSTUME": "kākahu panuku",
    "LOOKS_SWITCHBACKDROPTO": "panonitia te ārai tuarongo kia %1",
    "LOOKS_GOTOFRONTBACK": "haere ki te apa %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "mua",
    "LOOKS_GOTOFRONTBACK_BACK": "muri",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "nekehia %1, kia %2 ngā apaapa",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ki mua",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ki muri",
    "LOOKS_BACKDROPNUMBERNAME": "ārai tuarongo %1",
    "LOOKS_COSTUMENUMBERNAME": "kākahu %1",
    "LOOKS_NUMBERNAME_NUMBER": "nama",
    "LOOKS_NUMBERNAME_NAME": "ingoa",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "panonitia te ārai tuarongo kia %1, kātahi, tatari",
    "LOOKS_NEXTBACKDROP": "ārai tuarongo panuku",
    "LOOKS_PREVIOUSBACKDROP": "ārai tuarongo o mua",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "nekehia kia %1 ngā takahanga",
    "MOTION_TURNLEFT": "hurihia %1, kia %2 putu",
    "MOTION_TURNRIGHT": "hurihia %1, kia %2 putu",
    "MOTION_POINTINDIRECTION": "atatohua ki %1",
    "MOTION_POINTTOWARDS": "atatohua ki %1",
    "MOTION_POINTTOWARDS_POINTER": "atatohu-kiore",
    "MOTION_GOTO": "neke ki %1",
    "MOTION_GOTO_POINTER": "atatohu-kiore",
    "MOTION_GOTO_RANDOM": "tūnga matapōkere",
    "MOTION_GOTOXY": "neke ki x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "wania kia %1 hēkona ki x: %2 y: %3",
    "MOTION_GLIDETO": "wania kia %1 hēkona ki %2",
    "MOTION_GLIDETO_POINTER": "atatohu-kiore",
    "MOTION_GLIDETO_RANDOM": "tūnga matapōkere",
    "MOTION_CHANGEXBY": "panonitia x mā te %1",
    "MOTION_SETX": "tāutuhia te x kia %1",
    "MOTION_CHANGEYBY": "panonitia y mā te %1",
    "MOTION_SETY": "tāutuhia te y kia %1",
    "MOTION_IFONEDGEBOUNCE": "mēnā kei te taitapa, tupanatia",
    "MOTION_SETROTATIONSTYLE": "tautuhia te momo huringa kia %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "mauī-ki-katau",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "kaua e takahuri",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "huri noa",
    "MOTION_XPOSITION": "tūnga x",
    "MOTION_YPOSITION": "tūnga y",
    "MOTION_DIRECTION": "ahunga",
    "MOTION_SCROLLRIGHT": "panuku whakatekatau %1",
    "MOTION_SCROLLUP": "panuku whakarunga %1",
    "MOTION_ALIGNSCENE": "tīaro kāpeka %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "taha mauī o raro",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "taha katau o raro",
    "MOTION_ALIGNSCENE_MIDDLE": "waenga",
    "MOTION_ALIGNSCENE_TOPLEFT": "taha mauī o runga",
    "MOTION_ALIGNSCENE_TOPRIGHT": "taha katau o runga",
    "MOTION_XSCROLL": "panuku x",
    "MOTION_YSCROLL": "panuku y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "kōwhiria matapōkere %1 ki te %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 me %2",
    "OPERATORS_OR": "%1, %2 rānei",
    "OPERATORS_NOT": "ehara ko te %1",
    "OPERATORS_JOIN": "tāpiritia te %1, %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "te pū %1 o te %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "te roanga o te %1",
    "OPERATORS_CONTAINS": "kei roto i a %1 : %2?",
    "OPERATORS_MOD": "%1 % %2",
    "OPERATORS_ROUND": "whakaawhiwhi %1",
    "OPERATORS_MATHOP": "%1 o te %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "papa",
    "OPERATORS_MATHOP_CEILING": "tuanui",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "tāutu %1",
    "SENSING_TOUCHINGOBJECT": "kei te pā ki te %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "atatohu-kiore",
    "SENSING_TOUCHINGOBJECT_EDGE": "taitapa",
    "SENSING_TOUCHINGCOLOR": "kei te pā ki te tae %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "ka pā te tae %1 i te %2?",
    "SENSING_DISTANCETO": "tawhiti ki %1",
    "SENSING_DISTANCETO_POINTER": "atatohu-kiore",
    "SENSING_ASKANDWAIT": "pātai %1, kātahi, tatari",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "whakautu",
    "SENSING_KEYPRESSED": "kua pēhia te pātuhi %1?",
    "SENSING_MOUSEDOWN": "pāwhiri kiore?",
    "SENSING_MOUSEX": "x kiore",
    "SENSING_MOUSEY": "y kiore",
    "SENSING_SETDRAGMODE": "tautuhia te aratau tō kia %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ka taea te tō",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "kāore e taea te tō",
    "SENSING_LOUDNESS": "hoihoi",
    "SENSING_LOUD": "hoihoi?",
    "SENSING_TIMER": "taima",
    "SENSING_RESETTIMER": "tautuhia anōtia te taima",
    "SENSING_OF": "%1 o %2",
    "SENSING_OF_XPOSITION": "tūnga x",
    "SENSING_OF_YPOSITION": "tūnga y",
    "SENSING_OF_DIRECTION": "ahunga",
    "SENSING_OF_COSTUMENUMBER": "kākahu #",
    "SENSING_OF_COSTUMENAME": "ingoa kākahu",
    "SENSING_OF_SIZE": "rahi",
    "SENSING_OF_VOLUME": "kahaoro",
    "SENSING_OF_BACKDROPNUMBER": "ārai tuarongo #",
    "SENSING_OF_BACKDROPNAME": "ingoa ārai tuarongo",
    "SENSING_OF_STAGE": "Atamira",
    "SENSING_CURRENT": "%1 o nāianei",
    "SENSING_CURRENT_YEAR": "tau",
    "SENSING_CURRENT_MONTH": "marama",
    "SENSING_CURRENT_DATE": "te rā",
    "SENSING_CURRENT_DAYOFWEEK": "te rangi o te wiki",
    "SENSING_CURRENT_HOUR": "haora",
    "SENSING_CURRENT_MINUTE": "miniti",
    "SENSING_CURRENT_SECOND": "hēkona",
    "SENSING_DAYSSINCE2000": "ngā rā mai i 2000",
    "SENSING_USERNAME": "ingoa kaiwhakamahi",
    "SENSING_USERID": "tohu tuakiri",
    "SOUND_PLAY": "tīmatahia te whakatangi i te oro %1",
    "SOUND_PLAYUNTILDONE": "whakatangihia te oro %1 kia mutu rawa",
    "SOUND_STOPALLSOUNDS": "katia ngā oro katoa",
    "SOUND_SETEFFECTO": "tautuhia te rākeitanga %1 kia %2",
    "SOUND_CHANGEEFFECTBY": "panonitia te rākeitanga %1 mā te %2",
    "SOUND_CLEAREFFECTS": "ūkui rākeitanga orotaunaki",
    "SOUND_EFFECTS_PITCH": "hauoro",
    "SOUND_EFFECTS_PAN": "huri whakatemauī/whakatekatau",
    "SOUND_CHANGEVOLUMEBY": "panonitia te kahaoro mā te %1",
    "SOUND_SETVOLUMETO": "tautuhia te kahaoro kia %1%",
    "SOUND_VOLUME": "kahaoro",
    "CATEGORY_MOTION": "Nekehanga",
    "CATEGORY_LOOKS": "Āhua",
    "CATEGORY_SOUND": "Oro",
    "CATEGORY_EVENTS": "Takahanga",
    "CATEGORY_CONTROL": "Whakatina",
    "CATEGORY_SENSING": "Paerongo",
    "CATEGORY_OPERATORS": "Tohutūmahi",
    "CATEGORY_VARIABLES": "Ngā Taurangi",
    "CATEGORY_MYBLOCKS": "Aku Paraka",
    "DUPLICATE": "Tāruatia",
    "DELETE": "Mukua",
    "ADD_COMMENT": "Tāpiri Tākupu",
    "REMOVE_COMMENT": "Mukua te Tākupu",
    "DELETE_BLOCK": "Mukua te Paraka",
    "DELETE_X_BLOCKS": "Mukua %1 Paraka",
    "DELETE_ALL_BLOCKS": "Mukua te katoa o ngā paraka e %1 ?",
    "CLEAN_UP": "Whakatikatika i ngā Paraka",
    "HELP": "Āwhina",
    "UNDO": "Wetekia",
    "REDO": "Mahia anōtia",
    "EDIT_PROCEDURE": "Whakatikaina",
    "SHOW_PROCEDURE_DEFINITION": "Haere ki te tautuhinga",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Kīia tētahi mea...",
    "COLOUR_HUE_LABEL": "Tae",
    "COLOUR_SATURATION_LABEL": "Waiwai",
    "COLOUR_BRIGHTNESS_LABEL": "Pīataata",
    "CHANGE_VALUE_TITLE": "Panonitia te uara:",
    "RENAME_VARIABLE": "Tapaina anōtia te taurangi",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Tapaina anōtia te Taurangi",
    "NEW_VARIABLE": "Hangaia tētahi taurangi",
    "NEW_VARIABLE_TITLE": "Ingoa taurangi hou:",
    "VARIABLE_MODAL_TITLE": "Taurangi Hou",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Hangaia tētahi Paraka",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Hangaia tētahi Rārangi",
    "NEW_LIST_TITLE": "Ingoa rārangi hou:",
    "LIST_MODAL_TITLE": "Rārangi Hou",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Tapaina te Rārangi",
    "NEW_BROADCAST_MESSAGE": "Karere hou",
    "NEW_BROADCAST_MESSAGE_TITLE": "Ingoa karere hou:",
    "BROADCAST_MODAL_TITLE": "Karere Hou",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "karere1"
};

Blockly.ScratchMsgs.locales["nb"] =
{
    "CONTROL_FOREVER": "gjenta for alltid",
    "CONTROL_REPEAT": "gjenta %1 ganger",
    "CONTROL_IF": "hvis %1",
    "CONTROL_ELSE": "ellers",
    "CONTROL_STOP": "stopp",
    "CONTROL_STOP_ALL": "alle",
    "CONTROL_STOP_THIS": "dette skriptet",
    "CONTROL_STOP_OTHER": "andre skript i figuren",
    "CONTROL_WAIT": "vent %1 sekunder",
    "CONTROL_WAITUNTIL": "vent til %1",
    "CONTROL_REPEATUNTIL": "gjenta til %1",
    "CONTROL_WHILE": "gjenta hvis %1",
    "CONTROL_FOREACH": "for hver %1 i %2",
    "CONTROL_STARTASCLONE": "når jeg starter som klon",
    "CONTROL_CREATECLONEOF": "lag klon av %1",
    "CONTROL_CREATECLONEOF_MYSELF": "meg",
    "CONTROL_DELETETHISCLONE": "slett denne klonen",
    "CONTROL_COUNTER": "teller",
    "CONTROL_INCRCOUNTER": "tell opp med 1",
    "CONTROL_CLEARCOUNTER": "nullstill telleren",
    "CONTROL_ALLATONCE": "kjør fort",
    "DATA_SETVARIABLETO": "sett %1 til %2",
    "DATA_CHANGEVARIABLEBY": "endre %1 med %2",
    "DATA_SHOWVARIABLE": "vis variabel %1",
    "DATA_HIDEVARIABLE": "skjul variabel %1",
    "DATA_ADDTOLIST": "legg til %1 i %2",
    "DATA_DELETEOFLIST": "slett element %1 i %2",
    "DATA_INSERTATLIST": "sett inn %1 på plass %2 i %3",
    "DATA_REPLACEITEMOFLIST": "erstatt element %1 i %2 med %3",
    "DATA_ITEMOFLIST": "element %1 i %2",
    "DATA_LENGTHOFLIST": "lengden av %1",
    "DATA_LISTCONTAINSITEM": "%1 inneholder %2?",
    "DATA_SHOWLIST": "vis liste %1",
    "DATA_HIDELIST": "skjul liste %1",
    "DATA_INDEX_ALL": "alle",
    "DATA_INDEX_LAST": "siste",
    "DATA_INDEX_RANDOM": "tilfeldig",
    "EVENT_WHENFLAGCLICKED": "når %1 klikkes",
    "EVENT_WHENTHISSPRITECLICKED": "når denne figuren klikkes",
    "EVENT_WHENSTAGECLICKED": "når scenen klikkes",
    "EVENT_WHENTOUCHINGOBJECT": "når denne figuren berører %1",
    "EVENT_WHENBROADCASTRECEIVED": "når jeg mottar %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "når bakgrunn bytter til %1",
    "EVENT_WHENGREATERTHAN": "når %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "sekundklokke",
    "EVENT_BROADCAST": "send melding %1",
    "EVENT_BROADCASTANDWAIT": "send melding %1 og vent",
    "EVENT_WHENKEYPRESSED": "når %1 trykkes",
    "EVENT_WHENKEYPRESSED_SPACE": "mellomrom",
    "EVENT_WHENKEYPRESSED_LEFT": "pil venstre",
    "EVENT_WHENKEYPRESSED_RIGHT": "pil høyre",
    "EVENT_WHENKEYPRESSED_DOWN": "pil ned",
    "EVENT_WHENKEYPRESSED_UP": "pil opp",
    "EVENT_WHENKEYPRESSED_ANY": "hvilken som helst",
    "LOOKS_SAYFORSECS": "si %1 i %2 sekunder",
    "LOOKS_SAY": "si %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "tenk %1 i %2 sekunder",
    "LOOKS_THINK": "tenk %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "vis",
    "LOOKS_HIDE": "skjul",
    "LOOKS_HIDEALLSPRITES": "skjul alle figurer",
    "LOOKS_EFFECT_COLOR": "farge",
    "LOOKS_EFFECT_FISHEYE": "fiskeøye",
    "LOOKS_EFFECT_WHIRL": "virvel",
    "LOOKS_EFFECT_PIXELATE": "piksel",
    "LOOKS_EFFECT_MOSAIC": "mosaikk",
    "LOOKS_EFFECT_BRIGHTNESS": "lysstyrke",
    "LOOKS_EFFECT_GHOST": "gjennomsiktig",
    "LOOKS_CHANGEEFFECTBY": "endre %1 effekt med %2",
    "LOOKS_SETEFFECTTO": "sett %1 effekt til %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "fjern grafiske effekter",
    "LOOKS_CHANGESIZEBY": "endre størrelse med %1",
    "LOOKS_SETSIZETO": "sett størrelse til %1 %",
    "LOOKS_SIZE": "størrelse",
    "LOOKS_CHANGESTRETCHBY": "endre strekk med %1",
    "LOOKS_SETSTRETCHTO": "sett strekk til %1 %",
    "LOOKS_SWITCHCOSTUMETO": "bytt drakt til %1",
    "LOOKS_NEXTCOSTUME": "neste drakt",
    "LOOKS_SWITCHBACKDROPTO": "bytt bakgrunn til %1",
    "LOOKS_GOTOFRONTBACK": "legg %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "foran alt",
    "LOOKS_GOTOFRONTBACK_BACK": "bakerst",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gå %1 %2 lag",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "forover",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "bakover",
    "LOOKS_BACKDROPNUMBERNAME": "bakgrunn %1",
    "LOOKS_COSTUMENUMBERNAME": "drakt %1",
    "LOOKS_NUMBERNAME_NUMBER": "nummer",
    "LOOKS_NUMBERNAME_NAME": "navn",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "bytt bakgrunn til %1 og vent",
    "LOOKS_NEXTBACKDROP": "neste bakgrunn",
    "LOOKS_PREVIOUSBACKDROP": "forrige bakgrunn",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "gå %1 steg",
    "MOTION_TURNLEFT": "snu %1 %2 grader",
    "MOTION_TURNRIGHT": "snu %1 %2 grader",
    "MOTION_POINTINDIRECTION": "pek i retning %1",
    "MOTION_POINTTOWARDS": "pek mot %1",
    "MOTION_POINTTOWARDS_POINTER": "musepeker",
    "MOTION_GOTO": "gå til %1",
    "MOTION_GOTO_POINTER": "musepeker",
    "MOTION_GOTO_RANDOM": "tilfeldig sted",
    "MOTION_GOTOXY": "gå til x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "gli %1 sekunder til x: %2 y: %3",
    "MOTION_GLIDETO": "gli %1 sekunder til %2",
    "MOTION_GLIDETO_POINTER": "musepeker",
    "MOTION_GLIDETO_RANDOM": "tilfeldig sted",
    "MOTION_CHANGEXBY": "endre x med %1",
    "MOTION_SETX": "sett x til %1",
    "MOTION_CHANGEYBY": "endre y med %1",
    "MOTION_SETY": "sett y til %1",
    "MOTION_IFONEDGEBOUNCE": "sprett tilbake ved kanten",
    "MOTION_SETROTATIONSTYLE": "begrens rotasjon %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vend sideveis",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ikke roter",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "fri rotasjon",
    "MOTION_XPOSITION": "x-posisjon",
    "MOTION_YPOSITION": "y-posisjon",
    "MOTION_DIRECTION": "retning",
    "MOTION_SCROLLRIGHT": "rull høyre %1",
    "MOTION_SCROLLUP": "rull opp %1",
    "MOTION_ALIGNSCENE": "flytt bakgrunn %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "nederst til venstre",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "nederst til høyre",
    "MOTION_ALIGNSCENE_MIDDLE": "i midten",
    "MOTION_ALIGNSCENE_TOPLEFT": "øverst til venstre",
    "MOTION_ALIGNSCENE_TOPRIGHT": "øverst til høyre",
    "MOTION_XSCROLL": "rull x",
    "MOTION_YSCROLL": "rull y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "tilfeldig tall fra %1 til %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 og %2",
    "OPERATORS_OR": "%1 eller %2",
    "OPERATORS_NOT": "ikke %1",
    "OPERATORS_JOIN": "sett sammen %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "bokstav %1 i %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "lengden av %1",
    "OPERATORS_CONTAINS": "%1 inneholder %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "avrund %1",
    "OPERATORS_MATHOP": "%1 av %2",
    "OPERATORS_MATHOP_ABS": "absoluttverdi",
    "OPERATORS_MATHOP_FLOOR": "avrund ned",
    "OPERATORS_MATHOP_CEILING": "avrund opp",
    "OPERATORS_MATHOP_SQRT": "kvadratrot",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definer %1",
    "SENSING_TOUCHINGOBJECT": "berører %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "musepeker",
    "SENSING_TOUCHINGOBJECT_EDGE": "kant",
    "SENSING_TOUCHINGCOLOR": "berører fargen %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "farge %1 berører %2?",
    "SENSING_DISTANCETO": "avstand til %1",
    "SENSING_DISTANCETO_POINTER": "musepeker",
    "SENSING_ASKANDWAIT": "spør %1 og vent",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "svar",
    "SENSING_KEYPRESSED": "tast %1 trykket?",
    "SENSING_MOUSEDOWN": "museknappen er trykket?",
    "SENSING_MOUSEX": "mus x",
    "SENSING_MOUSEY": "mus y",
    "SENSING_SETDRAGMODE": "%1 å dra med musen",
    "SENSING_SETDRAGMODE_DRAGGABLE": "tillat",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ikke tillat",
    "SENSING_LOUDNESS": "lydnivå",
    "SENSING_LOUD": "høy lyd?",
    "SENSING_TIMER": "sekundklokke",
    "SENSING_RESETTIMER": "nullstill klokken",
    "SENSING_OF": "%1 av %2",
    "SENSING_OF_XPOSITION": "x-posisjon",
    "SENSING_OF_YPOSITION": "y-posisjon",
    "SENSING_OF_DIRECTION": "retning",
    "SENSING_OF_COSTUMENUMBER": "drakt nr.",
    "SENSING_OF_COSTUMENAME": "draktnavn",
    "SENSING_OF_SIZE": "størrelse",
    "SENSING_OF_VOLUME": "volum",
    "SENSING_OF_BACKDROPNUMBER": "bakgrunn nr.",
    "SENSING_OF_BACKDROPNAME": "navn på bakgrunn",
    "SENSING_OF_STAGE": "Scene",
    "SENSING_CURRENT": "%1 nå",
    "SENSING_CURRENT_YEAR": "år",
    "SENSING_CURRENT_MONTH": "måned",
    "SENSING_CURRENT_DATE": "dato",
    "SENSING_CURRENT_DAYOFWEEK": "ukedag",
    "SENSING_CURRENT_HOUR": "time",
    "SENSING_CURRENT_MINUTE": "minutt",
    "SENSING_CURRENT_SECOND": "sekund",
    "SENSING_DAYSSINCE2000": "dager siden 2000",
    "SENSING_USERNAME": "brukernavn",
    "SENSING_USERID": "brukernavn",
    "SOUND_PLAY": "start lyden %1",
    "SOUND_PLAYUNTILDONE": "spill lyden %1 til den er ferdig",
    "SOUND_STOPALLSOUNDS": "stopp alle lyder",
    "SOUND_SETEFFECTO": "sett %1 effekt til %2",
    "SOUND_CHANGEEFFECTBY": "endre %1 effekt med %2",
    "SOUND_CLEAREFFECTS": "fjern lydeffekter",
    "SOUND_EFFECTS_PITCH": "tonehøyde",
    "SOUND_EFFECTS_PAN": "retning",
    "SOUND_CHANGEVOLUMEBY": "endre volum med %1",
    "SOUND_SETVOLUMETO": "sett volum %1%",
    "SOUND_VOLUME": "volum",
    "CATEGORY_MOTION": "Bevegelse",
    "CATEGORY_LOOKS": "Utseende",
    "CATEGORY_SOUND": "Lyd",
    "CATEGORY_EVENTS": "Hendelser",
    "CATEGORY_CONTROL": "Styring",
    "CATEGORY_SENSING": "Sansing",
    "CATEGORY_OPERATORS": "Operatorer",
    "CATEGORY_VARIABLES": "Variabler",
    "CATEGORY_MYBLOCKS": "Mine klosser",
    "DUPLICATE": "Lag en kopi",
    "DELETE": "Slett",
    "ADD_COMMENT": "Skriv en kommentar",
    "REMOVE_COMMENT": "Fjern kommentar",
    "DELETE_BLOCK": "Slett kloss",
    "DELETE_X_BLOCKS": "Slett %1 klosser",
    "DELETE_ALL_BLOCKS": "Slette disse %1  klossene?",
    "CLEAN_UP": "Rydd opp klossene",
    "HELP": "Hjelp",
    "UNDO": "Angre",
    "REDO": "Gjør igjen",
    "EDIT_PROCEDURE": "Rediger",
    "SHOW_PROCEDURE_DEFINITION": "Gå til definisjonen",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Si noe...",
    "COLOUR_HUE_LABEL": "Farge",
    "COLOUR_SATURATION_LABEL": "Fargemetning",
    "COLOUR_BRIGHTNESS_LABEL": "Lysstyrke",
    "CHANGE_VALUE_TITLE": "Endre verdi:",
    "RENAME_VARIABLE": "Endre navn på variabel",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Endre navn på variabel",
    "NEW_VARIABLE": "Lag en variabel",
    "NEW_VARIABLE_TITLE": "Nytt variabelnavn:",
    "VARIABLE_MODAL_TITLE": "Ny variabel",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Lag en kloss",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Lag en Liste",
    "NEW_LIST_TITLE": "Nytt navn på listen:",
    "LIST_MODAL_TITLE": "Ny liste",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Gi listen et annet navn",
    "NEW_BROADCAST_MESSAGE": "Ny melding",
    "NEW_BROADCAST_MESSAGE_TITLE": "Skriv ny  melding:",
    "BROADCAST_MODAL_TITLE": "Ny melding",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "melding1"
};

Blockly.ScratchMsgs.locales["nl"] =
{
    "CONTROL_FOREVER": "herhaal",
    "CONTROL_REPEAT": "herhaal %1",
    "CONTROL_IF": "als %1 dan",
    "CONTROL_ELSE": "anders",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "alle",
    "CONTROL_STOP_THIS": "dit script",
    "CONTROL_STOP_OTHER": "andere scripts in sprite",
    "CONTROL_WAIT": "wacht %1 sec.",
    "CONTROL_WAITUNTIL": "wacht tot %1",
    "CONTROL_REPEATUNTIL": "herhaal tot %1",
    "CONTROL_WHILE": "zolang %1",
    "CONTROL_FOREACH": "voor elke %1 in %2",
    "CONTROL_STARTASCLONE": "wanneer ik als kloon start",
    "CONTROL_CREATECLONEOF": "maak een kloon van %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mijzelf",
    "CONTROL_DELETETHISCLONE": "verwijder deze kloon",
    "CONTROL_COUNTER": "teller",
    "CONTROL_INCRCOUNTER": "verhoog teller",
    "CONTROL_CLEARCOUNTER": "zet teller op 0",
    "CONTROL_ALLATONCE": "alles in een keer",
    "DATA_SETVARIABLETO": "maak %1 %2",
    "DATA_CHANGEVARIABLEBY": "verander %1 met %2",
    "DATA_SHOWVARIABLE": "toon variabele %1",
    "DATA_HIDEVARIABLE": "verberg variabele %1",
    "DATA_ADDTOLIST": "voeg %1 toe aan %2",
    "DATA_DELETEOFLIST": "verwijder %1 van %2",
    "DATA_INSERTATLIST": "voeg %1 toe op %2 van %3",
    "DATA_REPLACEITEMOFLIST": "vervang item %1 van %2 door %3",
    "DATA_ITEMOFLIST": "item %1 van %2",
    "DATA_LENGTHOFLIST": "lengte van %1",
    "DATA_LISTCONTAINSITEM": "%1 bevat %2?",
    "DATA_SHOWLIST": "toon lijst %1",
    "DATA_HIDELIST": "verberg lijst %1",
    "DATA_INDEX_ALL": "alle",
    "DATA_INDEX_LAST": "laatste",
    "DATA_INDEX_RANDOM": "willekeurig",
    "EVENT_WHENFLAGCLICKED": "wanneer op %1 wordt geklikt",
    "EVENT_WHENTHISSPRITECLICKED": "wanneer op deze sprite wordt geklikt",
    "EVENT_WHENSTAGECLICKED": "wanneer op het speelveld wordt geklikt",
    "EVENT_WHENTOUCHINGOBJECT": "wanneer deze sprite %1 raakt",
    "EVENT_WHENBROADCASTRECEIVED": "wanneer ik signaal %1 ontvang",
    "EVENT_WHENBACKDROPSWITCHESTO": "wanneer achtergrond verandert naar %1",
    "EVENT_WHENGREATERTHAN": "wanneer %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "klok",
    "EVENT_BROADCAST": "zend signaal %1",
    "EVENT_BROADCASTANDWAIT": "zend signaal %1 en wacht",
    "EVENT_WHENKEYPRESSED": "wanneer %1 is ingedrukt",
    "EVENT_WHENKEYPRESSED_SPACE": "spatiebalk",
    "EVENT_WHENKEYPRESSED_LEFT": "pijltje links",
    "EVENT_WHENKEYPRESSED_RIGHT": "pijltje rechts",
    "EVENT_WHENKEYPRESSED_DOWN": "pijltje omlaag",
    "EVENT_WHENKEYPRESSED_UP": "pijltje omhoog",
    "EVENT_WHENKEYPRESSED_ANY": "willekeurig",
    "LOOKS_SAYFORSECS": "zeg %1 %2 sec.",
    "LOOKS_SAY": "zeg %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "denk %1 %2 sec.",
    "LOOKS_THINK": "denk %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "verschijn",
    "LOOKS_HIDE": "verdwijn",
    "LOOKS_HIDEALLSPRITES": "verberg alle sprites",
    "LOOKS_EFFECT_COLOR": "kleur",
    "LOOKS_EFFECT_FISHEYE": "vissenoog",
    "LOOKS_EFFECT_WHIRL": "draaikolk",
    "LOOKS_EFFECT_PIXELATE": "pixeleren",
    "LOOKS_EFFECT_MOSAIC": "mozaïek",
    "LOOKS_EFFECT_BRIGHTNESS": "helderheid",
    "LOOKS_EFFECT_GHOST": "geest",
    "LOOKS_CHANGEEFFECTBY": "verander %1 effect met %2",
    "LOOKS_SETEFFECTTO": "zet %1 effect op %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "zet alle effecten uit",
    "LOOKS_CHANGESIZEBY": "verander grootte met %1",
    "LOOKS_SETSIZETO": "maak grootte %1 %",
    "LOOKS_SIZE": "grootte",
    "LOOKS_CHANGESTRETCHBY": "verander stretch met %1",
    "LOOKS_SETSTRETCHTO": "maak stretch %1 %",
    "LOOKS_SWITCHCOSTUMETO": "verander uiterlijk naar %1",
    "LOOKS_NEXTCOSTUME": "volgend uiterlijk",
    "LOOKS_SWITCHBACKDROPTO": "verander achtergrond naar %1",
    "LOOKS_GOTOFRONTBACK": "ga naar laag %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "voorgrond",
    "LOOKS_GOTOFRONTBACK_BACK": "achtergrond",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ga %1 %2 lagen",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "naar voren",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "naar achteren",
    "LOOKS_BACKDROPNUMBERNAME": "achtergrond %1",
    "LOOKS_COSTUMENUMBERNAME": "uiterlijk %1",
    "LOOKS_NUMBERNAME_NUMBER": "nummer",
    "LOOKS_NUMBERNAME_NAME": "naam",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "verander achtergrond naar %1 en wacht",
    "LOOKS_NEXTBACKDROP": "volgende achtergrond",
    "LOOKS_PREVIOUSBACKDROP": "vorige achtergrond",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "neem %1 stappen",
    "MOTION_TURNLEFT": "draai %1 %2 graden",
    "MOTION_TURNRIGHT": "draai %1 %2 graden",
    "MOTION_POINTINDIRECTION": "richt naar %1 graden",
    "MOTION_POINTTOWARDS": "richt naar %1",
    "MOTION_POINTTOWARDS_POINTER": "muisaanwijzer",
    "MOTION_GOTO": "ga naar %1",
    "MOTION_GOTO_POINTER": "muisaanwijzer",
    "MOTION_GOTO_RANDOM": "willekeurige positie",
    "MOTION_GOTOXY": "ga naar x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "schuif in %1 sec. naar x: %2 y: %3",
    "MOTION_GLIDETO": "schuif in %1 sec. naar %2",
    "MOTION_GLIDETO_POINTER": "muisaanwijzer",
    "MOTION_GLIDETO_RANDOM": "willekeurige positie",
    "MOTION_CHANGEXBY": "verander x met %1",
    "MOTION_SETX": "maak x %1",
    "MOTION_CHANGEYBY": "verander y met %1",
    "MOTION_SETY": "maak y %1",
    "MOTION_IFONEDGEBOUNCE": "keer om aan de rand",
    "MOTION_SETROTATIONSTYLE": "maak draaistijl %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "links-rechts",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "niet draaien",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "helemaal rond",
    "MOTION_XPOSITION": "x-positie",
    "MOTION_YPOSITION": "y-positie",
    "MOTION_DIRECTION": "richting",
    "MOTION_SCROLLRIGHT": "rechts scrollen %1",
    "MOTION_SCROLLUP": "omhoog scrollen %1",
    "MOTION_ALIGNSCENE": "scène uitlijnen %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "linksonder",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "rechtsonder",
    "MOTION_ALIGNSCENE_MIDDLE": "midden",
    "MOTION_ALIGNSCENE_TOPLEFT": "linksboven",
    "MOTION_ALIGNSCENE_TOPRIGHT": "rechtsboven",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "willekeurig getal tussen %1 en %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 en %2",
    "OPERATORS_OR": "%1 of %2",
    "OPERATORS_NOT": "niet %1",
    "OPERATORS_JOIN": "voeg %1 en %2 samen",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letter %1 van %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "lengte van %1",
    "OPERATORS_CONTAINS": "%1 bevat %2?",
    "OPERATORS_MOD": "%1 modulo %2",
    "OPERATORS_ROUND": "afgerond %1",
    "OPERATORS_MATHOP": "%1 van %2",
    "OPERATORS_MATHOP_ABS": "absoluut",
    "OPERATORS_MATHOP_FLOOR": "beneden",
    "OPERATORS_MATHOP_CEILING": "boven",
    "OPERATORS_MATHOP_SQRT": "wortel",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definieer %1",
    "SENSING_TOUCHINGOBJECT": "raak ik %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "muisaanwijzer",
    "SENSING_TOUCHINGOBJECT_EDGE": "rand",
    "SENSING_TOUCHINGCOLOR": "raak ik kleur %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "raakt kleur %1 kleur %2?",
    "SENSING_DISTANCETO": "afstand tot %1",
    "SENSING_DISTANCETO_POINTER": "muisaanwijzer",
    "SENSING_ASKANDWAIT": "vraag %1 en wacht",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "antwoord",
    "SENSING_KEYPRESSED": "toets %1 ingedrukt?",
    "SENSING_MOUSEDOWN": "muis ingedrukt?",
    "SENSING_MOUSEX": "muis x",
    "SENSING_MOUSEY": "muis y",
    "SENSING_SETDRAGMODE": "zet sleepbaar op %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "sleepbaar",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "niet sleepbaar",
    "SENSING_LOUDNESS": "volume",
    "SENSING_LOUD": "luid?",
    "SENSING_TIMER": "klok",
    "SENSING_RESETTIMER": "zet klok op 0",
    "SENSING_OF": "%1 van %2",
    "SENSING_OF_XPOSITION": "x-positie",
    "SENSING_OF_YPOSITION": "y-positie",
    "SENSING_OF_DIRECTION": "richting",
    "SENSING_OF_COSTUMENUMBER": "uiterlijk #",
    "SENSING_OF_COSTUMENAME": "naam uiterlijk",
    "SENSING_OF_SIZE": "grootte",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "achtergrond #",
    "SENSING_OF_BACKDROPNAME": "achtergrond naam",
    "SENSING_OF_STAGE": "Speelveld",
    "SENSING_CURRENT": "huidige %1",
    "SENSING_CURRENT_YEAR": "jaar",
    "SENSING_CURRENT_MONTH": "maand",
    "SENSING_CURRENT_DATE": "datum",
    "SENSING_CURRENT_DAYOFWEEK": "dag van de week",
    "SENSING_CURRENT_HOUR": "uur",
    "SENSING_CURRENT_MINUTE": "minuut",
    "SENSING_CURRENT_SECOND": "seconde",
    "SENSING_DAYSSINCE2000": "dagen sinds 2000",
    "SENSING_USERNAME": "gebruikersnaam",
    "SENSING_USERID": "gebruiker id",
    "SOUND_PLAY": "start geluid %1",
    "SOUND_PLAYUNTILDONE": "start geluid %1 en wacht",
    "SOUND_STOPALLSOUNDS": "stop alle geluiden",
    "SOUND_SETEFFECTO": "zet effect %1 op %2",
    "SOUND_CHANGEEFFECTBY": "verander %1-effect met %2",
    "SOUND_CLEAREFFECTS": "zet alle effecten uit",
    "SOUND_EFFECTS_PITCH": "toonhoogte",
    "SOUND_EFFECTS_PAN": "kanaal links/rechts",
    "SOUND_CHANGEVOLUMEBY": "verander volume met %1",
    "SOUND_SETVOLUMETO": "zet volume op %1%",
    "SOUND_VOLUME": "volume",
    "CATEGORY_MOTION": "Beweging",
    "CATEGORY_LOOKS": "Uiterlijken",
    "CATEGORY_SOUND": "Geluid",
    "CATEGORY_EVENTS": "Gebeurtenissen",
    "CATEGORY_CONTROL": "Besturen",
    "CATEGORY_SENSING": "Waarnemen",
    "CATEGORY_OPERATORS": "Functies",
    "CATEGORY_VARIABLES": "Variabelen",
    "CATEGORY_MYBLOCKS": "Mijn blokken",
    "DUPLICATE": "Kopie maken",
    "DELETE": "Verwijderen",
    "ADD_COMMENT": "Commentaar toevoegen",
    "REMOVE_COMMENT": "Commentaar verwijderen",
    "DELETE_BLOCK": "Blok verwijderen",
    "DELETE_X_BLOCKS": "Verwijder %1 blokken",
    "DELETE_ALL_BLOCKS": "Verwijder alle %1 blokken?",
    "CLEAN_UP": "Blokken opruimen",
    "HELP": "Help",
    "UNDO": "Ongedaan maken",
    "REDO": "Opnieuw",
    "EDIT_PROCEDURE": "Bewerk",
    "SHOW_PROCEDURE_DEFINITION": "Ga naar definitie",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Zeg iets...",
    "COLOUR_HUE_LABEL": "Kleur",
    "COLOUR_SATURATION_LABEL": "Verzadiging",
    "COLOUR_BRIGHTNESS_LABEL": "Helderheid",
    "CHANGE_VALUE_TITLE": "Verander waarde:",
    "RENAME_VARIABLE": "Variabele hernoemen",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Variabele hernoemen",
    "NEW_VARIABLE": "Maak een variabele",
    "NEW_VARIABLE_TITLE": "Nieuwe variabelenaam:",
    "VARIABLE_MODAL_TITLE": "Nieuwe variabele",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Maak een blok",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Maak een lijst",
    "NEW_LIST_TITLE": "Nieuwe lijstnaam:",
    "LIST_MODAL_TITLE": "Nieuwe lijst",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Lijst hernoemen",
    "NEW_BROADCAST_MESSAGE": "Nieuw bericht",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nieuwe berichtnaam:",
    "BROADCAST_MODAL_TITLE": "Nieuw bericht",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "bericht1"
};

Blockly.ScratchMsgs.locales["pt-br"] =
{
    "CONTROL_FOREVER": "sempre",
    "CONTROL_REPEAT": "repita %1",
    "CONTROL_IF": "se %1 então",
    "CONTROL_ELSE": "senão",
    "CONTROL_STOP": "pare",
    "CONTROL_STOP_ALL": "todos",
    "CONTROL_STOP_THIS": "este script",
    "CONTROL_STOP_OTHER": "outros scripts no ator",
    "CONTROL_WAIT": "aguarde %1 segundos",
    "CONTROL_WAITUNTIL": "aguarde até %1",
    "CONTROL_REPEATUNTIL": "repita até %1",
    "CONTROL_WHILE": "enquanto %1",
    "CONTROL_FOREACH": "para cada %1 em %2",
    "CONTROL_STARTASCLONE": "quando eu iniciar como um clone",
    "CONTROL_CREATECLONEOF": "criar clone de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "este ator",
    "CONTROL_DELETETHISCLONE": "apagar este clone",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "incremente contador",
    "CONTROL_CLEARCOUNTER": "limpar contador",
    "CONTROL_ALLATONCE": "todos de uma vez",
    "DATA_SETVARIABLETO": "ponha %1 para %2",
    "DATA_CHANGEVARIABLEBY": "mude %1 por %2",
    "DATA_SHOWVARIABLE": "mostre variável %1",
    "DATA_HIDEVARIABLE": "esconda variável %1",
    "DATA_ADDTOLIST": "adicione %1 a %2",
    "DATA_DELETEOFLIST": "apague %1 de %2",
    "DATA_INSERTATLIST": "insira %1 a %2 de %3",
    "DATA_REPLACEITEMOFLIST": "substituir item %1 de %2 com %3",
    "DATA_ITEMOFLIST": "item %1 de %2",
    "DATA_LENGTHOFLIST": "comprimento de %1",
    "DATA_LISTCONTAINSITEM": "%1 contém %2",
    "DATA_SHOWLIST": "mostre lista %1",
    "DATA_HIDELIST": "esconda lista %1",
    "DATA_INDEX_ALL": "todos",
    "DATA_INDEX_LAST": "último",
    "DATA_INDEX_RANDOM": "aleatório",
    "EVENT_WHENFLAGCLICKED": "quando %1 clicado",
    "EVENT_WHENTHISSPRITECLICKED": "quando este ator clicado",
    "EVENT_WHENSTAGECLICKED": "quando palco clicado",
    "EVENT_WHENTOUCHINGOBJECT": "quando este ator tocar %1",
    "EVENT_WHENBROADCASTRECEIVED": "quando eu receber %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "quando pano de fundo mudar para %1",
    "EVENT_WHENGREATERTHAN": "quando %1 >%2",
    "EVENT_WHENGREATERTHAN_TIMER": "cronômetro",
    "EVENT_BROADCAST": "transmita %1",
    "EVENT_BROADCASTANDWAIT": "transmita %1 e espere",
    "EVENT_WHENKEYPRESSED": "quando tecla %1 pressionada",
    "EVENT_WHENKEYPRESSED_SPACE": "espaço",
    "EVENT_WHENKEYPRESSED_LEFT": "seta esquerda",
    "EVENT_WHENKEYPRESSED_RIGHT": "seta direita",
    "EVENT_WHENKEYPRESSED_DOWN": "seta para baixo",
    "EVENT_WHENKEYPRESSED_UP": "seta para cima",
    "EVENT_WHENKEYPRESSED_ANY": "qualquer",
    "LOOKS_SAYFORSECS": "diga %1 por %2 segundos",
    "LOOKS_SAY": "diga %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "pense %1 por %2 segundos",
    "LOOKS_THINK": "pense %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "mostre",
    "LOOKS_HIDE": "esconda",
    "LOOKS_HIDEALLSPRITES": "ocultar todos",
    "LOOKS_EFFECT_COLOR": "cor",
    "LOOKS_EFFECT_FISHEYE": "olho de peixe",
    "LOOKS_EFFECT_WHIRL": "turbilhão",
    "LOOKS_EFFECT_PIXELATE": "pixelizada",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "brilho",
    "LOOKS_EFFECT_GHOST": "fantasma",
    "LOOKS_CHANGEEFFECTBY": "mude efeito %1 para %2",
    "LOOKS_SETEFFECTTO": "defina efeito %1 para %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "limpe efeitos gráficos",
    "LOOKS_CHANGESIZEBY": "mude tamanho por %1",
    "LOOKS_SETSIZETO": "fixe tamanho para %1 %",
    "LOOKS_SIZE": "tamanho",
    "LOOKS_CHANGESTRETCHBY": "mude trajeto por %1",
    "LOOKS_SETSTRETCHTO": "ajuste curso para %1 %",
    "LOOKS_SWITCHCOSTUMETO": "mude traje para %1",
    "LOOKS_NEXTCOSTUME": "próximo traje",
    "LOOKS_SWITCHBACKDROPTO": "mude pano de fundo para %1",
    "LOOKS_GOTOFRONTBACK": "vá para %1 camada",
    "LOOKS_GOTOFRONTBACK_FRONT": "frente",
    "LOOKS_GOTOFRONTBACK_BACK": "trás",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "vá para %1 %2 camadas",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "para frente",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "para trás",
    "LOOKS_BACKDROPNUMBERNAME": "pano de fundo %1",
    "LOOKS_COSTUMENUMBERNAME": "traje %1",
    "LOOKS_NUMBERNAME_NUMBER": "número",
    "LOOKS_NUMBERNAME_NAME": "nome",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "mudo pano de fundo para %1 e espere",
    "LOOKS_NEXTBACKDROP": "próximo pano de fundo",
    "LOOKS_PREVIOUSBACKDROP": "cenário anterior",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "mova %1 passos",
    "MOTION_TURNLEFT": "gire %1 %2 graus",
    "MOTION_TURNRIGHT": "gire %1 %2 graus",
    "MOTION_POINTINDIRECTION": "aponte na direção %1",
    "MOTION_POINTTOWARDS": "aponte para a direção %1",
    "MOTION_POINTTOWARDS_POINTER": "ponteiro do mouse",
    "MOTION_GOTO": "vá para %1",
    "MOTION_GOTO_POINTER": "ponteiro do mouse",
    "MOTION_GOTO_RANDOM": "posição aleatória",
    "MOTION_GOTOXY": "vá para x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "deslizar %1 segs para x: %2 y: %3",
    "MOTION_GLIDETO": "deslizar %1 segs para %2",
    "MOTION_GLIDETO_POINTER": "ponteiro do mouse",
    "MOTION_GLIDETO_RANDOM": "posição aleatória",
    "MOTION_CHANGEXBY": "mude x por %1",
    "MOTION_SETX": "fixe x para %1",
    "MOTION_CHANGEYBY": "mude y por %1",
    "MOTION_SETY": "fixe y para %1",
    "MOTION_IFONEDGEBOUNCE": "se tocar na borda, volte",
    "MOTION_SETROTATIONSTYLE": "ajuste rotação para estilo %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "esquerda-direita",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "não rotacionar",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "tudo a volta",
    "MOTION_XPOSITION": "posição x",
    "MOTION_YPOSITION": "posição y",
    "MOTION_DIRECTION": "direção",
    "MOTION_SCROLLRIGHT": "rolar para direita %1 %",
    "MOTION_SCROLLUP": "rolar para cima %1",
    "MOTION_ALIGNSCENE": "alinhar cena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "inferior esquerda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "inferior direita",
    "MOTION_ALIGNSCENE_MIDDLE": "meio",
    "MOTION_ALIGNSCENE_TOPLEFT": "superior esquerdo",
    "MOTION_ALIGNSCENE_TOPRIGHT": "superior direita",
    "MOTION_XSCROLL": "rolagem eixo x",
    "MOTION_YSCROLL": "rolagem eixo y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "número aleatório entre %1 e %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 e %2",
    "OPERATORS_OR": "%1 ou %2",
    "OPERATORS_NOT": "não %1",
    "OPERATORS_JOIN": "junte %1 com %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letra %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "tamanho de %1",
    "OPERATORS_CONTAINS": "%1 contém %2",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "arredonde %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "piso",
    "OPERATORS_MATHOP_CEILING": "teto",
    "OPERATORS_MATHOP_SQRT": "raiz",
    "OPERATORS_MATHOP_SIN": "seno",
    "OPERATORS_MATHOP_COS": "cosseno",
    "OPERATORS_MATHOP_TAN": "tangente",
    "OPERATORS_MATHOP_ASIN": "arcoseno",
    "OPERATORS_MATHOP_ACOS": "arcocosseno",
    "OPERATORS_MATHOP_ATAN": "arcotangente",
    "OPERATORS_MATHOP_LN": "Em",
    "OPERATORS_MATHOP_LOG": "logaritmo",
    "OPERATORS_MATHOP_EEXP": "base elevada à potência",
    "OPERATORS_MATHOP_10EXP": "10 elevado à potência",
    "PROCEDURES_DEFINITION": "defina %1",
    "SENSING_TOUCHINGOBJECT": "tocando %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "Ponteiro do mouse",
    "SENSING_TOUCHINGOBJECT_EDGE": "borda",
    "SENSING_TOUCHINGCOLOR": "Tocando na cor %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "cor %1 está tocando %2?",
    "SENSING_DISTANCETO": "distância %1",
    "SENSING_DISTANCETO_POINTER": "ponteiro do mouse",
    "SENSING_ASKANDWAIT": "pergunte %1 e espere",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "resposta",
    "SENSING_KEYPRESSED": "quando a tecla %1 for pressionada",
    "SENSING_MOUSEDOWN": "mouse pressionado?",
    "SENSING_MOUSEX": "mouse x",
    "SENSING_MOUSEY": "mouse y",
    "SENSING_SETDRAGMODE": "arraste para %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastável",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "não arrastável",
    "SENSING_LOUDNESS": "ruído",
    "SENSING_LOUD": "alto?",
    "SENSING_TIMER": "cronômetro",
    "SENSING_RESETTIMER": "reiniciar o tempo",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "posição x",
    "SENSING_OF_YPOSITION": "posição y",
    "SENSING_OF_DIRECTION": "direção",
    "SENSING_OF_COSTUMENUMBER": "traje%1",
    "SENSING_OF_COSTUMENAME": "nome do traje/ nome da fantasia",
    "SENSING_OF_SIZE": "tamanho",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "pano de fundo#",
    "SENSING_OF_BACKDROPNAME": "nome do pano de fundo",
    "SENSING_OF_STAGE": "Palco",
    "SENSING_CURRENT": "atual %1",
    "SENSING_CURRENT_YEAR": "ano",
    "SENSING_CURRENT_MONTH": "mês",
    "SENSING_CURRENT_DATE": "data",
    "SENSING_CURRENT_DAYOFWEEK": "dia da semana",
    "SENSING_CURRENT_HOUR": "hora",
    "SENSING_CURRENT_MINUTE": "minuto",
    "SENSING_CURRENT_SECOND": "segundo",
    "SENSING_DAYSSINCE2000": "dias desde 2000",
    "SENSING_USERNAME": "nome de usuário",
    "SENSING_USERID": "id do usuário",
    "SOUND_PLAY": "iniciar o som%1",
    "SOUND_PLAYUNTILDONE": "tocar o som %1 até que esteja completo/pronto",
    "SOUND_STOPALLSOUNDS": "parar todos os sons",
    "SOUND_SETEFFECTO": "definir %1 efeito para %2",
    "SOUND_CHANGEEFFECTBY": "mudar efeito %1 por %2",
    "SOUND_CLEAREFFECTS": "limpar os efeitos de som ",
    "SOUND_EFFECTS_PITCH": "passo",
    "SOUND_EFFECTS_PAN": "balanço esquerda/direita",
    "SOUND_CHANGEVOLUMEBY": "mudar o volume por %1",
    "SOUND_SETVOLUMETO": "fixar o volume para %1%",
    "SOUND_VOLUME": "volume",
    "CATEGORY_MOTION": "Movimento",
    "CATEGORY_LOOKS": "Aparência",
    "CATEGORY_SOUND": "Som",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Controle",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variáveis",
    "CATEGORY_MYBLOCKS": "Meus Blocos",
    "DUPLICATE": "Duplicar",
    "DELETE": "Apagar",
    "ADD_COMMENT": "Comentar",
    "REMOVE_COMMENT": "Remover Comentário",
    "DELETE_BLOCK": "Deletar Bloco",
    "DELETE_X_BLOCKS": "Deletar %1 Blocos",
    "DELETE_ALL_BLOCKS": "Deletar todos %1 blocos?",
    "CLEAN_UP": "Limpar Blocos",
    "HELP": "Ajuda",
    "UNDO": "Desfazer",
    "REDO": "Refazer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Vá para definição",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Diga algo...",
    "COLOUR_HUE_LABEL": "cor",
    "COLOUR_SATURATION_LABEL": "saturação",
    "COLOUR_BRIGHTNESS_LABEL": "Brilho",
    "CHANGE_VALUE_TITLE": "Mudar valor:",
    "RENAME_VARIABLE": "Renomear variável",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renomear variável",
    "NEW_VARIABLE": "Criar uma Variável",
    "NEW_VARIABLE_TITLE": "Novo nome para variável:",
    "VARIABLE_MODAL_TITLE": "Nova Variável",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Criar um bloco",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Criar uma lista",
    "NEW_LIST_TITLE": "Novo nome de lista:",
    "LIST_MODAL_TITLE": "Nova Lista",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Renomear Lista",
    "NEW_BROADCAST_MESSAGE": "Nova mensagem",
    "NEW_BROADCAST_MESSAGE_TITLE": "Novo nome de mensagem:",
    "BROADCAST_MODAL_TITLE": "Nova Mensagem",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "mensagem 1"
};

Blockly.ScratchMsgs.locales["pt"] =
{
    "CONTROL_FOREVER": "repete para sempre",
    "CONTROL_REPEAT": "repete %1 vezes",
    "CONTROL_IF": "se %1 , então",
    "CONTROL_ELSE": "senão,",
    "CONTROL_STOP": "pára",
    "CONTROL_STOP_ALL": "tudo",
    "CONTROL_STOP_THIS": "este guião",
    "CONTROL_STOP_OTHER": "os teus outros guiões",
    "CONTROL_WAIT": "espera %1 s",
    "CONTROL_WAITUNTIL": "espera até que %1",
    "CONTROL_REPEATUNTIL": "até que %1 , repete",
    "CONTROL_WHILE": "enquanto %1",
    "CONTROL_FOREACH": "para cada %1 em %2",
    "CONTROL_STARTASCLONE": "Quando fores criado como um clone",
    "CONTROL_CREATECLONEOF": "cria um clone de %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ti mesmo",
    "CONTROL_DELETETHISCLONE": "remove-te como clone",
    "CONTROL_COUNTER": "contador",
    "CONTROL_INCRCOUNTER": "incrementa o contador",
    "CONTROL_CLEARCOUNTER": "põe o contador a zero",
    "CONTROL_ALLATONCE": "executa tudo de uma vez",
    "DATA_SETVARIABLETO": "altera %1 para %2",
    "DATA_CHANGEVARIABLEBY": "adiciona a %1 o valor %2",
    "DATA_SHOWVARIABLE": "mostra a variável %1",
    "DATA_HIDEVARIABLE": "esconde a variável %1",
    "DATA_ADDTOLIST": "acrescenta %1 a %2",
    "DATA_DELETEOFLIST": "remove %1 de %2",
    "DATA_INSERTATLIST": "insere %1 como %2 de %3",
    "DATA_REPLACEITEMOFLIST": "substitui %1 de %2 por %3",
    "DATA_ITEMOFLIST": "%1 de %2",
    "DATA_LENGTHOFLIST": "o comprimento de %1",
    "DATA_LISTCONTAINSITEM": "%1 contém %2",
    "DATA_SHOWLIST": "mostra a lista %1",
    "DATA_HIDELIST": "esconde a lista %1",
    "DATA_INDEX_ALL": "tudo",
    "DATA_INDEX_LAST": "o último item",
    "DATA_INDEX_RANDOM": "um item ao acaso",
    "EVENT_WHENFLAGCLICKED": "Quando alguém clicar em %1",
    "EVENT_WHENTHISSPRITECLICKED": "Quando alguém clicar em ti",
    "EVENT_WHENSTAGECLICKED": "Quando alguém clicar no palco",
    "EVENT_WHENTOUCHINGOBJECT": "Quando tocares em %1",
    "EVENT_WHENBROADCASTRECEIVED": "Quando receberes a mensagem %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "Quando o cenário mudar para %1",
    "EVENT_WHENGREATERTHAN": "Quando o valor do sensor %1 exceder %2",
    "EVENT_WHENGREATERTHAN_TIMER": "o valor do cronómetro",
    "EVENT_BROADCAST": "difunde a mensagem %1",
    "EVENT_BROADCASTANDWAIT": "difunde a mensagem %1 e espera",
    "EVENT_WHENKEYPRESSED": "Quando alguém pressionar a tecla %1",
    "EVENT_WHENKEYPRESSED_SPACE": "espaço",
    "EVENT_WHENKEYPRESSED_LEFT": "seta para a esquerda",
    "EVENT_WHENKEYPRESSED_RIGHT": "seta para a direita",
    "EVENT_WHENKEYPRESSED_DOWN": "seta para baixo",
    "EVENT_WHENKEYPRESSED_UP": "seta para cima",
    "EVENT_WHENKEYPRESSED_ANY": "qualquer",
    "LOOKS_SAYFORSECS": "diz %1 durante %2 s",
    "LOOKS_SAY": "diz %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "pensa %1 durante %2 s",
    "LOOKS_THINK": "pensa %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "mostra-te",
    "LOOKS_HIDE": "esconde-te",
    "LOOKS_HIDEALLSPRITES": "esconde todos os actores",
    "LOOKS_EFFECT_COLOR": "cor",
    "LOOKS_EFFECT_FISHEYE": "olho de peixe",
    "LOOKS_EFFECT_WHIRL": "remoinho",
    "LOOKS_EFFECT_PIXELATE": "pixelização",
    "LOOKS_EFFECT_MOSAIC": "mosaico",
    "LOOKS_EFFECT_BRIGHTNESS": "brilho",
    "LOOKS_EFFECT_GHOST": "fantasma",
    "LOOKS_CHANGEEFFECTBY": "adiciona ao teu efeito %1 o valor %2",
    "LOOKS_SETEFFECTTO": "altera o teu efeito %1 para %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "cancela os teus efeitos gráficos",
    "LOOKS_CHANGESIZEBY": "adiciona %1 ao teu tamanho",
    "LOOKS_SETSIZETO": "altera o teu tamanho para %1 %",
    "LOOKS_SIZE": "o tamanho",
    "LOOKS_CHANGESTRETCHBY": "adiciona %1 % ao esticamento",
    "LOOKS_SETSTRETCHTO": "altera o esticamento para %1 %",
    "LOOKS_SWITCHCOSTUMETO": "muda o teu traje para %1",
    "LOOKS_NEXTCOSTUME": "passa para o teu próximo traje",
    "LOOKS_SWITCHBACKDROPTO": "muda o cenário para %1",
    "LOOKS_GOTOFRONTBACK": "vai para a camada %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "frontal",
    "LOOKS_GOTOFRONTBACK_BACK": "traseira",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 camadas",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "avança",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "recua",
    "LOOKS_BACKDROPNUMBERNAME": "%1 do cenário",
    "LOOKS_COSTUMENUMBERNAME": "%1 to traje",
    "LOOKS_NUMBERNAME_NUMBER": "o número",
    "LOOKS_NUMBERNAME_NAME": "o nome",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "muda o cenário para %1 e espera",
    "LOOKS_NEXTBACKDROP": "passa para o teu próximo cenário",
    "LOOKS_PREVIOUSBACKDROP": "o cenário anterior",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "anda %1 passos",
    "MOTION_TURNLEFT": "gira %1 %2 °",
    "MOTION_TURNRIGHT": "gira %1 %2 °",
    "MOTION_POINTINDIRECTION": "altera a tua direcção para %1 °",
    "MOTION_POINTTOWARDS": "aponta em direcção a %1",
    "MOTION_POINTTOWARDS_POINTER": "ponteiro do rato",
    "MOTION_GOTO": "vai para %1",
    "MOTION_GOTO_POINTER": "o ponteiro do rato",
    "MOTION_GOTO_RANDOM": "uma posição ao acaso",
    "MOTION_GOTOXY": "vai para as coordenadas (x:%1 , y:%2 )",
    "MOTION_GLIDESECSTOXY": "desliza em %1 s para as coordenadas (x:%2 , y:%3 )",
    "MOTION_GLIDETO": "desliza em %1 s em direcção a%2",
    "MOTION_GLIDETO_POINTER": "o ponteiro do rato",
    "MOTION_GLIDETO_RANDOM": "uma posição ao acaso",
    "MOTION_CHANGEXBY": "adiciona %1 à tua coordenada x",
    "MOTION_SETX": "altera a tua coordenada x para %1",
    "MOTION_CHANGEYBY": "adiciona %1 à tua coordenada y",
    "MOTION_SETY": "altera a tua coordenada y para %1",
    "MOTION_IFONEDGEBOUNCE": "se estiveres a bater na borda, ressalta",
    "MOTION_SETROTATIONSTYLE": "altera o teu estilo de rotação para %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "olha apenas para a esquerda e para a direita",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "não gires",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "gira a toda a volta",
    "MOTION_XPOSITION": "a coordenada x da posição",
    "MOTION_YPOSITION": "a coordenada y da posição",
    "MOTION_DIRECTION": "a direcção",
    "MOTION_SCROLLRIGHT": "rola %1 para a direita",
    "MOTION_SCROLLUP": "rola %1 para cima",
    "MOTION_ALIGNSCENE": "alinha a cena %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ao fundo e à esquerda",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ao fundo e à direita",
    "MOTION_ALIGNSCENE_MIDDLE": "a meio",
    "MOTION_ALIGNSCENE_TOPLEFT": "no topo e à esquerda",
    "MOTION_ALIGNSCENE_TOPRIGHT": "no topo e à direita",
    "MOTION_XSCROLL": "o rolamento em x",
    "MOTION_YSCROLL": "o rolamento em y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 − %2",
    "OPERATORS_MULTIPLY": "%1 × %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "um valor ao acaso entre %1 e %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 e %2",
    "OPERATORS_OR": "%1 ou %2",
    "OPERATORS_NOT": "é falso que %1",
    "OPERATORS_JOIN": "a junção de %1 com %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "o caractere %1 de %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "o comprimento de %1",
    "OPERATORS_CONTAINS": "%1 contém %2",
    "OPERATORS_MOD": "o resto de %1 a dividir por %2",
    "OPERATORS_ROUND": "o arredondamento de %1",
    "OPERATORS_MATHOP": "%1 de %2",
    "OPERATORS_MATHOP_ABS": "o valor absoluto",
    "OPERATORS_MATHOP_FLOOR": "o chão (o maior inteiro não superior)",
    "OPERATORS_MATHOP_CEILING": "o tecto (menor inteiro não inferior)",
    "OPERATORS_MATHOP_SQRT": "a raiz quadrada",
    "OPERATORS_MATHOP_SIN": "o seno",
    "OPERATORS_MATHOP_COS": "o cosseno",
    "OPERATORS_MATHOP_TAN": "a tangente",
    "OPERATORS_MATHOP_ASIN": "o arco-seno",
    "OPERATORS_MATHOP_ACOS": "o arco-cosseno",
    "OPERATORS_MATHOP_ATAN": "o arco-tangente",
    "OPERATORS_MATHOP_LN": "o logaritmo natural",
    "OPERATORS_MATHOP_LOG": "o logaritmo",
    "OPERATORS_MATHOP_EEXP": "a exponencial",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "define %1",
    "SENSING_TOUCHINGOBJECT": "estás a tocar em %1",
    "SENSING_TOUCHINGOBJECT_POINTER": "o ponteiro do rato",
    "SENSING_TOUCHINGOBJECT_EDGE": "a borda",
    "SENSING_TOUCHINGCOLOR": "estás a tocar na cor %1",
    "SENSING_COLORISTOUCHINGCOLOR": "a cor %1 está a tocar na cor %2",
    "SENSING_DISTANCETO": "a distância até %1",
    "SENSING_DISTANCETO_POINTER": "o ponteiro do rato",
    "SENSING_ASKANDWAIT": "pergunta %1 e espera pela resposta",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "a resposta",
    "SENSING_KEYPRESSED": "a tecla %1 está a ser pressionada",
    "SENSING_MOUSEDOWN": "o botão do rato está pressionado",
    "SENSING_MOUSEX": "a coordenada x do rato",
    "SENSING_MOUSEY": "a coordenada y do rato",
    "SENSING_SETDRAGMODE": "altera o modo de arrasto para %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "arrastável",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "não arrastável",
    "SENSING_LOUDNESS": "o volume",
    "SENSING_LOUD": "o som é forte",
    "SENSING_TIMER": "o valor do cronómetro",
    "SENSING_RESETTIMER": "reinicia o cronómetro",
    "SENSING_OF": "%1 de %2",
    "SENSING_OF_XPOSITION": "a coordenada x da posição",
    "SENSING_OF_YPOSITION": "a coordenada y da posição",
    "SENSING_OF_DIRECTION": "a direcção",
    "SENSING_OF_COSTUMENUMBER": "o número do traje",
    "SENSING_OF_COSTUMENAME": "o nome do traje",
    "SENSING_OF_SIZE": "o tamanho",
    "SENSING_OF_VOLUME": "o volume",
    "SENSING_OF_BACKDROPNUMBER": "o número do cenário",
    "SENSING_OF_BACKDROPNAME": "o nome do cenário",
    "SENSING_OF_STAGE": "Palco",
    "SENSING_CURRENT": "%1 actual",
    "SENSING_CURRENT_YEAR": "o ano",
    "SENSING_CURRENT_MONTH": "o mês",
    "SENSING_CURRENT_DATE": "a data",
    "SENSING_CURRENT_DAYOFWEEK": "o dia da semana",
    "SENSING_CURRENT_HOUR": "a hora",
    "SENSING_CURRENT_MINUTE": "o minuto",
    "SENSING_CURRENT_SECOND": "o segundo",
    "SENSING_DAYSSINCE2000": "o número de dias desde 2000",
    "SENSING_USERNAME": "o nome de utilizador",
    "SENSING_USERID": "o ID de utilizador",
    "SOUND_PLAY": "toca o som %1",
    "SOUND_PLAYUNTILDONE": "toca o som %1 até terminar",
    "SOUND_STOPALLSOUNDS": "pára todos os sons",
    "SOUND_SETEFFECTO": "altera o teu efeito %1 para %2",
    "SOUND_CHANGEEFFECTBY": "adiciona ao teu efeito %1 o valor %2",
    "SOUND_CLEAREFFECTS": "cancela todos os teus efeitos sonoros",
    "SOUND_EFFECTS_PITCH": "tom",
    "SOUND_EFFECTS_PAN": "canal esquerdo/direito",
    "SOUND_CHANGEVOLUMEBY": "adiciona %1 % ao teu volume",
    "SOUND_SETVOLUMETO": "altera o teu volume para %1%",
    "SOUND_VOLUME": "o volume",
    "CATEGORY_MOTION": "Movimento",
    "CATEGORY_LOOKS": "Aparência",
    "CATEGORY_SOUND": "Som",
    "CATEGORY_EVENTS": "Eventos",
    "CATEGORY_CONTROL": "Controlo",
    "CATEGORY_SENSING": "Sensores",
    "CATEGORY_OPERATORS": "Operadores",
    "CATEGORY_VARIABLES": "Variáveis",
    "CATEGORY_MYBLOCKS": "Os Meus Blocos",
    "DUPLICATE": "Duplicar",
    "DELETE": "Remover",
    "ADD_COMMENT": "Adicionar Comentário",
    "REMOVE_COMMENT": "Remover Comentário",
    "DELETE_BLOCK": "Remover Bloco",
    "DELETE_X_BLOCKS": "Remover %1 Blocos",
    "DELETE_ALL_BLOCKS": "Remover todos os %1 blocos?",
    "CLEAN_UP": "Arrumar Blocos",
    "HELP": "Ajuda",
    "UNDO": "Desfazer",
    "REDO": "Refazer",
    "EDIT_PROCEDURE": "Editar",
    "SHOW_PROCEDURE_DEFINITION": "Ir para a definição",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Diga qualquer coisa…",
    "COLOUR_HUE_LABEL": "Matiz",
    "COLOUR_SATURATION_LABEL": "Saturação",
    "COLOUR_BRIGHTNESS_LABEL": "Brilho",
    "CHANGE_VALUE_TITLE": "Alterar o valor:",
    "RENAME_VARIABLE": "Renomear variável",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Renomear Variável",
    "NEW_VARIABLE": "Criar uma Variável",
    "NEW_VARIABLE_TITLE": "Novo nome da variável:",
    "VARIABLE_MODAL_TITLE": "Nova Variável",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Criar um Bloco",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Criar uma Lista",
    "NEW_LIST_TITLE": "Nome da nova lista:",
    "LIST_MODAL_TITLE": "Nova Lista",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Renomear Lista",
    "NEW_BROADCAST_MESSAGE": "Nova mensagem",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nome da nova mensagem:",
    "BROADCAST_MODAL_TITLE": "Nova Mensagem",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "a mensagem 1"
};

Blockly.ScratchMsgs.locales["sl"] =
{
    "CONTROL_FOREVER": "ponavljaj",
    "CONTROL_REPEAT": "ponovi %1",
    "CONTROL_IF": "če %1 potem",
    "CONTROL_ELSE": "sicer",
    "CONTROL_STOP": "ustavi",
    "CONTROL_STOP_ALL": "vse",
    "CONTROL_STOP_THIS": "te ukaze",
    "CONTROL_STOP_OTHER": "ostale ukaze za to figuro",
    "CONTROL_WAIT": "počakaj %1 sekund",
    "CONTROL_WAITUNTIL": "počakaj dokler %1",
    "CONTROL_REPEATUNTIL": "ponavljaj, dokler ne bo %1",
    "CONTROL_WHILE": "dokler %1",
    "CONTROL_FOREACH": "za vsak %1 v %2",
    "CONTROL_STARTASCLONE": "ko začnem kot klon",
    "CONTROL_CREATECLONEOF": "ustvari klon %1",
    "CONTROL_CREATECLONEOF_MYSELF": "sebe",
    "CONTROL_DELETETHISCLONE": "zbriši ta klon",
    "CONTROL_COUNTER": "števec",
    "CONTROL_INCRCOUNTER": "povečaj števec",
    "CONTROL_CLEARCOUNTER": "počisti števec",
    "CONTROL_ALLATONCE": "vse hkrati",
    "DATA_SETVARIABLETO": "nastavi %1 na %2",
    "DATA_CHANGEVARIABLEBY": "spremeni %1 za %2",
    "DATA_SHOWVARIABLE": "pokaži spremenljivko %1",
    "DATA_HIDEVARIABLE": "skrij spremenljivko %1",
    "DATA_ADDTOLIST": "dodaj %1 k %2",
    "DATA_DELETEOFLIST": "zbriši %1 v %2",
    "DATA_INSERTATLIST": "vstavi %1 na %2 v %3",
    "DATA_REPLACEITEMOFLIST": "zamenjaj %1 v %2 z %3",
    "DATA_ITEMOFLIST": "element %1 v %2",
    "DATA_LENGTHOFLIST": "dolžina %1",
    "DATA_LISTCONTAINSITEM": "Ali %1 vsebuje %2?",
    "DATA_SHOWLIST": "pokaži seznam %1",
    "DATA_HIDELIST": "skrij seznam %1",
    "DATA_INDEX_ALL": "vse",
    "DATA_INDEX_LAST": "zadnji",
    "DATA_INDEX_RANDOM": "naključno",
    "EVENT_WHENFLAGCLICKED": "ko kliknemo na %1",
    "EVENT_WHENTHISSPRITECLICKED": "ko kliknemo to figuro",
    "EVENT_WHENSTAGECLICKED": "ko kliknemo na oder",
    "EVENT_WHENTOUCHINGOBJECT": "ko se ta figura dotika %1",
    "EVENT_WHENBROADCASTRECEIVED": "ko prejmem %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "ko se ozadje zamenja na %1",
    "EVENT_WHENGREATERTHAN": "ko je %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "štoparica",
    "EVENT_BROADCAST": "objavi %1",
    "EVENT_BROADCASTANDWAIT": "objavi %1 in čakaj",
    "EVENT_WHENKEYPRESSED": "ko je pritisnjena tipka %1 ",
    "EVENT_WHENKEYPRESSED_SPACE": "presledek",
    "EVENT_WHENKEYPRESSED_LEFT": "puščica levo",
    "EVENT_WHENKEYPRESSED_RIGHT": "puščica desno",
    "EVENT_WHENKEYPRESSED_DOWN": "puščica dol",
    "EVENT_WHENKEYPRESSED_UP": "puščica gor",
    "EVENT_WHENKEYPRESSED_ANY": "poljubna",
    "LOOKS_SAYFORSECS": "reci %1 za %2 sekund",
    "LOOKS_SAY": "reci %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "pomisli %1 za %2 sekund",
    "LOOKS_THINK": "pomisli %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "pokaži",
    "LOOKS_HIDE": "skrij",
    "LOOKS_HIDEALLSPRITES": "skrij vse figure",
    "LOOKS_EFFECT_COLOR": "barva",
    "LOOKS_EFFECT_FISHEYE": "ribje oko",
    "LOOKS_EFFECT_WHIRL": "vrtinec",
    "LOOKS_EFFECT_PIXELATE": "pikčasto",
    "LOOKS_EFFECT_MOSAIC": "mozaik",
    "LOOKS_EFFECT_BRIGHTNESS": "svetlost",
    "LOOKS_EFFECT_GHOST": "duh",
    "LOOKS_CHANGEEFFECTBY": "spremeni učinek %1 za %2",
    "LOOKS_SETEFFECTTO": "nastavi učinek %1 na %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "odstrani slikovne učinke",
    "LOOKS_CHANGESIZEBY": "spremeni velikost za %1",
    "LOOKS_SETSIZETO": "nastavi velikost na %1 %",
    "LOOKS_SIZE": "velikost",
    "LOOKS_CHANGESTRETCHBY": "spremeni razteg za %1",
    "LOOKS_SETSTRETCHTO": "nastavi razteg na %1 %",
    "LOOKS_SWITCHCOSTUMETO": "zamenjaj videz na %1",
    "LOOKS_NEXTCOSTUME": "naslednji videz",
    "LOOKS_SWITCHBACKDROPTO": "zamenjaj ozadje na %1",
    "LOOKS_GOTOFRONTBACK": "pojdi na %1 plast",
    "LOOKS_GOTOFRONTBACK_FRONT": "spredaj",
    "LOOKS_GOTOFRONTBACK_BACK": "zadaj",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "pojdi %1 %2 plasti",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "naprej",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "nazaj",
    "LOOKS_BACKDROPNUMBERNAME": "ozadje %1",
    "LOOKS_COSTUMENUMBERNAME": "videz %1",
    "LOOKS_NUMBERNAME_NUMBER": "število",
    "LOOKS_NUMBERNAME_NAME": "ime",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "zamenjaj ozadje na %1 in počakaj",
    "LOOKS_NEXTBACKDROP": "naslednje ozadje",
    "LOOKS_PREVIOUSBACKDROP": "prejšnje ozadje",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "pojdi %1 korakov",
    "MOTION_TURNLEFT": "obrni se za %1 %2 stopinj",
    "MOTION_TURNRIGHT": "obrni se za %1 %2 stopinj",
    "MOTION_POINTINDIRECTION": "obrni se v smer %1",
    "MOTION_POINTTOWARDS": "obrni se proti %1",
    "MOTION_POINTTOWARDS_POINTER": "kazalcu miške",
    "MOTION_GOTO": "pojdi na %1",
    "MOTION_GOTO_POINTER": "kazalcu miške",
    "MOTION_GOTO_RANDOM": "naključnemu mestu",
    "MOTION_GOTOXY": "pojdi na x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "drsi %1 sekund do x: %2 y: %3",
    "MOTION_GLIDETO": "drsi %1 sekund do %2",
    "MOTION_GLIDETO_POINTER": "kazalca miške",
    "MOTION_GLIDETO_RANDOM": "naključnega mesta",
    "MOTION_CHANGEXBY": "spremeni x za %1",
    "MOTION_SETX": "nastavi x na %1",
    "MOTION_CHANGEYBY": "spremeni y za %1",
    "MOTION_SETY": "nastavi y na %1",
    "MOTION_IFONEDGEBOUNCE": "odbij se, če si na robu",
    "MOTION_SETROTATIONSTYLE": "nastavi način vrtenja %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "levo-desno",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ne zasukaj",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "na vse strani",
    "MOTION_XPOSITION": "položaj x",
    "MOTION_YPOSITION": "položaj y",
    "MOTION_DIRECTION": "smer",
    "MOTION_SCROLLRIGHT": "premik desno %1",
    "MOTION_SCROLLUP": "premik gor%1",
    "MOTION_ALIGNSCENE": "poravnaj sceno %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "levo spodaj",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "desno spodaj",
    "MOTION_ALIGNSCENE_MIDDLE": "sredina",
    "MOTION_ALIGNSCENE_TOPLEFT": "levo zgoraj",
    "MOTION_ALIGNSCENE_TOPRIGHT": "desno zgoraj",
    "MOTION_XSCROLL": "premik v smeri x",
    "MOTION_YSCROLL": "premik v smeri y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "naključno število med %1 in %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 in %2",
    "OPERATORS_OR": "%1 ali %2",
    "OPERATORS_NOT": "ne %1",
    "OPERATORS_JOIN": "združi %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "%1 črka v %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "dolžina %1",
    "OPERATORS_CONTAINS": "ali %1 vsebuje %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "zaokroži %1",
    "OPERATORS_MATHOP": "%1 od %2",
    "OPERATORS_MATHOP_ABS": "absolutna vrednost",
    "OPERATORS_MATHOP_FLOOR": "zaokroži navzdol",
    "OPERATORS_MATHOP_CEILING": "zaokroži navzgor",
    "OPERATORS_MATHOP_SQRT": "kvadratni koren ",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctg",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definiraj %1",
    "SENSING_TOUCHINGOBJECT": "se dotika %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "kazalca miške",
    "SENSING_TOUCHINGOBJECT_EDGE": "roba",
    "SENSING_TOUCHINGCOLOR": "se dotika barve %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "se barva %1 dotika %2?",
    "SENSING_DISTANCETO": "razdalja do %1",
    "SENSING_DISTANCETO_POINTER": "kazalca miške",
    "SENSING_ASKANDWAIT": "vprašaj %1 in počakaj",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "odgovor",
    "SENSING_KEYPRESSED": "je pritisnjena tipka %1?",
    "SENSING_MOUSEDOWN": "je miška kliknjena?",
    "SENSING_MOUSEX": "miška x",
    "SENSING_MOUSEY": "miška y",
    "SENSING_SETDRAGMODE": "nastavi način drsenja %1 ",
    "SENSING_SETDRAGMODE_DRAGGABLE": "drseče",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ne drseče",
    "SENSING_LOUDNESS": "glasnost",
    "SENSING_LOUD": "glasno?",
    "SENSING_TIMER": "štoparica",
    "SENSING_RESETTIMER": "ponastavi štoparico",
    "SENSING_OF": "%1 od %2",
    "SENSING_OF_XPOSITION": "položaj x",
    "SENSING_OF_YPOSITION": "položaj y",
    "SENSING_OF_DIRECTION": "smer",
    "SENSING_OF_COSTUMENUMBER": "videz #",
    "SENSING_OF_COSTUMENAME": "ime videza",
    "SENSING_OF_SIZE": "velikost",
    "SENSING_OF_VOLUME": "glasnost",
    "SENSING_OF_BACKDROPNUMBER": "ozadje #",
    "SENSING_OF_BACKDROPNAME": "ime ozadja",
    "SENSING_OF_STAGE": "Oder",
    "SENSING_CURRENT": "trenutni %1",
    "SENSING_CURRENT_YEAR": "leto",
    "SENSING_CURRENT_MONTH": "mesec",
    "SENSING_CURRENT_DATE": "datum",
    "SENSING_CURRENT_DAYOFWEEK": "dan v tednu",
    "SENSING_CURRENT_HOUR": "ura",
    "SENSING_CURRENT_MINUTE": "minuta",
    "SENSING_CURRENT_SECOND": "sekunda",
    "SENSING_DAYSSINCE2000": "dni od leta 2000",
    "SENSING_USERNAME": "uporabniško ime",
    "SENSING_USERID": "uporabnikova številka",
    "SOUND_PLAY": "predvajaj zvok %1",
    "SOUND_PLAYUNTILDONE": "predvajaj zvok %1 do konca",
    "SOUND_STOPALLSOUNDS": "ustavi vse zvoke",
    "SOUND_SETEFFECTO": "nastavi učinek %1 na %2",
    "SOUND_CHANGEEFFECTBY": "spremeni učinek %1 za %2",
    "SOUND_CLEAREFFECTS": "izbriši zvočne učinke",
    "SOUND_EFFECTS_PITCH": "višina tona",
    "SOUND_EFFECTS_PAN": "premik levo/desno",
    "SOUND_CHANGEVOLUMEBY": "spremeni glasnost za %1",
    "SOUND_SETVOLUMETO": "nastavi glasnost na %1",
    "SOUND_VOLUME": "glasnost",
    "CATEGORY_MOTION": "Gibanje",
    "CATEGORY_LOOKS": "Videzi",
    "CATEGORY_SOUND": "Zvok",
    "CATEGORY_EVENTS": "Dogodki",
    "CATEGORY_CONTROL": "Krmiljenje",
    "CATEGORY_SENSING": "Zaznavanje",
    "CATEGORY_OPERATORS": "Operatorji",
    "CATEGORY_VARIABLES": "Spremenljivke",
    "CATEGORY_MYBLOCKS": "Moji bloki",
    "DUPLICATE": "Podvoji",
    "DELETE": "Izbriši",
    "ADD_COMMENT": "Dodaj komentar",
    "REMOVE_COMMENT": "Odstrani komentar",
    "DELETE_BLOCK": "Izbriši blok",
    "DELETE_X_BLOCKS": "Izbriši %1 blokov",
    "DELETE_ALL_BLOCKS": "Izbrisati vseh %1 blokov?",
    "CLEAN_UP": "Počisti bloke",
    "HELP": "Pomoč",
    "UNDO": "Razveljavi",
    "REDO": "Uveljavi",
    "EDIT_PROCEDURE": "Uredi",
    "SHOW_PROCEDURE_DEFINITION": "Pojdi na definicijo",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Reci kaj ...",
    "COLOUR_HUE_LABEL": "Barva",
    "COLOUR_SATURATION_LABEL": "Nasičenost",
    "COLOUR_BRIGHTNESS_LABEL": "Svetlost",
    "CHANGE_VALUE_TITLE": "Spremeni vrednost: ",
    "RENAME_VARIABLE": "Preimenuj spremenljivko",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Preimenuj spremenljivko",
    "NEW_VARIABLE": "Ustvari spremenljivko",
    "NEW_VARIABLE_TITLE": "Novo ime spremenljivke:",
    "VARIABLE_MODAL_TITLE": "Nova spremenljivka",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Ustvari blok",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Ustvari seznam",
    "NEW_LIST_TITLE": "Novi ime seznama:",
    "LIST_MODAL_TITLE": "Nov seznam",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Preimenuj seznam",
    "NEW_BROADCAST_MESSAGE": "Novo sporočilo",
    "NEW_BROADCAST_MESSAGE_TITLE": "Ime novega sporočila:",
    "BROADCAST_MODAL_TITLE": "Novo sporočilo",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "sporočilo1"
};

Blockly.ScratchMsgs.locales["sr"] =
{
    "CONTROL_FOREVER": "понављај заувек",
    "CONTROL_REPEAT": "понови %1",
    "CONTROL_IF": "ако је %1 онда",
    "CONTROL_ELSE": "у супротном",
    "CONTROL_STOP": "заустави",
    "CONTROL_STOP_ALL": "све",
    "CONTROL_STOP_THIS": "овај програм",
    "CONTROL_STOP_OTHER": "друге програме лика",
    "CONTROL_WAIT": "чекај %1 секунду",
    "CONTROL_WAITUNTIL": "чекај док не %1",
    "CONTROL_REPEATUNTIL": "понављај док не %1",
    "CONTROL_WHILE": "док је %1",
    "CONTROL_FOREACH": "за сваки %1 у %2",
    "CONTROL_STARTASCLONE": "када се појавим као умножак",
    "CONTROL_CREATECLONEOF": "направи умножак од %1",
    "CONTROL_CREATECLONEOF_MYSELF": "мене",
    "CONTROL_DELETETHISCLONE": "обриши овај умножак",
    "CONTROL_COUNTER": "бројач",
    "CONTROL_INCRCOUNTER": "увећај бројач",
    "CONTROL_CLEARCOUNTER": "обриши бројач",
    "CONTROL_ALLATONCE": "све одједном",
    "DATA_SETVARIABLETO": "нека %1 буде %2",
    "DATA_CHANGEVARIABLEBY": "промени %1 за %2",
    "DATA_SHOWVARIABLE": "прикажи променљиву %1",
    "DATA_HIDEVARIABLE": "сакриј променљиву %1",
    "DATA_ADDTOLIST": "додај %1 у %2",
    "DATA_DELETEOFLIST": "обриши %1 из %2",
    "DATA_INSERTATLIST": "убаци %1 на %2 у %3",
    "DATA_REPLACEITEMOFLIST": "замени елемент %1 у %2 са %3",
    "DATA_ITEMOFLIST": "елемент %1 из %2",
    "DATA_LENGTHOFLIST": "дужина %1",
    "DATA_LISTCONTAINSITEM": "да ли %1 садржи %2?",
    "DATA_SHOWLIST": "прикажи листу %1",
    "DATA_HIDELIST": "сакриј листу %1",
    "DATA_INDEX_ALL": "све",
    "DATA_INDEX_LAST": "последњи",
    "DATA_INDEX_RANDOM": "насумичан",
    "EVENT_WHENFLAGCLICKED": "када је кликнуто на %1",
    "EVENT_WHENTHISSPRITECLICKED": "када је кликнуто на овај лик",
    "EVENT_WHENSTAGECLICKED": "када је кликнуто на позорницу",
    "EVENT_WHENTOUCHINGOBJECT": "када овај лик додирне %1",
    "EVENT_WHENBROADCASTRECEIVED": "када примим %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "када се позадина промени у %1",
    "EVENT_WHENGREATERTHAN": "када је %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "тајмер",
    "EVENT_BROADCAST": "разгласи %1",
    "EVENT_BROADCASTANDWAIT": "разгласи %1 и чекај",
    "EVENT_WHENKEYPRESSED": "када је дирка %1 притиснута",
    "EVENT_WHENKEYPRESSED_SPACE": "размак",
    "EVENT_WHENKEYPRESSED_LEFT": "стрелица лево",
    "EVENT_WHENKEYPRESSED_RIGHT": "стрелица десно",
    "EVENT_WHENKEYPRESSED_DOWN": "стрелица доле",
    "EVENT_WHENKEYPRESSED_UP": "стрелица горе",
    "EVENT_WHENKEYPRESSED_ANY": "било који",
    "LOOKS_SAYFORSECS": "изговори %1 током %2 секунде",
    "LOOKS_SAY": "изговори %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "замисли %1 током %2 секунде",
    "LOOKS_THINK": "замисли %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "прикажи",
    "LOOKS_HIDE": "сакриј",
    "LOOKS_HIDEALLSPRITES": "сакриј све ликове",
    "LOOKS_EFFECT_COLOR": "боја",
    "LOOKS_EFFECT_FISHEYE": "рибље око",
    "LOOKS_EFFECT_WHIRL": "вртлог",
    "LOOKS_EFFECT_PIXELATE": "позрнати",
    "LOOKS_EFFECT_MOSAIC": "мозаик",
    "LOOKS_EFFECT_BRIGHTNESS": "осветљеност",
    "LOOKS_EFFECT_GHOST": "дух",
    "LOOKS_CHANGEEFFECTBY": "промени ефекат %1 за %2",
    "LOOKS_SETEFFECTTO": "нека ефекат %1 буде %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "уклони графичке ефекте",
    "LOOKS_CHANGESIZEBY": "промени величину за %1",
    "LOOKS_SETSIZETO": "нека величина буде %1 %",
    "LOOKS_SIZE": "величина",
    "LOOKS_CHANGESTRETCHBY": "промени увећање за %1",
    "LOOKS_SETSTRETCHTO": "нека увећање буде  %1 %",
    "LOOKS_SWITCHCOSTUMETO": "замени костим са %1",
    "LOOKS_NEXTCOSTUME": "следећи костим",
    "LOOKS_SWITCHBACKDROPTO": "промени позадину у %1",
    "LOOKS_GOTOFRONTBACK": "иди на %1 слој",
    "LOOKS_GOTOFRONTBACK_FRONT": "напред",
    "LOOKS_GOTOFRONTBACK_BACK": "назад",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "иди %1 %2 слоја",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "проследи",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "уназад",
    "LOOKS_BACKDROPNUMBERNAME": "позадина %1",
    "LOOKS_COSTUMENUMBERNAME": "костим %1",
    "LOOKS_NUMBERNAME_NUMBER": "број",
    "LOOKS_NUMBERNAME_NAME": "име",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "промени позадину у %1 и чекај",
    "LOOKS_NEXTBACKDROP": "следећа позадина",
    "LOOKS_PREVIOUSBACKDROP": "претходна позадина",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "иди %1 корака",
    "MOTION_TURNLEFT": "окрет %1 за %2 степени",
    "MOTION_TURNRIGHT": "окрет %1 за %2 степени",
    "MOTION_POINTINDIRECTION": "усмери се ка %1",
    "MOTION_POINTTOWARDS": "усмери се ка %1",
    "MOTION_POINTTOWARDS_POINTER": "показивач миша",
    "MOTION_GOTO": "иди до %1",
    "MOTION_GOTO_POINTER": "показивач миша",
    "MOTION_GOTO_RANDOM": "случајан положај",
    "MOTION_GOTOXY": "иди до x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "клизи %1 секунди до x: %2 y: %3",
    "MOTION_GLIDETO": "клизи %1 секунди до %2",
    "MOTION_GLIDETO_POINTER": "показивач миша",
    "MOTION_GLIDETO_RANDOM": "случајан положај",
    "MOTION_CHANGEXBY": "промени x за %1",
    "MOTION_SETX": "нека x буде %1",
    "MOTION_CHANGEYBY": "промени y за %1",
    "MOTION_SETY": "нека y буде %1",
    "MOTION_IFONEDGEBOUNCE": "ако си на рубу, окрени се",
    "MOTION_SETROTATIONSTYLE": "подеси начин окретања %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "лево-десно",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "без окретања",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "на све стране",
    "MOTION_XPOSITION": "место х",
    "MOTION_YPOSITION": "место у",
    "MOTION_DIRECTION": "смер",
    "MOTION_SCROLLRIGHT": "клизи у десно %1",
    "MOTION_SCROLLUP": "клизи горе  %1",
    "MOTION_ALIGNSCENE": "поравнај сцену %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "доле-лево",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "доле-десно",
    "MOTION_ALIGNSCENE_MIDDLE": "средина",
    "MOTION_ALIGNSCENE_TOPLEFT": "горе-лево",
    "MOTION_ALIGNSCENE_TOPRIGHT": "горе-десно",
    "MOTION_XSCROLL": "x клизање",
    "MOTION_YSCROLL": "y клизање",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "случајан број од %1 до %2 ",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 и %2",
    "OPERATORS_OR": "%1 или %2",
    "OPERATORS_NOT": "није %1",
    "OPERATORS_JOIN": "споји %1 и %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "%1 слово од %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "дужина %1",
    "OPERATORS_CONTAINS": "%1 садржи %2",
    "OPERATORS_MOD": "%1 мод %2",
    "OPERATORS_ROUND": "заокружи %1",
    "OPERATORS_MATHOP": "%1 од %2",
    "OPERATORS_MATHOP_ABS": "абс",
    "OPERATORS_MATHOP_FLOOR": "цео део",
    "OPERATORS_MATHOP_CEILING": "цео+1",
    "OPERATORS_MATHOP_SQRT": "корен",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tg",
    "OPERATORS_MATHOP_ASIN": "arcsin",
    "OPERATORS_MATHOP_ACOS": "arccos",
    "OPERATORS_MATHOP_ATAN": "arctan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "дефиниши %1",
    "SENSING_TOUCHINGOBJECT": "додирује ли %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "показивач миша",
    "SENSING_TOUCHINGOBJECT_EDGE": "ивица",
    "SENSING_TOUCHINGCOLOR": "додирује ли боју %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "боја %1 додирује %2?",
    "SENSING_DISTANCETO": "удаљеност од %1",
    "SENSING_DISTANCETO_POINTER": "показивач миша",
    "SENSING_ASKANDWAIT": "питај %1 и чекај",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "одговор",
    "SENSING_KEYPRESSED": "дугме %1 је притиснуто?",
    "SENSING_MOUSEDOWN": "миш притиснут?",
    "SENSING_MOUSEX": "миш x",
    "SENSING_MOUSEY": "миш y",
    "SENSING_SETDRAGMODE": "нека начин превлачења буде %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "превлачиво",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "није превлачиво",
    "SENSING_LOUDNESS": "јачина звука",
    "SENSING_LOUD": "гласно?",
    "SENSING_TIMER": "тајмер",
    "SENSING_RESETTIMER": "постави тајмер на 0",
    "SENSING_OF": "%1 од %2",
    "SENSING_OF_XPOSITION": "x положај",
    "SENSING_OF_YPOSITION": "y положај",
    "SENSING_OF_DIRECTION": "смер",
    "SENSING_OF_COSTUMENUMBER": "број костима",
    "SENSING_OF_COSTUMENAME": "име костима",
    "SENSING_OF_SIZE": "величина",
    "SENSING_OF_VOLUME": "јачина звука",
    "SENSING_OF_BACKDROPNUMBER": "број позадине",
    "SENSING_OF_BACKDROPNAME": "име позадине",
    "SENSING_OF_STAGE": "Позорница",
    "SENSING_CURRENT": "тренутно %1",
    "SENSING_CURRENT_YEAR": "година",
    "SENSING_CURRENT_MONTH": "месец",
    "SENSING_CURRENT_DATE": "датум",
    "SENSING_CURRENT_DAYOFWEEK": "дан у недељи",
    "SENSING_CURRENT_HOUR": "сат",
    "SENSING_CURRENT_MINUTE": "минут",
    "SENSING_CURRENT_SECOND": "секунда",
    "SENSING_DAYSSINCE2000": "дана после 2000",
    "SENSING_USERNAME": "корисничко име",
    "SENSING_USERID": "Корисников ид",
    "SOUND_PLAY": "покрени звук %1",
    "SOUND_PLAYUNTILDONE": "репродукуј звук %1 до краја",
    "SOUND_STOPALLSOUNDS": "заустави све звукове",
    "SOUND_SETEFFECTO": "нека ефекат %1 буде %2",
    "SOUND_CHANGEEFFECTBY": "промени ефекат %1 за %2",
    "SOUND_CLEAREFFECTS": "уклони звучне ефекте",
    "SOUND_EFFECTS_PITCH": "висина тона",
    "SOUND_EFFECTS_PAN": "кретање лево/десно",
    "SOUND_CHANGEVOLUMEBY": "промени јачину звука за %1",
    "SOUND_SETVOLUMETO": "нека јачина звука буде %1%",
    "SOUND_VOLUME": "јачина звука",
    "CATEGORY_MOTION": "Кретање",
    "CATEGORY_LOOKS": "Изглед",
    "CATEGORY_SOUND": "Звук",
    "CATEGORY_EVENTS": "Догађаји",
    "CATEGORY_CONTROL": "Управљање",
    "CATEGORY_SENSING": "Осећаји",
    "CATEGORY_OPERATORS": "Операције",
    "CATEGORY_VARIABLES": "Променљиве",
    "CATEGORY_MYBLOCKS": "Моји блокови",
    "DUPLICATE": "Умножи",
    "DELETE": "Обриши",
    "ADD_COMMENT": "Додај коментар",
    "REMOVE_COMMENT": "Уклони коментар",
    "DELETE_BLOCK": "Обриши блок",
    "DELETE_X_BLOCKS": "Обриши %1 блокова",
    "DELETE_ALL_BLOCKS": "Обрисати свих %1 блокова?",
    "CLEAN_UP": "Поспреми блокове",
    "HELP": "Помоћ",
    "UNDO": "Опозови",
    "REDO": "Понови",
    "EDIT_PROCEDURE": "Уреди",
    "SHOW_PROCEDURE_DEFINITION": "Иди до дефиниције",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Кажи нешто...",
    "COLOUR_HUE_LABEL": "Боја",
    "COLOUR_SATURATION_LABEL": "Засићење",
    "COLOUR_BRIGHTNESS_LABEL": "Осветљеност",
    "CHANGE_VALUE_TITLE": "Промени вредност:",
    "RENAME_VARIABLE": "Преименуј променљиву",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Преименуј променљиву",
    "NEW_VARIABLE": "Направи променљиву",
    "NEW_VARIABLE_TITLE": "Ново име променљиве:",
    "VARIABLE_MODAL_TITLE": "Нова променљива",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Направи блок",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Направи листу",
    "NEW_LIST_TITLE": "Ново име листе:",
    "LIST_MODAL_TITLE": "Нова листа",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Преименуј листу",
    "NEW_BROADCAST_MESSAGE": "Нова порука",
    "NEW_BROADCAST_MESSAGE_TITLE": "Име нове поруке:",
    "BROADCAST_MODAL_TITLE": "Нова порука",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "порука1"
};

Blockly.ScratchMsgs.locales["sv"] =
{
    "CONTROL_FOREVER": "för alltid",
    "CONTROL_REPEAT": "repetera %1",
    "CONTROL_IF": "om %1 då",
    "CONTROL_ELSE": "annars",
    "CONTROL_STOP": "stoppa",
    "CONTROL_STOP_ALL": "alla",
    "CONTROL_STOP_THIS": "detta skript",
    "CONTROL_STOP_OTHER": "andra skript i sprajten",
    "CONTROL_WAIT": "vänta %1 sekunder",
    "CONTROL_WAITUNTIL": "vänta tills %1",
    "CONTROL_REPEATUNTIL": "repetera tills %1",
    "CONTROL_WHILE": "medan %1",
    "CONTROL_FOREACH": "för varje %1 i %2",
    "CONTROL_STARTASCLONE": "när jag startar som klon",
    "CONTROL_CREATECLONEOF": "skapa klon av %1",
    "CONTROL_CREATECLONEOF_MYSELF": "mig själv",
    "CONTROL_DELETETHISCLONE": "radera klonen",
    "CONTROL_COUNTER": "räknare",
    "CONTROL_INCRCOUNTER": "öka räknare",
    "CONTROL_CLEARCOUNTER": "nollställ räknare",
    "CONTROL_ALLATONCE": "alla samtidig",
    "DATA_SETVARIABLETO": "sätt %1 till %2",
    "DATA_CHANGEVARIABLEBY": "ändra %1 med %2",
    "DATA_SHOWVARIABLE": "visa variabel %1",
    "DATA_HIDEVARIABLE": "göm variabel %1",
    "DATA_ADDTOLIST": "lägg till %1 i %2",
    "DATA_DELETEOFLIST": "ta bort %1 från %2",
    "DATA_INSERTATLIST": "infoga %1 vid %2 i %3",
    "DATA_REPLACEITEMOFLIST": "ersätt posten %1 i %2 med %3",
    "DATA_ITEMOFLIST": "post %1 i %2",
    "DATA_LENGTHOFLIST": "längden av %1",
    "DATA_LISTCONTAINSITEM": "%1 innehåller %2",
    "DATA_SHOWLIST": "visa listan %1",
    "DATA_HIDELIST": "göm listan %1",
    "DATA_INDEX_ALL": "alla",
    "DATA_INDEX_LAST": "sista",
    "DATA_INDEX_RANDOM": "slumpmässig",
    "EVENT_WHENFLAGCLICKED": "när %1 klickas på",
    "EVENT_WHENTHISSPRITECLICKED": "när denna sprite klickas på",
    "EVENT_WHENSTAGECLICKED": "när scenen klickas på",
    "EVENT_WHENTOUCHINGOBJECT": "när denna sprajt rör %1",
    "EVENT_WHENBROADCASTRECEIVED": "när jag tar emot %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "när bakgrunden växlar till %1",
    "EVENT_WHENGREATERTHAN": "när %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "timer",
    "EVENT_BROADCAST": "skicka %1",
    "EVENT_BROADCASTANDWAIT": "skicka %1 och vänta",
    "EVENT_WHENKEYPRESSED": "när %1 tangenten trycks ned",
    "EVENT_WHENKEYPRESSED_SPACE": "mellanslag",
    "EVENT_WHENKEYPRESSED_LEFT": "vänsterpil",
    "EVENT_WHENKEYPRESSED_RIGHT": "högerpil",
    "EVENT_WHENKEYPRESSED_DOWN": "nedåtpil",
    "EVENT_WHENKEYPRESSED_UP": "uppåtpil",
    "EVENT_WHENKEYPRESSED_ANY": "någon",
    "LOOKS_SAYFORSECS": "säg %1 i %2 sekunder",
    "LOOKS_SAY": "säg %1",
    "LOOKS_HELLO": "Hej!",
    "LOOKS_THINKFORSECS": "tänk %1 i %2 sekunder",
    "LOOKS_THINK": "tänk %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "visa",
    "LOOKS_HIDE": "göm",
    "LOOKS_HIDEALLSPRITES": "göm alla sprajtar",
    "LOOKS_EFFECT_COLOR": "färg ",
    "LOOKS_EFFECT_FISHEYE": "fisheye",
    "LOOKS_EFFECT_WHIRL": "virvel",
    "LOOKS_EFFECT_PIXELATE": "pixla",
    "LOOKS_EFFECT_MOSAIC": "mosaik",
    "LOOKS_EFFECT_BRIGHTNESS": "ljusstyrka",
    "LOOKS_EFFECT_GHOST": "genomskinlighet",
    "LOOKS_CHANGEEFFECTBY": "ändra %1 effekten med %2",
    "LOOKS_SETEFFECTTO": "sätt %1 effekten till %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "ta bort grafisk effekt",
    "LOOKS_CHANGESIZEBY": "ändra storlek med %1",
    "LOOKS_SETSIZETO": "sätt storleken till %1 %",
    "LOOKS_SIZE": "Storlek",
    "LOOKS_CHANGESTRETCHBY": "ändra töjning med %1",
    "LOOKS_SETSTRETCHTO": "sätt töjning till %1 %",
    "LOOKS_SWITCHCOSTUMETO": "ändra klädsel till %1",
    "LOOKS_NEXTCOSTUME": "nästa klädsel",
    "LOOKS_SWITCHBACKDROPTO": "växla bakgrund till %1",
    "LOOKS_GOTOFRONTBACK": "gå till %1 lagret",
    "LOOKS_GOTOFRONTBACK_FRONT": "placera längst fram",
    "LOOKS_GOTOFRONTBACK_BACK": "tillbaka",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "gå %1 %2 lager",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "framåt ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "bakåt ",
    "LOOKS_BACKDROPNUMBERNAME": "bakgrund %1",
    "LOOKS_COSTUMENUMBERNAME": "klädsel %1",
    "LOOKS_NUMBERNAME_NUMBER": "nummer",
    "LOOKS_NUMBERNAME_NAME": "namn ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "byt bakgrund till %1 och vänta",
    "LOOKS_NEXTBACKDROP": "nästa bakgrund",
    "LOOKS_PREVIOUSBACKDROP": "föregående bakgrund",
    "LOOKS_RANDOMBACKDROP": "slumpvis bakgrund",
    "MOTION_MOVESTEPS": "gå %1 steg",
    "MOTION_TURNLEFT": "rotera %1 %2 grader",
    "MOTION_TURNRIGHT": "rotera %1 %2 grader",
    "MOTION_POINTINDIRECTION": "peka i riktning %1",
    "MOTION_POINTTOWARDS": "peka mot %1",
    "MOTION_POINTTOWARDS_POINTER": "muspekare ",
    "MOTION_GOTO": "gå till %1",
    "MOTION_GOTO_POINTER": "muspekare ",
    "MOTION_GOTO_RANDOM": "slumpmässig position",
    "MOTION_GOTOXY": "gå till x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glid %1 sek till x: %2 y: %3",
    "MOTION_GLIDETO": "glid %1 sekunder till %2",
    "MOTION_GLIDETO_POINTER": "muspekare ",
    "MOTION_GLIDETO_RANDOM": "slumpmässig position",
    "MOTION_CHANGEXBY": "ändra x med %1",
    "MOTION_SETX": "sätt x till %1",
    "MOTION_CHANGEYBY": "ändra y med %1",
    "MOTION_SETY": "sätt y till %1",
    "MOTION_IFONEDGEBOUNCE": "om vid kanten, studsa",
    "MOTION_SETROTATIONSTYLE": "sätt rotationsstil %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "vänster-höger",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "rotera inte",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "rotera",
    "MOTION_XPOSITION": "x position",
    "MOTION_YPOSITION": "y position",
    "MOTION_DIRECTION": "riktning",
    "MOTION_SCROLLRIGHT": "skrolla höger %1",
    "MOTION_SCROLLUP": "skrolla upp %1",
    "MOTION_ALIGNSCENE": "arrangera scen %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "nedre-vänster",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "nedre-höger",
    "MOTION_ALIGNSCENE_MIDDLE": "mitten",
    "MOTION_ALIGNSCENE_TOPLEFT": "övre-vänster",
    "MOTION_ALIGNSCENE_TOPRIGHT": "övre-höger",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Scen vald: inga rörelseblock",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "välj slumptal %1 till %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 och %2",
    "OPERATORS_OR": "%1 eller %2",
    "OPERATORS_NOT": "inte %1",
    "OPERATORS_JOIN": "sammanfoga %1 %2",
    "OPERATORS_JOIN_APPLE": "äpple",
    "OPERATORS_JOIN_BANANA": "banan",
    "OPERATORS_LETTEROF": "bokstav %1 av %2",
    "OPERATORS_LETTEROF_APPLE": "ä",
    "OPERATORS_LENGTH": "längden av %1",
    "OPERATORS_CONTAINS": "%1 innehåller %2",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "avrunda %1",
    "OPERATORS_MATHOP": "%1 av %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "Golv",
    "OPERATORS_MATHOP_CEILING": "Tak",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "definiera %1",
    "SENSING_TOUCHINGOBJECT": "rör vid %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "muspekare ",
    "SENSING_TOUCHINGOBJECT_EDGE": "kant",
    "SENSING_TOUCHINGCOLOR": "rör vid färgen %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "rör färgen %1 vid %2?",
    "SENSING_DISTANCETO": "avstånd till %1",
    "SENSING_DISTANCETO_POINTER": "muspekare ",
    "SENSING_ASKANDWAIT": "fråga %1 och vänta",
    "SENSING_ASK_TEXT": "Vad heter du?",
    "SENSING_ANSWER": "svar",
    "SENSING_KEYPRESSED": "tangent %1 nedtryckt?",
    "SENSING_MOUSEDOWN": "musknappen?",
    "SENSING_MOUSEX": "mus x",
    "SENSING_MOUSEY": "mus y",
    "SENSING_SETDRAGMODE": "sätt dragläge %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "dragbar",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "inte dragbar",
    "SENSING_LOUDNESS": "ljudstyrka",
    "SENSING_LOUD": "högt ljud?",
    "SENSING_TIMER": "timer",
    "SENSING_RESETTIMER": "nollställ timer",
    "SENSING_OF": "%1 av %2",
    "SENSING_OF_XPOSITION": "x position",
    "SENSING_OF_YPOSITION": "y position",
    "SENSING_OF_DIRECTION": "riktning",
    "SENSING_OF_COSTUMENUMBER": "klädselnummer",
    "SENSING_OF_COSTUMENAME": "klädselnamn",
    "SENSING_OF_SIZE": "Storlek",
    "SENSING_OF_VOLUME": "volym ",
    "SENSING_OF_BACKDROPNUMBER": "bakgrundsnummer",
    "SENSING_OF_BACKDROPNAME": "bakgrundsnamn",
    "SENSING_OF_STAGE": "Scen",
    "SENSING_CURRENT": "aktuell %1",
    "SENSING_CURRENT_YEAR": "år ",
    "SENSING_CURRENT_MONTH": "månad ",
    "SENSING_CURRENT_DATE": "dag ",
    "SENSING_CURRENT_DAYOFWEEK": "veckodag ",
    "SENSING_CURRENT_HOUR": "timmar ",
    "SENSING_CURRENT_MINUTE": "minuter ",
    "SENSING_CURRENT_SECOND": "sekunder ",
    "SENSING_DAYSSINCE2000": "dagar sedan år 2000",
    "SENSING_USERNAME": "användarnamn ",
    "SENSING_USERID": "användarnamn",
    "SOUND_PLAY": "starta ljud %1",
    "SOUND_PLAYUNTILDONE": "spela ljudet %1 tills färdigt",
    "SOUND_STOPALLSOUNDS": "stoppa alla ljud",
    "SOUND_SETEFFECTO": "sätt %1 effekten till %2",
    "SOUND_CHANGEEFFECTBY": "ändra %1 effekten med %2",
    "SOUND_CLEAREFFECTS": "ta bort ljudeffekter",
    "SOUND_EFFECTS_PITCH": "tonhöjd",
    "SOUND_EFFECTS_PAN": "panorera vänster/höger",
    "SOUND_CHANGEVOLUMEBY": "ändra volymen med %1",
    "SOUND_SETVOLUMETO": "sätt volymen till %1%",
    "SOUND_VOLUME": "volym ",
    "CATEGORY_MOTION": "Rörelse",
    "CATEGORY_LOOKS": "Utseende",
    "CATEGORY_SOUND": "Ljud",
    "CATEGORY_EVENTS": "Händelser",
    "CATEGORY_CONTROL": "Kontroll",
    "CATEGORY_SENSING": "Känna av",
    "CATEGORY_OPERATORS": "Operatorer",
    "CATEGORY_VARIABLES": "Variabler",
    "CATEGORY_MYBLOCKS": "Mina block",
    "DUPLICATE": "Kopiera",
    "DELETE": "Radera",
    "ADD_COMMENT": "Lägg till kommentar",
    "REMOVE_COMMENT": "Ta bort kommentar",
    "DELETE_BLOCK": "Ta bort block",
    "DELETE_X_BLOCKS": "Ta bort %1 block",
    "DELETE_ALL_BLOCKS": "Ta bort alla %1 block?",
    "CLEAN_UP": "Rensa block",
    "HELP": "Hjälp",
    "UNDO": "Ångra",
    "REDO": "Gör om",
    "EDIT_PROCEDURE": "Redigera",
    "SHOW_PROCEDURE_DEFINITION": "Gå till definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Säg något...",
    "COLOUR_HUE_LABEL": "Färg",
    "COLOUR_SATURATION_LABEL": "Mättnad",
    "COLOUR_BRIGHTNESS_LABEL": "Ljusstyrka",
    "CHANGE_VALUE_TITLE": "Ändra värde:",
    "RENAME_VARIABLE": "Döp om variabeln",
    "RENAME_VARIABLE_TITLE": "Döp om alla \"%1\" variabler till:",
    "RENAME_VARIABLE_MODAL_TITLE": "Döp om variabel",
    "NEW_VARIABLE": "Gör en variabel",
    "NEW_VARIABLE_TITLE": "Nytt variabelnamn:",
    "VARIABLE_MODAL_TITLE": "Ny variabel",
    "VARIABLE_ALREADY_EXISTS": "En variabel \"%1\" finns redan.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "En variabel \"%1\" finns redan för en annan variabel av typ \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Ta bort %1 användningar av variabeln \"%2\"?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Kan inte ta bort variabel \"%1\" för att den är en del av definitionen av funktionen \"%2\"",
    "DELETE_VARIABLE": "Ta bort \"%1\" variabeln",
    "NEW_PROCEDURE": "Skapa ett Block",
    "PROCEDURE_ALREADY_EXISTS": "En funktion \"%1\" finns redan.",
    "NEW_LIST": "Gör en lista",
    "NEW_LIST_TITLE": "Nytt listnamn:",
    "LIST_MODAL_TITLE": "Ny lista",
    "LIST_ALREADY_EXISTS": "En lista \"%1\" finns redan.",
    "RENAME_LIST_TITLE": "Döp om alla \"%1\" listor till:",
    "RENAME_LIST_MODAL_TITLE": "Döp om lista",
    "NEW_BROADCAST_MESSAGE": "Nytt meddelande",
    "NEW_BROADCAST_MESSAGE_TITLE": "Nytt namn på meddelande:",
    "BROADCAST_MODAL_TITLE": "Nytt meddelande",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "meddelande1"
};

Blockly.ScratchMsgs.locales["th"] =
{
    "CONTROL_FOREVER": "วนซ้ำตลอด",
    "CONTROL_REPEAT": "ทำซ้ำ %1",
    "CONTROL_IF": "ถ้า %1 แล้ว",
    "CONTROL_ELSE": "มิฉะนั้น",
    "CONTROL_STOP": "หยุด",
    "CONTROL_STOP_ALL": "ทั้งหมด",
    "CONTROL_STOP_THIS": "สคริปต์นี้",
    "CONTROL_STOP_OTHER": "สริปต์อื่นในตัวละคร",
    "CONTROL_WAIT": "รอ %1 วินาที",
    "CONTROL_WAITUNTIL": "รอจนกระทั่ง %1",
    "CONTROL_REPEATUNTIL": "ทำซ้ำจน %1",
    "CONTROL_WHILE": "ขณะที่ %1",
    "CONTROL_FOREACH": "สำหรับแต่ละ %1 ใน %2",
    "CONTROL_STARTASCLONE": "เมื่อฉันเริ่มในฐานะโคลน",
    "CONTROL_CREATECLONEOF": "สร้าง โคลน ของ %1",
    "CONTROL_CREATECLONEOF_MYSELF": "ตัวฉันเอง",
    "CONTROL_DELETETHISCLONE": "ลบโคลนตัวนี้",
    "CONTROL_COUNTER": "ตัวนับ",
    "CONTROL_INCRCOUNTER": "ตัวนับเพิ่ม",
    "CONTROL_CLEARCOUNTER": "ล้างตัวนับ",
    "CONTROL_ALLATONCE": "ทั้งหมดในครั้งเดียว",
    "DATA_SETVARIABLETO": "ตั้งค่า %1 เป็น %2",
    "DATA_CHANGEVARIABLEBY": "เปลี่ยน %1 ทีละ %2",
    "DATA_SHOWVARIABLE": "แสดงตัวแปร %1",
    "DATA_HIDEVARIABLE": "ซ่อนตัวแปร %1",
    "DATA_ADDTOLIST": "เพิ่ม %1 ไปยัง %2",
    "DATA_DELETEOFLIST": "ลบ %1 ออกจาก %2",
    "DATA_INSERTATLIST": "แทรก %1 ที่ %2 ของ %3",
    "DATA_REPLACEITEMOFLIST": "แทนที่รายการ %1 ของ %2 ด้วย %3",
    "DATA_ITEMOFLIST": "รายการ %1 ของ %2",
    "DATA_LENGTHOFLIST": "จำนวนของ %1",
    "DATA_LISTCONTAINSITEM": "%1 มี %2?",
    "DATA_SHOWLIST": "แสดงรายการ %1",
    "DATA_HIDELIST": "ซ่อนรายการ %1",
    "DATA_INDEX_ALL": "ทั้งหมด",
    "DATA_INDEX_LAST": "สุดท้าย",
    "DATA_INDEX_RANDOM": "สุ่ม",
    "EVENT_WHENFLAGCLICKED": "เมื่อคลิก %1",
    "EVENT_WHENTHISSPRITECLICKED": "เมื่อตัวละครนี้ถูกคลิก",
    "EVENT_WHENSTAGECLICKED": "เมื่อคลิกเวที",
    "EVENT_WHENTOUCHINGOBJECT": "เมื่อสไปรต์นี้แตะ %1",
    "EVENT_WHENBROADCASTRECEIVED": "เมื่อฉันได้รับ %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "เมื่อฉากหลังเปลี่ยนเป็น %1",
    "EVENT_WHENGREATERTHAN": "เมื่อ %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "ตัวจับเวลา",
    "EVENT_BROADCAST": "กระจาย %1",
    "EVENT_BROADCASTANDWAIT": "กระจาย %1 และรอ",
    "EVENT_WHENKEYPRESSED": "เมื่อกดปุ่ม %1",
    "EVENT_WHENKEYPRESSED_SPACE": "สเปซบาร์",
    "EVENT_WHENKEYPRESSED_LEFT": "ลูกศรชี้ทางซ้าย",
    "EVENT_WHENKEYPRESSED_RIGHT": "ลูกศรชี้ขวา",
    "EVENT_WHENKEYPRESSED_DOWN": "ลูกศรชี้ลง",
    "EVENT_WHENKEYPRESSED_UP": "ลูกศรขึ้น",
    "EVENT_WHENKEYPRESSED_ANY": "อะไรก็ได้",
    "LOOKS_SAYFORSECS": "พูด %1   %2 วินาที",
    "LOOKS_SAY": "พูด %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "คิด %1   %2 วินาที",
    "LOOKS_THINK": "คิด %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "แสดง",
    "LOOKS_HIDE": "ซ่อน",
    "LOOKS_HIDEALLSPRITES": "ซ่อนสไปรต์ทั้งหมด",
    "LOOKS_EFFECT_COLOR": "สี",
    "LOOKS_EFFECT_FISHEYE": "ตาปลา",
    "LOOKS_EFFECT_WHIRL": "หมุนวน",
    "LOOKS_EFFECT_PIXELATE": "แยกพิกเซล",
    "LOOKS_EFFECT_MOSAIC": "โมเสก",
    "LOOKS_EFFECT_BRIGHTNESS": "ความสว่าง",
    "LOOKS_EFFECT_GHOST": "ล่องหน",
    "LOOKS_CHANGEEFFECTBY": "เปลี่ยนเอฟเฟกต์ %1 ทีละ %2",
    "LOOKS_SETEFFECTTO": "ตั้งค่าเอฟเฟกต์ %1 เป็น %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "ล้างเอฟเฟคภาพ",
    "LOOKS_CHANGESIZEBY": "เปลี่ยนขนาดทีละ %1",
    "LOOKS_SETSIZETO": "กำหนดขนาดเป็น %1 %",
    "LOOKS_SIZE": "ขนาด",
    "LOOKS_CHANGESTRETCHBY": "เปลี่ยนความยืดทีละ %1",
    "LOOKS_SETSTRETCHTO": "ตั้งค่าความยืดเป็น %1 %",
    "LOOKS_SWITCHCOSTUMETO": "เปลี่ยนคอสตูมเป็น %1",
    "LOOKS_NEXTCOSTUME": "ชุดถัดไป",
    "LOOKS_SWITCHBACKDROPTO": "เปลี่ยนฉากหลังเป็น %1",
    "LOOKS_GOTOFRONTBACK": "ไปที่ระดับ %1 ",
    "LOOKS_GOTOFRONTBACK_FRONT": "หน้าสุด",
    "LOOKS_GOTOFRONTBACK_BACK": "หลังสุด",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "ไป %1 %2 ระดับ",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ด้านหน้า",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "ด้านหลัง",
    "LOOKS_BACKDROPNUMBERNAME": "ฉากหลัง %1",
    "LOOKS_COSTUMENUMBERNAME": "คอสตูม %1",
    "LOOKS_NUMBERNAME_NUMBER": "หมายเลข",
    "LOOKS_NUMBERNAME_NAME": "ชื่อ",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "เปลี่ยนฉากหลังเป็น %1 และรอ",
    "LOOKS_NEXTBACKDROP": "ฉากหลังต่อไป",
    "LOOKS_PREVIOUSBACKDROP": "ฉากหลังก่อนหน้า",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "เคลื่อนที่ %1 ก้าว",
    "MOTION_TURNLEFT": "หมุน %1 %2 องศา",
    "MOTION_TURNRIGHT": "หมุน %1 %2 องศา",
    "MOTION_POINTINDIRECTION": "หันในแนว %1",
    "MOTION_POINTTOWARDS": "หันไปทาง %1",
    "MOTION_POINTTOWARDS_POINTER": "ตัวชี้เมาส์",
    "MOTION_GOTO": "ไปที่ %1",
    "MOTION_GOTO_POINTER": "ตัวชี้เมาส์",
    "MOTION_GOTO_RANDOM": "ตำแหน่งสุ่ม",
    "MOTION_GOTOXY": "ไปที่ x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "เหิน %1 วินาที ไปยัง x: %2 y: %3",
    "MOTION_GLIDETO": "เหิน %1 วินาที ไปยัง %2",
    "MOTION_GLIDETO_POINTER": "ตัวชี้เมาส์",
    "MOTION_GLIDETO_RANDOM": "ตำแหน่งสุ่ม",
    "MOTION_CHANGEXBY": "เปลี่ยน x ทีละ %1",
    "MOTION_SETX": "ตั้งค่า x เป็น %1",
    "MOTION_CHANGEYBY": "เปลี่ยน y ทีละ %1",
    "MOTION_SETY": "ตั้งค่า y เป็น %1",
    "MOTION_IFONEDGEBOUNCE": "ถ้าชนขอบให้สะท้อนกลับ",
    "MOTION_SETROTATIONSTYLE": "ตั้งรูปแบบการหมุนเป็น %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "ซ้าย-ขวา",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "ห้ามหมุน",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "รอบด้าน",
    "MOTION_XPOSITION": "ตำแหน่ง x ",
    "MOTION_YPOSITION": "ตำแหน่ง y",
    "MOTION_DIRECTION": "ทิศทาง",
    "MOTION_SCROLLRIGHT": "เลื่อนขวา %1",
    "MOTION_SCROLLUP": "เลื่อนขึ้น %1",
    "MOTION_ALIGNSCENE": "แนวฉาก %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "ล่างซ้าย",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "ล่างขวา",
    "MOTION_ALIGNSCENE_MIDDLE": "กึ่งกลาง",
    "MOTION_ALIGNSCENE_TOPLEFT": "บนซ้าย",
    "MOTION_ALIGNSCENE_TOPRIGHT": "บนขวา",
    "MOTION_XSCROLL": "x เลื่อน",
    "MOTION_YSCROLL": "y เลื่อน",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "เลือกสุ่มจาก %1 ถึง %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 และ %2",
    "OPERATORS_OR": "%1 หรือ %2",
    "OPERATORS_NOT": "ไม่ %1",
    "OPERATORS_JOIN": "ต่อ %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "อักษรที่ %1 ของ %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "ความยาวของ %1",
    "OPERATORS_CONTAINS": "%1 มี %2?",
    "OPERATORS_MOD": "%1 หารเอาเศษ %2",
    "OPERATORS_ROUND": "ปัดเศษ %1",
    "OPERATORS_MATHOP": "%1 ของ %2",
    "OPERATORS_MATHOP_ABS": "ค่าสัมบูรณ์",
    "OPERATORS_MATHOP_FLOOR": "พื้น",
    "OPERATORS_MATHOP_CEILING": "เพดาน",
    "OPERATORS_MATHOP_SQRT": "รากที่สอง",
    "OPERATORS_MATHOP_SIN": "ไซน์",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ใน",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "กำหนด %1",
    "SENSING_TOUCHINGOBJECT": "แตะ %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "ตัวชี้เมาส์",
    "SENSING_TOUCHINGOBJECT_EDGE": "ขอบ",
    "SENSING_TOUCHINGCOLOR": "แตะสี %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "สี %1 แตะกับสี %2?",
    "SENSING_DISTANCETO": "ระยะห่างไปยัง %1",
    "SENSING_DISTANCETO_POINTER": "ตัวชี้เมาส์",
    "SENSING_ASKANDWAIT": "ถาม %1 และรอ",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "คำตอบ",
    "SENSING_KEYPRESSED": "ปุ่ม %1 ถูกกด?",
    "SENSING_MOUSEDOWN": "เมาส์ถูกกด?",
    "SENSING_MOUSEX": "ตำแหน่ง x ของเมาส์",
    "SENSING_MOUSEY": "ตำแหน่ง y ของเมาส์",
    "SENSING_SETDRAGMODE": "ตั้งค่าโหมดลาก %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "ลากได้",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "ลากไม่ได้",
    "SENSING_LOUDNESS": "ระดับความดัง",
    "SENSING_LOUD": "เสียงดัง?",
    "SENSING_TIMER": "จับเวลา",
    "SENSING_RESETTIMER": "จับเวลาใหม่",
    "SENSING_OF": "%1 ของ %2",
    "SENSING_OF_XPOSITION": "ตำแหน่ง x ",
    "SENSING_OF_YPOSITION": "ตำแหน่ง y",
    "SENSING_OF_DIRECTION": "ทิศทาง",
    "SENSING_OF_COSTUMENUMBER": "คอสตูม #",
    "SENSING_OF_COSTUMENAME": "ชื่อคอสตูม",
    "SENSING_OF_SIZE": "ขนาด",
    "SENSING_OF_VOLUME": "ระดับเสียง",
    "SENSING_OF_BACKDROPNUMBER": "ฉากหลัง #",
    "SENSING_OF_BACKDROPNAME": "ชื่อฉากหลัง",
    "SENSING_OF_STAGE": "เวที",
    "SENSING_CURRENT": "%1 ปัจจุบัน",
    "SENSING_CURRENT_YEAR": "ปี",
    "SENSING_CURRENT_MONTH": "เดือน",
    "SENSING_CURRENT_DATE": "วันที่",
    "SENSING_CURRENT_DAYOFWEEK": "วันของสัปดาห์",
    "SENSING_CURRENT_HOUR": "ชั่วโมง",
    "SENSING_CURRENT_MINUTE": "นาที",
    "SENSING_CURRENT_SECOND": "วินาที",
    "SENSING_DAYSSINCE2000": "จำนวนวันตั้งแต่ปี ค.ศ 2000",
    "SENSING_USERNAME": "ชื่อผู้ใช้",
    "SENSING_USERID": "รหัสผู้ใช้",
    "SOUND_PLAY": "เริ่มเสียง %1",
    "SOUND_PLAYUNTILDONE": "เล่นเสียง %1 จนจบ",
    "SOUND_STOPALLSOUNDS": "หยุดเสียงทั้งหมด",
    "SOUND_SETEFFECTO": "ตั้งค่าเอฟเฟกต์ %1 เป็น %2",
    "SOUND_CHANGEEFFECTBY": "เปลี่ยนเอฟเฟกต์ %1 ทีละ %2",
    "SOUND_CLEAREFFECTS": "ล้างเอฟเฟกต์เสียง",
    "SOUND_EFFECTS_PITCH": "เสียงสูงต่ำ",
    "SOUND_EFFECTS_PAN": "แพนเสียงซ้าย/ขวา",
    "SOUND_CHANGEVOLUMEBY": "เปลี่ยนระดับเสียงทีละ %1",
    "SOUND_SETVOLUMETO": "ตั้งระดับเสียงเป็น %1%",
    "SOUND_VOLUME": "ระดับเสียง",
    "CATEGORY_MOTION": "เคลื่อนที่",
    "CATEGORY_LOOKS": "รูปร่าง",
    "CATEGORY_SOUND": "เสียง",
    "CATEGORY_EVENTS": "เหตุการณ์",
    "CATEGORY_CONTROL": "ควบคุม",
    "CATEGORY_SENSING": "ตรวจจับ",
    "CATEGORY_OPERATORS": "ตัวดำเนินการ",
    "CATEGORY_VARIABLES": "ตัวแปร",
    "CATEGORY_MYBLOCKS": "บล็อกของฉัน",
    "DUPLICATE": "ทำซ้ำ",
    "DELETE": "ลบ",
    "ADD_COMMENT": "เพิ่มคำอธิบาย",
    "REMOVE_COMMENT": "ลบคำอธิบาย",
    "DELETE_BLOCK": "ลบบล็อก",
    "DELETE_X_BLOCKS": "ลบ %1 บล็อก",
    "DELETE_ALL_BLOCKS": "ลบทั้งหมด %1 บล็อก?",
    "CLEAN_UP": "จัดระเบียบบล็อก",
    "HELP": "ช่วยเหลือ",
    "UNDO": "ย้อนกลับ",
    "REDO": "ทำซ้ำ",
    "EDIT_PROCEDURE": "แก้ไข",
    "SHOW_PROCEDURE_DEFINITION": "ไปยังตัวกำหนด",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "พูดอะไรสักอย่าง...",
    "COLOUR_HUE_LABEL": "สี",
    "COLOUR_SATURATION_LABEL": "ความอิ่มตัว",
    "COLOUR_BRIGHTNESS_LABEL": "ความสว่าง",
    "CHANGE_VALUE_TITLE": "เปลี่ยนค่า:",
    "RENAME_VARIABLE": "เปลี่ยนชื่อตัวแปร",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "เปลี่ยนชื่อตัวแปร",
    "NEW_VARIABLE": "สร้างตัวแปร",
    "NEW_VARIABLE_TITLE": "ชื่อตัวแปรใหม่:",
    "VARIABLE_MODAL_TITLE": "ตัวแปรใหม่",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "สร้างบล็อกใหม่",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "สร้างรายการ",
    "NEW_LIST_TITLE": "ชื่อรายการ:",
    "LIST_MODAL_TITLE": "รายการใหม่",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "เปลี่ยนชื่อรายการ",
    "NEW_BROADCAST_MESSAGE": "ข้อความใหม่",
    "NEW_BROADCAST_MESSAGE_TITLE": "ชื่อข้อความใหม่:",
    "BROADCAST_MODAL_TITLE": "ข้อความใหม่",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "ข้อความ1"
};

Blockly.ScratchMsgs.locales["tr"] =
{
    "CONTROL_FOREVER": "sürekli tekrarla",
    "CONTROL_REPEAT": "%1 defa tekrarla",
    "CONTROL_IF": "eğer %1 ise",
    "CONTROL_ELSE": "değilse",
    "CONTROL_STOP": "durdur",
    "CONTROL_STOP_ALL": "tümü",
    "CONTROL_STOP_THIS": "bu diziyi",
    "CONTROL_STOP_OTHER": "kuklanın diğer dizilerini",
    "CONTROL_WAIT": "%1 saniye bekle",
    "CONTROL_WAITUNTIL": "%1 olana kadar bekle",
    "CONTROL_REPEATUNTIL": "%1 olana kadar tekrarla",
    "CONTROL_WHILE": "%1 olana kadar tekrarla",
    "CONTROL_FOREACH": "%2 deki her %1 için",
    "CONTROL_STARTASCLONE": "ikiz olarak başladığımda",
    "CONTROL_CREATECLONEOF": "%1'in ikizini yarat",
    "CONTROL_CREATECLONEOF_MYSELF": "kendim",
    "CONTROL_DELETETHISCLONE": "bu ikizi sil",
    "CONTROL_COUNTER": "sayaç",
    "CONTROL_INCRCOUNTER": "sayacı artır",
    "CONTROL_CLEARCOUNTER": "sayacı sıfırla",
    "CONTROL_ALLATONCE": "tümü tek seferde",
    "DATA_SETVARIABLETO": "%1 i %2 ye ayarla",
    "DATA_CHANGEVARIABLEBY": "%1 i %2 kadar değiştir",
    "DATA_SHOWVARIABLE": "%1 değişkenini göster",
    "DATA_HIDEVARIABLE": "%1 değişkenini gizle",
    "DATA_ADDTOLIST": "%1 i %2 ye ekle",
    "DATA_DELETEOFLIST": "%2 nin %1 ini sil",
    "DATA_INSERTATLIST": "%1 i %3 ün %2 pozisyonuna ekle",
    "DATA_REPLACEITEMOFLIST": "%2 öğesinin %1 öğe yerine %3 koy",
    "DATA_ITEMOFLIST": "%2 nin %1 öğesi",
    "DATA_LENGTHOFLIST": "%1'in uzunluğu",
    "DATA_LISTCONTAINSITEM": "%1'de %2 içeriyor mu? ",
    "DATA_SHOWLIST": "%1 listesini göster",
    "DATA_HIDELIST": "%1 listesini gizle",
    "DATA_INDEX_ALL": "tümü",
    "DATA_INDEX_LAST": "son",
    "DATA_INDEX_RANDOM": "rastgele",
    "EVENT_WHENFLAGCLICKED": "%1 tıklandığında",
    "EVENT_WHENTHISSPRITECLICKED": "bu kukla tıklandığında",
    "EVENT_WHENSTAGECLICKED": "sahne tıklandığında",
    "EVENT_WHENTOUCHINGOBJECT": "bu kukla %1 e dokunduğunda",
    "EVENT_WHENBROADCASTRECEIVED": "%1 haberi gelince",
    "EVENT_WHENBACKDROPSWITCHESTO": "dekor %1 olduğunda",
    "EVENT_WHENGREATERTHAN": "%1 > %2 olduğunda",
    "EVENT_WHENGREATERTHAN_TIMER": "kronometre",
    "EVENT_BROADCAST": "%1 haberini sal",
    "EVENT_BROADCASTANDWAIT": "%1 haberini sal ve bekle",
    "EVENT_WHENKEYPRESSED": "%1 tuşuna basılınca",
    "EVENT_WHENKEYPRESSED_SPACE": "boşluk",
    "EVENT_WHENKEYPRESSED_LEFT": "sol ok",
    "EVENT_WHENKEYPRESSED_RIGHT": "sağ ok",
    "EVENT_WHENKEYPRESSED_DOWN": "aşağı ok",
    "EVENT_WHENKEYPRESSED_UP": "yukarı ok",
    "EVENT_WHENKEYPRESSED_ANY": "herhangi",
    "LOOKS_SAYFORSECS": "%2 saniye boyunca %1 de ",
    "LOOKS_SAY": "%1 de",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "%2 saniye boyunca %1 diye düşün",
    "LOOKS_THINK": "%1 diye düşün",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "göster",
    "LOOKS_HIDE": "gizle",
    "LOOKS_HIDEALLSPRITES": "tüm kuklaları gizle",
    "LOOKS_EFFECT_COLOR": "renk",
    "LOOKS_EFFECT_FISHEYE": "balık gözü",
    "LOOKS_EFFECT_WHIRL": "fırılda",
    "LOOKS_EFFECT_PIXELATE": "benekleştir",
    "LOOKS_EFFECT_MOSAIC": "mozaik",
    "LOOKS_EFFECT_BRIGHTNESS": "parlaklık",
    "LOOKS_EFFECT_GHOST": "hayalet",
    "LOOKS_CHANGEEFFECTBY": "%1 etkisini %2 değiştir",
    "LOOKS_SETEFFECTTO": "%1 etkisi %2 olsun",
    "LOOKS_CLEARGRAPHICEFFECTS": "görsel etkileri temizle",
    "LOOKS_CHANGESIZEBY": "boyutu %1 birim büyüt",
    "LOOKS_SETSIZETO": "boyutu %1 % e ayarla",
    "LOOKS_SIZE": "büyüklük",
    "LOOKS_CHANGESTRETCHBY": "esnekliği %1 kadar değiştir",
    "LOOKS_SETSTRETCHTO": "esnekliği %1 e ayarla",
    "LOOKS_SWITCHCOSTUMETO": "%1 kılığına geç",
    "LOOKS_NEXTCOSTUME": "sonraki kostüm",
    "LOOKS_SWITCHBACKDROPTO": "%1 dekoruna geç",
    "LOOKS_GOTOFRONTBACK": "%1 katmanına git",
    "LOOKS_GOTOFRONTBACK_FRONT": "ön",
    "LOOKS_GOTOFRONTBACK_BACK": "arka",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 katmanına git",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "ileri",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "geri",
    "LOOKS_BACKDROPNUMBERNAME": "dekor %1",
    "LOOKS_COSTUMENUMBERNAME": "kostüm %1",
    "LOOKS_NUMBERNAME_NUMBER": "sayı",
    "LOOKS_NUMBERNAME_NAME": "isim",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "%1 dekoruna geç ve bekle",
    "LOOKS_NEXTBACKDROP": "sonraki dekor",
    "LOOKS_PREVIOUSBACKDROP": "önceki dekor",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "%1 adım git",
    "MOTION_TURNLEFT": "%1 %2 derece dön",
    "MOTION_TURNRIGHT": "%1 %2 derece dön",
    "MOTION_POINTINDIRECTION": "%1 yönüne dön",
    "MOTION_POINTTOWARDS": "%1'na doğru dön",
    "MOTION_POINTTOWARDS_POINTER": "fare oku",
    "MOTION_GOTO": "%1'na git",
    "MOTION_GOTO_POINTER": "fare oku",
    "MOTION_GOTO_RANDOM": "rastgele pozisyon",
    "MOTION_GOTOXY": "x: %1 y: %2 konumuna git",
    "MOTION_GLIDESECSTOXY": "%1 sn.de x: %2 y: %3'a süzül",
    "MOTION_GLIDETO": "%1 saniyede %2 noktasına süzül",
    "MOTION_GLIDETO_POINTER": "fare oku",
    "MOTION_GLIDETO_RANDOM": "rastgele konum",
    "MOTION_CHANGEXBY": "x konumunu %1 artır",
    "MOTION_SETX": "x konumunu %1 yap",
    "MOTION_CHANGEYBY": "y konumunu %1 artır",
    "MOTION_SETY": "y konumunu %1 yap",
    "MOTION_IFONEDGEBOUNCE": "kenara geldiyse sektir",
    "MOTION_SETROTATIONSTYLE": "dönüş stilini %1 yap",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "sol-sağ",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "döndürme",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "tüm yönlere",
    "MOTION_XPOSITION": "x konumu",
    "MOTION_YPOSITION": "y konumu",
    "MOTION_DIRECTION": "yön",
    "MOTION_SCROLLRIGHT": "sağa %1 kaydır",
    "MOTION_SCROLLUP": "yukarı %1 kaydır",
    "MOTION_ALIGNSCENE": "%1 görüntüsünü hizala",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "alt-sol",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "alt-sağ",
    "MOTION_ALIGNSCENE_MIDDLE": "orta",
    "MOTION_ALIGNSCENE_TOPLEFT": "sol üst",
    "MOTION_ALIGNSCENE_TOPRIGHT": "sağ üst",
    "MOTION_XSCROLL": "x ekseninde kaydır",
    "MOTION_YSCROLL": "y ekseninde kaydır",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "%1 ile %2 arasında rastgele sayı tut",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 ve %2",
    "OPERATORS_OR": "%1 veya %2",
    "OPERATORS_NOT": "%1 değil",
    "OPERATORS_JOIN": "birleştir %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "%2 in %1. harfi",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "%1'in uzunluğu",
    "OPERATORS_CONTAINS": "%1'de %2 içeriyor mu?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "%1'i yuvarla",
    "OPERATORS_MATHOP": "%2 nin %1 i",
    "OPERATORS_MATHOP_ABS": "mutlak değer",
    "OPERATORS_MATHOP_FLOOR": "aşağı yuvarla",
    "OPERATORS_MATHOP_CEILING": "yukarı yuvarla",
    "OPERATORS_MATHOP_SQRT": "karekök",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "%1 tanımla",
    "SENSING_TOUCHINGOBJECT": "%1'a değdi mi?",
    "SENSING_TOUCHINGOBJECT_POINTER": "fare oku",
    "SENSING_TOUCHINGOBJECT_EDGE": "kenar",
    "SENSING_TOUCHINGCOLOR": "%1 rengine dokundu mu?",
    "SENSING_COLORISTOUCHINGCOLOR": "%1 rengi %2 rengine değdi mi?",
    "SENSING_DISTANCETO": "%1'e mesafe",
    "SENSING_DISTANCETO_POINTER": "fare oku",
    "SENSING_ASKANDWAIT": "%1 diye sor ve bekle",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "cevap",
    "SENSING_KEYPRESSED": "%1 tuşuna basıldı mı?",
    "SENSING_MOUSEDOWN": "fareye basılı mı?",
    "SENSING_MOUSEX": "farenin x'i",
    "SENSING_MOUSEY": "farenin y'si",
    "SENSING_SETDRAGMODE": "sürükleme modunu %1 yap",
    "SENSING_SETDRAGMODE_DRAGGABLE": "sürüklenebilir",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "sürüklenemez",
    "SENSING_LOUDNESS": "ses şiddeti",
    "SENSING_LOUD": "yükses ses?",
    "SENSING_TIMER": "kronometre",
    "SENSING_RESETTIMER": "kronometreyi sıfırla",
    "SENSING_OF": "%2 nin %1 i",
    "SENSING_OF_XPOSITION": "x konumu",
    "SENSING_OF_YPOSITION": "y konumu",
    "SENSING_OF_DIRECTION": "yönü",
    "SENSING_OF_COSTUMENUMBER": "kostüm #",
    "SENSING_OF_COSTUMENAME": "kostüm ismi",
    "SENSING_OF_SIZE": "büyüklük",
    "SENSING_OF_VOLUME": "ses düzeyi",
    "SENSING_OF_BACKDROPNUMBER": "dekor #",
    "SENSING_OF_BACKDROPNAME": "dekorun adı",
    "SENSING_OF_STAGE": "Sahne",
    "SENSING_CURRENT": "şimdiki %1",
    "SENSING_CURRENT_YEAR": "yıl",
    "SENSING_CURRENT_MONTH": "ay",
    "SENSING_CURRENT_DATE": "tarih",
    "SENSING_CURRENT_DAYOFWEEK": "haftanın günü",
    "SENSING_CURRENT_HOUR": "saat",
    "SENSING_CURRENT_MINUTE": "dakika",
    "SENSING_CURRENT_SECOND": "saniye",
    "SENSING_DAYSSINCE2000": "2000'den beri geçen gün",
    "SENSING_USERNAME": "kullanıcı adı",
    "SENSING_USERID": "kullanıcı kimliği",
    "SOUND_PLAY": "%1 sesini çal",
    "SOUND_PLAYUNTILDONE": "%1 sesini bitene kadar çal",
    "SOUND_STOPALLSOUNDS": "tüm sesleri durdur",
    "SOUND_SETEFFECTO": "%1 etkisi %2 olsun",
    "SOUND_CHANGEEFFECTBY": "%1 etkisini %2 artır",
    "SOUND_CLEAREFFECTS": "ses etkilerini temizle",
    "SOUND_EFFECTS_PITCH": "ses perdesi",
    "SOUND_EFFECTS_PAN": "sağa-sola dönebilsin",
    "SOUND_CHANGEVOLUMEBY": "ses şiddetini %1 artır",
    "SOUND_SETVOLUMETO": "ses şiddetini %1% yap",
    "SOUND_VOLUME": "ses düzeyi",
    "CATEGORY_MOTION": "Hareket",
    "CATEGORY_LOOKS": "Görünüm",
    "CATEGORY_SOUND": "Ses",
    "CATEGORY_EVENTS": "Olaylar",
    "CATEGORY_CONTROL": "Kontrol",
    "CATEGORY_SENSING": "Algılama",
    "CATEGORY_OPERATORS": "İşlemler",
    "CATEGORY_VARIABLES": "Değişkenler",
    "CATEGORY_MYBLOCKS": "Bloklarım",
    "DUPLICATE": "Kopyasını çıkart",
    "DELETE": "Sil",
    "ADD_COMMENT": "Yorum Ekle",
    "REMOVE_COMMENT": "Yorumu Sil",
    "DELETE_BLOCK": "Bloğu Sil",
    "DELETE_X_BLOCKS": "%1 bloğu sil",
    "DELETE_ALL_BLOCKS": "Tüm %1 blokları sil",
    "CLEAN_UP": "Blokları düzenle",
    "HELP": "Yardım",
    "UNDO": "Geri Al",
    "REDO": "İleri Al",
    "EDIT_PROCEDURE": "Düzenle",
    "SHOW_PROCEDURE_DEFINITION": "Tanımlamaya git",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Birşey söyle",
    "COLOUR_HUE_LABEL": "Renk",
    "COLOUR_SATURATION_LABEL": "Doygunluk",
    "COLOUR_BRIGHTNESS_LABEL": "Parlaklık",
    "CHANGE_VALUE_TITLE": "Değeri değiştir",
    "RENAME_VARIABLE": "Değişkeni adlandır",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Değişkeni Yeniden Adlandır",
    "NEW_VARIABLE": "Bir Değişken Oluştur",
    "NEW_VARIABLE_TITLE": "Yeni değişken ismi:",
    "VARIABLE_MODAL_TITLE": "Yeni Değişken",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Bir Blok Oluştur",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Bir Liste Oluştur",
    "NEW_LIST_TITLE": "Yeni liste ismi:",
    "LIST_MODAL_TITLE": "Yeni Liste",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Listeyi Adlandır",
    "NEW_BROADCAST_MESSAGE": "Yeni haber",
    "NEW_BROADCAST_MESSAGE_TITLE": "Yeni haber ismi:",
    "BROADCAST_MODAL_TITLE": "Yeni Haber",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "haber1"
};

Blockly.ScratchMsgs.locales["uk"] =
{
    "CONTROL_FOREVER": "завжди",
    "CONTROL_REPEAT": "повторити %1",
    "CONTROL_IF": "якщо %1 то",
    "CONTROL_ELSE": "інакше",
    "CONTROL_STOP": "зупинити",
    "CONTROL_STOP_ALL": "все",
    "CONTROL_STOP_THIS": "цей скрипт",
    "CONTROL_STOP_OTHER": "інші скрипти цього спрайту",
    "CONTROL_WAIT": "чекати %1 секунд",
    "CONTROL_WAITUNTIL": "чекати поки %1",
    "CONTROL_REPEATUNTIL": "повторити поки не %1",
    "CONTROL_WHILE": "поки %1",
    "CONTROL_FOREACH": "для кожного %1 в %2",
    "CONTROL_STARTASCLONE": "коли я починаю як клон",
    "CONTROL_CREATECLONEOF": "створити клон з %1",
    "CONTROL_CREATECLONEOF_MYSELF": "сам",
    "CONTROL_DELETETHISCLONE": "вилучити цей клон",
    "CONTROL_COUNTER": "лічильник",
    "CONTROL_INCRCOUNTER": "збільшити лічильник",
    "CONTROL_CLEARCOUNTER": "очистити лічильник",
    "CONTROL_ALLATONCE": "всі одночасно",
    "DATA_SETVARIABLETO": "задати значення %1 для %2",
    "DATA_CHANGEVARIABLEBY": "змінити %1 на %2",
    "DATA_SHOWVARIABLE": "показати змінну %1",
    "DATA_HIDEVARIABLE": "сховати змінну %1",
    "DATA_ADDTOLIST": "додати %1 до %2",
    "DATA_DELETEOFLIST": "вилучити %1 з %2",
    "DATA_INSERTATLIST": "вставити %1 в %2 з %3",
    "DATA_REPLACEITEMOFLIST": "замінити елемент %1 в %2 на %3",
    "DATA_ITEMOFLIST": "елемент %1 з %2",
    "DATA_LENGTHOFLIST": "довжина %1",
    "DATA_LISTCONTAINSITEM": "%1 містить %2?",
    "DATA_SHOWLIST": "показати список %1",
    "DATA_HIDELIST": "сховати список %1",
    "DATA_INDEX_ALL": "все",
    "DATA_INDEX_LAST": "останні",
    "DATA_INDEX_RANDOM": "випадково",
    "EVENT_WHENFLAGCLICKED": "коли %1 натиснуто",
    "EVENT_WHENTHISSPRITECLICKED": "коли спрайт натиснуто",
    "EVENT_WHENSTAGECLICKED": "коли сцену натиснуто",
    "EVENT_WHENTOUCHINGOBJECT": "коли цей спрай доторкнеться %1",
    "EVENT_WHENBROADCASTRECEIVED": "коли я отримую %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "коли тло змінится на %1",
    "EVENT_WHENGREATERTHAN": "доки %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "таймер",
    "EVENT_BROADCAST": "оповістити %1",
    "EVENT_BROADCASTANDWAIT": "оповістити %1 і чекати",
    "EVENT_WHENKEYPRESSED": "доки клавішу %1 натиснуто ",
    "EVENT_WHENKEYPRESSED_SPACE": "пропуск",
    "EVENT_WHENKEYPRESSED_LEFT": "стрілка ліворуч",
    "EVENT_WHENKEYPRESSED_RIGHT": "стрілка праворуч",
    "EVENT_WHENKEYPRESSED_DOWN": "стрілка вниз",
    "EVENT_WHENKEYPRESSED_UP": "стрілка вгору",
    "EVENT_WHENKEYPRESSED_ANY": "будь-яка",
    "LOOKS_SAYFORSECS": "говорити %1 %2 сек",
    "LOOKS_SAY": "говорити %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "подумати %1 %2 сек",
    "LOOKS_THINK": "подумати %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "показати",
    "LOOKS_HIDE": "сховати",
    "LOOKS_HIDEALLSPRITES": "сховати усі спрайти",
    "LOOKS_EFFECT_COLOR": "колір",
    "LOOKS_EFFECT_FISHEYE": "роздуття",
    "LOOKS_EFFECT_WHIRL": "закручування",
    "LOOKS_EFFECT_PIXELATE": "пікселями",
    "LOOKS_EFFECT_MOSAIC": "мозаїка",
    "LOOKS_EFFECT_BRIGHTNESS": "яскравість",
    "LOOKS_EFFECT_GHOST": "привид",
    "LOOKS_CHANGEEFFECTBY": "змінити ефект %1 на %2",
    "LOOKS_SETEFFECTTO": "встановити ефект %1 в %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "очистити графічні ефекти",
    "LOOKS_CHANGESIZEBY": "змінити розмір на %1",
    "LOOKS_SETSIZETO": "задати розмір %1",
    "LOOKS_SIZE": "розмір",
    "LOOKS_CHANGESTRETCHBY": "змінити розтяг на %1",
    "LOOKS_SETSTRETCHTO": "задати розтяг %1 %",
    "LOOKS_SWITCHCOSTUMETO": "змінити образ на %1",
    "LOOKS_NEXTCOSTUME": "наступний образ",
    "LOOKS_SWITCHBACKDROPTO": "змінити тло на %1",
    "LOOKS_GOTOFRONTBACK": "помістити на %1 план",
    "LOOKS_GOTOFRONTBACK_FRONT": "передній",
    "LOOKS_GOTOFRONTBACK_BACK": "задній",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "перемістити %1 на %2 шар",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "вперед",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "назад",
    "LOOKS_BACKDROPNUMBERNAME": "тло %1",
    "LOOKS_COSTUMENUMBERNAME": "образ %1",
    "LOOKS_NUMBERNAME_NUMBER": "номер",
    "LOOKS_NUMBERNAME_NAME": "назва",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "змінити тло на %1 та чекати",
    "LOOKS_NEXTBACKDROP": "наступне тло",
    "LOOKS_PREVIOUSBACKDROP": "попереднє тло",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "перемістити на %1 кроків",
    "MOTION_TURNLEFT": "поворот %1 на %2 градусів",
    "MOTION_TURNRIGHT": "поворот %1 на %2 градусів",
    "MOTION_POINTINDIRECTION": "повернути в напрямку %1",
    "MOTION_POINTTOWARDS": "слідувати за %1",
    "MOTION_POINTTOWARDS_POINTER": "вказівник",
    "MOTION_GOTO": "перейти до %1",
    "MOTION_GOTO_POINTER": "вказівник",
    "MOTION_GOTO_RANDOM": "випадкова позиція",
    "MOTION_GOTOXY": "перемістити в x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "ковзати %1 сек до x: %2 y: %3",
    "MOTION_GLIDETO": "ковзати %1 сек до %2",
    "MOTION_GLIDETO_POINTER": "вказівник",
    "MOTION_GLIDETO_RANDOM": "випадкова позиція",
    "MOTION_CHANGEXBY": "змінити x на %1",
    "MOTION_SETX": "задати x %1",
    "MOTION_CHANGEYBY": "змінити y на %1",
    "MOTION_SETY": "задати y %1",
    "MOTION_IFONEDGEBOUNCE": "якщо на межі, відбити",
    "MOTION_SETROTATIONSTYLE": "стиль обертання %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "зліва-направо",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "не обертати",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "навколо",
    "MOTION_XPOSITION": "значення x",
    "MOTION_YPOSITION": "значення y",
    "MOTION_DIRECTION": "напрям",
    "MOTION_SCROLLRIGHT": "прокрутити праворуч %1",
    "MOTION_SCROLLUP": "прокрутити вгору %1",
    "MOTION_ALIGNSCENE": "вирівняти сцену %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "внизу-ліворуч",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "вниз-праворуч",
    "MOTION_ALIGNSCENE_MIDDLE": "посередині",
    "MOTION_ALIGNSCENE_TOPLEFT": "зверху-ліворуч",
    "MOTION_ALIGNSCENE_TOPRIGHT": "зверху-праворуч",
    "MOTION_XSCROLL": "x прокрутка",
    "MOTION_YSCROLL": "y прокрутка",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "випадкове від %1 до %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 і %2",
    "OPERATORS_OR": "%1 або %2",
    "OPERATORS_NOT": "не %1",
    "OPERATORS_JOIN": "з'єднати %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "символ %1 у %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "довжина %1",
    "OPERATORS_CONTAINS": "%1 містить %2?",
    "OPERATORS_MOD": "остача %1 на %2",
    "OPERATORS_ROUND": "округлити %1",
    "OPERATORS_MATHOP": "%1 з %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "менше ціле",
    "OPERATORS_MATHOP_CEILING": "більше ціле",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "визначити %1",
    "SENSING_TOUCHINGOBJECT": "доторкається %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "вказівник",
    "SENSING_TOUCHINGOBJECT_EDGE": "межа",
    "SENSING_TOUCHINGCOLOR": "доторкається кольору %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "колір %1 торкається %2?",
    "SENSING_DISTANCETO": "відстань до %1",
    "SENSING_DISTANCETO_POINTER": "вказівник",
    "SENSING_ASKANDWAIT": "запитати %1 і чекати",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "відповідь",
    "SENSING_KEYPRESSED": "клавішу %1 натиснуто?",
    "SENSING_MOUSEDOWN": "мишку натиснуто?",
    "SENSING_MOUSEX": "мишка x",
    "SENSING_MOUSEY": "мишка y",
    "SENSING_SETDRAGMODE": "перетягувати %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "дозволено",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "не дозволено",
    "SENSING_LOUDNESS": "гучність",
    "SENSING_LOUD": "гучно?",
    "SENSING_TIMER": "таймер",
    "SENSING_RESETTIMER": "перезапустити таймер",
    "SENSING_OF": "%1 з %2",
    "SENSING_OF_XPOSITION": "значення x",
    "SENSING_OF_YPOSITION": "значення y",
    "SENSING_OF_DIRECTION": "напрям",
    "SENSING_OF_COSTUMENUMBER": "образ #",
    "SENSING_OF_COSTUMENAME": "ім’я образу",
    "SENSING_OF_SIZE": "розмір",
    "SENSING_OF_VOLUME": "гучність",
    "SENSING_OF_BACKDROPNUMBER": "тло #",
    "SENSING_OF_BACKDROPNAME": "ім’я тла",
    "SENSING_OF_STAGE": "Сцена",
    "SENSING_CURRENT": "сьогодні %1",
    "SENSING_CURRENT_YEAR": "рік",
    "SENSING_CURRENT_MONTH": "місяць",
    "SENSING_CURRENT_DATE": "дата",
    "SENSING_CURRENT_DAYOFWEEK": "день тижня",
    "SENSING_CURRENT_HOUR": "година",
    "SENSING_CURRENT_MINUTE": "хвилина ",
    "SENSING_CURRENT_SECOND": "секунда",
    "SENSING_DAYSSINCE2000": "днів після 2000",
    "SENSING_USERNAME": "користувач",
    "SENSING_USERID": "користувач ID",
    "SOUND_PLAY": "відтворити звук %1",
    "SOUND_PLAYUNTILDONE": "відтворити звук %1 до кінця",
    "SOUND_STOPALLSOUNDS": "зупини всі звуки",
    "SOUND_SETEFFECTO": "встановити ефект %1 в %2",
    "SOUND_CHANGEEFFECTBY": "змінити ефект %1 на %2",
    "SOUND_CLEAREFFECTS": "очистити звукові ефекти",
    "SOUND_EFFECTS_PITCH": "висота",
    "SOUND_EFFECTS_PAN": "панорама",
    "SOUND_CHANGEVOLUMEBY": "змінити гучність на %1",
    "SOUND_SETVOLUMETO": "встановити гучність %1%",
    "SOUND_VOLUME": "гучність",
    "CATEGORY_MOTION": "Рух",
    "CATEGORY_LOOKS": "Вигляд",
    "CATEGORY_SOUND": "Звук",
    "CATEGORY_EVENTS": "Події",
    "CATEGORY_CONTROL": "Керувати",
    "CATEGORY_SENSING": "Датчики",
    "CATEGORY_OPERATORS": "Оператори",
    "CATEGORY_VARIABLES": "Змінні",
    "CATEGORY_MYBLOCKS": "Мої блоки",
    "DUPLICATE": "Дублювати",
    "DELETE": "Вилучити",
    "ADD_COMMENT": "Додати коментар",
    "REMOVE_COMMENT": "Вилучити коментар",
    "DELETE_BLOCK": "Вилучити блок",
    "DELETE_X_BLOCKS": "Вилучити %1 блоки",
    "DELETE_ALL_BLOCKS": "Вилучити всі %1 блоки?",
    "CLEAN_UP": "Впорядкувати блоки",
    "HELP": "Допомога",
    "UNDO": "Скасувати",
    "REDO": "Повернути",
    "EDIT_PROCEDURE": "Правка",
    "SHOW_PROCEDURE_DEFINITION": "Перейти до визначення",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Скажіть щось...",
    "COLOUR_HUE_LABEL": "Колір",
    "COLOUR_SATURATION_LABEL": "Насиченість",
    "COLOUR_BRIGHTNESS_LABEL": "Яскравість",
    "CHANGE_VALUE_TITLE": "Змінити значення:",
    "RENAME_VARIABLE": "Перейменувати змінну",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Перейменувати змінну",
    "NEW_VARIABLE": "Створити змінну",
    "NEW_VARIABLE_TITLE": "Нове ім'я змінної:",
    "VARIABLE_MODAL_TITLE": "Нова змінна",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Створити блок",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Створити список",
    "NEW_LIST_TITLE": "Нове ім’я списку:",
    "LIST_MODAL_TITLE": "Новий список",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Перейменувати список",
    "NEW_BROADCAST_MESSAGE": "Нове повідомлення",
    "NEW_BROADCAST_MESSAGE_TITLE": "Нове ім’я повідомлення:",
    "BROADCAST_MODAL_TITLE": "Нове повідомлення",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "повідомлення1"
};

Blockly.ScratchMsgs.locales["vi"] =
{
    "CONTROL_FOREVER": "mãi mãi",
    "CONTROL_REPEAT": "lặp lại %1",
    "CONTROL_IF": "nếu %1 thì",
    "CONTROL_ELSE": "nếu không thì ",
    "CONTROL_STOP": "dừng lại",
    "CONTROL_STOP_ALL": "tất cả",
    "CONTROL_STOP_THIS": "kịch bản này",
    "CONTROL_STOP_OTHER": "các kịch bản khác cho đối tượng ",
    "CONTROL_WAIT": "đợi %1 giây",
    "CONTROL_WAITUNTIL": "đợi đến khi %1",
    "CONTROL_REPEATUNTIL": "lặp lại cho đến khi %1",
    "CONTROL_WHILE": "trong khi %1",
    "CONTROL_FOREACH": "với mỗi %1 trong %2",
    "CONTROL_STARTASCLONE": "khi tôi bắt đầu là một bản sao",
    "CONTROL_CREATECLONEOF": "tạo bản sao của %1",
    "CONTROL_CREATECLONEOF_MYSELF": "bản thân tôi",
    "CONTROL_DELETETHISCLONE": "xóa bản sao này",
    "CONTROL_COUNTER": "bộ đếm",
    "CONTROL_INCRCOUNTER": "bộ đếm tăng dần",
    "CONTROL_CLEARCOUNTER": "xóa bộ đếm",
    "CONTROL_ALLATONCE": "tất cả cùng một lúc",
    "DATA_SETVARIABLETO": "đặt %1 thành %2",
    "DATA_CHANGEVARIABLEBY": "đổi %1 thành %2",
    "DATA_SHOWVARIABLE": "hiện biến số %1",
    "DATA_HIDEVARIABLE": "ẩn biến số %1",
    "DATA_ADDTOLIST": "thêm %1 vào %2",
    "DATA_DELETEOFLIST": "xóa %1 từ %2",
    "DATA_INSERTATLIST": "chèn %1 tại %2 của %3",
    "DATA_REPLACEITEMOFLIST": "thay phần tử %1 của %2 bằng %3",
    "DATA_ITEMOFLIST": "phần tử %1 của %2",
    "DATA_LENGTHOFLIST": "độ dày của %1",
    "DATA_LISTCONTAINSITEM": "%1 chứa %2?",
    "DATA_SHOWLIST": "hiện danh sách %1",
    "DATA_HIDELIST": "ăn danh sách %1",
    "DATA_INDEX_ALL": "tất cả",
    "DATA_INDEX_LAST": "cuối cùng",
    "DATA_INDEX_RANDOM": "ngẫu nhiên",
    "EVENT_WHENFLAGCLICKED": "Khi bấm vào %1",
    "EVENT_WHENTHISSPRITECLICKED": "Khi bấm vào đối tượng này",
    "EVENT_WHENSTAGECLICKED": "khi bấm vào phông nền",
    "EVENT_WHENTOUCHINGOBJECT": "Khi đối tượng này chạm vào %1",
    "EVENT_WHENBROADCASTRECEIVED": "khi tôi nhận %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "khi phông nền chuyển thành %1",
    "EVENT_WHENGREATERTHAN": "khi %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "đồng hồ bấm giờ",
    "EVENT_BROADCAST": "phát tin %1",
    "EVENT_BROADCASTANDWAIT": "phát tin %1 và đợi",
    "EVENT_WHENKEYPRESSED": "khi bấm phím %1",
    "EVENT_WHENKEYPRESSED_SPACE": "khoảng cách",
    "EVENT_WHENKEYPRESSED_LEFT": "mũi tên bên trái",
    "EVENT_WHENKEYPRESSED_RIGHT": "mũi tên sang phải",
    "EVENT_WHENKEYPRESSED_DOWN": "mũi tên xuống",
    "EVENT_WHENKEYPRESSED_UP": "mũi tên lên",
    "EVENT_WHENKEYPRESSED_ANY": "bất kỳ",
    "LOOKS_SAYFORSECS": "nói %1 trong %2 giây",
    "LOOKS_SAY": "nói %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "nghĩ %1 trong %2 giây",
    "LOOKS_THINK": "nghĩ %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "hiển thị",
    "LOOKS_HIDE": "ẩn",
    "LOOKS_HIDEALLSPRITES": "ẩn tất cả đối tượng",
    "LOOKS_EFFECT_COLOR": "màu",
    "LOOKS_EFFECT_FISHEYE": "gương cầu",
    "LOOKS_EFFECT_WHIRL": "xoay",
    "LOOKS_EFFECT_PIXELATE": "nhòe",
    "LOOKS_EFFECT_MOSAIC": "khảm",
    "LOOKS_EFFECT_BRIGHTNESS": "độ sáng",
    "LOOKS_EFFECT_GHOST": "bóng ma",
    "LOOKS_CHANGEEFFECTBY": "đổi hiệu ứng %1 thành %2",
    "LOOKS_SETEFFECTTO": "đặt hiệu ứng %1 thành %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "bỏ các hiệu ứng đồ họa",
    "LOOKS_CHANGESIZEBY": "đổi kích thước thành %1",
    "LOOKS_SETSIZETO": "đặt kích thước bằng %1 %",
    "LOOKS_SIZE": "kích thước",
    "LOOKS_CHANGESTRETCHBY": "đổi kéo căng bằng %1",
    "LOOKS_SETSTRETCHTO": "đặt kéo căng thành %1 %",
    "LOOKS_SWITCHCOSTUMETO": "đổi trang phục thành %1",
    "LOOKS_NEXTCOSTUME": "trang phục kế tiếp",
    "LOOKS_SWITCHBACKDROPTO": "đổi phông nền thành %1",
    "LOOKS_GOTOFRONTBACK": "đi tới layer %1",
    "LOOKS_GOTOFRONTBACK_FRONT": "mặt trước",
    "LOOKS_GOTOFRONTBACK_BACK": "mặt sau",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "đi %1 %2 lớp",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "tới",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "lùi",
    "LOOKS_BACKDROPNUMBERNAME": "phông nền %1",
    "LOOKS_COSTUMENUMBERNAME": "trang phục %1",
    "LOOKS_NUMBERNAME_NUMBER": "số",
    "LOOKS_NUMBERNAME_NAME": "tên",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "đổi phông nền thành %1 và đợi",
    "LOOKS_NEXTBACKDROP": "phông nền tiếp theo",
    "LOOKS_PREVIOUSBACKDROP": "phông nền trước",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "di chuyển %1 bước",
    "MOTION_TURNLEFT": "xoay %1 %2 độ",
    "MOTION_TURNRIGHT": "xoay %1 %2 độ",
    "MOTION_POINTINDIRECTION": "hướng về phía %1",
    "MOTION_POINTTOWARDS": "hướng về %1",
    "MOTION_POINTTOWARDS_POINTER": "con trỏ chuột",
    "MOTION_GOTO": "đi tới %1",
    "MOTION_GOTO_POINTER": "con trỏ chuột",
    "MOTION_GOTO_RANDOM": "vị trí ngẫu nhiên",
    "MOTION_GOTOXY": "đi tới điểm x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "lướt trong %1 giây tới điểm x: %2 y: %3",
    "MOTION_GLIDETO": "lướt trong %1 giây tới %2",
    "MOTION_GLIDETO_POINTER": "con trỏ chuột",
    "MOTION_GLIDETO_RANDOM": "vị trí ngẫu nhiên",
    "MOTION_CHANGEXBY": "đổi x bằng %1",
    "MOTION_SETX": "đặt x bằng %1",
    "MOTION_CHANGEYBY": "đổi y bằng %1",
    "MOTION_SETY": "đặt y bằng %1",
    "MOTION_IFONEDGEBOUNCE": "nếu tiếp xúc với cạnh, bật lại",
    "MOTION_SETROTATIONSTYLE": "đặt kiểu xoay %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "trái - phải",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "không xoay",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "tất cả xung quanh",
    "MOTION_XPOSITION": "hoành độ",
    "MOTION_YPOSITION": "tung độ",
    "MOTION_DIRECTION": "hướng",
    "MOTION_SCROLLRIGHT": "cuộn phải %1",
    "MOTION_SCROLLUP": "cuộn lên %1",
    "MOTION_ALIGNSCENE": "căn chỉnh phân cảnh %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "góc trái dưới",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "góc phải dưới",
    "MOTION_ALIGNSCENE_MIDDLE": "giữa",
    "MOTION_ALIGNSCENE_TOPLEFT": "góc trái trên",
    "MOTION_ALIGNSCENE_TOPRIGHT": "góc phải trên",
    "MOTION_XSCROLL": "cuộn x",
    "MOTION_YSCROLL": "cuộn y",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "lấy ngẫu nhiên từ %1 đến %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 và %2",
    "OPERATORS_OR": "%1 hoặc %2",
    "OPERATORS_NOT": "không phải %1",
    "OPERATORS_JOIN": "kết hợp %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "ký tự %1 của %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "độ dài của %1",
    "OPERATORS_CONTAINS": "%1 chứa %2?",
    "OPERATORS_MOD": "%1 chia lấy dư %2",
    "OPERATORS_ROUND": "làm tròn %1",
    "OPERATORS_MATHOP": "%1 của %2",
    "OPERATORS_MATHOP_ABS": "giá trị tuyệt đối",
    "OPERATORS_MATHOP_FLOOR": "làm tròn xuống",
    "OPERATORS_MATHOP_CEILING": "trần",
    "OPERATORS_MATHOP_SQRT": "căn bậc hai",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "trong",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "định nghĩa %1",
    "SENSING_TOUCHINGOBJECT": "đang chạm %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "con trỏ chuột",
    "SENSING_TOUCHINGOBJECT_EDGE": "cạnh",
    "SENSING_TOUCHINGCOLOR": "đang chạm màu %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "màu %1 đang chạm %2?",
    "SENSING_DISTANCETO": "khoảng cách đến %1",
    "SENSING_DISTANCETO_POINTER": "con trỏ chuột",
    "SENSING_ASKANDWAIT": "hỏi %1 và đợi",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "trả lời",
    "SENSING_KEYPRESSED": "phím %1 được bấm?",
    "SENSING_MOUSEDOWN": "chuột được nhấn?",
    "SENSING_MOUSEX": "hoành độ con trỏ chuột",
    "SENSING_MOUSEY": "tung độ con trỏ chuột",
    "SENSING_SETDRAGMODE": "đặt chế độ kéo %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "kéo thả được",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "không kéo thả được",
    "SENSING_LOUDNESS": "độ ồn",
    "SENSING_LOUD": "tiếng to?",
    "SENSING_TIMER": "đồng hồ bấm giờ",
    "SENSING_RESETTIMER": "đặt lại đống hồ bấm giờ",
    "SENSING_OF": "%1 của %2",
    "SENSING_OF_XPOSITION": "hoành độ",
    "SENSING_OF_YPOSITION": "tung độ",
    "SENSING_OF_DIRECTION": "hướng",
    "SENSING_OF_COSTUMENUMBER": "trang phục #",
    "SENSING_OF_COSTUMENAME": "tên trang phục",
    "SENSING_OF_SIZE": "kích thước",
    "SENSING_OF_VOLUME": "âm lượng",
    "SENSING_OF_BACKDROPNUMBER": "phông nền #",
    "SENSING_OF_BACKDROPNAME": "tên phông nền",
    "SENSING_OF_STAGE": "Sân khấu",
    "SENSING_CURRENT": "dòng %1",
    "SENSING_CURRENT_YEAR": "năm",
    "SENSING_CURRENT_MONTH": "tháng",
    "SENSING_CURRENT_DATE": "ngày",
    "SENSING_CURRENT_DAYOFWEEK": "ngày trong tuần",
    "SENSING_CURRENT_HOUR": "giờ",
    "SENSING_CURRENT_MINUTE": "phút",
    "SENSING_CURRENT_SECOND": "giây",
    "SENSING_DAYSSINCE2000": "ngày từ năm 2000",
    "SENSING_USERNAME": "tên đăng nhập",
    "SENSING_USERID": "id người dùng",
    "SOUND_PLAY": "bắt đầu âm thanh %1",
    "SOUND_PLAYUNTILDONE": "phát âm thanh %1 đến hết",
    "SOUND_STOPALLSOUNDS": "ngừng mọi âm thanh",
    "SOUND_SETEFFECTO": "đặt hiệu ứng %1 là %2",
    "SOUND_CHANGEEFFECTBY": "đổi hiệu ứng %1 bằng %2",
    "SOUND_CLEAREFFECTS": "xóa hiệu ứng âm thanh",
    "SOUND_EFFECTS_PITCH": "cao độ",
    "SOUND_EFFECTS_PAN": "pan trái/phải",
    "SOUND_CHANGEVOLUMEBY": "đổi âm lượng %1",
    "SOUND_SETVOLUMETO": "đặt âm lượng %1%",
    "SOUND_VOLUME": "âm lượng",
    "CATEGORY_MOTION": "Chuyển động",
    "CATEGORY_LOOKS": "Hiển thị",
    "CATEGORY_SOUND": "Âm thanh",
    "CATEGORY_EVENTS": "Sự kiện",
    "CATEGORY_CONTROL": "Điều khiển",
    "CATEGORY_SENSING": "Cảm biến",
    "CATEGORY_OPERATORS": "Các phép toán",
    "CATEGORY_VARIABLES": "Các biến số",
    "CATEGORY_MYBLOCKS": "My Blocks",
    "DUPLICATE": "Nhân bản",
    "DELETE": "Xóa",
    "ADD_COMMENT": "Thêm chú thích",
    "REMOVE_COMMENT": "Xóa chú thích",
    "DELETE_BLOCK": "Xóa khối",
    "DELETE_X_BLOCKS": "Xóa %1 khối",
    "DELETE_ALL_BLOCKS": "Delete all %1 blocks?",
    "CLEAN_UP": "Clean up Blocks",
    "HELP": "Trợ giúp",
    "UNDO": "Hoàn tác",
    "REDO": "Làm lại ",
    "EDIT_PROCEDURE": "Chỉnh sửa",
    "SHOW_PROCEDURE_DEFINITION": "Go to definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Nói gì đó...",
    "COLOUR_HUE_LABEL": "Màu sắc",
    "COLOUR_SATURATION_LABEL": "Độ bão hòa",
    "COLOUR_BRIGHTNESS_LABEL": "Độ sáng",
    "CHANGE_VALUE_TITLE": "Thay đổi giá trị:",
    "RENAME_VARIABLE": "Đặt tên cho biến",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Đặt tên biến",
    "NEW_VARIABLE": "Tạo một biến",
    "NEW_VARIABLE_TITLE": "Tên biến mới:",
    "VARIABLE_MODAL_TITLE": "Biến số mới",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Tạo một mảnh ghép",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "Tạo một Danh sách",
    "NEW_LIST_TITLE": "Tên danh sách mới:",
    "LIST_MODAL_TITLE": "Danh sách mới",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Đặt tên danh sách",
    "NEW_BROADCAST_MESSAGE": "Thông báo mới",
    "NEW_BROADCAST_MESSAGE_TITLE": "Tên thông báo mới:",
    "BROADCAST_MODAL_TITLE": "Tin nhắn mới",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "tin nhắn 1"
};

Blockly.ScratchMsgs.locales["zh-cn"] =
{
    "CONTROL_FOREVER": "重复执行",
    "CONTROL_REPEAT": "重复执行 %1 次",
    "CONTROL_IF": "如果 %1 那么",
    "CONTROL_ELSE": "否则",
    "CONTROL_STOP": "停止",
    "CONTROL_STOP_ALL": "全部脚本",
    "CONTROL_STOP_THIS": "这个脚本",
    "CONTROL_STOP_OTHER": "该角色的其他脚本",
    "CONTROL_WAIT": "等待 %1 秒",
    "CONTROL_WAITUNTIL": "等待 %1",
    "CONTROL_REPEATUNTIL": "重复执行直到 %1",
    "CONTROL_WHILE": "当 %1 重复执行",
    "CONTROL_FOREACH": "对于 %2 中的每个 %1",
    "CONTROL_STARTASCLONE": "当作为克隆体启动时",
    "CONTROL_CREATECLONEOF": "克隆 %1",
    "CONTROL_CREATECLONEOF_MYSELF": "自己",
    "CONTROL_DELETETHISCLONE": "删除此克隆体",
    "CONTROL_COUNTER": "计数器",
    "CONTROL_INCRCOUNTER": "计数器加一",
    "CONTROL_CLEARCOUNTER": "计数器归零",
    "CONTROL_ALLATONCE": "所有脚本",
    "DATA_SETVARIABLETO": "将 %1 设为 %2",
    "DATA_CHANGEVARIABLEBY": "将 %1 增加 %2",
    "DATA_SHOWVARIABLE": "显示变量 %1",
    "DATA_HIDEVARIABLE": "隐藏变量 %1",
    "DATA_ADDTOLIST": "将 %1 加入 %2",
    "DATA_DELETEOFLIST": "删除 %2 的第 %1 项",
    "DATA_INSERTATLIST": "在 %3 的第 %2 项插入 %1",
    "DATA_REPLACEITEMOFLIST": "将 %2 的第 %1 项替换为 %3",
    "DATA_ITEMOFLIST": "%2 的第 %1 项",
    "DATA_LENGTHOFLIST": "%1 的项目数",
    "DATA_LISTCONTAINSITEM": "%1 包含 %2 ?",
    "DATA_SHOWLIST": "显示列表 %1",
    "DATA_HIDELIST": "隐藏列表 %1",
    "DATA_INDEX_ALL": "全部",
    "DATA_INDEX_LAST": "末尾",
    "DATA_INDEX_RANDOM": "随机",
    "EVENT_WHENFLAGCLICKED": "当 %1 被点击",
    "EVENT_WHENTHISSPRITECLICKED": "当角色被点击",
    "EVENT_WHENSTAGECLICKED": "当舞台被点击",
    "EVENT_WHENTOUCHINGOBJECT": "当该角色碰到 %1",
    "EVENT_WHENBROADCASTRECEIVED": "当接收到 %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "当背景换成 %1",
    "EVENT_WHENGREATERTHAN": "当 %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "计时器",
    "EVENT_BROADCAST": "广播 %1",
    "EVENT_BROADCASTANDWAIT": "广播 %1 并等待",
    "EVENT_WHENKEYPRESSED": "当按下 %1 键",
    "EVENT_WHENKEYPRESSED_SPACE": "空格",
    "EVENT_WHENKEYPRESSED_LEFT": "←",
    "EVENT_WHENKEYPRESSED_RIGHT": "→",
    "EVENT_WHENKEYPRESSED_DOWN": "↓",
    "EVENT_WHENKEYPRESSED_UP": "↑",
    "EVENT_WHENKEYPRESSED_ANY": "任意",
    "LOOKS_SAYFORSECS": "说 %1 %2 秒",
    "LOOKS_SAY": "说 %1",
    "LOOKS_HELLO": "你好！",
    "LOOKS_THINKFORSECS": "思考 %1 %2 秒",
    "LOOKS_THINK": "思考 %1",
    "LOOKS_HMM": "嗯……",
    "LOOKS_SHOW": "显示",
    "LOOKS_HIDE": "隐藏",
    "LOOKS_HIDEALLSPRITES": "隐藏所有角色",
    "LOOKS_EFFECT_COLOR": "颜色",
    "LOOKS_EFFECT_FISHEYE": "鱼眼",
    "LOOKS_EFFECT_WHIRL": "漩涡",
    "LOOKS_EFFECT_PIXELATE": "像素化",
    "LOOKS_EFFECT_MOSAIC": "马赛克",
    "LOOKS_EFFECT_BRIGHTNESS": "亮度",
    "LOOKS_EFFECT_GHOST": "虚像",
    "LOOKS_CHANGEEFFECTBY": "将 %1 特效增加 %2",
    "LOOKS_SETEFFECTTO": "将 %1 特效设定为 %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "清除图形特效",
    "LOOKS_CHANGESIZEBY": "将大小增加 %1",
    "LOOKS_SETSIZETO": "将大小设为 %1",
    "LOOKS_SIZE": "大小",
    "LOOKS_CHANGESTRETCHBY": "伸缩%1",
    "LOOKS_SETSTRETCHTO": "设置伸缩为%1 %",
    "LOOKS_SWITCHCOSTUMETO": "换成 %1 造型",
    "LOOKS_NEXTCOSTUME": "下一个造型",
    "LOOKS_SWITCHBACKDROPTO": "换成 %1 背景",
    "LOOKS_GOTOFRONTBACK": "移到最 %1 ",
    "LOOKS_GOTOFRONTBACK_FRONT": "前面",
    "LOOKS_GOTOFRONTBACK_BACK": "后面",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 层",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "前移",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "后移",
    "LOOKS_BACKDROPNUMBERNAME": "背景 %1",
    "LOOKS_COSTUMENUMBERNAME": "造型 %1",
    "LOOKS_NUMBERNAME_NUMBER": "编号",
    "LOOKS_NUMBERNAME_NAME": "名称",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "换成 %1 背景并等待",
    "LOOKS_NEXTBACKDROP": "下一个背景",
    "LOOKS_PREVIOUSBACKDROP": "上一个背景",
    "LOOKS_RANDOMBACKDROP": "随机背景",
    "MOTION_MOVESTEPS": "移动 %1 步",
    "MOTION_TURNLEFT": "左转 %1 %2 度",
    "MOTION_TURNRIGHT": "右转 %1 %2 度",
    "MOTION_POINTINDIRECTION": "面向 %1 方向",
    "MOTION_POINTTOWARDS": "面向 %1",
    "MOTION_POINTTOWARDS_POINTER": "鼠标指针",
    "MOTION_GOTO": "移到 %1",
    "MOTION_GOTO_POINTER": "鼠标指针",
    "MOTION_GOTO_RANDOM": "随机位置",
    "MOTION_GOTOXY": "移到x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "在 %1 秒内滑行到x: %2 y: %3",
    "MOTION_GLIDETO": "在 %1 秒内滑行到 %2",
    "MOTION_GLIDETO_POINTER": "鼠标指针",
    "MOTION_GLIDETO_RANDOM": "随机位置",
    "MOTION_CHANGEXBY": "将x坐标增加 %1",
    "MOTION_SETX": "将x坐标设为 %1",
    "MOTION_CHANGEYBY": "将y坐标增加 %1",
    "MOTION_SETY": "将y坐标设为 %1",
    "MOTION_IFONEDGEBOUNCE": "碰到边缘就反弹",
    "MOTION_SETROTATIONSTYLE": "将旋转方式设为 %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "左右翻转",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "不可旋转",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "任意旋转",
    "MOTION_XPOSITION": "x 坐标",
    "MOTION_YPOSITION": "y 坐标",
    "MOTION_DIRECTION": "方向",
    "MOTION_SCROLLRIGHT": "向右滚动到 %1 的位置",
    "MOTION_SCROLLUP": "向上滚动到 %1 的位置",
    "MOTION_ALIGNSCENE": "和场景 %1 对齐",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "左下角",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "右下角",
    "MOTION_ALIGNSCENE_MIDDLE": "中间",
    "MOTION_ALIGNSCENE_TOPLEFT": "左上角",
    "MOTION_ALIGNSCENE_TOPRIGHT": "右上角",
    "MOTION_XSCROLL": "x滚动位置",
    "MOTION_YSCROLL": "y滚动位置",
    "MOTION_STAGE_SELECTED": "选中了舞台：不可使用运动类积木",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "在 %1 和 %2 之间取随机数",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 和 %2",
    "OPERATORS_OR": "%1 或 %2",
    "OPERATORS_NOT": "%1 不成立",
    "OPERATORS_JOIN": "连接 %1 和 %2",
    "OPERATORS_JOIN_APPLE": "苹果",
    "OPERATORS_JOIN_BANANA": "香蕉",
    "OPERATORS_LETTEROF": "%2 的第 %1 个字符",
    "OPERATORS_LETTEROF_APPLE": "果",
    "OPERATORS_LENGTH": "%1 的字符数",
    "OPERATORS_CONTAINS": "%1 包含 %2 ?",
    "OPERATORS_MOD": "%1 除以 %2 的余数",
    "OPERATORS_ROUND": "四舍五入 %1",
    "OPERATORS_MATHOP": "%1 %2",
    "OPERATORS_MATHOP_ABS": "绝对值",
    "OPERATORS_MATHOP_FLOOR": "向下取整",
    "OPERATORS_MATHOP_CEILING": "向上取整",
    "OPERATORS_MATHOP_SQRT": "平方根",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "定义 %1",
    "SENSING_TOUCHINGOBJECT": "碰到 %1 ?",
    "SENSING_TOUCHINGOBJECT_POINTER": "鼠标指针",
    "SENSING_TOUCHINGOBJECT_EDGE": "舞台边缘",
    "SENSING_TOUCHINGCOLOR": "碰到颜色 %1 ?",
    "SENSING_COLORISTOUCHINGCOLOR": "颜色 %1 碰到 %2 ?",
    "SENSING_DISTANCETO": "到 %1 的距离",
    "SENSING_DISTANCETO_POINTER": "鼠标指针",
    "SENSING_ASKANDWAIT": "询问 %1 并等待",
    "SENSING_ASK_TEXT": "你叫什么名字？",
    "SENSING_ANSWER": "回答",
    "SENSING_KEYPRESSED": "按下 %1 键?",
    "SENSING_MOUSEDOWN": "按下鼠标?",
    "SENSING_MOUSEX": "鼠标的x坐标",
    "SENSING_MOUSEY": "鼠标的y坐标",
    "SENSING_SETDRAGMODE": "将拖动模式设为 %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "可拖动",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "不可拖动",
    "SENSING_LOUDNESS": "响度",
    "SENSING_LOUD": "响声？",
    "SENSING_TIMER": "计时器",
    "SENSING_RESETTIMER": "计时器归零",
    "SENSING_OF": "%2 的 %1",
    "SENSING_OF_XPOSITION": "x 坐标",
    "SENSING_OF_YPOSITION": "y 坐标",
    "SENSING_OF_DIRECTION": "方向",
    "SENSING_OF_COSTUMENUMBER": "造型编号",
    "SENSING_OF_COSTUMENAME": "造型名称",
    "SENSING_OF_SIZE": "大小",
    "SENSING_OF_VOLUME": "音量",
    "SENSING_OF_BACKDROPNUMBER": "背景编号",
    "SENSING_OF_BACKDROPNAME": "背景名称",
    "SENSING_OF_STAGE": "舞台",
    "SENSING_CURRENT": "当前时间的 %1",
    "SENSING_CURRENT_YEAR": "年",
    "SENSING_CURRENT_MONTH": "月",
    "SENSING_CURRENT_DATE": "日",
    "SENSING_CURRENT_DAYOFWEEK": "星期",
    "SENSING_CURRENT_HOUR": "时",
    "SENSING_CURRENT_MINUTE": "分",
    "SENSING_CURRENT_SECOND": "秒",
    "SENSING_DAYSSINCE2000": "2000年至今的天数",
    "SENSING_USERNAME": "用户名",
    "SENSING_USERID": "用户id",
    "SOUND_PLAY": "播放声音 %1",
    "SOUND_PLAYUNTILDONE": "播放声音 %1 等待播完",
    "SOUND_STOPALLSOUNDS": "停止所有声音",
    "SOUND_SETEFFECTO": "将 %1 音效设为 %2",
    "SOUND_CHANGEEFFECTBY": "将 %1 音效增加 %2",
    "SOUND_CLEAREFFECTS": "停止播放所有声音",
    "SOUND_EFFECTS_PITCH": "音调",
    "SOUND_EFFECTS_PAN": "左右平衡",
    "SOUND_CHANGEVOLUMEBY": "将音量增加 %1",
    "SOUND_SETVOLUMETO": "将音量设为 %1%",
    "SOUND_VOLUME": "音量",
    "CATEGORY_MOTION": "运动",
    "CATEGORY_LOOKS": "外观",
    "CATEGORY_SOUND": "声音",
    "CATEGORY_EVENTS": "事件",
    "CATEGORY_CONTROL": "控制",
    "CATEGORY_SENSING": "侦测",
    "CATEGORY_OPERATORS": "运算",
    "CATEGORY_VARIABLES": "变量",
    "CATEGORY_MYBLOCKS": "自定义积木",
    "DUPLICATE": "复制",
    "DELETE": "删除",
    "ADD_COMMENT": "添加注释",
    "REMOVE_COMMENT": "删除注释",
    "DELETE_BLOCK": "删除",
    "DELETE_X_BLOCKS": "删除 %1 积木",
    "DELETE_ALL_BLOCKS": "删除全部 %1 积木？",
    "CLEAN_UP": "整理积木",
    "HELP": "帮助",
    "UNDO": "撤销",
    "REDO": "重做",
    "EDIT_PROCEDURE": "编辑",
    "SHOW_PROCEDURE_DEFINITION": "查看定义",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "说些什么……",
    "COLOUR_HUE_LABEL": "颜色",
    "COLOUR_SATURATION_LABEL": "饱和度",
    "COLOUR_BRIGHTNESS_LABEL": "亮度",
    "CHANGE_VALUE_TITLE": "更改变量：",
    "RENAME_VARIABLE": "修改变量名",
    "RENAME_VARIABLE_TITLE": "将所有的「%1」变量名改为：",
    "RENAME_VARIABLE_MODAL_TITLE": "修改变量名",
    "NEW_VARIABLE": "建立一个变量",
    "NEW_VARIABLE_TITLE": "新变量名：",
    "VARIABLE_MODAL_TITLE": "新建变量",
    "VARIABLE_ALREADY_EXISTS": "已经存在名为「%1」的变量。",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "已经存在一个名为「%1」的变量，其类型为「%2」。",
    "DELETE_VARIABLE_CONFIRMATION": "删除%1处「%2」变量吗？",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "无法删除变量「%1」，因为函数「%2」的定义中用到了它",
    "DELETE_VARIABLE": "删除变量「%1」",
    "NEW_PROCEDURE": "制作新的积木",
    "PROCEDURE_ALREADY_EXISTS": "已经存在名为「%1」的程序。",
    "NEW_LIST": "建立一个列表",
    "NEW_LIST_TITLE": "新的列表名：",
    "LIST_MODAL_TITLE": "新建列表",
    "LIST_ALREADY_EXISTS": "名为 「%1」 的列表已存在。",
    "RENAME_LIST_TITLE": "将所有的「%1」的列表名改为：",
    "RENAME_LIST_MODAL_TITLE": "修改列表名",
    "NEW_BROADCAST_MESSAGE": "新消息",
    "NEW_BROADCAST_MESSAGE_TITLE": "新消息的名称：",
    "BROADCAST_MODAL_TITLE": "新消息",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "消息1"
};

Blockly.ScratchMsgs.locales["zh-tw"] =
{
    "CONTROL_FOREVER": "重複無限次",
    "CONTROL_REPEAT": "重複 %1 次",
    "CONTROL_IF": "如果 %1 那麼",
    "CONTROL_ELSE": "否則",
    "CONTROL_STOP": "停止",
    "CONTROL_STOP_ALL": "全部",
    "CONTROL_STOP_THIS": "這個程式",
    "CONTROL_STOP_OTHER": "角色的其它程式",
    "CONTROL_WAIT": "等待 %1 秒",
    "CONTROL_WAITUNTIL": "等待直到 %1",
    "CONTROL_REPEATUNTIL": "重複直到 %1",
    "CONTROL_WHILE": "當 %1",
    "CONTROL_FOREACH": "計數 %1 於 %2",
    "CONTROL_STARTASCLONE": "當分身產生",
    "CONTROL_CREATECLONEOF": "建立 %1 的分身",
    "CONTROL_CREATECLONEOF_MYSELF": "自己",
    "CONTROL_DELETETHISCLONE": "分身刪除",
    "CONTROL_COUNTER": "計數器",
    "CONTROL_INCRCOUNTER": "計數器累計",
    "CONTROL_CLEARCOUNTER": "計數器重置",
    "CONTROL_ALLATONCE": "全部一起",
    "DATA_SETVARIABLETO": "%1 設為 %2",
    "DATA_CHANGEVARIABLEBY": "%1 改變 %2",
    "DATA_SHOWVARIABLE": "變數 %1 顯示",
    "DATA_HIDEVARIABLE": "變數 %1 隱藏",
    "DATA_ADDTOLIST": "添加 %1 到 %2",
    "DATA_DELETEOFLIST": "刪除 %2 的第 %1 項",
    "DATA_INSERTATLIST": "插入 %1 到 %3 的第 %2 項",
    "DATA_REPLACEITEMOFLIST": "替換 %2 的第 %1 項為 %3",
    "DATA_ITEMOFLIST": "%2 的第 %1 項",
    "DATA_LENGTHOFLIST": "清單 %1 的長度",
    "DATA_LISTCONTAINSITEM": "清單 %1 包含 %2？",
    "DATA_SHOWLIST": "清單 %1 顯示",
    "DATA_HIDELIST": "清單 %1 隱藏",
    "DATA_INDEX_ALL": "全部",
    "DATA_INDEX_LAST": "末",
    "DATA_INDEX_RANDOM": "隨機",
    "EVENT_WHENFLAGCLICKED": "當 %1 被點擊",
    "EVENT_WHENTHISSPRITECLICKED": "當角色被點擊",
    "EVENT_WHENSTAGECLICKED": "當舞台被點擊",
    "EVENT_WHENTOUCHINGOBJECT": "當角色碰到 %1",
    "EVENT_WHENBROADCASTRECEIVED": "當收到訊息 %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "當背景換成 %1",
    "EVENT_WHENGREATERTHAN": "當 %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "計時器",
    "EVENT_BROADCAST": "廣播訊息 %1",
    "EVENT_BROADCASTANDWAIT": "廣播訊息 %1 並等待",
    "EVENT_WHENKEYPRESSED": "當 %1 鍵被按下",
    "EVENT_WHENKEYPRESSED_SPACE": "空白",
    "EVENT_WHENKEYPRESSED_LEFT": "向左",
    "EVENT_WHENKEYPRESSED_RIGHT": "向右",
    "EVENT_WHENKEYPRESSED_DOWN": "向下",
    "EVENT_WHENKEYPRESSED_UP": "向上",
    "EVENT_WHENKEYPRESSED_ANY": "任何",
    "LOOKS_SAYFORSECS": "說出 %1 %2 秒",
    "LOOKS_SAY": "說出 %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "想著 %1 %2 秒",
    "LOOKS_THINK": "想著 %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "顯示",
    "LOOKS_HIDE": "隱藏",
    "LOOKS_HIDEALLSPRITES": "隱藏所有角色",
    "LOOKS_EFFECT_COLOR": "顏色",
    "LOOKS_EFFECT_FISHEYE": "魚眼",
    "LOOKS_EFFECT_WHIRL": "漩渦",
    "LOOKS_EFFECT_PIXELATE": "像素化",
    "LOOKS_EFFECT_MOSAIC": "馬賽克",
    "LOOKS_EFFECT_BRIGHTNESS": "亮度",
    "LOOKS_EFFECT_GHOST": "幻影",
    "LOOKS_CHANGEEFFECTBY": "圖像效果 %1 改變 %2",
    "LOOKS_SETEFFECTTO": "圖像效果 %1 設為 %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "圖像效果清除",
    "LOOKS_CHANGESIZEBY": "尺寸改變 %1",
    "LOOKS_SETSIZETO": "尺寸設為 %1 %",
    "LOOKS_SIZE": "尺寸",
    "LOOKS_CHANGESTRETCHBY": "伸縮改變 %1",
    "LOOKS_SETSTRETCHTO": "伸縮設為 %1 %",
    "LOOKS_SWITCHCOSTUMETO": "造型換成 %1",
    "LOOKS_NEXTCOSTUME": "下一個造型",
    "LOOKS_SWITCHBACKDROPTO": "背景換成 %1",
    "LOOKS_GOTOFRONTBACK": "圖層移到 %1 層",
    "LOOKS_GOTOFRONTBACK_FRONT": "最上",
    "LOOKS_GOTOFRONTBACK_BACK": "最下",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "圖層 %1 移 %2 層",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "上",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "下",
    "LOOKS_BACKDROPNUMBERNAME": "背景 %1",
    "LOOKS_COSTUMENUMBERNAME": "造型 %1",
    "LOOKS_NUMBERNAME_NUMBER": "編號",
    "LOOKS_NUMBERNAME_NAME": "名稱",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "背景換成 %1 並等待",
    "LOOKS_NEXTBACKDROP": "下一個背景",
    "LOOKS_PREVIOUSBACKDROP": "上一個背景",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "移動 %1 點",
    "MOTION_TURNLEFT": "左轉 %1 %2 度",
    "MOTION_TURNRIGHT": "右轉 %1 %2 度",
    "MOTION_POINTINDIRECTION": "面朝 %1 度",
    "MOTION_POINTTOWARDS": "面朝 %1 向",
    "MOTION_POINTTOWARDS_POINTER": "鼠標",
    "MOTION_GOTO": "定位到 %1 位置",
    "MOTION_GOTO_POINTER": "鼠標",
    "MOTION_GOTO_RANDOM": "隨機",
    "MOTION_GOTOXY": "定位到 x:%1 y:%2",
    "MOTION_GLIDESECSTOXY": "滑行 %1 秒到 x:%2 y:%3",
    "MOTION_GLIDETO": "滑行 %1 秒到 %2 位置",
    "MOTION_GLIDETO_POINTER": "鼠標",
    "MOTION_GLIDETO_RANDOM": "隨機",
    "MOTION_CHANGEXBY": "x 改變 %1",
    "MOTION_SETX": "x 設為 %1",
    "MOTION_CHANGEYBY": "y 改變 %1",
    "MOTION_SETY": "y 設為 %1",
    "MOTION_IFONEDGEBOUNCE": "碰到邊緣就反彈",
    "MOTION_SETROTATIONSTYLE": "迴轉方式設為 %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "左-右",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "不旋轉",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "不設限",
    "MOTION_XPOSITION": "x 座標",
    "MOTION_YPOSITION": "y 座標",
    "MOTION_DIRECTION": "方向",
    "MOTION_SCROLLRIGHT": "滾動向右 %1",
    "MOTION_SCROLLUP": "滾動向上 %1",
    "MOTION_ALIGNSCENE": "場景 %1 對齊",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "左下",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "右下",
    "MOTION_ALIGNSCENE_MIDDLE": "中間",
    "MOTION_ALIGNSCENE_TOPLEFT": "左上",
    "MOTION_ALIGNSCENE_TOPRIGHT": "右上",
    "MOTION_XSCROLL": "x 捲軸",
    "MOTION_YSCROLL": "y 捲軸",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "隨機取數 %1 到 %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 且 %2",
    "OPERATORS_OR": "%1 或 %2",
    "OPERATORS_NOT": "%1 不成立",
    "OPERATORS_JOIN": "字串組合 %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "字串 %2 的第 %1 字",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "字串 %1 的長度",
    "OPERATORS_CONTAINS": "字串 %1 包含 %2？",
    "OPERATORS_MOD": "%1 除以 %2 的餘數",
    "OPERATORS_ROUND": "四捨五入數值 %1",
    "OPERATORS_MATHOP": "%1 數值 %2",
    "OPERATORS_MATHOP_ABS": "絕對值",
    "OPERATORS_MATHOP_FLOOR": "無條件捨去",
    "OPERATORS_MATHOP_CEILING": "無條件進位",
    "OPERATORS_MATHOP_SQRT": "平方根",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "定義 %1",
    "SENSING_TOUCHINGOBJECT": "碰到 %1？",
    "SENSING_TOUCHINGOBJECT_POINTER": "鼠標",
    "SENSING_TOUCHINGOBJECT_EDGE": "邊緣",
    "SENSING_TOUCHINGCOLOR": "碰到顏色 %1？",
    "SENSING_COLORISTOUCHINGCOLOR": "顏色 %1 碰到 顏色 %2？",
    "SENSING_DISTANCETO": "與 %1 的間距",
    "SENSING_DISTANCETO_POINTER": "鼠標",
    "SENSING_ASKANDWAIT": "詢問 %1 並等待",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "詢問的答案",
    "SENSING_KEYPRESSED": "%1 鍵被按下？",
    "SENSING_MOUSEDOWN": "滑鼠鍵被按下？",
    "SENSING_MOUSEX": "鼠標的 x",
    "SENSING_MOUSEY": "鼠標的 y",
    "SENSING_SETDRAGMODE": "拖曳方式設為 %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "可拖曳",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "不可拖曳",
    "SENSING_LOUDNESS": "聲音響度",
    "SENSING_LOUD": "大聲？",
    "SENSING_TIMER": "計時器",
    "SENSING_RESETTIMER": "計時器重置",
    "SENSING_OF": "%2 的 %1",
    "SENSING_OF_XPOSITION": "x 座標",
    "SENSING_OF_YPOSITION": "y 座標",
    "SENSING_OF_DIRECTION": "方向",
    "SENSING_OF_COSTUMENUMBER": "造型編號",
    "SENSING_OF_COSTUMENAME": "造型名稱",
    "SENSING_OF_SIZE": "尺寸",
    "SENSING_OF_VOLUME": "音量",
    "SENSING_OF_BACKDROPNUMBER": "背景編號",
    "SENSING_OF_BACKDROPNAME": "背景名稱",
    "SENSING_OF_STAGE": "舞台",
    "SENSING_CURRENT": "目前時間的 %1",
    "SENSING_CURRENT_YEAR": "年",
    "SENSING_CURRENT_MONTH": "月",
    "SENSING_CURRENT_DATE": "日",
    "SENSING_CURRENT_DAYOFWEEK": "週",
    "SENSING_CURRENT_HOUR": "時",
    "SENSING_CURRENT_MINUTE": "分",
    "SENSING_CURRENT_SECOND": "秒",
    "SENSING_DAYSSINCE2000": "2000年迄今日數",
    "SENSING_USERNAME": "用戶名稱",
    "SENSING_USERID": "用戶 ID",
    "SOUND_PLAY": "播放音效 %1",
    "SOUND_PLAYUNTILDONE": "播放音效 %1 直到結束",
    "SOUND_STOPALLSOUNDS": "停播所有音效",
    "SOUND_SETEFFECTO": "聲音效果 %1 設為 %2",
    "SOUND_CHANGEEFFECTBY": "聲音效果 %1 改變 %2",
    "SOUND_CLEAREFFECTS": "聲音效果清除",
    "SOUND_EFFECTS_PITCH": "音高",
    "SOUND_EFFECTS_PAN": "聲道左/右",
    "SOUND_CHANGEVOLUMEBY": "音量改變 %1",
    "SOUND_SETVOLUMETO": "音量設為 %1%",
    "SOUND_VOLUME": "音量",
    "CATEGORY_MOTION": "動作",
    "CATEGORY_LOOKS": "外觀",
    "CATEGORY_SOUND": "音效",
    "CATEGORY_EVENTS": "事件",
    "CATEGORY_CONTROL": "控制",
    "CATEGORY_SENSING": "偵測",
    "CATEGORY_OPERATORS": "運算",
    "CATEGORY_VARIABLES": "變數",
    "CATEGORY_MYBLOCKS": "函式積木",
    "DUPLICATE": "複製",
    "DELETE": "刪除",
    "ADD_COMMENT": "添加註解",
    "REMOVE_COMMENT": "移除註解",
    "DELETE_BLOCK": "刪除積木",
    "DELETE_X_BLOCKS": "刪除 %1 個積木",
    "DELETE_ALL_BLOCKS": "要刪除全部（%1 個）積木？",
    "CLEAN_UP": "整理積木",
    "HELP": "求助",
    "UNDO": "復原",
    "REDO": "重做",
    "EDIT_PROCEDURE": "編輯",
    "SHOW_PROCEDURE_DEFINITION": "移至定義",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "說些什麼…",
    "COLOUR_HUE_LABEL": "顏色",
    "COLOUR_SATURATION_LABEL": "彩度",
    "COLOUR_BRIGHTNESS_LABEL": "亮度",
    "CHANGE_VALUE_TITLE": "改成：",
    "RENAME_VARIABLE": "重新命名變數",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "重新命名變數",
    "NEW_VARIABLE": "建立一個變數",
    "NEW_VARIABLE_TITLE": "新變數的名稱",
    "VARIABLE_MODAL_TITLE": "新的變數",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "建立一個積木",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "NEW_LIST": "建立一個清單",
    "NEW_LIST_TITLE": "新清單的名稱：",
    "LIST_MODAL_TITLE": "新的清單",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "重新命名清單",
    "NEW_BROADCAST_MESSAGE": "新的訊息",
    "NEW_BROADCAST_MESSAGE_TITLE": "新訊息的名稱：",
    "BROADCAST_MODAL_TITLE": "新的訊息",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "訊息1"
};


/*** EXPORTS FROM exports-loader ***/
module.exports = Blockly;



//////////////////
// WEBPACK FOOTER
// ./~/imports-loader?Blockly=../shim/blocks_compressed_vertical-blockly_compressed_vertical-messages,goog=../shim/blockly_compressed_vertical.goog!./~/exports-loader?Blockly!./~/scratch-blocks/msg/scratch_msgs.js
// module id = 64
// module chunks = 0